webpackJsonp([1],{

/***/ "+4eR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relListCli"}},[_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Clientes que não compram há algum tempo","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"cardBody"},[_c('section',[_c('b-pagination-nav',{attrs:{"size":"sm","number-of-pages":_vm.pObjPaginacao.length,"pages":_vm.pObjPaginacao,"align":"right","use-router":""},on:{"input":_vm.buscarClientesPorPagina},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}})],1),_vm._v(" "),_c('b-card-text',{staticClass:"table"},[_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.clientes,"fields":_vm.fieldsClientes},scopedSlots:_vm._u([{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.cnpjCpf.length === 14)?_c('div',{staticClass:"col-md-8"},[_vm._v("CNPJ: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]):_c('div',{staticClass:"col-md-8"},[_vm._v("CPF: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v(_vm._s(row.item.telefone))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_vm._v("Últ. Compra: "+_vm._s(row.item.emissao))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.valor)))])])]}}])})],1),_vm._v(" "),_c('section',{staticClass:"mt-3"},[_c('b-pagination-nav',{attrs:{"size":"sm","number-of-pages":_vm.pObjPaginacao.length,"pages":_vm.pObjPaginacao,"align":"right","use-router":""},on:{"input":_vm.buscarClientesPorPagina},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}})],1)],1)],1),_vm._v(" "),(_vm.blockUI.visibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+aRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioPedidosVue_vue__ = __webpack_require__("pKu9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca7a2a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioPedidosVue_vue__ = __webpack_require__("Fr2c");
function injectStyle (ssrContext) {
  __webpack_require__("o55V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca7a2a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioPedidosVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca7a2a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioPedidosVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+bo8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCatalGradeVue_vue__ = __webpack_require__("h3jR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9c985b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCatalGradeVue_vue__ = __webpack_require__("PaKm");
function injectStyle (ssrContext) {
  __webpack_require__("RjI3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9c985b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCatalGradeVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9c985b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCatalGradeVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/WNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioGerencialVue_vue__ = __webpack_require__("sF6d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27b89b10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioGerencialVue_vue__ = __webpack_require__("qctk");
function injectStyle (ssrContext) {
  __webpack_require__("jBOa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27b89b10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioGerencialVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27b89b10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioGerencialVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/rev":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "05AP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  listar: function listar() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedido');
  },
  listarSelect: function listarSelect() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedidoStatus');
  },
  listarPedidos: function listarPedidos(parametros) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedido?termo=' + parametros.termo + '&codStatus=' + parametros.codStatus + '&emissaoDe=' + parametros.emissaoDe + '&emissaoAte=' + parametros.emissaoAte);
  },
  obterPedido: function obterPedido(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedido/' + param.idPedido + '/' + param.isErp);
  },
  selecionar: function selecionar() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/dadosTabelasPedido');
  },
  inserirPedido: function inserirPedido(pedido) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedido', pedido);
  },
  inserirPedidoItem: function inserirPedidoItem(pedidoItem) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedidoItem', pedidoItem);
  },
  removerItem: function removerItem(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedidoItem/' + param.idPedido + '/' + param.idPedidoItem, param);
  },
  calcularTributos: function calcularTributos(item) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/calculaTributacaoPedidoItem', item);
  },
  aplicarDesconto: function aplicarDesconto(item) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/calculaDescontoPedido', item);
  },
  listarSituacaoPedido: function listarSituacaoPedido() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/situacaoPedido');
  }
});

/***/ }),

/***/ "0izi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('b-card',{staticClass:"cardDestaques",attrs:{"border-variant":"light"}},[_c('b-card-header',{staticStyle:{"background-color":"rgb(55, 71, 79)"},attrs:{"header":_vm.header,"header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),_c('b-card-text',[_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((_vm.destaques.destaques),function(destaque){return _c('swiper-slide',{key:destaque.codigo},[[_c('span',{staticClass:"imgGrade"},[_c('img',{attrs:{"src":destaque.url,"alt":""}})]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Item:")]),_vm._v(" "+_vm._s(destaque.codigoGrade))]),_vm._v(" "),_c('span',{staticClass:"descGrade"},[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(destaque.descricaoGrade))])]],2)}),1),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Vd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",attrs:{"role":"tablist","id":"listCliente"}},[_c('div',[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Lista de Clientes","header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),_c('b-card',{staticClass:"mb-1 shadow b-radius-0 p-3",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"table"},[(this.clientes.length > 0)?_c('b-table',{staticClass:"verticalAlign",attrs:{"bordered":"","striped":"","items":_vm.clientes,"fields":_vm.fields},scopedSlots:_vm._u([{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),(row.item.cnpjCpf.length === 14)?_c('div',{staticClass:"form-row mb-1"},[_vm._v("CNPJ: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]):_c('div',{staticClass:"form-row mb-1"},[_vm._v("CPF: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_vm._v("Endereço: "+_vm._s(_vm.toCapitalize(row.item.endereco))+" - "+_vm._s(_vm.toCapitalize(row.item.cidade))+" - "+_vm._s(row.item.uf))])]}},{key:"actions",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.selecionar(row.item)}}},[_vm._v("\n              Selecionar\n            ")])]}}],null,false,61730301)}):_c('span',[_vm._v("\n          Não foram encontrados clientes com os termos pesquisados, tente novamente\n        ")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BcH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2eij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('b-progress',{staticClass:"mt-3",attrs:{"value":_vm.metaAtingida,"max":_vm.max,"variant":_vm.variant,"show-progress":""}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("% Expectativa mensal atingida")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ihc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2mXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2oeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relatorios"}},[_c('b-row',{staticClass:"pt-3 pb-2"},[_c('b-col',{attrs:{"sm":"12 title"}},[_vm._v("RELATÓRIOS")])],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro relatFiltro shadow p-2"},[_c('b-col',{attrs:{"cols":"3","id":"selecRelat"}},[_c('b-form-select',{attrs:{"size":"sm","options":_vm.options},on:{"change":function($event){return _vm.selecionarRelatorio()}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),(_vm.visibility.statusRel)?_c('b-col',{attrs:{"cols":"4","id":"selecStatus"}},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.statusPedido),callback:function ($$v) {_vm.statusPedido=$$v},expression:"statusPedido"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Status --")])]),_vm._v(" "),_vm._l((_vm.statusOrdenados),function(item,key){return _c('option',{key:item.codigo,domProps:{"value":key}},[_vm._v("\n          "+_vm._s(item.descricao)+"\n        ")])})],2)],1):_vm._e(),_vm._v(" "),(_vm.visibility.filtroMesAno)?_c('b-col',{attrs:{"cols":"2","id":"selecMes"}},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.selectedMes),callback:function ($$v) {_vm.selectedMes=$$v},expression:"selectedMes"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Mês --")])]),_vm._v(" "),_vm._l((_vm.optionsMes),function(item,key){return _c('option',{key:item.mes,domProps:{"value":key}},[_vm._v("\n          "+_vm._s(item.descricao)+"\n        ")])})],2)],1):_vm._e(),_vm._v(" "),(_vm.visibility.filtroMesAno)?_c('b-col',{attrs:{"cols":"2","id":"inputAno"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('after:1900|before:2100|date_format:yyyy'),expression:"'after:1900|before:2100|date_format:yyyy'"}],attrs:{"placeholder":"Ano","autocomplete":"no","name":"filter_date","step":"1","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","type":"number","size":"sm","data-vv-as":"filter_date"},on:{"keyup":function($event){return _vm.changeClean()},"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.anoSelecionado),callback:function ($$v) {_vm.anoSelecionado=$$v},expression:"anoSelecionado"}})],1):_vm._e(),_vm._v(" "),(_vm.visibility.filtroGerencial)?_c('b-col',{attrs:{"cols":"3","id":"selecDate"}},[_c('div',{staticClass:"datepicker-container with-button"},[_c('div',{staticClass:"datepicker-trigger"},[_c('b-button',{attrs:{"id":"datepicker-button-trigger","size":"sm"}},[_vm._v("\n            "+_vm._s(_vm.formatDates(_vm.datePicker.buttonDateOne, _vm.datePicker.buttonDateTwo) || 'Período')+"\n          ")]),_vm._v(" "),_c('airbnb-style-datepicker',{attrs:{"trigger-element-id":'datepicker-button-trigger',"mode":'range',"date-one":_vm.datePicker.buttonDateOne,"date-two":_vm.datePicker.buttonDateTwo,"min-date":'2018-02-28',"fullscreen-mobile":true,"months-to-show":2,"offset-y":10,"trigger":_vm.datePicker.trigger},on:{"date-one-selected":function(val) { _vm.datePicker.buttonDateOne = val },"date-two-selected":function(val) { _vm.datePicker.buttonDateTwo = val },"closed":_vm.onClosed,"previous-month":_vm.onMonthChange,"next-month":_vm.onMonthChange}})],1)])]):_vm._e(),_vm._v(" "),(_vm.visibility.btnBuscar)?_c('b-col',{staticClass:"pb-2",attrs:{"cols":"2","id":"btnBuscar"}},[_c('b-button',{attrs:{"size":"sm","disabled":_vm.errors.has('filter_date')},on:{"click":function($event){return _vm.buscarDados()}}},[_vm._v("Buscar")])],1):_vm._e(),_vm._v(" "),(_vm.errors.has('filter_date'))?_c('span',{staticClass:"mt-1",staticStyle:{"color":"#7c000a"}},[_c('b',[_vm._v("Digite uma data válida")])]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro shadow p-2",attrs:{"id":"filtroMob"}},[_c('b-button',{attrs:{"id":"abreModalFiltro","size":"sm"},on:{"click":function($event){return _vm.abreModalFiltro()}}},[_c('i',{staticClass:"fas fa-search mr-2"}),_vm._v("Filtrar")])],1),_vm._v(" "),_c('b-modal',{attrs:{"hide-footer":"","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.filtrar},model:{value:(_vm.modalFiltro),callback:function ($$v) {_vm.modalFiltro=$$v},expression:"modalFiltro"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Filtrar Relatórios")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row m-0"},[_c('b-col',{attrs:{"cols":"3","id":"selecRelat"}},[_c('b-form-select',{attrs:{"size":"sm","options":_vm.options},on:{"change":function($event){return _vm.selecionarRelatorio()}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),(_vm.visibility.statusRel)?_c('b-col',{attrs:{"cols":"4","id":"selecStatus"}},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.statusPedido),callback:function ($$v) {_vm.statusPedido=$$v},expression:"statusPedido"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Status --")])]),_vm._v(" "),_vm._l((_vm.statusOrdenados),function(item,key){return _c('option',{key:item.codigo,domProps:{"value":key}},[_vm._v("\n              "+_vm._s(item.descricao)+"\n            ")])})],2)],1):_vm._e(),_vm._v(" "),(_vm.visibility.filtroMesAno)?_c('b-col',{attrs:{"cols":"2","id":"selecMes"}},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.selectedMes),callback:function ($$v) {_vm.selectedMes=$$v},expression:"selectedMes"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Mês --")])]),_vm._v(" "),_vm._l((_vm.optionsMes),function(item,key){return _c('option',{key:item.mes,domProps:{"value":key}},[_vm._v("\n              "+_vm._s(item.descricao)+"\n            ")])})],2)],1):_vm._e(),_vm._v(" "),(_vm.visibility.filtroMesAno)?_c('b-col',{attrs:{"cols":"2","id":"inputAno"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('after:1900|before:2100|date_format:yyyy'),expression:"'after:1900|before:2100|date_format:yyyy'"}],attrs:{"placeholder":"Ano","autocomplete":"no","name":"filter_date","type":"number","size":"sm","data-vv-as":"filter_date"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.anoSelecionado),callback:function ($$v) {_vm.anoSelecionado=$$v},expression:"anoSelecionado"}})],1):_vm._e(),_vm._v(" "),(_vm.errors.has('filter_date'))?_c('span',{staticClass:"mt-1",staticStyle:{"color":"#7c000a"}},[_c('b',[_vm._v("Digite uma data válida")])]):_vm._e(),_vm._v(" "),(_vm.visibility.filtroGerencial)?_c('b-col',{attrs:{"cols":"3","id":"selecDate"}},[_c('div',{staticClass:"datepicker-container with-button"},[_c('div',{staticClass:"datepicker-trigger"},[_c('b-button',{attrs:{"id":"datepicker-button-trigger","size":"sm"}},[_vm._v("\n                "+_vm._s(_vm.formatDates(_vm.datePicker.buttonDateOne, _vm.datePicker.buttonDateTwo) || 'Período')+"\n              ")]),_vm._v(" "),_c('airbnb-style-datepicker',{attrs:{"trigger-element-id":'datepicker-button-trigger',"mode":'range',"date-one":_vm.datePicker.buttonDateOne,"date-two":_vm.datePicker.buttonDateTwo,"min-date":'2018-02-28',"fullscreen-mobile":true,"months-to-show":2,"offset-y":10,"trigger":_vm.datePicker.trigger},on:{"date-one-selected":function(val) { _vm.datePicker.buttonDateOne = val },"date-two-selected":function(val) { _vm.datePicker.buttonDateTwo = val },"closed":_vm.onClosed,"previous-month":_vm.onMonthChange,"next-month":_vm.onMonthChange}})],1)])]):_vm._e(),_vm._v(" "),(_vm.visibility.btnBuscar)?_c('b-col',{staticClass:"pb-2",attrs:{"cols":"2","id":"btnBuscar"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.buscarDados()}}},[_vm._v("Buscar")])],1):_vm._e()],1)])],2),_vm._v(" "),(_vm.visibility.relCliRanking)?_c('relatorios-clientes-ranking',{attrs:{"pObjClientes":_vm.objClientes,"pObjPaginacao":_vm.objPaginacao}}):_vm._e(),_vm._v(" "),(_vm.visibility.relCliNaoComp)?_c('relatorios-clientes-nao-compram',{attrs:{"pObjClientes":_vm.objClientes,"pObjPaginacao":_vm.objPaginacao,"pTipoRelatorio":_vm.relatorioSelecionado}}):_vm._e(),_vm._v(" "),(_vm.visibility.relCliPendencia)?_c('relatorios-clientes-pendencia',{attrs:{"pObjClientes":_vm.objClientes,"pObjPaginacao":_vm.objPaginacao}}):_vm._e(),_vm._v(" "),(_vm.visibility.relPedidos)?_c('relatorios-pedido-vue',{attrs:{"pObjPedido":_vm.objPedido,"pObjStatus":_vm.statusSelecionado}}):_vm._e(),_vm._v(" "),(_vm.visibility.relComissoes)?_c('relatorios-comissoes',{attrs:{"pResumoComissoes":_vm.resumoComissoes}}):_vm._e(),_vm._v(" "),(_vm.visibility.relMetas)?_c('relatorio-metas',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRelMetas),expression:"showRelMetas"}],attrs:{"pMetasDados":_vm.metasDados}}):_vm._e(),_vm._v(" "),(_vm.visibility.relGerencial)?_c('relatorio-gerencial-vue',{attrs:{"pRelatorioGerencialDados":_vm.relatorioGerencialDados}}):_vm._e(),_vm._v(" "),(_vm.blockUI.visibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e(),_vm._v(" "),_c('toast-vue',{attrs:{"idToast":_vm.message.idToast,"variant":_vm.message.variant,"titleMsg":_vm.message.titleMsg,"message":_vm.message.message}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "300Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("mvb9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252a2a72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("GTIM");
function injectStyle (ssrContext) {
  __webpack_require__("kDM7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-252a2a72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252a2a72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "39Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  listarDashboard: function listarDashboard() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/dashboard');
  },
  listarComissao: function listarComissao() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/comissaoMesRepresentante');
  },
  listarPedOrcamento: function listarPedOrcamento(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/pedido?termo=' + param.termo + '&codStatus=' + param.codStatus + '&emissaoDe=' + param.emissaoDe + '&emissaoAte=' + param.emissaoAte);
  },
  obterComissaoCorrenteRepresentante: function obterComissaoCorrenteRepresentante() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/comissaoMesRepresentante');
  }
});

/***/ }),

/***/ "39eN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: '',
    header: '',
    pCardPedidosEmObservacaoValues: { duplicatas: [] }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var cor = state.cor.cor;

      return {
        'background-color': cor
      };
    }
  })),
  watch: {
    pCardPedidosEmObservacaoValues: function pCardPedidosEmObservacaoValues(newVal, oldVal) {
      // watch it
      this.dashboard = newVal;
    }
  },
  data: function data() {
    return {
      clientesObs: [],
      fields: [{
        key: 'fantasia',
        label: 'Cliente',
        sortable: true,
        formatter: this.toCapitalize,
        class: 'colCLiente txtLeft'
      }, {
        key: 'vencimento',
        label: 'Vencto.',
        sortable: true,
        class: 'p-0'
      }, {
        key: 'diasAtraso',
        label: 'Dias Atr.',
        sortable: true
      }, {
        key: 'valor',
        label: 'Valor R$',
        sortable: true,
        formatter: this.formatterValue,
        class: 'txtRight'
        // ,
        // {
        //   key: 'codCliente',
        //   label: 'Cód. Cliente',
        //   sortable: true
        // }
      }]
    };
  },
  mounted: function mounted() {
    this.clientesObs = this.pCardPedidosEmObservacaoValues;
  },

  methods: {
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
});

/***/ }),

/***/ "3vl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableEditClientesVue_vue__ = __webpack_require__("qaQL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c102c04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableEditClientesVue_vue__ = __webpack_require__("r/qe");
function injectStyle (ssrContext) {
  __webpack_require__("zeQ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c102c04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableEditClientesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c102c04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableEditClientesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4OE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TablePedidosVue_vue__ = __webpack_require__("JGxn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39295d00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TablePedidosVue_vue__ = __webpack_require__("YG69");
function injectStyle (ssrContext) {
  __webpack_require__("K8Ct")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39295d00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TablePedidosVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39295d00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TablePedidosVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Ts9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mostraPedidos)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.exibirListaPedido),expression:"exibirListaPedido"}]},[_c('new-items-vue',{attrs:{"title":_vm.titlePageLista,"placeholderNm":"IDGosales, Razão, Fant., Ped., Orç., Ped. Compra ..."}}),_vm._v(" "),_c('table-pedidos-vue')],1):_vm._e(),_vm._v(" "),(_vm.mostraPedidos)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.exibirSelecionarCliente),expression:"exibirSelecionarCliente"}]},[_c('new-items-clientes-vue',{attrs:{"title":"SELECIONAR CLIENTE","placeholderNm":"Cód. Cliente, Fantasia, Razão, CNPJ e Endereço","placeholderCid":"Cidade"}}),_vm._v(" "),_c('table-acoes-vue',{attrs:{"title":"Lista de clientes"}})],1):_vm._e(),_vm._v(" "),(_vm.mostraPedidos)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.novoPedido),expression:"novoPedido"}]},[_c('novo-pedido-vue',{attrs:{"title":"NOVO PEDIDO","clienteSelecionado":_vm.cliente}})],1):_vm._e(),_vm._v(" "),(!_vm.mostraPedidos)?_c('p',{attrs:{"id":"construcao"}},[_vm._v("Desculpe o transtorno, estamos trabalhando para melhor atendê-los!")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4maw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModoLista),expression:"isModoLista"}]},[_c('new-items-catalogo-vue',{attrs:{"title":"CATÁLOGOS","placeholderNm":"Grade, Produto, Código, ..."}}),_vm._v(" "),_c('card-categorias-vue',{staticClass:"mt-4",attrs:{"header":"Destaques"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isModoLista),expression:"!isModoLista"}]},[_c('table-catal-grade-vue',{attrs:{"title":"GRADE"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5JdH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5JxE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5NKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableAcoesVue_vue__ = __webpack_require__("lPSB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270db6c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableAcoesVue_vue__ = __webpack_require__("1Vd5");
function injectStyle (ssrContext) {
  __webpack_require__("j9Lh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-270db6c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableAcoesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270db6c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableAcoesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5fI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosVue_vue__ = __webpack_require__("HMJr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56af36f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatoriosVue_vue__ = __webpack_require__("2oeK");
function injectStyle (ssrContext) {
  __webpack_require__("etK7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56af36f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56af36f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatoriosVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6/OE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComunicadoVue_vue__ = __webpack_require__("RfKs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42dc7453_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComunicadoVue_vue__ = __webpack_require__("BBoj");
function injectStyle (ssrContext) {
  __webpack_require__("R/zC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42dc7453"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComunicadoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42dc7453_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComunicadoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6AU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relListMet"}},[_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"card shadow"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header-text-variant":"white","header-tag":"header","header":"Média de Desempenho Mensal"}}),_vm._v(" "),_c('b-card',[(_vm.pMetasDados.descricaoMes)?_c('div',{staticClass:"title ml-3 titulo-mes"},[_vm._v(_vm._s(_vm.pMetasDados.descricaoMes))]):_vm._e(),_vm._v(" "),_c('b-table',{attrs:{"items":_vm.tableMes,"fields":_vm.fieldsMensal,"caption-top":""},scopedSlots:_vm._u([{key:"desempenho",fn:function(row){return [_c('b-progress',{staticClass:"mt-2 prog",attrs:{"show-value":"","value":row.item.percAtingido,"max":_vm.max,"variant":"warning"}})]}},{key:"mobileGeral",fn:function(row){return [_c('div',{staticClass:"shadow pb-1 mb-2"},[_c('div',{staticClass:"titleMob"},[_vm._v(_vm._s(_vm.pMetasDados.descricaoMes))]),_vm._v(" "),_c('div',{staticClass:"contMob"},[_c('b-progress',{staticClass:"mb-3 prog",attrs:{"show-value":"","value":row.item.percAtingido,"max":_vm.max,"variant":"warning"}}),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Meta")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formatterValue(row.item.valorMeta)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Atingido")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formatterValue(row.item.valorAtingido)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Média")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formatterValue(row.item.valorMedio)))])])])],1)])]}}])}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.pMetasDados.porCategoria && _vm.pMetasDados.porCategoria.length > 0)?_c('b-table',{attrs:{"items":_vm.pMetasDados.porCategoria,"fields":_vm.fieldsCategoria,"caption-top":""},scopedSlots:_vm._u([{key:"categorias",fn:function(row){return [_c('div',{staticClass:"txtLeft mb-1 label-categoria"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.categoria)))]),_vm._v(" "),_c('b-progress',{staticClass:"mb-3",attrs:{"show-value":"","value":row.item.percAtingido,"max":_vm.max,"variant":"warning"}})]}},{key:"mobileCategorias",fn:function(row){return [_c('div',{staticClass:"shadow pb-1 mb-2"},[_c('div',{staticClass:"titleMob"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.categoria)))]),_vm._v(" "),_c('div',{staticClass:"contMob"},[_c('b-progress',{staticClass:"mb-3",attrs:{"show-value":"","value":row.item.percAtingido,"max":_vm.max,"variant":"warning"}}),_vm._v(" "),_c('div',{staticClass:"form-row mb-3"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Meta")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formatterValue(row.item.valorMeta)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Atingido")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formatterValue(row.item.valorAtingido)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Média")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.formatterValue(row.item.valorMedio)))])])])],1)])]}}],null,false,560919017)}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1)],1)]),_vm._v(" "),(_vm.blockUI.visibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6D4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import jsPDF from 'jsPDF'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fields: ['first_name', 'last_name', 'age'],
      items: [{ age: 40, first_name: 'Dickerson', last_name: 'Macdonald' }, { age: 21, first_name: 'Larsen', last_name: 'Shaw' }, { age: 89, first_name: 'Geneva', last_name: 'Wilson' }]
    };
  },

  methods: {
    imprimirPedido: function imprimirPedido() {
      // let conteudo = document.getElementById('sua_div').innerHTML,
      //   telaImpressao = window.open('about:blank')
      // telaImpressao.document.write(conteudo)
      // telaImpressao.window.print()
      // telaImpressao.window.close()
      // let pdfName = 'test'
      // var doc = jsPDF()
      // doc.text(this.name, 10, 10)
      // doc.save(pdfName + '.pdf')
      this.teste();
    },

    teste: function teste() {
      var html = '';
      html += '<html>';
      html += '<head>';
      html += '</head>';
      html += '<body>';
      // inicio body
      html += '<h1>testando</h1>';
      // fim body
      html += '</body>';
      html += '</html>';
      var win = window.open('', '', 'height=700,width=700');
      win.write(html);
      // win.document.write('<html><head>');
      // win.document.write('<title>Relatório de vendas de Produtos</title>');   // <title> CABEÇALHO DO PDF.
      // //win.document.write(style)// INCLUI UM ESTILO NA TAB HEAD
      // win.document.write('</head>')
      // win.document.write('<body>')
      // win.document.write(tab)// O CONTEUDO DA TABELA DENTRO DA TAG BODY
      // win.document.write('</body></html>')
      win.document.close(); // FECHA A JANELA
      win.print();
    }
  }
});

/***/ }),

/***/ "7Ov1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardBannersVue_vue__ = __webpack_require__("rUTP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84a1282c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardBannersVue_vue__ = __webpack_require__("DQpm");
function injectStyle (ssrContext) {
  __webpack_require__("pxRZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84a1282c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardBannersVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84a1282c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardBannersVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7l4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_relatorios__ = __webpack_require__("OLWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ToastVue: __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__["a" /* default */]
  },
  props: {
    pObjClientes: {},
    pObjPaginacao: {}
  },
  data: function data() {
    return {
      blockUI: {
        message: '',
        visibility: false
      },
      current_page: '0',
      tipoPedido: [],
      statusSelecionado: {},
      clientes: [],
      fieldsClientes: [{
        key: 'codCliente',
        label: 'Cód. Cli.',
        sortable: true,
        class: 'relCliCod'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'relCliFant txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true,
        class: 'relCliRaz txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'cnpjCpf',
        label: 'CNPJ/CPF',
        sortable: true,
        class: 'relCliCnpj',
        formatter: this.formatterCnpjCpf
      }, {
        key: 'email',
        label: 'Email',
        sortable: true,
        class: 'relCliEmail'
      }, {
        key: 'telefone',
        label: 'Telefone',
        sortable: true,
        class: 'relCliTel'
      }, {
        key: 'vencimento',
        label: 'Vencimento',
        sortable: true,
        class: 'relCliVen txtLeft'
      }, {
        key: 'valor',
        label: 'Valor R$',
        sortable: true,
        class: 'relCliVal txtRight',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobile',
        class: 'relCliMobile txtLeft'
      }]
    };
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
  },

  watch: {
    pObjClientes: function pObjClientes(newVal, oldVal) {
      // watch it
      // console.log(JSON.stringify(newVal))
      this.clientes = newVal;
    }
  },
  methods: {
    buscarClientesPorPagina: function buscarClientesPorPagina() {
      var _this = this;

      var paginaCorrente = this.current_page - 1;
      var paginacao = this.pObjPaginacao[paginaCorrente];
      // console.log(JSON.stringify(paginacao))
      var paramCliente = { tipoRelatorio: '0', paginacao: paginacao.pagina, registrosPorPagina: paginacao.registrosPorPagina };
      __WEBPACK_IMPORTED_MODULE_0__services_relatorios__["a" /* default */].listarClientes(paramCliente).then(function (response) {
        _this.clientes = response.data.clientes;
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this.blockUI.visibility = false;
      });
    },
    showMessage: function showMessage(message, title, variantColor) {
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast');
    },
    relatorioCliente: function relatorioCliente() {
      var _this2 = this;

      this.blockUI.visibility = true;
      this.blockUI.message = 'Listando clientes, aguarde...';
      __WEBPACK_IMPORTED_MODULE_0__services_relatorios__["a" /* default */].listarClientes().then(function (response) {
        _this2.clientes = response.data;
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this2.blockUI.visibility = false;
      });
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterValue: function formatterValue(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatterCnpjCpf: function formatterCnpjCpf(value) {
      if (value.length === 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
      }
      if (value.length === 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
      }
    }
  }
});

/***/ }),

/***/ "7luQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toastVue_vue__ = __webpack_require__("aVrV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b25c5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toastVue_vue__ = __webpack_require__("TwnM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toastVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b25c5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toastVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7sUr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sem-imagem.44e3842.png";

/***/ }),

/***/ "828A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogoVue_vue__ = __webpack_require__("Lzip");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59281c27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogoVue_vue__ = __webpack_require__("4maw");
function injectStyle (ssrContext) {
  __webpack_require__("5JxE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59281c27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59281c27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9ERK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AX/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-banners-vue',{attrs:{"pCardBannersValues":_vm.cardBannersValues}}),_vm._v(" "),_c('card-Metas-vue',{staticClass:"shadow",attrs:{"pCardMetasValues":_vm.cardMetasValues,"comissao":"Comissão","style1":_vm.cor}}),_vm._v(" "),(_vm.blockUI.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BBoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('a',{staticClass:"alert-link",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "+_vm._s(_vm.comunicado))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C0PT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticLayout_vue__ = __webpack_require__("tDQt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ab6caa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticLayout_vue__ = __webpack_require__("GVxo");
function injectStyle (ssrContext) {
  __webpack_require__("uiNs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12ab6caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ab6caa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CEID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioClientesNaoCompramVue_vue__ = __webpack_require__("M37V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316a6410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioClientesNaoCompramVue_vue__ = __webpack_require__("+4eR");
function injectStyle (ssrContext) {
  __webpack_require__("hmr2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-316a6410"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioClientesNaoCompramVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316a6410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioClientesNaoCompramVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CyCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return endPointPublic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return endPointPrivate; });
var endPointPublic = 'http://api.webrep.gosales.com.br/api/public/';
var endPointPrivate = 'http://api.webrep.gosales.com.br/api/private/';
// export let endPointPublic = 'http://192.168.100.45:8085/api/public/'
// export let endPointPrivate = 'http://192.168.100.45:8085/api/private/'

/***/ }),

/***/ "DQpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"shadow2 mb-3",attrs:{"border-variant":"light","id":"cardBanner"}},[(_vm.pCardBannersValues.banners.length > 0)?_c('b-card-text',[_c('swiper',{attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.pCardBannersValues.banners),function(banner){return _c('swiper-slide',{key:banner.url,staticClass:"bannerMiddle"},[_c('img',{attrs:{"src":banner.url}})])}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)],1):_c('b-card-text',[_c('span',[_c('img',{attrs:{"src":__webpack_require__("eAmv"),"alt":""}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EfIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-css ng-scope"},[_c('div',{staticClass:"lds-spin",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})]),_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}},[_c('div',{staticStyle:{"background-color":"rgb(55, 71, 79)"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FEof":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioClientesPendenciaVue_vue__ = __webpack_require__("7l4e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78fc5e49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioClientesPendenciaVue_vue__ = __webpack_require__("Zm2F");
function injectStyle (ssrContext) {
  __webpack_require__("XdU7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78fc5e49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioClientesPendenciaVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78fc5e49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioClientesPendenciaVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FZRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  listarSelect: function listarSelect(parametros) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/cliente?termo=' + parametros.termo + '&uf=' + parametros.uf + '&cidade=' + parametros.cidade);
  },
  editCliente: function editCliente(parametros) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/cliente/' + parametros.id + '/' + parametros.codCliente + '/' + parametros.clienteNovo);
  },
  selecionar: function selecionar() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/dadosTabelasCliente');
  },
  verificaCNPJ: function verificaCNPJ(parametro) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/cliente/' + parametro);
  },
  salvar: function salvar(dados) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/cliente', dados);
  }
});

/***/ }),

/***/ "FaGc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fr2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relListPed"}},[_c('section',{staticClass:"mt-4 card"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":_vm.statusSelecionado.descricao,"header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"cardBody"},[_c('b-card-text',{staticClass:"table"},[(_vm.pedidos && _vm.pedidos.length > 0)?_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.pedidos,"fields":_vm.fieldsPedidos},scopedSlots:_vm._u([{key:"urlImagemCanal",fn:function(row){return [_c('img',{attrs:{"src":row.item.canal.url}})]}},{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_vm._v("Emissão: "+_vm._s(row.item.emissao))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.numeroOrcamento)?_c('div',{staticClass:"col-md-8"},[_vm._v("Nº Orç.: "+_vm._s(row.item.numeroOrcamento))]):_c('div',{staticClass:"col-md-8"},[_vm._v("Nº Orç.: -")]),_vm._v(" "),(row.item.numeroPedido)?_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("Nº Ped.: "+_vm._s(row.item.numeroPedido))]):_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("Nº Ped.: -")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_vm._v("Status "+_vm._s(row.item.status.descricao))]),_vm._v(" "),(row.item.numeroPedidoCompra)?_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("Ped. Compra: "+_vm._s(row.item.numeroPedidoCompra))]):_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("Ped. Compra: -")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8 relPedImgMob"},[_c('img',{attrs:{"src":row.item.canal.url}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("Total: "+_vm._s(_vm.formatterValue(row.item.totalPedido)))])])]}}],null,false,2097769829)}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GTIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-center",attrs:{"id":"login"}},[_c('b-col',[(_vm.browser)?_c('div',{staticClass:"mt-3"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('h2',{staticClass:"alert-heading"},[_vm._v("Atenção!")]),_vm._v(" "),_c('p',[_vm._v("\r\n          Verificamos que o navegador utilizado é o "),_c('b',[_vm._v(_vm._s(_vm.result || 'detecting…'))]),_vm._v(", esta aplicação só é compatível com a versão 18 ou superior, por favor, seguir os seguintes passos para\r\n          atualizar seu navegador:\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n          Entrar em "),_c('b',[_vm._v("\"Configurações\"")]),_vm._v(", após isso "),_c('b',[_vm._v("\"Atualizações  segurança\"")]),_vm._v(", verificar se há atualizações disponíveis (Windows update), clicar em "),_c('b',[_vm._v("\"Verificar se há atualizações\"")]),_vm._v(" e aguardar a instalação.\r\n          Talvez seja necessário repetir essa operação algumas vezes até que não haja mais nenhuma atualização disponível para download.\r\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('b',[_vm._v("Ou então para melhor uso da aplicação, recomendamos o uso do Chrome, Firefox ou Safari.")])])])],1):_vm._e(),_vm._v(" "),_c('b-card-group',[_c('b-card',{staticClass:"bradius content-login"},[_c('img',{staticClass:"mb-5 mt-5",attrs:{"src":__webpack_require__("enmS"),"alt":"","id":"logoGoSales"}}),_vm._v(" "),_c('b-card-text',{staticClass:"content-center",on:{"submit":function($event){$event.preventDefault();return _vm.listarEmpresas($event)}}},[(_vm.esqueciASenha)?_c('div',{staticClass:"content-center itens"},[_c('b-input-group',{staticClass:"mb-2 col-10"},[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'input': true, 'invalidLogin': _vm.errors.has('email')},attrs:{"type":"text","placeholder":"Email","size":"sm","name":"email"},model:{value:(_vm.authUser.usuario),callback:function ($$v) {_vm.$set(_vm.authUser, "usuario", $$v)},expression:"authUser.usuario"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"invalidLogin"},[_vm._v(_vm._s(_vm.errors.first('email')))]),_vm._v(" "),_c('b-input-group',{staticClass:"col-10"},[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-unlock-alt"})])]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:4'),expression:"'required|min:4'"}],class:{'input': true, 'invalidLogin': _vm.errors.has('senha')},attrs:{"type":"password","placeholder":"Senha","size":"sm","name":"senha"},model:{value:(_vm.authUser.senha),callback:function ($$v) {_vm.$set(_vm.authUser, "senha", $$v)},expression:"authUser.senha"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('senha')),expression:"errors.has('senha')"}],staticClass:"invalidLogin"},[_vm._v(_vm._s(_vm.errors.first('senha')))]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"mt-3 btn-continuar",attrs:{"variant":"light","disabled":_vm.disabled || _vm.authUser.senha.length < 4,"size":"sm"},on:{"click":function($event){return _vm.listarEmpresas()}}},[(_vm.isLoading)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":"","label":"Small Spinner"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Continuar")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.escolhaEmpresas),expression:"escolhaEmpresas"}],staticClass:"mt-2 mb-2",on:{"submit":_vm.logar}},[_c('div',{staticClass:"selecionar-empresa"},[_vm._v("Selecionar empresa:")]),_vm._v(" "),_c('div',{staticStyle:{"border-top":"1px solid rgba(255,255,255,0.36)"}}),_vm._v(" "),_c('b-card',[_c('swiper',{attrs:{"options":_vm.swiperOption}},_vm._l((_vm.empresas),function(empresa){return _c('swiper-slide',{key:empresa.id},[_c('img',{staticClass:"mr-2 ml-2 empresas",attrs:{"src":empresa.urlLogoPositivo,"alt":""},on:{"click":function($event){return _vm.logar(empresa)}}})])}),1)],1)],1)],1),_vm._v(" "),_c('b-button',{staticClass:"mt-2",staticStyle:{"width":"180px"},attrs:{"variant":"outline-light","size":"sm"},on:{"click":function($event){return _vm.recuperaSenha()}}},[_vm._v("Esqueci minha senha")])],1):_c('div',{staticClass:"content-center itens"},[_c('b-input-group',{staticClass:"mb-5 col-10"},[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-envelope"})])]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'input': true, 'invalidLogin': _vm.errors.has('email')},attrs:{"type":"text","placeholder":"Email","size":"sm","name":"email"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"invalidLogin"},[_vm._v(_vm._s(_vm.errors.first('email')))]),_vm._v(" "),_c('b-button',{staticClass:"col-3",attrs:{"variant":"outline-light","size":"sm"},on:{"click":_vm.cancelar}},[_vm._v("Cancelar")]),_vm._v(" "),_c('b-button',{staticClass:"col-3",attrs:{"variant":"outline-light","size":"sm"}},[_vm._v("Enviar")])],1)])],1),_vm._v(" "),_c('toast-vue',{attrs:{"idToast":_vm.idToastItem,"variant":_vm.variant,"titleMsg":_vm.titleMsg,"message":_vm.message}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GVxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"StaticLayout"}},[_c('header-vue',{style:(_vm.cor)}),_vm._v(" "),_c('div',{staticClass:"content-center bg-gray"},[_c('router-view')],1),_vm._v(" "),_c('footer-vue',{style:(_vm.cor)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ga2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-brand fixed-top"},[_c('b-navbar',{staticClass:"shadow",attrs:{"toggleable":"lg","type":"dark"}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"","id":"logo"}})]),_vm._v(" "),_c('b-nav-item',{staticClass:"ml-5"},[_c('router-link',{attrs:{"to":"/Home"}},[_vm._v("HOME")])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{attrs:{"to":"/Pedidos","href":"#filtroPedido"}},[_vm._v("PEDIDOS")])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{attrs:{"to":"/Clientes"}},[_vm._v("CLIENTES")])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{attrs:{"to":"/Relatorios"}},[_vm._v("RELATÓRIOS")])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{attrs:{"to":"/Catalogo"}},[_vm._v("CATÁLOGO")])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-form',{staticClass:"mr-4",attrs:{"id":"selecRepDesk"}},[(this.listaRepresentantes.length > 1 && _vm.viewListaRepresentantes === false)?_c('div',{staticClass:"contentRepSelecao"},[(this.representanteSelecionado)?_c('div',[(this.representanteSelecionado.urlFoto === '')?_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":this.representanteSelecionado.urlFoto}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toCapitalize(this.representanteSelecionado.apelido)))])]):_vm._e()]):(this.listaRepresentantes.length > 1)?_c('div',{staticClass:"btnRepSelec contentRepSelecao",on:{"click":function($event){return _vm.abreModalSelecRep()}}},[(this.representanteSelecionado)?_c('div',{staticClass:"btn btn-secondary"},[(this.representanteSelecionado.urlFoto === '')?_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":this.representanteSelecionado.urlFoto}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toCapitalize(this.representanteSelecionado.apelido)))])]):_c('button',{staticClass:"btn btn-secondary btnSelecionar",staticStyle:{"border":"none"},style:(_vm.cor2),on:{"click":function($event){return _vm.abreModalSelecRep()}}},[_vm._v("Selecionar Representante")])]):(this.listaRepresentantes.length === 1)?_c('div',{staticClass:"contentRepSelecao"},[_c('div',[(this.listaRepresentantes[0].urlFoto === '')?_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":this.listaRepresentantes[0].urlFoto}}),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.toCapitalize(this.listaRepresentantes[0].apelido)))])])])]):_vm._e()]),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"text":"User","right":"","id":"menuUsuario"}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-user-circle"})]),_vm._v(" "),_c('div',{attrs:{"id":"selecRepMob"}},[(this.listaRepresentantes.length > 1 && _vm.viewListaRepresentantes === false)?_c('b-dropdown-item',{staticClass:"contentRepSelecao"},[(this.representanteSelecionado)?_c('div',[(this.representanteSelecionado.urlFoto === '')?_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":this.representanteSelecionado.urlFoto}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toCapitalize(this.representanteSelecionado.apelido)))])]):_vm._e()]):(this.listaRepresentantes.length > 1)?_c('b-dropdown-item',{staticClass:"btnRepSelec contentRepSelecao",on:{"click":function($event){return _vm.abreModalSelecRep()}}},[(this.representanteSelecionado)?_c('div',{staticClass:"btn btn-secondary"},[(this.representanteSelecionado.urlFoto === '')?_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":this.representanteSelecionado.urlFoto}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toCapitalize(this.representanteSelecionado.apelido)))])]):_c('button',{staticClass:"btn btn-secondary btnSelecionar",staticStyle:{"border":"none"},style:(_vm.cor2),on:{"click":function($event){return _vm.abreModalSelecRep()}}},[_vm._v("Selecionar Representante")])]):(this.listaRepresentantes.length === 1)?_c('b-dropdown-item',{staticClass:"contentRepSelecao"},[(this.listaRepresentantes[0].urlFoto === '')?_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"ml-1 mr-1 fotoRepBtn",attrs:{"src":this.listaRepresentantes[0].urlFoto}}),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.toCapitalize(this.listaRepresentantes[0].apelido)))])])]):_vm._e()],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.sair}},[_vm._v("Sair")])],2)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Selecione um Representante","ok-title":"Salvar","ok-variant":"primary","cancel-title":"Fechar","cancel-variant":"secondary","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant,"hide-footer":""},model:{value:(_vm.modalSelecRepresentante),callback:function ($$v) {_vm.modalSelecRepresentante=$$v},expression:"modalSelecRepresentante"}},[_c('b-row',{staticClass:"p-0 mb-1",attrs:{"id":"filtroRepresentante"}},[_c('b-form-input',{staticClass:"col-md-3",attrs:{"type":"text","size":"sm","placeholder":"Código"},model:{value:(_vm.codigoRep),callback:function ($$v) {_vm.codigoRep=$$v},expression:"codigoRep"}}),_vm._v(" "),_c('b-form-input',{staticClass:"col-md-8",attrs:{"type":"text","size":"sm","placeholder":"Representante"},model:{value:(_vm.apelidoRep),callback:function ($$v) {_vm.apelidoRep=$$v},expression:"apelidoRep"}}),_vm._v(" "),_c('b-button',{staticClass:"btnLimpaFiltroRep col-md-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltro()}}},[_c('i',{staticClass:"fas fa-eraser mr-2"})])],1),_vm._v(" "),_c('b-row',{staticClass:"table tab-rep p-0"},[(_vm.filteredList.length > 0)?_c('b-table',{staticClass:"m-0",attrs:{"bordered":"","striped":"","items":_vm.filteredList,"fields":_vm.fieldsRepresentantes},scopedSlots:_vm._u([{key:"urlFoto",fn:function(row){return [(row.item.urlFoto === '')?_c('img',{staticClass:"fotoRepModal",attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{staticClass:"m-1 fotoRepModal",attrs:{"src":row.item.urlFoto}})]}},{key:"acao",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.admSelecRep(row.item, row.index)}}},[_vm._v("\n            Selecionar\n            ")])]}}],null,false,500526397)}):_c('span',[_vm._v("\n        Não foram encontrados representantes com o termo pesquisado, tente novamente\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gn9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",attrs:{"id":"cardMetas"}},[_c('b-card-header',{style:(_vm.style1),attrs:{"header":_vm.comissao + ' - ' + _vm.pCardMetasValues.periodo,"header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),_c('b-card',{staticClass:"cardBody"},[_c('b-row',[_c('b-col',{staticClass:"border-right",attrs:{"cols":"8","id":"progressMeta"}},[_c('progress-metas-vue',{attrs:{"pProgressMetasValues":_vm.progressMetasValues}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4","id":"prevComissao"}},[_c('label',[_c('i',{staticClass:"fas fa-money-check-alt mr-1"}),_c('b',[_vm._v("Previsão Comissão")])]),_vm._v(" "),_c('div',{staticClass:"meta",attrs:{"id":"btnVisualizar"}},[(_vm.visualizarComissao)?_c('label',{staticClass:"mt-3 mb-3",on:{"click":function($event){return _vm.obterComissao()}}},[_c('i',{staticClass:"fas fa-eye-slash"}),_c('b',[_vm._v(" R$ "+_vm._s(_vm.formatPrice(_vm.comissaoRep.valor)))])]):_c('label',{staticClass:"mt-3 mb-3",on:{"click":function($event){return _vm.obterComissao()}}},[_c('i',{staticClass:"fas fa-eye"}),_c('b',[_vm._v(" VISUALIZAR")])])])])],1)],1),_vm._v(" "),(_vm.blockUI.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.msgBlockUi}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Guud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HMJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_relatorioPedidosVue__ = __webpack_require__("+aRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_items_relatorioClientesPendenciaVue__ = __webpack_require__("FEof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_items_relatorioClientesRankingVue__ = __webpack_require__("tqkD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_items_relatorioClientesNaoCompramVue__ = __webpack_require__("CEID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_items_relatoriosComissoesVue__ = __webpack_require__("txSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_items_relatorioMetasVue__ = __webpack_require__("uk2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_tablePedidos__ = __webpack_require__("05AP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_relatorios__ = __webpack_require__("OLWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_items_relatorioGerencialVue__ = __webpack_require__("/WNH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// import RelatorioClientesVue from '@/components/items/relatorioClientesPendenciaVue'


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // RelatorioClientesVue,
    relatoriosPedidoVue: __WEBPACK_IMPORTED_MODULE_3__components_items_relatorioPedidosVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_1__components_items_SpinnerVue__["a" /* default */],
    ToastVue: __WEBPACK_IMPORTED_MODULE_0__components_layouts_toastVue__["a" /* default */],
    relatoriosClientesPendencia: __WEBPACK_IMPORTED_MODULE_4__components_items_relatorioClientesPendenciaVue__["a" /* default */],
    relatoriosClientesRanking: __WEBPACK_IMPORTED_MODULE_5__components_items_relatorioClientesRankingVue__["a" /* default */],
    relatoriosClientesNaoCompram: __WEBPACK_IMPORTED_MODULE_6__components_items_relatorioClientesNaoCompramVue__["a" /* default */],
    relatoriosComissoes: __WEBPACK_IMPORTED_MODULE_7__components_items_relatoriosComissoesVue__["a" /* default */],
    relatorioMetas: __WEBPACK_IMPORTED_MODULE_8__components_items_relatorioMetasVue__["a" /* default */],
    relatorioGerencialVue: __WEBPACK_IMPORTED_MODULE_11__components_items_relatorioGerencialVue__["a" /* default */]
  },
  data: function data() {
    return {
      cor: '',
      headerTextVariant: 'light',
      headerBgVariant: 'dark',
      modalFiltro: false,
      datePicker: {
        dateFormat: 'D MMM',
        buttonDateOne: '',
        buttonDateTwo: '',
        inlineDateOne: '',
        sundayDateOne: '',
        sundayFirst: false,
        alignRight: false,
        trigger: false
      },
      visibility: {
        relCliRanking: false,
        relCliNaoComp: false,
        relCliPendencia: false,
        relPedidos: false,
        relComissoes: false,
        relMetas: false,
        statusRel: true,
        relGerencial: false,
        filtroGerencial: false,
        filtroMesAno: false,
        btnBuscar: false
      },
      showRelMetas: false,
      blockUI: {
        message: '',
        visibility: false
      },
      message: {
        idToast: 'my-toast',
        titleMsg: '',
        message: '',
        variant: ''
      },
      selected: null,
      selectedMes: null,
      anoSelecionado: null,
      metasDados: {
        mesAtual: {},
        porCategoria: [],
        descricaoMes: []
      },
      options: [{ value: null, text: '-- Relatório --' }, { value: '1', text: 'Clientes' }, { value: '2', text: 'Pedidos' }, { value: '3', text: 'Comissões' }, { value: '4', text: 'Metas' }, { value: '5', text: 'Gerencial' }],
      optionsClientes: [{ codigo: 0, descricao: 'Com pendência financeira' }, { codigo: 1, descricao: 'Ranking clientes ult. 6 meses' }, { codigo: 2, descricao: 'Que não compram a 30 dias' }, { codigo: 3, descricao: 'Que não compram a 60 dias' }, { codigo: 4, descricao: 'Que não compram a 90 dias' }],
      optionsMes: [{ mes: 1, descricao: 'Janeiro' }, { mes: 2, descricao: 'Fevereiro' }, { mes: 3, descricao: 'Março' }, { mes: 4, descricao: 'Abril' }, { mes: 5, descricao: 'Maio' }, { mes: 6, descricao: 'Junho' }, { mes: 7, descricao: 'Julho' }, { mes: 8, descricao: 'Agosto' }, { mes: 9, descricao: 'Setembro' }, { mes: 10, descricao: 'Outubro' }, { mes: 11, descricao: 'Novembro' }, { mes: 12, descricao: 'Dezembro' }],
      codigo: null,
      statusPedidos: [],
      statusOrdenados: [],
      resumoComissoes: {},
      statusPedido: null,
      statusSelecionado: {},
      objPedido: [],
      paginacao: {},
      objClientes: [],
      objPaginacao: [],
      relatorioSelecionado: '',
      relatorioGerencialDados: {
        objPorCategorias: []
      }
    };
  },
  created: function created() {
    window.addEventListener('beforeunload', this.toTopOnRefresh);
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.datePicker.buttonDateOne = firstDay.toJSON().slice(0, 10);
    this.datePicker.buttonDateTwo = lastDay.toJSON().slice(0, 10);
    this.selectedMes = date.getMonth();
    this.anoSelecionado = date.getFullYear();
  },

  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    },
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    buscarDados: function buscarDados() {
      if (this.selected === '3') {
        this.listarComissao();
      } else if (this.selected === '4') {
        this.listarMetas();
      } else if (this.selected === '5') {
        this.listarGerencial();
      }
    },
    listarMetas: function listarMetas() {
      var _this = this;

      var json = {
        mesAtual: {
          valorMedio: 0,
          percAtingido: 0,
          valorAtingido: 0,
          valorMeta: 0,
          codRepresentante: ''
        },
        porCategoria: []
      };
      this.metasDados = json;
      this.blockUI.message = 'Listando Metas, aguarde...';
      this.blockUI.visibility = true;
      if (typeof this.anoSelecionado === 'string') {
        this.anoSelecionado = parseInt(this.anoSelecionado);
      }
      var param = { mes: this.selectedMes + 1, ano: this.anoSelecionado
        // console.log(JSON.stringify(param))
      };__WEBPACK_IMPORTED_MODULE_10__services_relatorios__["a" /* default */].listarMetas(param).then(function (response) {
        _this.metasDados = response.data;
        _this.metasDados.porCategoria = response.data.porCategoria.sort(function (a, b) {
          return b.percAtingido - a.percAtingido;
        });
        var mes = '';
        var meses = _this.optionsMes.filter(function (m) {
          return m.mes === _this.selectedMes + 1;
        });
        if (meses.length > 0) {
          mes = meses[0].descricao;
        }
        _this.metasDados.descricaoMes = mes;
        _this.showRelMetas = true;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 500) {
          console.log('500');
          _this.metasDados = [];
          _this.metasDados.porCategoria = [];
          _this.metasDados.mesAtual = {};
        }
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this.blockUI.visibility = false;
      });
    },
    listarGerencial: function listarGerencial() {
      var _this2 = this;

      if (this.datePicker.buttonDateOne === '' || this.datePicker.buttonDateTwo === '') {
        this.showMessage('Selecione um periodo!', 'Atenção', 'danger');
        return;
      }
      this.visibility.relPedidos = false;
      this.blockUI.message = 'Listando Dados, aguarde...';
      this.blockUI.visibility = true;
      var codRepresentante = '';
      var dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'));
      if (dadosAcesso.perfil.id === 3) {
        codRepresentante = dadosAcesso.representante.codigo;
      }
      var param = { codRepresentante: codRepresentante, dataDe: this.datePicker.buttonDateOne, dataAte: this.datePicker.buttonDateTwo };
      __WEBPACK_IMPORTED_MODULE_10__services_relatorios__["a" /* default */].resumoGerencialPeriodo(param).then(function (response) {
        var data = response.data;
        // CATEGORIA
        data.porCategoria = data.porCategoria.sort(function (a, b) {
          return a.ordem - b.ordem;
        });
        // REPRESENTANTE
        data.porRepresentate = data.porRepresentate.sort(function (a, b) {
          return b.valor - a.valor;
        });
        // CLIENTE
        data.porCliente = data.porCliente.sort(function (a, b) {
          return b.valor - a.valor;
        });
        // UF
        data.porUFCliente = data.porUFCliente.sort(function (a, b) {
          return b.valor - a.valor;
        });
        // DIA
        data.porDia = data.porDia.sort(function (a, b) {
          return a.emissaoDateOrder - b.emissaoDateOrder;
        });
        // atualiza a variavel que gerencia o relatorio
        _this2.relatorioGerencialDados = data;
      }).catch(function (error) {
        console.log(error);
        _this2.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this2.blockUI.visibility = false;
      });
    },
    filtrar: function filtrar() {
      var objectPost = { termo: this.termo, codStatus: this.codStatus, emissaoDe: this.dataDe, emissaoAte: this.dataAte };
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('filtrosSelecionados', objectPost);
    },
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        this.dataDe = dateOne;
        var dataFormatada = dateOne.substring(8, 10) + '/' + dateOne.substring(5, 7) + '/' + dateOne.substring(0, 4);
        // console.log(dataFormatada)
        formattedDates = dataFormatada; // dateFns.format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        this.dataAte = dateTwo;
        var _dataFormatada = dateTwo.substring(8, 10) + '/' + dateTwo.substring(5, 7) + '/' + dateTwo.substring(0, 4);
        formattedDates += ' - ' + _dataFormatada; // dateFns.format(dateTwo, this.dateFormat)
      }
      // console.log(formattedDates)
      return formattedDates;
    },
    onClosed: function onClosed() {
      var datesStr = this.formatDates(this.datePicker.buttonDateOne, this.datePicker.buttonDateTwo);
      console.log('Dates Selected: ' + datesStr);
      this.datePicker.trigger = false;
    },
    onMonthChange: function onMonthChange(dates) {
      // console.log('months changed', dates)
    },
    limparFiltro: function limparFiltro() {
      this.termo = '';
      this.statusPedido = null;
      this.dataDe = '';
      this.dataAte = '';
      this.datePicker.buttonDateOne = '';
      this.datePicker.buttonDateTwo = '';
      var objectPost = { termo: '', codStatus: '', emissaoDe: '', emissaoAte: '' };
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('filtrosSelecionados', objectPost);
    },
    showMessage: function showMessage(message, title, variantColor) {
      this.message.message = message;
      this.message.titleMsg = title;
      this.message.variant = variantColor;
      this.$bvToast.show(this.message.idToast);
    },
    listarClientes: function listarClientes(paramCliente) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_relatorios__["a" /* default */].listarClientes(paramCliente).then(function (response) {
        _this3.objClientes = response.data.clientes;
      }).catch(function (error) {
        console.log(error);
        _this3.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this3.blockUI.visibility = false;
      });
    },
    changeClean: function changeClean() {
      this.resumoComissoes = {
        aceite: {},
        extrato: [],
        porCategoria: [],
        valorMes: {
          valor: 0,
          mes: this.selectedMes
        }
      };
      this.resumoComissoes.mes = this.selectedMes + 1;
      this.resumoComissoes.ano = this.anoSelecionado;
      this.visibility.relMetas = true;
      this.showRelMetas = false;
      this.metasDados = {
        mesAtual: {
          valorMedio: 0,
          percAtingido: 0,
          valorAtingido: 0,
          valorMeta: 0,
          codRepresentante: ''
        },
        porCategoria: []
      };
    },
    onChange: function onChange(index) {
      var _this4 = this;

      var statusSelecionado = this.statusOrdenados[index];
      if (typeof statusSelecionado !== 'undefined' && typeof statusSelecionado.codigo !== 'undefined') {
        this.relatorioSelecionado = statusSelecionado.codigo;
      }
      this.metasDados.porCategoria = [];
      this.metasDados.mesAtual = {};
      switch (this.selected) {
        case '1':
          // cliente
          this.blockUI.message = 'Listando Status, aguarde...';
          this.blockUI.visibility = true;
          if (statusSelecionado.codigo === 0) {
            // com pendencia financeira
            this.visibility.relCliRanking = false;
            this.visibility.relCliNaoComp = false;
            this.visibility.relCliPendencia = true;
            var paginacao = this.paginacao.clientesComPendenciaFinanceira;
            this.objPaginacao = paginacao;
            var registrosPorPagina = 50;
            if (paginacao.length > 0) {
              registrosPorPagina = paginacao[0].registrosPorPagina;
            }
            var paramCliente = { tipoRelatorio: statusSelecionado.codigo, paginacao: 0, registrosPorPagina: registrosPorPagina };
            this.listarClientes(paramCliente);
          } else if (statusSelecionado.codigo === 1) {
            // ranking
            this.visibility.relCliRanking = true;
            this.visibility.relCliNaoComp = false;
            this.visibility.relCliPendencia = false;
            var _paginacao = this.paginacao.clientesPorRanking;
            this.objPaginacao = _paginacao;
            var _registrosPorPagina = 50;
            if (_paginacao.length > 0) {
              _registrosPorPagina = _paginacao[0].registrosPorPagina;
            }
            var _paramCliente = { tipoRelatorio: statusSelecionado.codigo, paginacao: 0, registrosPorPagina: _registrosPorPagina };
            this.listarClientes(_paramCliente);
          } else if (statusSelecionado.codigo === 2 || statusSelecionado.codigo === 3 || statusSelecionado.codigo === 4) {
            // 30 - 60 - 90 dias que nao compram
            this.visibility.relCliRanking = false;
            this.visibility.relCliNaoComp = true;
            this.visibility.relCliPendencia = false;
            var _paginacao2 = [];
            if (statusSelecionado.codigo === 2) {
              _paginacao2 = this.paginacao.clientesQueNaoCompramHa30Dias;
            } else if (statusSelecionado.codigo === 3) {
              _paginacao2 = this.paginacao.clientesQueNaoCompramHa60Dias;
            } else if (statusSelecionado.codigo === 4) {
              _paginacao2 = this.paginacao.clientesQueNaoCompramHa90Dias;
            }
            this.objPaginacao = _paginacao2;
            var _registrosPorPagina2 = 50;
            if (_paginacao2.length > 0) {
              _registrosPorPagina2 = _paginacao2[0].registrosPorPagina;
            }
            var _paramCliente2 = { tipoRelatorio: statusSelecionado.codigo, paginacao: 0, registrosPorPagina: _registrosPorPagina2 };
            this.listarClientes(_paramCliente2);
          }
          break;
        case '2':
          // pedidos
          this.blockUI.message = 'Listando Status, aguarde...';
          this.blockUI.visibility = true;
          this.visibility.relPedidos = true;
          // console.log(JSON.stringify(statusSelecionado))
          var paramPedido = { termo: '', codStatus: statusSelecionado.codigo, emissaoDe: '', emissaoAte: '' };
          __WEBPACK_IMPORTED_MODULE_9__services_tablePedidos__["a" /* default */].listarPedidos(paramPedido).then(function (response) {
            // console.log(response.data)
            _this4.statusSelecionado = statusSelecionado;
            if (response.data.pedidos) {
              _this4.objPedido = response.data.pedidos;
            } else {
              _this4.objPedido = [];
            }
            // this.statusOrdenados = response.data.statusPedido.sort(function (a, b) {
            //   return a.ordem - b.ordem
            // })
            // this.statusPedidos = response.data.statusPedido
          }).catch(function (error) {
            console.log(error);
            _this4.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
          }).finally(function () {
            _this4.blockUI.visibility = false;
          });
          break;
        case '3':
          // comissoes
          this.visibility.relComissoes = false;
          break;
        case '4':
          // metas
          this.visibility.relMetas = true;
          this.showRelMetas = false;
          this.metasDados = {
            mesAtual: {
              valorMedio: 0,
              percAtingido: 0,
              valorAtingido: 0,
              valorMeta: 0,
              codRepresentante: ''
            },
            porCategoria: []
          };
          break;
        case '5':
          // gerencial
          break;
      }
    },

    relatorioCliente: function relatorioCliente() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_relatorios__["a" /* default */].listarClientes().then(function (response) {
        _this5.clientes = response.data;
        // console.log(this.clientes)
      });
    },
    segundoFiltroPedidos: function segundoFiltroPedidos() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_tablePedidos__["a" /* default */].listarSelect().then(function (response) {
        _this6.statusOrdenados = response.data.statusPedido.sort(function (a, b) {
          return a.ordem - b.ordem;
        });
        // this.statusPedidos = response.data.statusPedido
      }).catch(function (error) {
        console.log(error);
        _this6.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this6.blockUI.visibility = false;
      });
    },
    segundoFiltroClientes: function segundoFiltroClientes() {
      var _this7 = this;

      this.visibility.relPedidos = false;
      this.blockUI.message = 'Listando Status, aguarde...';
      this.blockUI.visibility = true;
      __WEBPACK_IMPORTED_MODULE_10__services_relatorios__["a" /* default */].listarPaginacaoClientes().then(function (response) {
        _this7.paginacao = response.data;
        _this7.statusOrdenados = _this7.optionsClientes;
      }).catch(function (error) {
        console.log(error);
        _this7.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this7.blockUI.visibility = false;
      });
    },
    selecionarRelatorio: function selecionarRelatorio() {
      // console.log(JSON.stringify(this.selected))
      this.metasDados.porCategoria = [];
      this.metasDados.mesAtual = {};
      this.visibility.statusRel = true;
      this.visibility.relMetas = false;
      this.visibility.relPedidos = false;
      this.visibility.relGerencial = false;
      this.visibility.filtroGerencial = false;
      this.visibility.filtroMesAno = false;
      this.visibility.btnBuscar = false;

      switch (this.selected) {
        case '1':
          this.blockUI.message = 'Listando Relatórios, aguarde...';
          this.blockUI.visibility = true;
          this.segundoFiltroClientes();
          this.visibility.relComissoes = false;
          break;
        case '2':
          this.blockUI.message = 'Listando Relatórios, aguarde...';
          this.blockUI.visibility = true;
          this.segundoFiltroPedidos();
          this.visibility.relComissoes = false;
          this.visibility.relCliRanking = false;
          this.visibility.relCliNaoComp = false;
          this.visibility.relCliPendencia = false;
          break;
        case '3':
          // this.blockUI.message = 'Listando Relatórios, aguarde...'
          // this.blockUI.visibility = true
          this.visibility.filtroMesAno = true;
          this.visibility.relMetas = false;
          this.visibility.relComissoes = true;
          this.visibility.relCliRanking = false;
          this.visibility.relCliNaoComp = false;
          this.visibility.relCliPendencia = false;
          this.visibility.statusRel = false;
          this.visibility.btnBuscar = true;
          this.listarComissao();
          break;
        case '4':
          // this.blockUI.message = 'Listando Relatórios, aguarde...'
          // this.blockUI.visibility = true
          this.visibility.filtroMesAno = true;
          this.visibility.relComissoes = false;
          this.visibility.relMetas = true;
          this.visibility.relCliRanking = false;
          this.visibility.relCliNaoComp = false;
          this.visibility.relCliPendencia = false;
          this.visibility.statusRel = false;
          this.visibility.btnBuscar = true;
          this.listarMetas();
          break;
        case '5':
          this.visibility.relComissoes = false;
          this.visibility.relCliRanking = false;
          this.visibility.relCliNaoComp = false;
          this.visibility.relCliPendencia = false;
          this.visibility.relGerencial = true;
          this.visibility.filtroGerencial = true;
          this.visibility.statusRel = false;
          this.visibility.btnBuscar = true;
          break;
      }
    },
    listarComissao: function listarComissao() {
      var _this8 = this;

      this.blockUI.message = 'Listando Comissões, aguarde...';
      this.blockUI.visibility = true;
      var param = { mes: this.selectedMes + 1, ano: this.anoSelecionado
        // console.log(JSON.stringify(param))
      };__WEBPACK_IMPORTED_MODULE_10__services_relatorios__["a" /* default */].listarComissao(param).then(function (response) {
        _this8.resumoComissoes = response.data;
        _this8.resumoComissoes.mes = _this8.selectedMes + 1;
        _this8.resumoComissoes.ano = _this8.anoSelecionado;
        _this8.visibility.relComissoes = true;
      }).catch(function (error) {
        console.log(error);
        _this8.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this8.blockUI.visibility = false;
      });
    },
    abreModalFiltro: function abreModalFiltro() {
      this.modalFiltro = true;
    }
  }
});

/***/ }),

/***/ "JA57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_relatorios__ = __webpack_require__("OLWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ToastVue: __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__["a" /* default */]
  },
  props: {
    pObjClientes: {},
    pObjPaginacao: {}
  },
  data: function data() {
    return {
      cor: '',
      blockUI: {
        message: '',
        blockUiVisibility: false
      },
      current_page: 1,
      tipoPedido: [],
      statusSelecionado: {},
      clientes: [],
      fieldsClientes: [{
        key: 'codCliente',
        label: 'Cód. Cli.',
        sortable: true,
        class: 'relCliCod'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'relCliFant txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true,
        class: 'relCliRaz txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'cnpjCpf',
        label: 'CNPJ/CPF',
        sortable: true,
        class: 'relCliCnpj',
        formatter: this.formatterCnpjCpf
      }, {
        key: 'telefone',
        label: 'Telefone',
        sortable: true,
        class: 'relCliTel'
      }, {
        key: 'ranking',
        label: 'Ranking',
        sortable: true,
        class: 'relCliRan txtCenter'
      }, {
        key: 'valorPedido',
        label: 'Total R$',
        sortable: true,
        class: 'relCliVal txtRight',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobile',
        class: 'relCliMobile txtLeft'
      }]
    };
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
  },

  watch: {
    pObjClientes: function pObjClientes(newVal, oldVal) {
      // watch it
      // console.log(JSON.stringify(newVal))
      this.clientes = newVal;
    }
  },
  methods: {
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    buscarClientesPorPagina: function buscarClientesPorPagina() {
      var _this = this;

      var paginaCorrente = this.current_page - 1;
      var paginacao = this.pObjPaginacao[paginaCorrente];
      this.blockUI.visibility = true;
      this.blockUI.message = 'Listando clientes, aguarde...';
      // console.log(JSON.stringify(paginacao))
      var paramCliente = { tipoRelatorio: 1, paginacao: paginacao.pagina, registrosPorPagina: paginacao.registrosPorPagina };
      __WEBPACK_IMPORTED_MODULE_0__services_relatorios__["a" /* default */].listarClientes(paramCliente).then(function (response) {
        _this.clientes = response.data.clientes;
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this.blockUI.visibility = false;
      });
    },
    showMessage: function showMessage(message, title, variantColor) {
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast');
    },
    relatorioCliente: function relatorioCliente() {
      var _this2 = this;

      this.blockUI.blockUiVisibility = true;
      this.blockUI.message = 'Listando clientes, aguarde...';
      __WEBPACK_IMPORTED_MODULE_0__services_relatorios__["a" /* default */].listarClientes().then(function (response) {
        _this2.clientes = response.data;
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this2.blockUI.blockUiVisibility = false;
      });
    },
    formatterCnpjCpf: function formatterCnpjCpf(value) {
      if (value.length === 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
      }
      if (value.length === 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
      }
    }
  }
});

/***/ }),

/***/ "JGxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__ = __webpack_require__("05AP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__ = __webpack_require__("SSQZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TablePedidosVue',
  props: ['title'],
  components: {
    spinnerVue: __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__["a" /* default */]
  },
  data: function data() {
    return {
      empresaKatec: false,
      blockUiVisibility: false,
      msgBlockUi: '',
      status: [],
      statusX: [],
      pedidosDoStatus: [],
      codStatusSelecionado: '',
      termo: '',
      codStatus: '',
      dataDe: '',
      dataAte: '',
      // Note 'isActive' is left out and will not appear in the rendered table
      fieldsPedidos: [{
        key: 'id',
        label: 'ID Gosales',
        sortable: true,
        class: 'txtLeft pedListFant'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'txtLeft pedListFant',
        formatter: this.toCapitalize
      }, {
        key: 'statusPedido',
        label: 'Status',
        sortable: true,
        class: 'pedListEmi'
      }, {
        key: 'emissao',
        label: 'Emissão',
        sortable: true,
        class: 'pedListEmi'
      }, {
        key: 'urlImagemCanal',
        label: 'Origem',
        sortable: false,
        class: 'pedListImg'
      }, {
        key: 'totalPedido',
        label: 'Total',
        sortable: true,
        class: 'txtRight pedListTot',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobile',
        class: 'pedListMobile txtLeft'
      }, {
        label: 'Ação',
        key: 'acao',
        class: 'pedListAcoes'
      }],
      fieldsPedidosKatec: [{
        key: 'id',
        label: 'ID Gosales',
        sortable: true,
        class: 'txtLeft pedListFant'
      }, {
        key: 'fantasia',
        label: 'Cliente Reduzido',
        sortable: true,
        class: 'txtLeft pedListFant',
        formatter: this.toCapitalize
      }, {
        key: 'statusPedido',
        label: 'Status',
        sortable: true,
        class: 'pedListEmi'
      }, {
        key: 'emissao',
        label: 'Emissão',
        sortable: true,
        class: 'pedListEmi'
      }, {
        key: 'urlImagemCanal',
        label: 'Origem',
        sortable: false,
        class: 'pedListImg'
      }, {
        key: 'totalPedido',
        label: 'Total',
        sortable: true,
        class: 'txtRight pedListTot',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobile',
        class: 'pedListMobile txtLeft'
      }, {
        label: 'Ação',
        key: 'acao',
        class: 'pedListAcoes'
      }],
      buscaVazia: false
    };
  },
  created: function created() {
    var _this = this;

    var empresa = localStorage.getItem('empresaLogada');
    if (JSON.parse(empresa).identificador === 2355480534) {
      this.empresaKatec = true;
    }
    __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$on('filtrosSelecionados', function (filtros, from) {
      _this.buscaVazia = false;
      if (from === 0) {
        var objectPost = {
          termo: filtros.termo,
          codStatus: filtros.codStatus,
          emissaoDe: filtros.emissaoDe,
          emissaoAte: filtros.emissaoAte
          // console.log(JSON.stringify(objectPost))
        };_this.msgBlockUi = 'Listando pedidos, por favor aguarde...';
        _this.blockUiVisibility = true;
        __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__["a" /* default */].listarPedidos(objectPost).then(function (response) {
          if (response.data.pedidosX.length === 0 && response.data.pedidos.length === 0) {
            _this.buscaVazia = true;
          } else {
            _this.buscaVazia = false;
          }
          _this.status = _this.montaPedidos(response.data.pedidos);
          _this.statusX = _this.montaPedidosX(response.data.pedidosX);
          // console.log(this.status)
          // this.status = this.status.pedidos.sort(function (a, b) {
          //   return a.id - b.id
          // })
          // this.statusX = this.statusX.pedidos.sort(function (a, b) {
          //   return a.id - b.id
          // })
        }).catch(function (error) {
          console.log(error);
          alert('Aconteceu alguma coisa!' + error);
        }).finally(function () {
          _this.blockUiVisibility = false;
        });
      } else {
        _this.status = [];
        _this.statusX = [];
      }
    });
  },
  mounted: function mounted() {
    this.listarSelect();
    //  /api/private/v1/cliente/13121212/000564604540
  },

  methods: {
    montaPedidos: function montaPedidos(pedidos) {
      var statusPedidos = [];
      var pedidosSemStatus = [];

      var _loop = function _loop() {
        var pedido = pedidos[i];
        if (i === 0) {
          var _status = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pedido.status);
          statusPedidos.push(_status);
        } else {
          var statusExistentes = statusPedidos.filter(function (status) {
            return status.codigo === pedido.status.codigo;
          });
          if (statusExistentes.length <= 0) {
            var _status2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pedido.status);
            statusPedidos.push(_status2);
          }
        }
        // delete pedido.status
        pedidosSemStatus.push(pedido);
      };

      for (var i = 0; i < pedidos.length; i++) {
        _loop();
      }
      statusPedidos = statusPedidos.sort(function (a, b) {
        return a.ordem - b.ordem;
      });

      var _loop2 = function _loop2() {
        var status = statusPedidos[indice];
        var pedidosDoStatus = pedidosSemStatus.filter(function (pedido) {
          return pedido.codStatus === status.codigo;
        });
        statusPedidos[indice].pedidos = pedidosDoStatus;
      };

      for (var indice = 0; indice < statusPedidos.length; indice++) {
        _loop2();
      }
      return statusPedidos;
    },
    montaPedidosX: function montaPedidosX(pedidos) {
      var statusPedidos = [];
      var pedidosSemStatus = [];
      pedidos = pedidos.sort(function (a, b) {
        return b.id - a.id;
      });

      var _loop3 = function _loop3() {
        var pedido = pedidos[i];
        if (i === 0) {
          var _status3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pedido.status);
          statusPedidos.push(_status3);
        } else {
          var statusExistentes = statusPedidos.filter(function (status) {
            return status.codigo === pedido.status.codigo;
          });
          if (statusExistentes.length <= 0) {
            var _status4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pedido.status);
            statusPedidos.push(_status4);
          }
        }
        // delete pedido.status
        pedidosSemStatus.push(pedido);
      };

      for (var i = 0; i < pedidos.length; i++) {
        _loop3();
      }
      statusPedidos = statusPedidos.sort(function (a, b) {
        return a.ordem - b.ordem;
      });

      var _loop4 = function _loop4() {
        var status = statusPedidos[indice];
        var pedidosDoStatus = pedidosSemStatus.filter(function (pedido) {
          return pedido.codStatus === status.idStatus;
        });
        statusPedidos[indice].pedidos = pedidosDoStatus;
      };

      for (var indice = 0; indice < statusPedidos.length; indice++) {
        _loop4();
      }
      return statusPedidos;
    },
    listarPedidos: function listarPedidos(objectPost) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__["a" /* default */].listarPedidos(objectPost).then(function (response) {
        _this2.status = response.data.pedidos;
      });
    },
    listarSelect: function listarSelect() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__["a" /* default */].listarSelect().then(function (response) {
        _this3.statusPedidos = response.data.statusPedidos;
      });
    },
    pageEdit: function pageEdit(pedido, index) {
      var _this4 = this;

      this.blockUiVisibility = true;
      var param = { idPedido: pedido.id, isErp: pedido.isErp };
      __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__["a" /* default */].obterPedido(param).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('vizualizarPedido', '');
        var objPedido = { pedido: response.data.pedido, condPagtos: response.data.condPagtos
          // console.log(objPedido)
        };response.data.pedido.cliente.cnpjCpf = response.data.pedido.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '').replace('-', '');
        __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('pedidoSelecionado', objPedido);
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this4.blockUiVisibility = false;
      });
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
});

/***/ }),

/***/ "JqBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K8Ct":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KHI7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-carousel',{staticClass:"m-0",attrs:{"id":"carousel1","controls":"","indicators":"","interval":3000},on:{"sliding-start":_vm.onSlideStart,"sliding-end":_vm.onSlideEnd},model:{value:(_vm.slide),callback:function ($$v) {_vm.slide=$$v},expression:"slide"}},_vm._l((_vm.destaques),function(destaque,index){return _c('b-carousel-slide',{key:destaque.index,staticClass:"img-fluid",attrs:{"caption":destaque.index,"img-src":destaque.url}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LHVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableClientesVue_vue__ = __webpack_require__("YETF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60939d90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableClientesVue_vue__ = __webpack_require__("xCYA");
function injectStyle (ssrContext) {
  __webpack_require__("Guud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60939d90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableClientesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60939d90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableClientesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LPat":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dashboard__ = __webpack_require__("39Xj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      destaques: [],
      slide: 0,
      descricao: ''
    };
  },

  methods: {
    onSlideStart: function onSlideStart(index) {
      var descricao = this.destaques[index].descricao;
      this.descricao = descricao;
    },
    onSlideEnd: function onSlideEnd(index) {
      var descricao = this.destaques[index].descricao;
      this.descricao = descricao;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_dashboard__["a" /* default */].listarDashboard().then(function (response) {
      _this.destaques = response.data.destaques;
    });
  }
});

/***/ }),

/***/ "LVXU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ljhw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lzip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_items_NewItemsCatalogoVue__ = __webpack_require__("hERF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_TableCatalGradeVue__ = __webpack_require__("+bo8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_items_cardCategoriasVue__ = __webpack_require__("PXiq");
//
//
//
//
//
//
//
//
//
//
//



// import TableCatalogoVue from '@/components/items/TableCatalogoVue'




/* harmony default export */ __webpack_exports__["a"] = ({
  cor: '',
  name: 'Catalogo',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */],
    NewItemsCatalogoVue: __WEBPACK_IMPORTED_MODULE_1__components_items_NewItemsCatalogoVue__["a" /* default */],
    // TableCatalogoVue,
    TableCatalGradeVue: __WEBPACK_IMPORTED_MODULE_2__components_items_TableCatalGradeVue__["a" /* default */],
    CardCategoriasVue: __WEBPACK_IMPORTED_MODULE_4__components_items_cardCategoriasVue__["a" /* default */]
  },
  data: function data() {
    return {
      isModoLista: true
    };
  },
  created: function created() {
    var _this = this;

    window.addEventListener('beforeunload', this.toTopOnRefresh);
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp')
      // console.log('modo: ' + JSON.stringify(modo.LISTA))
    };__WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$on('pageViewGrade', function (parametro) {
      _this.isModoLista = parametro.modo === __WEBPACK_IMPORTED_MODULE_3__main__["modo"].LISTA;
    });
  },

  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "M37V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_relatorios__ = __webpack_require__("OLWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ToastVue: __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__["a" /* default */]
  },
  props: {
    pObjClientes: {},
    pObjPaginacao: {},
    pTipoRelatorio: {}
  },
  data: function data() {
    return {
      cor: '',
      current_page: 1,
      blockUI: {
        message: '',
        blockUiVisibility: false
      },
      tipoPedido: [],
      statusSelecionado: {},
      clientes: [],
      fieldsClientes: [{
        key: 'codCliente',
        label: 'Cód. Cli.',
        sortable: true,
        class: 'relCliCod'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'relCliFant txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true,
        class: 'relCliRaz txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'cnpjCpf',
        label: 'CNPJ/CPF',
        sortable: true,
        class: 'relCliCnpj',
        formatter: this.formatterCnpjCpf
      }, {
        key: 'telefone',
        label: 'Telefone',
        sortable: true,
        class: 'relCliTel'
      }, {
        key: 'emissao',
        label: 'Emissão',
        sortable: true,
        class: 'relCliVen txtCenter'
      }, {
        key: 'valor',
        label: 'Total R$',
        sortable: true,
        class: 'relCliVal txtRight',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobile',
        class: 'relCliMobile txtLeft'
      }]
    };
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
  },

  watch: {
    pObjClientes: function pObjClientes(newVal, oldVal) {
      // watch it
      // console.log(JSON.stringify(newVal))
      this.clientes = newVal;
    }
  },
  methods: {
    buscarClientesPorPagina: function buscarClientesPorPagina() {
      var _this = this;

      var paginaCorrente = this.current_page - 1;
      var paginacao = this.pObjPaginacao[paginaCorrente];
      this.blockUI.visibility = true;
      this.blockUI.message = 'Listando clientes, aguarde...';
      // console.log(JSON.stringify(paginacao))
      var paramCliente = { tipoRelatorio: this.pTipoRelatorio, paginacao: paginacao.pagina, registrosPorPagina: paginacao.registrosPorPagina };
      __WEBPACK_IMPORTED_MODULE_0__services_relatorios__["a" /* default */].listarClientes(paramCliente).then(function (response) {
        _this.clientes = response.data.clientes;
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this.blockUI.visibility = false;
      });
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterCnpjCpf: function formatterCnpjCpf(value) {
      if (value.length === 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
      }
      if (value.length === 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
      }
    },
    showMessage: function showMessage(message, title, variantColor) {
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast');
    },
    relatorioCliente: function relatorioCliente() {
      var _this2 = this;

      this.blockUI.blockUiVisibility = true;
      this.blockUI.message = 'Listando clientes, aguarde...';
      __WEBPACK_IMPORTED_MODULE_0__services_relatorios__["a" /* default */].listarClientes().then(function (response) {
        _this2.clientes = response.data;
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this2.blockUI.blockUiVisibility = false;
      });
    },
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194602ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("YW99");
function injectStyle (ssrContext) {
  __webpack_require__("ruqP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194602ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  pesquisarGrades: function pesquisarGrades(termo) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/grades?termo=' + termo);
  },
  detalheGrade: function detalheGrade(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/gradeProdutos?' + 'codigoGrade=' + param.codigoGrade + '&codProduto=' + param.codProduto + '&codigoTabelaPreco=' + param.codigoTabelaPreco);
  }
});

/***/ }),

/***/ "MW12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  listarTabelaDefault: function listarTabelaDefault() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/tabelaPrecoRepresentante');
  },
  listarNovidades: function listarNovidades() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/dashboard');
  },
  listarCategorias: function listarCategorias(termo) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/catalogoGradeProdutos?termo=' + termo);
  },
  listarBanners: function listarBanners() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/banners');
  },
  detalhesItemCategoria: function detalhesItemCategoria(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/gradeProdutos?' + 'codigoGrade=' + param.codigoGrade + '&codigoTabelaPreco=' + param.codigoTabelaPreco);
  },
  detalhesItemNovidade: function detalhesItemNovidade(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/gradeProdutos?' + 'codProduto=' + param.codigoProduto + '&codigoTabelaPreco=' + param.codigoTabelaPreco);
  },
  selecionar: function selecionar() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/dadosTabelasCliente');
  }
});

/***/ }),

/***/ "MfZd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalAddItensVue_vue__ = __webpack_require__("Ml/2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8d0fc5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalAddItensVue_vue__ = __webpack_require__("aCXL");
function injectStyle (ssrContext) {
  __webpack_require__("cmLO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f8d0fc5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalAddItensVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8d0fc5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalAddItensVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ml/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_tablePedidos__ = __webpack_require__("05AP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_money__ = __webpack_require__("9VIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_money__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import listarPedido from '@/services/tablePedidos'






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pedidoSelecionado: {}
  },
  name: 'modalItens',
  data: function data() {
    return {
      empresaKatec: false,
      dateTime: '',
      mostraCodBarras: true,
      desabilitaVariante: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      meu_valor: '0,00',
      idToastItem: 'my-toast-item',
      titleMsg: '',
      message: '',
      variant: '',
      previsao: {
        data: '',
        quantidade: ''
      },
      tabela: {},
      title: '',
      msgBlockUi: 'Salvando item do pedido, aguarde...',
      tabelaLote: false,
      quantidade: false,
      opcoesSobMedida: false,
      lotes: [],
      fields: [{
        isActive: true,
        label: 'Lote',
        key: 'numeroLote'
      }, {
        isActive: true,
        label: 'SubLote',
        key: 'subLote'
      }, {
        isActive: true,
        label: 'Quantidade',
        key: 'quantidade'
      }],
      selectMode: 'multi',
      selected: null,
      options: [{ value: 0, text: 'Por favor, selecione uma opção' }, { value: 1, text: 'Overlock 4 lados, sem borda' }, { value: 2, text: 'Borda virada, largura e overlock comprimento' }, { value: 3, text: 'Borda virada nos 4 lados' }],
      blockUiVisibility: false,
      detalhesItemPedido: '',
      gradeProdutos: {},
      exibeModal: false,
      tamanhos: [],
      tamanhoSelecionado: {},
      coresTamanhos: [],
      cores: [],
      corSelecionada: {},
      indiceCorSelecionada: 0,
      produtoSelecionado: {
        lotes: []
      },
      itemPedido: {
        corteRedondo: 0,
        bonificado: 0,
        numItemPedCompra: '',
        chaveErpPedido: '',
        lotes: [],
        valorICMSST: 0,
        valorTabela: 0,
        comprimento: 0,
        percDesconto: 0,
        numPedCompra: '',
        tipoVarianteSobreMedida: 0,
        codProduto: '',
        chaveErp: '',
        valorUnitario: 0,
        valorIPI: 0,
        largura: 0,
        qtdVenda: 0,
        observacao: ''
      },
      swiperOptionVariantes: {
        slidesPerView: 4,
        spaceBetween: 6,
        freeMode: true,
        navigation: {
          nextEl: '.swprBtnVarNext',
          prevEl: '.swprBtnVarPrev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOptionTamanhos: {
        slidesPerView: 3,
        spaceBetween: 3,
        freeMode: true,
        navigation: {
          nextEl: '.swprBtnTamNext',
          prevEl: '.swprBtnTamPrev'
        }
      },
      objToCalc: '',
      valorUnitarioSemFormat1: 0,
      valorTabelaSemFormat1: 0,
      valorIPISemFormat1: 0,
      valorICMSSTSemFormat1: 0,
      qtdVendaSemFormat1: 0,
      pedidoSelecEditar: '',
      pesqVariante: '',
      pesqTamanho: '',
      NOVO_ITEM: 0,
      EDICAO_ITEM: 1,
      indexTamSelecEdicao: 0,
      indexVarSelecEdicao: 0,
      itemExistPed: 0,
      disableButton: false
      // ,disableButton: true
    };
  },

  components: {
    ToastVue: __WEBPACK_IMPORTED_MODULE_9__layouts_toastVue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiperSlide"],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__["TheMask"],
    VMoney: __WEBPACK_IMPORTED_MODULE_10_v_money__["VMoney"]
  },
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__["mask"],
    money: __WEBPACK_IMPORTED_MODULE_10_v_money__["VMoney"]
  },
  created: function created() {
    var _this = this;

    var empresa = localStorage.getItem('empresaLogada');
    if (JSON.parse(empresa).identificador === 2355480534) {
      this.empresaKatec = true;
    }
    this.corEmpresa = { 'background-color': '#' + localStorage.getItem('corApp') };
    this.corEmpresa2 = '#' + localStorage.getItem('corApp');
    __WEBPACK_IMPORTED_MODULE_7__main__["broadcastServer"].$on('abreModaltens', function (param) {
      _this.carregaInfosGradeSelec(param, _this.NOVO_ITEM);
      // this.disabled = false
      // this.dataHoraEstoque()
      // this.gradeProdutos = param.gradeProdutos
      // this.tabela = param.tabela
      // let tamanhos = []
      // let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
      // for (var iTam = 0; iTam < tamanhosGrade.length; iTam++) {
      //   let tamanho = tamanhosGrade[iTam]
      //   if (iTam === 0) {
      //     tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active', count: 0, indexOrig: iTam})
      //     this.tamanhoSelecionado = {codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active', count: 0, indexOrig: iTam}
      //   } else {
      //     tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: '', count: 0, indexOrig: iTam})
      //   }
      // }
      // this.tamanhos = tamanhos
      // this.atualizarQtdesTamanho(this.pedidoSelecionado.itens)
      // this.exibeModal = true
      // if (this.tamanhos.length > 0) {
      //   this.selecionarCores(0)
      // }
      // let empresa = localStorage.getItem('empresaLogada')
      // if (JSON.parse(empresa).identificador === 2355480534) {
      //   this.mostraCodBarras = false
      // }
    });
    __WEBPACK_IMPORTED_MODULE_7__main__["broadcastServer"].$on('editarItemPedido', function (param) {
      _this.carregaInfosGradeSelec(param, _this.EDICAO_ITEM);
      //   this.dataHoraEstoque()
      //   this.pedidoSelecEditar = param.itemPedido
      //   this.itemPedido = param.itemPedido
      //   this.gradeProdutos = param.gradeProdutos
      //   this.tabela = param.tabela
      //   // desabilita swipers
      //   this.disabled = true
      //   let tamanhos = []
      //   let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
      //   for (var iTam = 0; iTam < tamanhosGrade.length; iTam++) {
      //     let tamanho = tamanhosGrade[iTam]
      //     if (tamanho.codigoTamanho === param.itemPedido.codigoTamanho) {
      //       tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active'})
      //       this.tamanhoSelecionado = {codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active'}
      //     }
      //   }
      //   this.tamanhos = tamanhos

      //   // cores
      //   this.cores = []
      //   this.coresTamanhos = []
      //   let cores = this.gradeProdutos.produtos.filter(prod => prod.codigoCor === param.itemPedido.codigoCor)
      //   if (cores.length > 0) {
      //     this.produtoSelecionado = {lotes: []}
      //     this.cores.push({cor: cores[0], classe: 'imgSelecionada'})
      //     this.corSelecionada = {cor: cores[0], classe: 'imgSelecionada'}
      //     this.coresTamanhos = cores
      //     this.selecionarProduto(this.cores[0].cor, 0, 1)
      //   }
      //   this.exibeModal = true
      //   let empresa = localStorage.getItem('empresaLogada')
      //   if (JSON.parse(empresa).identificador === 2355480534) {
      //     this.mostraCodBarras = false
      //   }
    });
  },
  computed: {
    qtdVenda: {
      get: function get() {
        return this.formatPrice(this.itemPedido.qtdVenda);
      },
      set: function set(newValue) {
        this.itemPedido.qtdVenda = newValue;
      }
    },
    variantesFiltradas: function variantesFiltradas() {
      var _this2 = this;

      return this.cores.filter(function (item) {
        return item.cor.codigo.toLowerCase().includes(_this2.pesqVariante.toLowerCase()) || item.cor.codigoCor.toLowerCase().includes(_this2.pesqVariante.toLowerCase()) || item.cor.descricaoCor.toLowerCase().includes(_this2.pesqVariante.toLowerCase()) || item.cor.descricao.toLowerCase().includes(_this2.pesqVariante.toLowerCase());
      });
    },
    tamanhosFiltrados: function tamanhosFiltrados() {
      var _this3 = this;

      // console.log(this.tamanhos.length)
      return this.tamanhos.filter(function (item) {
        return item.codigoTamanho.toLowerCase().includes(_this3.pesqTamanho.toLowerCase()) || item.descricaoTamanho.toLowerCase().includes(_this3.pesqTamanho.toLowerCase());
      });
    }
  },
  methods: {
    carregaInfosGradeSelec: function carregaInfosGradeSelec(param, from) {
      // console.log('carregaInfosGradeSelec começo: ' + new Date())
      this.disabled = false;
      this.dataHoraEstoque();
      this.gradeProdutos = param.gradeProdutos;
      this.tabela = param.tabela;
      var tamanhos = [];
      // let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
      var tamanhosGrade = [{
        gradeProdutos: param.gradeProdutos,
        tamanhos: param.gradeProdutos.tamanhos,
        codigoGrade: param.gradeProdutos.codigoGrade
      }];
      tamanhosGrade[0].tamanhos = tamanhosGrade[0].tamanhos.sort(function (a, b) {
        return a.descricaoTamanho > b.descricaoTamanho ? 1 : b.descricaoTamanho > a.descricaoTamanho ? -1 : 0;
      });
      // console.log('array tamanhos começo: ' + new Date())
      for (var iTam = 0; iTam < tamanhosGrade[0].tamanhos.length; iTam++) {
        var tamanho = tamanhosGrade[0].tamanhos[iTam];
        if (from === this.NOVO_ITEM) {
          if (iTam === 0) {
            tamanhos.push({ codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: iTam });
            this.tamanhoSelecionado = { codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: iTam };
          } else {
            tamanhos.push({ codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: '', count: 0, indexOrig: iTam });
          }
        } else {
          this.indexTamSelecEdicao = tamanhosGrade[0].tamanhos.findIndex(function (tam) {
            return tam.codigoTamanho === param.itemPedido.codigoTamanho;
          });
          this.tamanhoSelecionado = { codigoTamanho: param.itemPedido.codigoTamanho, descricaoTamanho: param.itemPedido.descTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: this.indexTamSelecEdicao
            // console.log(this.indexTamSelecEdicao)
          };if (iTam === this.indexTamSelecEdicao) {
            tamanhos.push({ codigoTamanho: param.itemPedido.codigoTamanho, descricaoTamanho: param.itemPedido.descTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: this.indexTamSelecEdicao });
          } else {
            tamanhos.push({ codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: '', count: 0, indexOrig: iTam });
          }
        }
      }
      // console.log('array tamanhos fim: ' + new Date())
      this.tamanhos = tamanhos;
      this.atualizarQtdesTamanho(this.pedidoSelecionado.itens);
      this.limparFiltroMod();
      this.limparFiltroVar();
      this.exibeModal = true;
      if (this.tamanhos.length > 0) {
        if (from === this.NOVO_ITEM) {
          this.selecionarCores(0, this.NOVO_ITEM, '');
        } else {
          this.selecionarCores(this.indexTamSelecEdicao, this.EDICAO_ITEM, param);
        }
      }
      var empresa = localStorage.getItem('empresaLogada');
      if (JSON.parse(empresa).identificador === 2355480534) {
        this.mostraCodBarras = false;
      }
      // console.log('carregaInfosGradeSelec fim: ' + new Date())
    },
    atualizarQtdesTamanho: function atualizarQtdesTamanho(itens) {
      // console.log('atualizarQtdesTamanho começo: ' + new Date())
      // let itemTamanhoSoma = []
      // itens.reduce(function (res, value) {
      //   if (!res[value.codigoTamanho]) { // value.codigoTamanho
      //     res[value.codigoTamanho] = { codigoTamanho: value.codigoTamanho, count: 0, codigoGrade: value.codigoGrade }
      //     itemTamanhoSoma.push(res[value.codigoTamanho])
      //   }
      //   res[value.codigoTamanho].count += value.qtdVenda
      //   return res
      // }, {})
      var itemTamanhoSoma = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(itens.reduce(function (res, value) {
        var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([value.codigoTamanho, value.codigoGrade]);
        if (!res.has(key)) res.set(key, { codigoTamanho: value.codigoTamanho, count: 0, codigoGrade: value.codigoGrade });
        res.get(key).count += value.qtdVenda;
        return res;
      }, new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a()).values()));
      // console.log(itemTamanhoSoma)
      this.tamanhos.forEach(function (keyTamanho, valueTamanho) {
        itemTamanhoSoma.forEach(function (keyItem, valueItem) {
          if (keyItem.codigoTamanho === keyTamanho.codigoTamanho && keyItem.codigoGrade === keyTamanho.codigoGrade) {
            keyTamanho.count = keyItem.count;
          }
        });
      });
      // console.log('atualizarQtdesTamanho fim: ' + new Date())
    },
    atualizarQtdesVariantes: function atualizarQtdesVariantes(itens) {
      // console.log('atualizarQtdesVariantes começo: ' + new Date())
      // this.cores.forEach(function (keyCor, valueCor) {
      //   itens.forEach(function (keyItemCor, valueItemCor) {
      //     // if (keyItemCor.codProduto === keyCor.cor.codigo) {
      //     if (keyItemCor.codigoTamanho === keyCor.cor.codigoTamanho && keyItemCor.codigoCor === keyCor.cor.codigoCor && keyItemCor.codProduto === keyCor.cor.codigo) {
      //       keyCor.count = keyItemCor.qtdVenda
      //     }
      //   })
      // })
      this.cores.forEach(function (keyCor, valueCor) {
        itens.forEach(function (keyItemCor, valueItemCor) {
          // if (keyItemCor.codProduto === keyCor.cor.codigo) {
          if (keyItemCor.codigoTamanho === keyCor.cor.codigoTamanho && keyItemCor.codigoCor === keyCor.cor.codigoCor && keyItemCor.codProduto === keyCor.cor.codigo) {
            keyCor.count = keyItemCor.qtdVenda;
          }
        });
      });
      // console.log('atualizarQtdesVariantes fim: ' + new Date())
    },
    refreshPedido: function refreshPedido(objPedido) {
      // console.log('refresh começo: ' + new Date())
      this.pedido = objPedido.pedido;
      // console.log('refresh fim: ' + new Date())
    },
    dataHoraEstoque: function dataHoraEstoque() {
      var today = new Date();
      var date = ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear().toString().substr(-2);
      var hour = ('0' + today.getHours()).slice(-2);
      var minute = ('0' + today.getMinutes()).slice(-2);
      var seconds = ('0' + today.getSeconds()).slice(-2);
      var time = hour + ':' + minute + ':' + seconds;
      this.dateTime = date + ' - ' + time;
    },
    verificaFormatoValores: function verificaFormatoValores() {
      if (typeof this.itemPedido.valorUnitario === 'string') {
        this.valorUnitarioSemFormat1 = parseFloat(this.itemPedido.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.valorUnitarioSemFormat1 = this.itemPedido.valorUnitario;
      }
      if (typeof this.itemPedido.valorDesconto === 'string') {
        this.valorDescontoSemFormat1 = parseFloat(this.itemPedido.valorDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.valorDescontoSemFormat1 = this.itemPedido.valorDesconto;
      }
      if (typeof this.itemPedido.valorTabela === 'string') {
        this.valorTabelaSemFormat1 = parseFloat(this.itemPedido.valorTabela.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.valorTabelaSemFormat1 = this.itemPedido.valorTabela;
      }
      if (typeof this.itemPedido.percDesconto === 'string') {
        this.percDescontoSemFormat1 = parseFloat(this.itemPedido.percDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.percDescontoSemFormat1 = this.itemPedido.percDesconto;
      }
      if (typeof this.itemPedido.valorIPI === 'string') {
        this.valorIPISemFormat1 = parseFloat(this.itemPedido.valorIPI.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.valorIPISemFormat1 = this.itemPedido.valorIPI;
      }
      if (typeof this.itemPedido.valorICMSST === 'string') {
        this.valorICMSSTSemFormat1 = parseFloat(this.itemPedido.valorICMSST.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.valorICMSSTSemFormat1 = this.itemPedido.valorICMSST;
      }
      if (typeof this.itemPedido.qtdVenda === 'string') {
        this.qtdVendaSemFormat1 = parseFloat(this.itemPedido.qtdVenda.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      } else {
        this.qtdVendaSemFormat1 = this.itemPedido.qtdVenda;
      }
    },
    redondoMudaVariante: function redondoMudaVariante() {
      // Esta função está funcionando com as condições ao contrário pois o copilador está pegando o ultimo estado do switch e nao o atual
      if (this.itemPedido.corteRedondo) {
        this.desabilitaVariante = false;
      } else {
        this.itemPedido.tipoVarianteSobreMedida = 1;
        this.desabilitaVariante = true;
      }
    },
    showMessage: function showMessage(message, title, variantColor, from) {
      console.log('from: ' + from + ' / message: ' + message);
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast-item');
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatQtde: function formatQtde(qtde) {
      if (typeof qtde !== 'undefined') {
        return qtde.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },
    desabilitaBotao: function desabilitaBotao() {
      this.disableButton = true;
    },
    calcularTributos: function calcularTributos(fromInput) {
      var _this4 = this;

      // console.log('calcularTributos começo: ' + new Date())
      this.disableButton = false;
      if (fromInput === 3) {
        fromInput = this.produtoSelecionado.precoTabela === this.valorUnitarioSemFormat1 ? 1 : 2;
      }
      this.verificaFormatoValores();
      this.objToCalc = {
        id: this.itemPedido.id,
        idPedido: this.pedidoSelecionado.id,
        qtdVenda: this.qtdVendaSemFormat1,
        codProduto: this.itemPedido.codProduto,
        valorTabela: this.valorTabelaSemFormat1,
        percDesconto: this.percDescontoSemFormat1,
        valorUnitario: this.valorUnitarioSemFormat1,
        valorDesconto: this.valorDescontoSemFormat1,
        fromInput: fromInput
        // console.log(this.objToCalc)
      };this.blockUiVisibility = true;
      this.msgBlockUi = 'Calculando valores, aguarde...';
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.objToCalc));
      __WEBPACK_IMPORTED_MODULE_8__services_tablePedidos__["a" /* default */].calcularTributos(this.objToCalc).then(function (response) {
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data));
        _this4.itemPedido.percDesconto = response.data.percDesconto;
        _this4.itemPedido.valorUnitario = _this4.formatPrice(response.data.valorUnitario);
        _this4.itemPedido.valorTabela = _this4.formatPrice(response.data.valorTabela);
        _this4.itemPedido.valorICMSST = _this4.formatPrice(response.data.valorICMSST);
        _this4.itemPedido.valorIPI = _this4.formatPrice(response.data.valorIPI);
        _this4.itemPedido.valorDesconto = _this4.formatPrice(response.data.valorDesconto);
        _this4.itemPedido.totalItem = _this4.formatPrice(response.data.totalItem);
        _this4.itemPedido.qtdVenda = _this4.formatQtde(response.data.qtdVenda);
        if (typeof response.data.valorUnitario === 'string') {
          _this4.valorUnitarioSemFormat1 = parseFloat(response.data.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
        } else {
          _this4.valorUnitarioSemFormat1 = response.data.valorUnitario;
        }
        // console.log('calcularTributos meio: ' + new Date())
      }).catch(function (error) {
        console.log(error.message);
        // this.showMessage('Aconteceu alguma coisa!' + error.message, 'Atenção', 'danger', 'calcularTributos erro')
      }).finally(function () {
        _this4.blockUiVisibility = false;
        // console.log('calcularTributos fim: ' + new Date())
      });
    },
    selecionarCores: function selecionarCores(indiceTamanhoSelecionado, from, param) {
      // console.log('selecionarCores começo: ' + new Date())
      this.produtoSelecionado = { lotes: [] };
      for (var iTam = 0; iTam < this.tamanhos.length; iTam++) {
        this.tamanhos[iTam].active = '';
        if (indiceTamanhoSelecionado === iTam) {
          this.tamanhos[iTam].active = 'active';
        }
      }
      // let tamanho = this.gradeProdutos.produtos[indiceTamanhoSelecionado]
      var tamanhosGrade = [{
        gradeProdutos: this.gradeProdutos,
        tamanhos: this.gradeProdutos.tamanhos,
        codigoGrade: this.gradeProdutos.codigoGrade
      }];
      var tamanho = tamanhosGrade[0].gradeProdutos.tamanhos[indiceTamanhoSelecionado];
      this.tamanhoSelecionado = tamanho;
      // let cores = this.gradeProdutos.produtos.filter(prod => prod.codigoTamanho === tamanho.codigoTamanho)
      var cores = tamanhosGrade[0].gradeProdutos.produtos.filter(function (prod) {
        return prod.codigoTamanho === tamanho.codigoTamanho;
      });
      this.cores = [];
      for (var iCor = 0; iCor < cores.length; iCor++) {
        var cor = cores[iCor];
        if (from === this.NOVO_ITEM) {
          if (iCor === 0) {
            this.cores.push({ cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor });
            this.corSelecionada = { cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor };
          } else {
            this.cores.push({ cor: cor, classe: 'imgNaoSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor });
          }
        } else {
          if (param.itemPedido.codigoCor !== '') {
            this.indexVarSelecEdicao = cores.findIndex(function (tam) {
              return tam.codigoCor === param.itemPedido.codigoCor;
            });
          } else {
            this.indexVarSelecEdicao = 0;
          }
          if (iCor === this.indexVarSelecEdicao) {
            this.cores.push({ cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: this.indexVarSelecEdicao });
            this.corSelecionada = { cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: this.indexVarSelecEdicao };
          } else {
            this.cores.push({ cor: cor, classe: 'imgNaoSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor });
          }
        }
      }
      this.coresTamanhos = cores;
      this.atualizarQtdesVariantes(this.pedidoSelecionado.itens);
      if (this.cores.length > 0) {
        if (from === this.NOVO_ITEM) {
          this.selecionarProduto(this.cores[0].cor, 0, 0);
        } else {
          this.selecionarProduto(this.corSelecionada.cor, this.indexVarSelecEdicao, 0);
        }
      }
      // console.log('selecionarCores fim: ' + new Date())
    },
    selecionarProduto: function selecionarProduto(corSelecionada, indiceCorSelecionada, from) {
      var _this5 = this;

      // console.log('selec produto começo: ' + new Date())
      this.dataHoraEstoque();
      this.produtoSelecionado = { lotes: [] };
      this.corSelecionada = corSelecionada;
      this.indiceCorSelecionada = indiceCorSelecionada;
      for (var iCor = 0; iCor < this.cores.length; iCor++) {
        this.cores[iCor].classe = 'imgNaoSelecionada';
        if (indiceCorSelecionada === iCor) {
          this.cores[iCor].classe = 'imgSelecionada';
        }
      }
      var produtos = this.gradeProdutos.produtos.filter(function (prod) {
        return prod.codigoTamanho === _this5.tamanhoSelecionado.codigoTamanho && prod.codigoCor === corSelecionada.codigoCor;
      });
      if (produtos.length > 0) {
        this.produtoSelecionado = produtos[0];
        var itemExistPed = this.pedidoSelecionado.itens.filter(function (item) {
          return item.codProduto === produtos[0].codigo;
        });
        if (itemExistPed.length > 0) {
          this.itemExistPed = 1;
        } else {
          this.itemExistPed = 0;
        }
        this.previsao.data = this.produtoSelecionado.previsao.length === 0 ? 'Sem Previsão' : this.produtoSelecionado.previsao[0].dataPrevisao;
        this.previsao.quantidade = this.produtoSelecionado.previsao.length === 0 ? '' : this.produtoSelecionado.previsao[0].quantidade;
        if (this.produtoSelecionado.vendaSobMedidaM2 === 1) {
          this.opcoesSobMedida = true;
          this.tabelaLote = false;
          this.quantidade = false;
        } else if (this.produtoSelecionado.lotes.length > 0) {
          this.tabelaLote = true;
          this.quantidade = false;
          this.opcoesSobMedida = false;
        } else {
          this.tabelaLote = false;
          this.quantidade = true;
          this.opcoesSobMedida = false;
        }
        if (from === 0) {
          this.novoItemPedido();
          this.valorUnitarioSemFormat1 = this.itemPedido.valorUnitario;
          this.valorTabelaSemFormat1 = this.itemPedido.valorTabela;
          this.percDescontoSemFormat1 = this.itemPedido.percDesconto;
          var produtoSelecionado = this.produtoSelecionado;
          // let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codProduto === this.produtoSelecionado.codigo)
          // let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codigoTamanho === this.produtoSelecionado.codigoTamanho && item.codigoCor === this.produtoSelecionado.codigoCor)
          var itemSelecPedido = this.pedidoSelecionado.itens.filter(function (item) {
            return item.codigoTamanho === produtoSelecionado.codigoTamanho && item.codigoCor === produtoSelecionado.codigoCor && item.codProduto === produtoSelecionado.codigo;
          });
          itemSelecPedido = itemSelecPedido[0];
          if (itemSelecPedido) {
            this.itemPedido.id = itemSelecPedido.id;
            this.itemPedido.corteRedondo = itemSelecPedido.corteRedondo;
            this.itemPedido.bonificado = itemSelecPedido.bonificado;
            this.itemPedido.numItemPedCompra = itemSelecPedido.numItemPedCompra;
            this.itemPedido.lotes = itemSelecPedido.lotes;
            this.itemPedido.valorICMSST = this.formatPrice(itemSelecPedido.valorICMSST);
            this.itemPedido.valorTabela = this.formatPrice(itemSelecPedido.valorTabela);
            this.itemPedido.comprimento = itemSelecPedido.comprimento;
            this.itemPedido.percDesconto = itemSelecPedido.percDesconto;
            this.itemPedido.numPedCompra = itemSelecPedido.numPedCompra;
            this.itemPedido.tipoVarianteSobreMedida = itemSelecPedido.tipoVarianteSobreMedida;
            this.itemPedido.codProduto = itemSelecPedido.codProduto;
            this.itemPedido.valorUnitario = this.formatPrice(itemSelecPedido.valorUnitario);
            this.itemPedido.valorIPI = this.formatPrice(itemSelecPedido.valorIPI);
            this.itemPedido.valorDesconto = this.formatPrice(itemSelecPedido.valorDesconto);
            this.itemPedido.valorBruto = this.formatPrice(itemSelecPedido.valorBruto);
            this.itemPedido.percentualIpi = itemSelecPedido.percentualIpi;
            this.itemPedido.valorLiquido = this.formatPrice(itemSelecPedido.valorLiquido);
            this.itemPedido.descTamanho = this.formatPrice(itemSelecPedido.descTamanho);
            this.itemPedido.totalItem = this.formatPrice(itemSelecPedido.totalItem);
            this.itemPedido.largura = itemSelecPedido.largura;
            this.itemPedido.qtdVenda = itemSelecPedido.qtdVenda;
            // console.log(this.itemPedido)
          }
          this.calcularTributos(1);
        } else {
          var paramPerc = this.produtoSelecionado.precoTabela === this.pedidoSelecEditar.valorUnitario ? 1 : 2;
          this.valorUnitarioSemFormat1 = this.pedidoSelecEditar.valorUnitario;
          this.valorTabelaSemFormat1 = this.pedidoSelecEditar.valorTabela;
          this.percDescontoSemFormat1 = this.pedidoSelecEditar.percDesconto;
          var _itemSelecPedido = this.pedidoSelecionado.itens.filter(function (item) {
            return item.codProduto === _this5.produtoSelecionado.codigo;
          });
          _itemSelecPedido = _itemSelecPedido[0];
          if (_itemSelecPedido) {
            this.itemPedido.id = _itemSelecPedido.id;
            this.itemPedido.corteRedondo = _itemSelecPedido.corteRedondo;
            this.itemPedido.bonificado = _itemSelecPedido.bonificado;
            this.itemPedido.numItemPedCompra = _itemSelecPedido.numItemPedCompra;
            this.itemPedido.lotes = _itemSelecPedido.lotes;
            this.itemPedido.valorICMSST = this.formatPrice(_itemSelecPedido.valorICMSST);
            this.itemPedido.valorTabela = this.formatPrice(_itemSelecPedido.valorTabela);
            this.itemPedido.comprimento = _itemSelecPedido.comprimento;
            this.itemPedido.percDesconto = _itemSelecPedido.percDesconto;
            this.itemPedido.numPedCompra = _itemSelecPedido.numPedCompra;
            this.itemPedido.tipoVarianteSobreMedida = _itemSelecPedido.tipoVarianteSobreMedida;
            this.itemPedido.codProduto = _itemSelecPedido.codProduto;
            this.itemPedido.valorUnitario = this.formatPrice(_itemSelecPedido.valorUnitario);
            this.itemPedido.valorIPI = this.formatPrice(_itemSelecPedido.valorIPI);
            this.itemPedido.valorDesconto = this.formatPrice(_itemSelecPedido.valorDesconto);
            this.itemPedido.valorBruto = this.formatPrice(_itemSelecPedido.valorBruto);
            this.itemPedido.percentualIpi = _itemSelecPedido.percentualIpi;
            this.itemPedido.valorLiquido = this.formatPrice(_itemSelecPedido.valorLiquido);
            this.itemPedido.descTamanho = this.formatPrice(_itemSelecPedido.descTamanho);
            this.itemPedido.totalItem = this.formatPrice(_itemSelecPedido.totalItem);
            this.itemPedido.largura = _itemSelecPedido.largura;
            this.itemPedido.qtdVenda = _itemSelecPedido.qtdVenda;
            // console.log(this.itemPedido)
          }
          this.calcularTributos(paramPerc);
        }
      }
      // console.log('selec produto fim: ' + new Date())
    },
    atualizarItensPedido: function atualizarItensPedido(corSelecionada, indiceCorSelecionada, from) {
      var _this6 = this;

      // console.log('atualizar produto começo: ' + new Date())
      this.produtoSelecionado = { lotes: [] };
      this.corSelecionada = corSelecionada;
      this.indiceCorSelecionada = indiceCorSelecionada;
      for (var iCor = 0; iCor < this.cores.length; iCor++) {
        this.cores[iCor].classe = 'imgNaoSelecionada';
        if (indiceCorSelecionada === iCor) {
          this.cores[iCor].classe = 'imgSelecionada';
        }
      }
      var produtos = this.gradeProdutos.produtos.filter(function (prod) {
        return prod.codigoTamanho === _this6.tamanhoSelecionado.codigoTamanho && prod.codigoCor === corSelecionada.codigoCor;
      });
      if (produtos.length > 0) {
        this.produtoSelecionado = produtos[0];
        var itemExistPed = this.pedido.itens.filter(function (item) {
          return item.codProduto === produtos[0].codigo;
        });
        if (itemExistPed.length > 0) {
          this.itemExistPed = 1;
        } else {
          this.itemExistPed = 0;
        }
        this.previsao.data = this.produtoSelecionado.previsao.length === 0 ? 'Sem Previsão' : this.produtoSelecionado.previsao[0].dataPrevisao;
        this.previsao.quantidade = this.produtoSelecionado.previsao.length === 0 ? '' : this.produtoSelecionado.previsao[0].quantidade;
        if (this.produtoSelecionado.vendaSobMedidaM2 === 1) {
          this.opcoesSobMedida = true;
          this.tabelaLote = false;
          this.quantidade = false;
        } else if (this.produtoSelecionado.lotes.length > 0) {
          this.tabelaLote = true;
          this.quantidade = false;
          this.opcoesSobMedida = false;
        } else {
          this.tabelaLote = false;
          this.quantidade = true;
          this.opcoesSobMedida = false;
        }
        if (from === 0) {
          this.novoItemPedido();
          this.valorUnitarioSemFormat1 = this.itemPedido.valorUnitario;
          this.valorTabelaSemFormat1 = this.itemPedido.valorTabela;
          this.percDescontoSemFormat1 = this.itemPedido.percDesconto;
          var produtoSelecionado = this.produtoSelecionado;
          // let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codProduto === this.produtoSelecionado.codigo)
          // let itemSelecPedido = this.pedido.itens.filter(item => item.codigoTamanho === this.produtoSelecionado.codigoTamanho && item.codigoCor === this.produtoSelecionado.codigoCor)
          var itemSelecPedido = this.pedido.itens.filter(function (item) {
            return item.codigoTamanho === produtoSelecionado.codigoTamanho && item.codigoCor === produtoSelecionado.codigoCor && item.codProduto === produtoSelecionado.codigo;
          });
          itemSelecPedido = itemSelecPedido[0];
          if (itemSelecPedido) {
            this.itemPedido.id = itemSelecPedido.id;
            this.itemPedido.corteRedondo = itemSelecPedido.corteRedondo;
            this.itemPedido.bonificado = itemSelecPedido.bonificado;
            this.itemPedido.numItemPedCompra = itemSelecPedido.numItemPedCompra;
            this.itemPedido.lotes = itemSelecPedido.lotes;
            this.itemPedido.valorICMSST = this.formatPrice(itemSelecPedido.valorICMSST);
            this.itemPedido.valorTabela = this.formatPrice(itemSelecPedido.valorTabela);
            this.itemPedido.comprimento = itemSelecPedido.comprimento;
            this.itemPedido.percDesconto = itemSelecPedido.percDesconto;
            this.itemPedido.numPedCompra = itemSelecPedido.numPedCompra;
            this.itemPedido.tipoVarianteSobreMedida = itemSelecPedido.tipoVarianteSobreMedida;
            this.itemPedido.codProduto = itemSelecPedido.codProduto;
            this.itemPedido.valorUnitario = this.formatPrice(itemSelecPedido.valorUnitario);
            this.itemPedido.valorIPI = this.formatPrice(itemSelecPedido.valorIPI);
            this.itemPedido.largura = itemSelecPedido.largura;
            this.itemPedido.qtdVenda = itemSelecPedido.qtdVenda;
            // console.log(this.itemPedido)
          }
          this.calcularTributos(1);
        } else {
          var paramPerc = this.produtoSelecionado.precoTabela === this.pedidoSelecEditar.valorUnitario ? 1 : 2;
          this.valorUnitarioSemFormat1 = this.pedidoSelecEditar.valorUnitario;
          this.valorTabelaSemFormat1 = this.pedidoSelecEditar.valorTabela;
          this.percDescontoSemFormat1 = this.pedidoSelecEditar.percDesconto;
          var _itemSelecPedido2 = this.pedido.itens.filter(function (item) {
            return item.codProduto === _this6.produtoSelecionado.codigo;
          });
          _itemSelecPedido2 = _itemSelecPedido2[0];
          if (_itemSelecPedido2) {
            this.itemPedido.id = _itemSelecPedido2.id;
            this.itemPedido.corteRedondo = _itemSelecPedido2.corteRedondo;
            this.itemPedido.bonificado = _itemSelecPedido2.bonificado;
            this.itemPedido.numItemPedCompra = _itemSelecPedido2.numItemPedCompra;
            this.itemPedido.lotes = _itemSelecPedido2.lotes;
            this.itemPedido.valorICMSST = this.formatPrice(_itemSelecPedido2.valorICMSST);
            this.itemPedido.valorTabela = this.formatPrice(_itemSelecPedido2.valorTabela);
            this.itemPedido.comprimento = _itemSelecPedido2.comprimento;
            this.itemPedido.percDesconto = _itemSelecPedido2.percDesconto;
            this.itemPedido.numPedCompra = _itemSelecPedido2.numPedCompra;
            this.itemPedido.tipoVarianteSobreMedida = _itemSelecPedido2.tipoVarianteSobreMedida;
            this.itemPedido.codProduto = _itemSelecPedido2.codProduto;
            this.itemPedido.valorUnitario = this.formatPrice(_itemSelecPedido2.valorUnitario);
            this.itemPedido.valorIPI = this.formatPrice(_itemSelecPedido2.valorIPI);
            this.itemPedido.largura = _itemSelecPedido2.largura;
            this.itemPedido.qtdVenda = _itemSelecPedido2.qtdVenda;
            // console.log(this.itemPedido)
          }
          this.calcularTributos(paramPerc);
        }
      }
      // console.log('atualizar produto fim: ' + new Date())
    },

    selecionaLote: function selecionaLote(lotes) {
      var qtdeLotes = 0;
      for (var i = 0; i < lotes.length; i++) {
        qtdeLotes += lotes[i].quantidade;
      }
      this.itemPedido.qtdVenda = qtdeLotes;
      this.itemPedido.lotes = lotes;
    },
    novoItemPedido: function novoItemPedido() {
      // console.log('novoItemPedido começo: ' + new Date())
      this.itemPedido = {
        id: 0,
        idPedido: 0,
        corteRedondo: 0,
        bonificado: 0,
        numItemPedCompra: '',
        chaveErpPedido: '',
        lotes: [],
        valorICMSST: 0,
        valorTabela: 0,
        comprimento: undefined,
        percDesconto: 0,
        numPedCompra: '',
        tipoVarianteSobreMedida: 0,
        codProduto: '',
        chaveErp: '',
        valorUnitario: 0,
        valorIPI: 0,
        valorDesconto: 0,
        valorBruto: 0,
        percentualIpi: 0,
        valorLiquido: 0,
        descTamanho: 0,
        totalItem: 0,
        largura: undefined,
        qtdVenda: 1,
        observacao: '',
        codTabelaPreco: '',
        clienteNovo: 0
      };
      this.itemPedido.valorTabela = this.produtoSelecionado.precoTabela;
      this.itemPedido.tipoVarianteSobreMedida = 0;
      this.itemPedido.codProduto = this.produtoSelecionado.chaveErp;
      this.itemPedido.chaveErp = '';
      this.itemPedido.valorUnitario = this.produtoSelecionado.precoTabela;
      this.itemPedido.valorIPI = 0.00;
      this.itemPedido.largura = 0.00;
      this.itemPedido.qtdVenda = 1.00;
      if (this.produtoSelecionado.vendaSobMedidaM2 === 1 || this.produtoSelecionado.lotes.length > 0) {
        this.itemPedido.qtdVenda = 0.00;
      }
      var empresa = localStorage.getItem('empresaLogada');
      if (JSON.parse(empresa).identificador === 224262964110) {
        console.log('empresa -> ' + empresa);
        this.itemPedido.tipoVarianteSobreMedida = 1;
      } else if (JSON.parse(empresa).identificador === 67365910546) {
        this.itemPedido.tipoVarianteSobreMedida = 2;
      } else {
        this.itemPedido.tipoVarianteSobreMedida = 0;
      }
      // console.log('novoItemPedido fim: ' + new Date())
    },
    // calculaTotalItem: function () {
    //   this.itemPedido.totalItem = this.formatPrice((this.itemPedido.qtdVenda * this.valorUnitarioSemFormat1))
    // },
    calculaDimensao: function calculaDimensao() {
      if (this.itemPedido.largura === '' || typeof this.itemPedido.largura === 'undefined') {
        this.itemPedido.largura = 0;
      }
      if (this.itemPedido.comprimento === '' || typeof this.itemPedido.comprimento === 'undefined') {
        this.itemPedido.comprimento = 0;
      }

      if (typeof this.itemPedido.largura !== 'number') {
        if (this.itemPedido.largura.includes(',')) {
          this.itemPedido.largura = this.itemPedido.largura.replace(/,/g, '.');
        }
      }
      if (typeof this.itemPedido.comprimento !== 'number') {
        if (this.itemPedido.comprimento.includes(',')) {
          this.itemPedido.comprimento = this.itemPedido.comprimento.replace(/,/g, '.');
        }
      }
      var largura = parseFloat(this.itemPedido.largura);
      var comprimento = parseFloat(this.itemPedido.comprimento);
      if (this.itemPedido.tipoVarianteSobreMedida === 2) {
        comprimento += 0.1;
      } else if (this.itemPedido.tipoVarianteSobreMedida === 3) {
        largura += 0.1;
        comprimento += 0.1;
      }

      this.itemPedido.qtdVenda = (largura * comprimento).toFixed(2);
    },
    salvarItemFechar: function salvarItemFechar() {
      var param = 1;
      __WEBPACK_IMPORTED_MODULE_7__main__["broadcastServer"].$emit('fechaModalItens', param);
      this.exibeModal = false;
      this.limparFiltroMod();
      this.limparFiltroVar();
      this.selecionarProduto(this.corSelecionada, this.indiceCorSelecionada, 0);
    },
    addQtde: function addQtde(from) {
      var _this7 = this;

      if (typeof this.itemPedido.qtdVenda === 'string') {
        this.itemPedido.qtdVenda = parseFloat(this.itemPedido.qtdVenda.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
        if (this.itemPedido.qtdVenda === 0) {
          this.showMessage('É necessário que seja adicionado pelo menos um item antes de salvar.', 'Atenção', 'warning', 'addQtde if qtdVenda');
          return;
        }
      } else {
        if (this.itemPedido.qtdVenda === 0) {
          this.showMessage('É necessário que seja adicionado pelo menos um item antes de salvar.', 'Atenção', 'warning', 'addQtde else qtdVenda');
          return;
        }
      }
      if (this.itemPedido.qtdVenda === '' || typeof this.itemPedido.qtdVenda === 'undefined') {
        this.itemPedido.qtdVenda = 1;
      }
      if (this.produtoSelecionado.foraDeLinha === 1 && this.produtoSelecionado.estoque <= 0) {
        this.showMessage('Produto fora de linha e/ou estoque indisponível, não será possível adicionar este produto ao pedido.', 'Atenção', 'warning', 'addQtde foraDeLinha 1');
        return;
      }
      if (this.produtoSelecionado.foraDeLinha === 1 && this.produtoSelecionado.estoque < this.itemPedido.qtdVenda) {
        console.log('é menor');
        this.showMessage('Quantidade de itens adicionada não disponível em estoque. Verifique a quantidade antes de continuar.', 'Atenção', 'danger', 'addQtde foraDeLinha 2');
        return;
      }
      if (this.produtoSelecionado.vendaSobMedidaM2 === 1 && this.itemPedido.tipoVarianteSobreMedida === 0) {
        this.showMessage('Selecione a variante sob Medida.', 'Atenção', 'warning', 'addQtde vendaSobMedidaM2');
        return;
      }
      if (this.itemPedido.largura === '' || typeof this.itemPedido.largura === 'undefined') {
        this.itemPedido.largura = 0;
      }
      if (this.itemPedido.comprimento === '' || typeof this.itemPedido.comprimento === 'undefined') {
        this.itemPedido.comprimento = 0;
      }
      if (this.produtoSelecionado.vendaSobMedidaM2 === 1) {
        if (this.itemPedido.comprimento < this.itemPedido.largura) {
          this.showMessage('Comprimento não pode ser menor que a largura.', 'Atenção', 'warning', 'addQtde vendaSobMedidaM2 > comprimento');
          return;
        }
      }
      var percLimiteDescontoRepresentante = 0.00;
      var dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'));
      percLimiteDescontoRepresentante = dadosAcesso.representante.percLimiteDesconto;
      if (percLimiteDescontoRepresentante === '' || typeof percLimiteDescontoRepresentante === 'undefined') {
        percLimiteDescontoRepresentante = 0;
      }
      if (this.itemPedido.percDesconto > percLimiteDescontoRepresentante) {
        this.showMessage('Percentual de desconto não permitido acima de: ' + percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'addQtde percDesconto');
        return;
      }
      this.itemPedido.idPedido = this.pedidoSelecionado.id;
      this.itemPedido.chaveErpPedido = this.pedidoSelecionado.chaveErp;
      this.itemPedido.codProduto = this.produtoSelecionado.codigo;
      this.itemPedido.codTabelaPreco = this.pedidoSelecionado.tabelaPreco.codigo;
      if (typeof this.itemPedido.valorTabela === 'string') {
        this.itemPedido.valorTabela = parseFloat(this.itemPedido.valorTabela.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.valorUnitario === 'string') {
        this.itemPedido.valorUnitario = parseFloat(this.itemPedido.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.valorDesconto === 'string') {
        this.itemPedido.valorDesconto = parseFloat(this.itemPedido.valorDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.percDesconto === 'string') {
        this.itemPedido.percDesconto = parseFloat(this.itemPedido.percDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.totalItem === 'string') {
        this.itemPedido.totalItem = parseFloat(this.itemPedido.totalItem.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.qtdVenda === 'string') {
        this.itemPedido.qtdVenda = parseFloat(this.itemPedido.qtdVenda.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.valorICMSST === 'string') {
        this.itemPedido.valorICMSST = parseFloat(this.itemPedido.valorICMSST.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      if (typeof this.itemPedido.valorIPI === 'string') {
        this.itemPedido.valorIPI = parseFloat(this.itemPedido.valorIPI.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      }
      // this.itemPedido.clienteNovo = this.pedidoSelecionado.cliente.clienteNovo
      this.blockUiVisibility = true;
      this.msgBlockUi = 'Salvando item do pedido, aguarde...';
      __WEBPACK_IMPORTED_MODULE_8__services_tablePedidos__["a" /* default */].inserirPedidoItem(this.itemPedido).then(function (response) {
        var objPedido = { pedido: response.data.pedido, condPagtos: response.data.condPagtos };
        __WEBPACK_IMPORTED_MODULE_7__main__["broadcastServer"].$emit('refreshPedido', objPedido);
        _this7.refreshPedido(objPedido);
        // console.log(this.pedidoSelecionado.itens)
        _this7.atualizarQtdesTamanho(_this7.pedido.itens);
        _this7.atualizarQtdesVariantes(_this7.pedido.itens);
        // let param = 1
        // broadcastServer.$emit('fechaModalItens', param)
        // this.exibeModal = false
        _this7.atualizarItensPedido(_this7.corSelecionada, _this7.indiceCorSelecionada, 0);
        if (from === 0) {
          _this7.showMessage('Produto incluído com sucesso', 'Sucesso', 'success', 'addItem inserirPedido ok');
        } else {
          _this7.showMessage('Produto alterado com sucesso', 'Sucesso', 'success', 'addItem inserirPedido ok');
        }
      }).catch(function (error) {
        console.log(error);
        _this7.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'addQtde inserirPedidoItem erro');
      }).finally(function () {
        _this7.blockUiVisibility = false;
      });
    },
    rowSelected: function rowSelected(fields) {
      this.selected = fields;
    },
    onSlideStart: function onSlideStart(index) {
      var descricao = this.destaques[index].descricao;
      this.descricao = descricao;
    },
    onSlideEnd: function onSlideEnd(index) {
      var descricao = this.destaques[index].descricao;
      this.descricao = descricao;
    },

    limparFiltroMod: function limparFiltroMod() {
      this.pesqTamanho = '';
    },
    limparFiltroVar: function limparFiltroVar() {
      this.pesqVariante = '';
    }
    // ,
    // detalhesItem: function () {
    //   broadcastServer.$on('detalhesItem', detalhes => {
    //     this.detalhesItemPedido = detalhes
    //     console.log(detalhes)
    //   })
    // }

    // mounted () {
    //   dashboard.listarDashboard().then(response => {
    //     this.destaques = response.data.destaques
    //   })
    // }
  } });

/***/ }),

/***/ "N1v1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_items_ProgressMetasVue__ = __webpack_require__("flXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_dashboard__ = __webpack_require__("39Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    aaa: '',
    comissao: '',
    style1: '',
    pCardMetasValues: {
      valorMeta: 0.00,
      valorAtingido: 0.00,
      periodo: ''
    }
  },
  data: function data() {
    return {
      comissaoRep: { valor: 0.00 },
      visualizarComissao: false,
      progressMetasValues: {},
      blockUI: {
        message: '',
        blockUiVisibility: false
      },
      metaAtingida: 0,
      restante: 0,
      max: 100
    };
  },

  watch: {
    pCardMetasValues: function pCardMetasValues(newVal, oldVal) {
      // watch it
      this.progressMetasValues = newVal;
    }
  },
  components: {
    ProgressMetasVue: __WEBPACK_IMPORTED_MODULE_1__components_items_ProgressMetasVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_4__components_items_SpinnerVue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var cor = state.cor.cor;

      return {
        'background-color': cor
      };
    }
  })),
  methods: {
    obterComissao: function obterComissao() {
      var _this = this;

      this.visualizarComissao = !this.visualizarComissao;
      if (this.visualizarComissao) {
        this.blockUI.blockUiVisibility = true;
        this.blockUI.message = 'Buscando Comissão, aguarde...';
        __WEBPACK_IMPORTED_MODULE_2__services_dashboard__["a" /* default */].obterComissaoCorrenteRepresentante().then(function (response) {
          _this.comissaoRep.valor = response.data.valor;
        }).catch(function (error) {
          console.log(error);
          _this.showMessage('Erro ao obter comissão!\n' + error, 'Atenção', 'danger');
        }).finally(function () {
          _this.blockUI.blockUiVisibility = false;
        });
      }
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  },
  created: function created() {
    var _this2 = this;

    // console.log('card metas criado')
    __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$on('emitBuscaDadosDashboard', function (parametro) {
      _this2.visualizarComissao = false;
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "broadcastServer", function() { return broadcastServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "operacao", function() { return operacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modo", function() { return modo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cor", function() { return cor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "corSelec", function() { return corSelec; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_pt_BR__ = __webpack_require__("RAMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_pt_BR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_pt_BR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_airbnb_style_datepicker__ = __webpack_require__("dHJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css__ = __webpack_require__("rcKX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_blockui__ = __webpack_require__("KVzY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_v_money__ = __webpack_require__("9VIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_google_charts__ = __webpack_require__("kXf/");



















var broadcastServer = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

var isToday = __webpack_require__("GvNH");
isToday(new Date());

var operacao = {
  ADICIONAR: 'adicionar',
  ALTERAR: 'alterar'
};
var modo = {
  LISTA: 'lista',
  EDICAO: 'edicao'
};
var cor = { 'background-color': '#' + localStorage.getItem('corApp') };
var corSelec = { 'background-color': '#' + localStorage.getItem('corSelecionado') };

var datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado', 'Domingo'],
  daysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  keyboardShortcuts: [{ symbol: '↵', label: 'Seleciona a data', symbolDescription: 'Pressionar enter' }, { symbol: '←/→', label: 'Move para trás (esquerda) e frente (direita) um dia de cada vez.', symbolDescription: 'Left or right arrow keys' }, { symbol: '↑/↓', label: 'Move para trás (cima) e frente (baixo) uma semana de cada vez.', symbolDescription: 'Up or down arrow keys' }, { symbol: 'PgUp/PgDn', label: 'Troca os meses.', symbolDescription: 'PageUp and PageDown keys' }, { symbol: 'Home/End', label: 'Vai para o primeiro dia da semana.', symbolDescription: 'Teclas Home ou End' }, { symbol: 'Esc', label: 'Fecha este painel', symbolDescription: 'Escape key' }, { symbol: '?', label: 'Abre este painel', symbolDescription: 'Question mark' }],
  colors: {
    selected: '#484848',
    inRange: '#b0b0b0',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#f6f6f6',
    disabled: '#fff'
  },
  texts: {
    apply: 'Aplicar',
    cancel: 'Cancelar',
    keyboardShortcuts: 'Teclas de Atalho'
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_google_charts__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper___default.a /* { default global options } */);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_v_money___default.a, { precision: 4 });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_airbnb_style_datepicker__["a" /* default */], datepickerOptions);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_blockui__["default"]);
__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* Validator */].localize({ pt_BR: __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_pt_BR___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* default */], { locale: 'pt_BR', fieldsBagName: 'veeFields' });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  }
});
// tablePedidos.listarPedidos(objectPost).then(response => {
//
// }).catch(error => {
//   console.log(error)
//   alert('Aconteceu alguma coisa!' + error)
// }).finally(() => {
//   this.blockUiVisibility = false
// })

/***/ }),

/***/ "NiA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardNovidadesVue_vue__ = __webpack_require__("WXZH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c769dfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardNovidadesVue_vue__ = __webpack_require__("0izi");
function injectStyle (ssrContext) {
  __webpack_require__("lGdt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c769dfd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardNovidadesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c769dfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardNovidadesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  listarPaginacaoClientes: function listarPaginacaoClientes() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/relatorioClientesPaginacao');
  },
  listarClientes: function listarClientes(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/relatorioClientes?' + 'tipoRelatorio=' + param.tipoRelatorio + '&paginacao=' + param.paginacao + '&registrosPorPagina=' + param.registrosPorPagina);
  },
  listarAnosMetas: function listarAnosMetas() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/anosMeta');
  },
  listarCatRepresentante: function listarCatRepresentante() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1//categoriasRepresentante');
  },
  MetasVsAtingido: function MetasVsAtingido(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/metasVsAtingido?' + 'ano=' + param.ano + '&codCategoria=' + param.codCategoria);
  },
  resumoComissoes: function resumoComissoes(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/comissaoRepresentante?qtdeDias=180');
  },
  resumoComissoesCategoria: function resumoComissoesCategoria(periodo) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/comissaoRepresentanteCategoria?periodo=' + periodo);
  },
  resumoGerencialPeriodo: function resumoGerencialPeriodo(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/relatorioGerencial?codRepresentante=' + param.codRepresentante + '&dataDe=' + param.dataDe + '&dataAte=' + param.dataAte);
  },
  listarMetas: function listarMetas(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/metasVsAtingido?' + 'mes=' + param.mes + '&ano=' + param.ano);
  },
  listarComissao: function listarComissao(param) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/comissaoRepresentante?' + 'mes=' + param.mes + '&ano=' + param.ano);
  },
  enviar: function enviar(parametros) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* endPointPrivate */] + 'v1/comissaoMesRepresentante', parametros);
  }
});

/***/ }),

/***/ "OckI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-brand fixed-bottom"},[_c('b-navbar',{staticClass:"nav",attrs:{"toggleable":"lg","type":"dark","b-row":""}},[_c('b-navbar-nav',[_c('b-col',[_c('router-link',{attrs:{"to":"/Home"}},[_c('i',{staticClass:"fas fa-home"}),_vm._v("Home")])],1),_vm._v(" "),_c('b-col',[_c('router-link',{attrs:{"to":"/Pedidos"}},[_c('i',{staticClass:"fas fa-list-ul"}),_vm._v("Pedidos")])],1),_vm._v(" "),_c('b-col',[_c('router-link',{attrs:{"to":"/Clientes"}},[_c('i',{staticClass:"fas fa-users"}),_vm._v("Clientes")])],1),_vm._v(" "),_c('b-col',[_c('router-link',{attrs:{"to":"/Relatorios"}},[_c('i',{staticClass:"fas fa-chart-bar"}),_vm._v("Relatórios")])],1),_vm._v(" "),_c('b-col',[_c('router-link',{attrs:{"to":"/Catalogo"}},[_c('i',{staticClass:"fas fa-book-open"}),_vm._v("Catálogo")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OfRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("ZAW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderVue',
  components: {
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelListSelect"]
  },
  computed: {
    logo: function logo() {
      return this.$store.state.isLog.empresa;
    },
    filteredList: function filteredList() {
      var _this = this;

      return this.listaRepresentantes.filter(function (post) {
        return post.codigo.includes(_this.codigoRep) && post.apelido.toLowerCase().includes(_this.apelidoRep.toLowerCase());
      });
    }
  },
  data: function data() {
    return {
      codigoRep: '',
      apelidoRep: '',
      headerTextVariant: 'light',
      headerBgVariant: 'dark',
      modalSelecRepresentante: false,
      representanteSelecionado: null,
      viewListaRepresentantes: false,
      listaRepresentantes: [],
      fieldsRepresentantes: [{
        key: 'urlFoto',
        label: 'Foto'
      }, {
        key: 'codigo',
        label: 'Código'
      }, {
        key: 'apelido',
        label: 'Representante',
        formatter: this.toCapitalize,
        class: 'txtLeft'
      }, {
        label: 'Selecionar',
        key: 'acao'
      }]
    };
  },
  created: function created() {
    this.cor2 = { 'background-color': '#' + localStorage.getItem('corSelecionado') };
  },

  watch: {
    $route: function $route(to, from) {
      if (to.name === 'home') {
        this.viewListaRepresentantes = true;
      } else {
        this.viewListaRepresentantes = false;
      }
    }
  },
  mounted: function mounted() {
    this.$route.name === 'home' ? this.viewListaRepresentantes = true : this.viewListaRepresentantes = false;
    var representantesLogin = JSON.parse(localStorage.getItem('representantesLogin'));
    this.listaRepresentantes = representantesLogin.sort(function (a, b) {
      return a.codigo - b.codigo;
    });
    // console.log(this.listaRepresentantes)
  },

  methods: {
    sair: function sair() {
      localStorage.clear();
      this.$router.push('/');
    },
    admSelecRep: function admSelecRep(item, index) {
      this.representanteSelecionado = item;
      localStorage.setItem('representanteSelecionado', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.representanteSelecionado));
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('emitBuscaDadosDashboard', this.representanteSelecionado);
      this.modalSelecRepresentante = false;
    },
    abreModalSelecRep: function abreModalSelecRep() {
      event.preventDefault();
      this.modalSelecRepresentante = true;
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    limparFiltro: function limparFiltro() {
      this.codigoRep = '';
      this.apelidoRep = '';
    }
  }
});

/***/ }),

/***/ "PVzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PXiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardCategoriasVue_vue__ = __webpack_require__("a9Ub");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e47ad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardCategoriasVue_vue__ = __webpack_require__("jdFW");
function injectStyle (ssrContext) {
  __webpack_require__("LVXU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2e47ad6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardCategoriasVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e47ad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardCategoriasVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PaKm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"tablist","id":"pageGrade"}},[_c('b-row',{staticClass:"pt-3",attrs:{"id":"titleCatGrade"}},[_c('b-col',{staticStyle:{"text-align":"left !important"},attrs:{"sm":"8 pt-1 title txtLeft"}},[_vm._v(_vm._s(_vm.title || "Título não informado"))]),_vm._v(" "),_c('b-col',{staticClass:"right pr-0",attrs:{"sm":"4"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.pageLista()}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Voltar")])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1 shadow mt-2",attrs:{"no-body":""}},[_c('b-card-body',[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('div',{staticClass:"mt-4 mb-5 ml-2 mr-2"},[(_vm.produtoSelecionado.url)?_c('img',{attrs:{"id":"imgGrade","src":_vm.produtoSelecionado.url,"alt":""}}):_c('span',{staticClass:"semImagem"},[_c('img',{attrs:{"src":__webpack_require__("7sUr"),"alt":""}})])]),_vm._v(" "),_c('b-card',{staticClass:"shadow2 mb-3",attrs:{"border-variant":"light","id":"dadosGradeDesk"}},[_c('b-card-text',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Nome: ")]),_vm._v(" "+_vm._s(_vm.gradeProdutos.descricaoGrade))]),_vm._v(" "),(_vm.produtoSelecionado.codigo && !_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Item: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.codigo))]):(_vm.produtoSelecionado.codigo && _vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Código: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.codigo))]):(!_vm.produtoSelecionado.codigo && _vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Código: ")]),_vm._v(" - ")]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Item: ")]),_vm._v(" - ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[(_vm.produtoSelecionado.ean && !_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Cód. Barras: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.ean))]):(!_vm.produtoSelecionado.ean && !_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Cód. Barras: ")]),_vm._v(" - ")]):_vm._e(),_vm._v(" "),(_vm.produtoSelecionado.estoque)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Estoque: ")]),_vm._v(_vm._s(_vm.formatQtde(_vm.produtoSelecionado.estoque)))]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Estoque: ")]),_vm._v(" - ")]),_vm._v(" "),(_vm.produtoSelecionado.unidMed)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Unid.Med: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.unidMed))]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Unid.Med: ")]),_vm._v(" - ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Estoque atualizado:")]),_vm._v(" "+_vm._s(_vm.dateTime))])],1),_vm._v(" "),(!_vm.empresaKatec)?_c('b-row',{staticClass:"mb-2"},[(_vm.produtoSelecionado.descricao)?_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Descrição: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.descricao))]):_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Descrição: ")]),_vm._v(" - ")])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[(_vm.previsao.data && !_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Previsão: ")]),_vm._v(_vm._s(_vm.previsao.data))]):(_vm.previsao.data && _vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Próx. Chegada: ")]),_vm._v(_vm._s(_vm.previsao.data))]):(!_vm.previsao.data && _vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Próx. Chegada: ")]),_vm._v(" - ")]):_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Previsão: ")]),_vm._v(" - ")]),_vm._v(" "),(_vm.produtoSelecionado.foraDeLinha === 0 && _vm.previsao.quantidade && !_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Qtd. prevista: ")]),_vm._v(" "+_vm._s(_vm.formatQtde(_vm.previsao.quantidade)))]):(_vm.produtoSelecionado.foraDeLinha === 0 && _vm.previsao.quantidade && _vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Qtd. disp.: ")]),_vm._v(" "+_vm._s(_vm.formatQtde(_vm.previsao.quantidade)))]):(_vm.produtoSelecionado.foraDeLinha === 0 && !_vm.previsao.quantidade && _vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Qtd. disp.: ")]),_vm._v(" - ")]):_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Qtd. prevista: ")]),_vm._v(" -")]),_vm._v(" "),(_vm.produtoSelecionado.foraDeLinha === 0 && _vm.previsao.data === 'Sem Previsão')?_c('b-col',{staticClass:"txtLeft text-danger",attrs:{"cols":"4"}},[_c('b',[_vm._v("Sem Reposição")])]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2",staticStyle:{"background":"#eee"}},[_c('b-col',{staticClass:"txtCenter"},[_c('b',[_vm._v(_vm._s(this.tabela.descricao))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Preço Tabela: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.precoTabela)))]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("IPI: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.percentualIpi)+"%")]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Preço com IPI: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.precoComIpi)))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Preço M²: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.valorM2)))]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Preço M² com IPI: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.precoM2ComIpi)))])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"shadow2 mb-3",attrs:{"border-variant":"light","id":"dadosGradeMob"}},[_c('b-card-text',[_c('b-row',{staticClass:"mb-1"},[_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("Nome: ")]),_vm._v(" "+_vm._s(_vm.gradeProdutos.descricaoGrade))]),_vm._v(" "),(_vm.produtoSelecionado.codigo)?_c('b-col',{staticClass:"txtRight",attrs:{"cols":"6"}},[_c('b',[_vm._v("Item: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.codigo))]):_c('b-col',{staticClass:"txtRight",attrs:{"cols":"6"}},[_c('b',[_vm._v("Item: ")]),_vm._v(" - ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[(_vm.produtoSelecionado.descricao)?_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Descrição: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.descricao))]):_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Descrição: ")]),_vm._v(" - ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[(_vm.produtoSelecionado.estoque)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("Estoque: ")]),_vm._v(_vm._s(_vm.formatQtde(_vm.produtoSelecionado.estoque)))]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("Estoque: ")]),_vm._v(" - ")]),_vm._v(" "),(_vm.produtoSelecionado.unidMed)?_c('b-col',{staticClass:"txtRight",attrs:{"cols":"6"}},[_c('b',[_vm._v("Unid.Med: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.unidMed))]):_c('b-col',{staticClass:"txtRight",attrs:{"cols":"6"}},[_c('b',[_vm._v("Unid.Med: ")]),_vm._v(" - ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Estoque atualizado:")]),_vm._v(" "+_vm._s(_vm.dateTime))])],1),_vm._v(" "),(_vm.produtoSelecionado.ean && !_vm.empresaKatec)?_c('b-row',{staticClass:"mb-1"},[(_vm.produtoSelecionado.ean)?_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Cód. Barras: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.ean))]):_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Cód. Barras: ")]),_vm._v(" - ")])],1):_vm._e(),_vm._v(" "),(_vm.previsao.data)?_c('b-row',{staticClass:"mb-1"},[(_vm.previsao.data)?_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Previsão: ")]),_vm._v(_vm._s(_vm.previsao.data))]):_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Previsão: ")]),_vm._v(" - ")])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[(_vm.produtoSelecionado.foraDeLinha && _vm.produtoSelecionado.foraDeLinha === 0)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("Qtd. prevista: ")]),_vm._v(" "+_vm._s(_vm.previsao.quantidade))]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("Qtd. prevista: ")]),_vm._v(" - ")]),_vm._v(" "),(_vm.produtoSelecionado.foraDeLinha === 0 && _vm.previsao.data === 'Sem Previsão')?_c('b-col',{staticClass:"txtRight text-danger",attrs:{"cols":"6"}},[_c('b',[_vm._v("Sem Reposição")])]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1",staticStyle:{"background":"#eee"},attrs:{"id":"tabelaPreco"}},[_c('b-col',{staticClass:"txtCenter"},[_c('b',[_vm._v(_vm._s(this.tabela.descricao))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1"},[_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Preço Tabela: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.precoTabela)))])],1),_vm._v(" "),(_vm.produtoSelecionado.percentualIpi)?_c('b-row',{staticClass:"mb-1"},[_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("IPI: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.percentualIpi)+"%")]),_vm._v(" "),_c('b-col',{staticClass:"txtRight",attrs:{"cols":"6"}},[_c('b',[_vm._v("Preço com IPI: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.precoComIpi)))])],1):_vm._e(),_vm._v(" "),(_vm.produtoSelecionado.valorM2)?_c('b-row',{staticClass:"mb-1"},[_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"6"}},[_c('b',[_vm._v("Preço M²: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.valorM2)))]),_vm._v(" "),_c('b-col',{staticClass:"txtRight",attrs:{"cols":"6"}},[_c('b',[_vm._v("Preço M² com IPI: ")]),_vm._v("R$ "+_vm._s(_vm.formatPrice(_vm.produtoSelecionado.precoM2ComIpi)))])],1):_vm._e()],1)],1),_vm._v(" "),(_vm.tamanhos.length > 0)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"11"}},[_c('p',[_vm._v("MODELO")])])],1):_vm._e(),_vm._v(" "),(_vm.tamanhos.length > 0)?_c('b-card',{staticClass:"shadow2 mb-3",attrs:{"border-variant":"light","id":"modelosGrade"}},[_c('b-card-text',[_c('swiper',{attrs:{"options":_vm.swiperOptionModelos,"id":"sliderTamanhos"}},[_vm._l((_vm.tamanhos),function(tamanho,index){return _c('swiper-slide',{key:tamanho.codigoTamanho,nativeOn:{"click":function($event){return _vm.selecionarCores(index)}}},[_c('b-button',{class:tamanho.active,attrs:{"variant":"secondary"}},[_vm._v(_vm._s(tamanho.descricaoTamanho))])],1)}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.cores.length > 0)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"11"}},[_c('p',[_vm._v("VARIANTE")])])],1):_vm._e(),_vm._v(" "),(_vm.cores.length > 0)?_c('b-card',{staticClass:"shadow2 mb-3",attrs:{"border-variant":"light","id":"variantesGrade"}},[_c('b-card-text',[_c('swiper',{attrs:{"options":_vm.swiperOptionVariantes,"id":"sliderCores"}},_vm._l((_vm.cores),function(cor,index){return _c('swiper-slide',{key:cor.codigo,staticClass:"selecionar-variante",nativeOn:{"click":function($event){return _vm.selecionarProduto(cor.cor, index)}}},[(cor.cor.url)?_c('div',{staticClass:"img"},[_c('img',{class:cor.classe,attrs:{"src":cor.cor.url,"alt":""}})]):_c('div',{staticClass:"img semImgItem"},[_c('img',{class:cor.classe,attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('label',{staticClass:"mt-4"},[_vm._v(_vm._s(cor.cor.descricaoCor))])])}),1),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q9Zx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"formPedido"}},[_c('b-row',{staticClass:"pt-3"},[_c('b-col',{attrs:{"sm":"9 pl-0 title","id":"titlePage"}},[_vm._v(_vm._s(_vm.title || "Título não informado"))]),_vm._v(" "),_c('b-col',{staticClass:"right pr-0 btnAcoesPag"},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.confSairSemSalvar()}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Voltar")])],1),_vm._v(" "),(_vm.pedido.isEditavel)?_c('b-col',{staticClass:"right btnAcoesPag pr-0"},[_c('b-button',{staticClass:"btnSalvar",on:{"click":function($event){return _vm.tentaSalvar()}}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Salvar")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card shadow mt-2",attrs:{"id":"pedDados"}},[_c('div',{style:(_vm.cor),attrs:{"id":"progBar"}},[_c('div',{staticClass:"progressbar"},_vm._l((this.status),function(st){return _c('button',{key:st.idStatus,class:[st.classe, {'color': (st.idStatus !== _vm.pedido.statusGoSales), 'colorSelec': (st.idStatus === _vm.pedido.statusGoSales)}],style:(st.idStatus !== _vm.pedido.statusGoSales ? _vm.cor : _vm.corSelec),attrs:{"disabled":_vm.desabilitaEdicao()},on:{"click":function($event){return _vm.selecionarStatus(st.idStatus)}}},[_vm._v(_vm._s(st.descricao))])}),0)]),_vm._v(" "),_c('b-card',[_c('b-card-text',[_c('form',{staticClass:"w-100"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-6 mb-3"},[_c('div',{staticClass:"form-row mt-3 ml-0 mr-0"},[_c('div',{staticClass:"title2 titleFluid col-10 pl-0"},[_c('p',[_vm._v("DADOS DO CLIENTE")])]),_vm._v(" "),(_vm.pedido.canal)?_c('div',{staticClass:"col-2",attrs:{"id":"imgOrigem"}},[_c('img',{attrs:{"src":_vm.pedido.canal.url,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"mb-2 col-4"},[_c('label',{staticClass:"left",attrs:{"for":"input-idPedido"}},[_vm._v("Nº do Pedido")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","id":"input-idPedido","placeholder":"Nº Pedido","disabled":""},model:{value:(_vm.pedido.numeroPedido),callback:function ($$v) {_vm.$set(_vm.pedido, "numeroPedido", $$v)},expression:"pedido.numeroPedido"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-2 col-4"},[_c('label',{staticClass:"left",attrs:{"for":"input-idOrcamento"}},[_vm._v("Nº Orçamento")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","id":"input-idOrcamento","placeholder":"Nº Orçamento","disabled":""},model:{value:(_vm.pedido.numeroOrcamento),callback:function ($$v) {_vm.$set(_vm.pedido, "numeroOrcamento", $$v)},expression:"pedido.numeroOrcamento"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-2 col-4"},[_c('label',{staticClass:"left",attrs:{"for":"input-idGoSales"}},[_vm._v("ID GoSales")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","id":"input-idGoSales","placeholder":"Nº Pedido","disabled":""},model:{value:(_vm.pedido.id),callback:function ($$v) {_vm.$set(_vm.pedido, "id", $$v)},expression:"pedido.id"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-6 mb-1"},[(!_vm.empresaKatec)?_c('label',{staticClass:"left",attrs:{"for":"input-fantasia"}},[_vm._v("Fantasia")]):_c('label',{staticClass:"left",attrs:{"for":"input-fantasia"}},[_vm._v("Cliente Reduzido")]),_vm._v(" "),(!_vm.empresaKatec)?_c('b-form-input',{attrs:{"size":"sm","id":"input-fantasia","placeholder":"Fantasia","disabled":""},model:{value:(_vm.pedido.cliente.fantasia),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "fantasia", $$v)},expression:"pedido.cliente.fantasia"}}):_c('b-form-input',{attrs:{"size":"sm","id":"input-fantasia","placeholder":"Cliente Reduzido","disabled":""},model:{value:(_vm.pedido.cliente.fantasia),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "fantasia", $$v)},expression:"pedido.cliente.fantasia"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-1"},[(_vm.tipoClienteJuridico)?_c('label',{staticClass:"left",attrs:{"for":"input-cnpj"}},[_vm._v("CNPJ")]):_c('label',{staticClass:"left",attrs:{"for":"input-cpf"}},[_vm._v("CPF")]),_vm._v(" "),(_vm.pedido.cliente.cnpjCpf && _vm.pedido.cliente.cnpjCpf.length >= 14)?_c('b-form-input',{attrs:{"size":"sm","type":"text","id":"input-cnpj","placeholder":"CNPJ","disabled":""},model:{value:(_vm.pedido.cliente.cnpjCpf),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "cnpjCpf", $$v)},expression:"pedido.cliente.cnpjCpf"}}):_c('b-form-input',{attrs:{"size":"sm","type":"text","id":"input-cpf","placeholder":"CPF","disabled":""},model:{value:(_vm.pedido.cliente.cnpjCpf),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "cnpjCpf", $$v)},expression:"pedido.cliente.cnpjCpf"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-6 mb-1"},[_c('label',{staticClass:"left",attrs:{"for":"input-razaoSocial"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","id":"input-razaoSocial","placeholder":"Razão Social","disabled":""},model:{value:(_vm.pedido.cliente.razaoSocial),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "razaoSocial", $$v)},expression:"pedido.cliente.razaoSocial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-4 mb-1"},[_c('label',{staticClass:"left",attrs:{"for":"input-ddd"}},[_vm._v("DDD")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('min:4'),expression:"'min:4'"},{name:"mask",rawName:"v-mask",value:('(##)'),expression:"'(##)'"}],class:{'input': true, 'invalid': _vm.errors.has('ddd')},attrs:{"size":"sm","id":"input-ddd","placeholder":"DDD","disabled":_vm.desabilitaEdicao(),"name":"ddd"},model:{value:(_vm.pedido.cliente.ddd),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "ddd", $$v)},expression:"pedido.cliente.ddd"}})],1),_vm._v(" "),_c('div',{staticClass:"col-8 mb-1"},[_c('label',{staticClass:"left",attrs:{"for":"input-telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('min:9'),expression:"'min:9'"},{name:"mask",rawName:"v-mask",value:(['####-####', '#####-####']),expression:"['####-####', '#####-####']"}],class:{'input': true, 'invalid': _vm.errors.has('telefone')},attrs:{"size":"sm","id":"input-telefone","placeholder":"Telefone","disabled":_vm.desabilitaEdicao(),"name":"telefone"},model:{value:(_vm.pedido.cliente.telefone),callback:function ($$v) {_vm.$set(_vm.pedido.cliente, "telefone", $$v)},expression:"pedido.cliente.telefone"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telefone')),expression:"errors.has('telefone')"}],staticClass:"invalid"},[_vm._v("Campo obrigatório | Mínimo 8 caracteres")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"form-row mt-5 mb-5",attrs:{"id":"dadosPedido"}},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid p-0",attrs:{"md":"12"}},[_c('p',[_vm._v("DADOS DO PEDIDO")])])],1),_vm._v(" "),(this.pedido.motivoCancelamento && this.pedido.statusGoSales === 3)?_c('div',{staticClass:"form-row mb-4",attrs:{"id":"cardMotCanc"}},[_c('b-card',{staticClass:"w-100",attrs:{"header-bg-variant":"secondary","bg-variant":"light","header-text-variant":"white","text-variant":"dark","header":"Motivo para o cancelamento do Pedido"}},[_c('b-card-text',[_vm._v(_vm._s(this.pedido.motivoCancelamento))])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-4 mb-3"},[_c('label',{staticClass:"left",attrs:{"for":"input-emissao"}},[_vm._v("Data de Emissão")]),_vm._v(" "),_c('b-form-input',{attrs:{"disabled":"","size":"sm","id":"input-emissao","placeholder":"Data de Emissão"},model:{value:(_vm.pedido.emissao),callback:function ($$v) {_vm.$set(_vm.pedido, "emissao", $$v)},expression:"pedido.emissao"}},[_vm._v("\n                  >")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-tabelaPreco"}},[_vm._v("Tabela de Preço")]),_vm._v(" "),_c('model-list-select',{attrs:{"id":"input-tabelaPreco","list":_vm.dadosTabela.tabelasPreco,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar","isDisabled":_vm.desabilitaEdicao()},model:{value:(_vm.pedido.tabelaPreco),callback:function ($$v) {_vm.$set(_vm.pedido, "tabelaPreco", $$v)},expression:"pedido.tabelaPreco"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-formaPagto"}},[_vm._v("Forma de Pagamento")]),_vm._v(" "),_c('model-list-select',{attrs:{"id":"input-formaPagto","list":_vm.dadosTabela.formaPagtos,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar","isDisabled":_vm.desabilitaEdicao()},model:{value:(_vm.pedido.formaPagto),callback:function ($$v) {_vm.$set(_vm.pedido, "formaPagto", $$v)},expression:"pedido.formaPagto"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-4 mb-3"},[_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-condPagto"}},[_vm._v("Condição de Pagamento")]),_vm._v(" "),_c('model-list-select',{attrs:{"id":"input-condPagto","list":_vm.dadosTabela.condPagtos,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar","isDisabled":_vm.desabilitaCondicaoPagto()},model:{value:(_vm.pedido.condPagto),callback:function ($$v) {_vm.$set(_vm.pedido, "condPagto", $$v)},expression:"pedido.condPagto"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-fretePed"}},[_vm._v("Frete")]),_vm._v(" "),_c('model-list-select',{attrs:{"id":"input-fretePed","list":_vm.dadosTabela.fretes,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar","isDisabled":_vm.desabilitaEdicao()},model:{value:(_vm.pedido.tipoFrete),callback:function ($$v) {_vm.$set(_vm.pedido, "tipoFrete", $$v)},expression:"pedido.tipoFrete"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3"},[(_vm.empresaKatec)?_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-transportadora"}},[_vm._v("Transp./Redespacho")]):_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-transportadora"}},[_vm._v("Transportadora")]),_vm._v(" "),_c('model-list-select',{attrs:{"id":"input-transportadora","list":_vm.dadosTabela.transportadoras,"option-value":"codigo","custom-text":_vm.descTabela,"placeholder":"Selecione ou digite para pesquisar","isDisabled":_vm.desabilitaEdicao()},model:{value:(_vm.pedido.transportadora),callback:function ($$v) {_vm.$set(_vm.pedido, "transportadora", $$v)},expression:"pedido.transportadora"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-4 mb-3"},[_c('label',{staticClass:"left labelSelect",attrs:{"for":"input-representante"}},[_vm._v("Representante")]),_vm._v(" "),_c('model-list-select',{attrs:{"id":"input-representante","list":_vm.dadosTabela.representante,"option-value":"codigo","custom-text":_vm.descRepresentante,"placeholder":"Selecione ou digite para pesquisar","isDisabled":_vm.desabilitaRepresentante()},model:{value:(_vm.pedido.representante),callback:function ($$v) {_vm.$set(_vm.pedido, "representante", $$v)},expression:"pedido.representante"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"left",attrs:{"for":"input-numeroPedidoCompra"}},[_vm._v("Número Pedido Compra")]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","id":"input-numeroPedidoCompra","placeholder":"Número do pedido de compra","disabled":_vm.desabilitaEdicao()},model:{value:(_vm.pedido.numeroPedidoCompra),callback:function ($$v) {_vm.$set(_vm.pedido, "numeroPedidoCompra", $$v)},expression:"pedido.numeroPedidoCompra"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-3"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"left",attrs:{"for":"input-cliente-industrial"}},[_vm._v("Cliente Industrializador")]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","id":"input-cliente-industrial","placeholder":"Cliente Industrial","disabled":true},model:{value:(_vm.clienteIndustrializadorNome),callback:function ($$v) {_vm.clienteIndustrializadorNome=$$v},expression:"clienteIndustrializadorNome"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"margin-top":"32px"}},[_c('b-button',{staticClass:"btn btn-secondary",attrs:{"size":"sm","disabled":_vm.desabilitaEdicao()},on:{"click":function($event){return _vm.adicionarClienteInd()}}},[_c('i',{staticClass:"fas fa-search"})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"margin-top":"32px"}},[_c('b-button',{staticClass:"btn btn-secondary",attrs:{"size":"sm","disabled":_vm.desabilitaEdicao()},on:{"click":function($event){return _vm.limparClientInd()}}},[_c('i',{staticClass:"fas fa-eraser"})])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row mb-5",attrs:{"id":"cardObs"}},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"10"}},[_c('p',[_vm._v("OBSERVAÇÕES")])]),_vm._v(" "),_c('b-col',{staticClass:"p-0 txtRight",attrs:{"md":"2"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.desabilitaEdicao()),expression:"!desabilitaEdicao()"}],staticClass:"col-md-8",attrs:{"variant":"secondary"},on:{"click":_vm.newObs}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Nova")])],1)],1),_vm._v(" "),_c('b-row',_vm._l((_vm.pedido.observacoes),function(obsPed,index){return _c('b-card',{key:index,staticClass:"shadow2 col-md-10 p-0 m-z-auto mb-3",attrs:{"border-variant":"light","header":obsPed.tipoObservacao.descricao}},[_c('b-card-text',[_c('div',{staticClass:"form-row ml-0 mr-0"},[_c('div',{staticClass:"txtLeft txtBreakAll"},[_vm._v("\n                        "+_vm._s(obsPed.observacao)+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-row",attrs:{"id":"btnsObs"}},[_c('div',{staticClass:"col-9"}),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"form-row"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.desabilitaEdicao()),expression:"!desabilitaEdicao()"}],staticClass:"col-md-6",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.alterarObs(obsPed, index)}}},[_vm._v("Alterar")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.desabilitaEdicao()),expression:"!desabilitaEdicao()"}],staticClass:"col-md-6",attrs:{"variant":"danger"},on:{"click":function($event){return _vm.confirmaExclusaoObs(index)}}},[_vm._v("Remover")])],1)])])],1)}),1)],1)],1),_vm._v(" "),(!_vm.desabilitaEdicao())?_c('div',{staticClass:"form-row mt-5 mb-5",attrs:{"id":"pedDescontosPed"}},[(this.pedido.itens.length > 0 )?_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"12"}},[_c('p',[_vm._v("DESCONTO")])])],1),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{staticClass:"mb-0"},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-7 mt-1 mb-0",attrs:{"label-for":"descPerc"}},[_vm._v("Percentual %")]),_vm._v(" "),_c('b-form-input',{staticClass:"col-5",attrs:{"size":"sm","id":"input-percentual","placeholder":"Desc.","disabled":this.desconto.valor !== '0,00'},on:{"keyup":function($event){return _vm.calculaValorDesconto(1)}},model:{value:(_vm.desconto.percentual),callback:function ($$v) {_vm.$set(_vm.desconto, "percentual", $$v)},expression:"desconto.percentual"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{staticClass:"mb-0"},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-5 mt-1 mb-0"},[_vm._v("Valor")]),_vm._v(" "),_c('b-form-input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],staticClass:"col-5",attrs:{"size":"sm","id":"input-desconto","placeholder":"Valor","disabled":this.desconto.percentual > 0},on:{"keyup":function($event){return _vm.calculaValorDesconto(2)}},model:{value:(_vm.desconto.valor),callback:function ($$v) {_vm.$set(_vm.desconto, "valor", $$v)},expression:"desconto.valor"}})],1)])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-6"},[_c('b-button',{attrs:{"variant":"secondary","size":"sm","disabled":!_vm.habilitaDescGeral},on:{"click":function($event){return _vm.aplicarDesconto()}}},[_vm._v("Aplicar")])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.limparDesconto()}}},[_vm._v("Limpar")])],1)])])])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-row mt-5 mb-5 ml-0 mr-0 w-100"},[_c('div',{staticClass:"w-100"},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid p-0",attrs:{"md":"12"}},[_c('p',[_vm._v("TOTAIS")])])],1),_vm._v(" "),_c('div',{attrs:{"id":"pedTotaisPed"}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-3 txtRight"},[_c('label',{attrs:{"id":"labelDescWeb"}},[_c('b',[_vm._v("DESCONTO")])]),_vm._v(" "),_c('label',{attrs:{"id":"labelDescMob"}},[_c('b',[_vm._v("DESC")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(_vm.pedido.totais.valorDesconto)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 txtRight"},[_c('label',[_c('b',[_vm._v("IPI")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(_vm.pedido.totais.valorIPI)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 txtRight"},[_c('label',[_c('b',[_vm._v("ICMS ST")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(_vm.pedido.totais.valorICMSST)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 txtRight"},[_c('label',[_c('b',[_vm._v("TOTAL")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(_vm.pedido.totais.valorTotal)))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-5 mb-5"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"10"}},[_c('p',[_vm._v("ITENS PEDIDO")])]),_vm._v(" "),_c('b-col',{staticClass:"p-0 txtRight",attrs:{"md":"2"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.desabilitaEdicao()),expression:"!desabilitaEdicao()"}],staticClass:"col-md-8",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.addItem()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Novo")])],1)],1),_vm._v(" "),_c('b-row',{attrs:{"id":"scrollItens"}},[_c('b-row',{attrs:{"id":"cardWeb"}},_vm._l((_vm.pedido.itens),function(item){return _c('b-card',{key:item.chaveErp,staticClass:"shadow2 col-md-11 mb-3 cardItem",attrs:{"border-variant":"light"}},[_c('b-card-text',[_c('b-row',[_c('b-col',{staticClass:"imgItem",attrs:{"cols":"2"}},[(item.url)?_c('img',{attrs:{"src":item.url,"img-alt":"Image"}}):_c('img',{staticClass:"semImagemItem card-img",attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft p-0 dadosItem",attrs:{"cols":"10"}},[_c('b-row',[(!_vm.empresaKatec)?_c('b-col',{attrs:{"cols":"9"}},[_c('b',[_vm._v("Item: ")]),_vm._v(_vm._s(item.codProduto))]):_c('b-col',{attrs:{"cols":"9"}},[_c('b',[_vm._v("Código: ")]),_vm._v(_vm._s(item.codProduto))]),_vm._v(" "),_c('b-col',{staticClass:"txtRight",attrs:{"cols":"3"}},[_c('b',[_vm._v("Qtde:")]),_vm._v(" "+_vm._s(_vm.formatQtde(item.qtdVenda))+" ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"12"}},[_c('b',[_vm._v("Tamanho:")]),_vm._v(" "+_vm._s(item.descTamanho))]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"12"}},[_c('b',[_vm._v("Cor:")]),_vm._v(" "+_vm._s(item.descCor))]),_vm._v(" "),(!_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"12"}},[_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.descricao))]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"12"}},[_c('b',[_vm._v("Produto:")]),_vm._v(" "+_vm._s(item.descricao))])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-divider mb-5"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',[_c('label',[_c('b',[_vm._v("Preço Tab.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorTabela)))])]),_vm._v(" "),_c('b-col',[_c('label',[_c('b',[_vm._v("Desc.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorDesconto)))])]),_vm._v(" "),_c('b-col',[_c('label',[_c('b',[_vm._v("Preço Unit.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorUnitario)))])]),_vm._v(" "),_c('b-col',[_c('label',[_c('b',[_vm._v("IPI")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorIPI)))])]),_vm._v(" "),_c('b-col',[_c('label',[_c('b',[_vm._v("ICMS ST")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorICMSST)))])]),_vm._v(" "),_c('b-col',[_c('label',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.totalItem)))])])],1),_vm._v(" "),(_vm.pedido.isEditavel)?_c('b-row',[_c('b-col',{staticClass:"offset-8 col-md-2"},[_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.confirmaExclusao(item.id)}}},[_vm._v("Excluir")])],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-2"},[_c('b-button',{attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){return _vm.editarItemPedido(item)}}},[_vm._v("Editar")])],1)],1):_vm._e()],1)}),1),_vm._v(" "),_c('b-row',{attrs:{"id":"cardMob"}},_vm._l((_vm.pedido.itens),function(item){return _c('b-card',{key:item.chaveErp,staticClass:"shadow2 col-md-11 mb-3 cardItem",attrs:{"border-variant":"light"}},[_c('b-card-text',[_c('b-row',[_c('b-col',{staticClass:"imgItem",attrs:{"cols":"2"}},[(item.url)?_c('img',{attrs:{"src":item.url,"img-alt":"Image"}}):_c('img',{staticClass:"semImagemItem card-img",attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft p-0 dadosItem",attrs:{"cols":"10"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Qtde:")]),_vm._v(" "+_vm._s(item.qtdVenda)+" ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Item: ")]),_vm._v(_vm._s(item.codProduto))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Tamanho:")]),_vm._v(" "+_vm._s(item.descTamanho))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Cor:")]),_vm._v(" "+_vm._s(item.descCor))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.descricao))])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-divider mb-5"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_c('b',[_vm._v("Preço Tab.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorTabela)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_c('b',[_vm._v("Desc.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorDesconto)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_c('b',[_vm._v("Preço Unit.")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorUnitario)))])])],1),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_c('b',[_vm._v("IPI")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorIPI)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_c('b',[_vm._v("ICMS ST")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.valorICMSST)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatterValue(item.totalItem)))])])],1),_vm._v(" "),(_vm.pedido.isEditavel)?_c('b-row',{attrs:{"id":"btnsItem"}},[_c('b-col',{staticClass:"offset-4 col-4"},[_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.confirmaExclusao(item.id)}}},[_vm._v("Excluir")])],1),_vm._v(" "),_c('b-col',{staticClass:"col-4"},[_c('b-button',{attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){return _vm.editarItemPedido(item)}}},[_vm._v("Editar")])],1)],1):_vm._e()],1)}),1)],1)],1)],1),_vm._v(" "),(_vm.btnSalvar)?_c('div',{staticClass:"mt-4 mg-auto",attrs:{"id":"btnImpressao"}},[_c('b-button',{staticClass:"col-3",attrs:{"variant":"secondary"},on:{"click":_vm.imprimePedido2}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" Visualizar Impressão")])],1):_vm._e()])])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-scoped","ok-title":"Salvar","ok-variant":"primary","cancel-title":"Fechar","cancel-variant":"secondary","ok-disabled":_vm.disableSalvarObs(),"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.addObs},model:{value:(_vm.modalObs),callback:function ($$v) {_vm.modalObs=$$v},expression:"modalObs"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Nova Observação")])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"left labelSelect"},[_vm._v("Tipo de observação")]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.dadosTabela.tiposObservacoes,"option-value":"codigo","option-text":"descricao","isDisabled":!_vm.novaObservacao,"placeholder":"Selecione ou digite para pesquisar"},model:{value:(_vm.observacao.tipoObservacao),callback:function ($$v) {_vm.$set(_vm.observacao, "tipoObservacao", $$v)},expression:"observacao.tipoObservacao"}})],1),_vm._v(" "),_c('b-form-textarea',{staticClass:"mt-3",attrs:{"id":"textarea","placeholder":"Digite o conteúdo da observação...","rows":"3","max-rows":"6"},model:{value:(_vm.observacao.observacao),callback:function ($$v) {_vm.$set(_vm.observacao, "observacao", $$v)},expression:"observacao.observacao"}})],2),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-scoped","ok-title":"Enviar","ok-variant":"primary","cancel-title":"Cancelar","cancel-variant":"secondary","ok-disabled":_vm.disableEnviarCancelamento(),"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.fechaModalCancelamento},model:{value:(_vm.modalConfirmaCancelamento),callback:function ($$v) {_vm.modalConfirmaCancelamento=$$v},expression:"modalConfirmaCancelamento"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Tem certeza que deseja cancelar este pedido?")])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"left labelSelect"},[_vm._v("Por favor, justifique o cancelamento deste pedido")]),_vm._v(" "),_c('b-form-textarea',{staticClass:"mt-3",attrs:{"id":"textarea","rows":"3","max-rows":"6"},model:{value:(_vm.textoMotivoCancelamento),callback:function ($$v) {_vm.textoMotivoCancelamento=$$v},expression:"textoMotivoCancelamento"}})],1)],2),_vm._v(" "),_c('b-modal',{attrs:{"title":"Escolha um item","header-text-variant":_vm.headerTextVariant,"header-bg-variant":_vm.headerBgVariant,"size":"lg","hide-footer":""},model:{value:(_vm.modalItens),callback:function ($$v) {_vm.modalItens=$$v},expression:"modalItens"}},[_c('div',[_c('b-input-group',[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Pesquisar por descrição, cor, tamanho...","autocomplete":"off"},on:{"focus":function($event){return _vm.limpaPesq()}},model:{value:(_vm.pesquisa.termo),callback:function ($$v) {_vm.$set(_vm.pesquisa, "termo", $$v)},expression:"pesquisa.termo"}}),_vm._v(" "),_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text",attrs:{"autocomplete":"no"},on:{"click":function($event){return _vm.pesquisarGrades()}}},[_c('i',{staticClass:"fa fa-search"})])])],1)],1),_vm._v(" "),(_vm.grades.length > 0)?_c('div',{staticClass:"mt-3 table"},[_c('b-table',{staticClass:"mt-0",attrs:{"bordered":"","striped":"","small":"","fields":_vm.fieldsGrades,"items":_vm.grades},scopedSlots:_vm._u([{key:"urlImagemGrade",fn:function(row){return [(row.item.urlImagemGrade === '')?_c('img',{attrs:{"src":__webpack_require__("7sUr"),"alt":""}}):_c('img',{attrs:{"src":row.item.urlImagemGrade,"alt":""}})]}},{key:"actions",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.buscarProdutosGrade(row.item)}}},[_vm._v("\n              Selecionar\n            ")])]}}],null,false,3071221439)})],1):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-scoped","size":"xl","ok-title":"Imprimir","ok-variant":"primary","cancel-title":"Fechar","cancel-variant":"secondary","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.imprimirPDF},model:{value:(_vm.modalImpressao),callback:function ($$v) {_vm.modalImpressao=$$v},expression:"modalImpressao"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Visualizar Impressão")])]),_vm._v(" "),_c('div',{attrs:{"id":"impressaoPedido"},domProps:{"innerHTML":_vm._s(_vm.htmlImpressao)}})],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Sim","ok-variant":"primary","cancel-title":"Não","size":"md","title":"Confirmação","centered":""},on:{"ok":function($event){return _vm.salvarPedido()},"cancel":_vm.mostraRepNatIvo},model:{value:(_vm.modalConfirmaRepLog),callback:function ($$v) {_vm.modalConfirmaRepLog=$$v},expression:"modalConfirmaRepLog"}},[_vm._v("\n      Você realmente deseja inserir essa venda para o(a) representante "),_c('b',[_vm._v(_vm._s(_vm.pedido.representante.apelido))]),_vm._v("?\n      ")]),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Sim","ok-variant":"primary","cancel-title":"Não","size":"sm","title":"Excluir Item","centered":""},on:{"ok":function($event){return _vm.removerItem(_vm.excluirItem)}},model:{value:(_vm.modalExclusao),callback:function ($$v) {_vm.modalExclusao=$$v},expression:"modalExclusao"}},[_vm._v("\n      Você tem certeza que deseja excluir este item do pedido?\n      ")]),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Sim","ok-variant":"primary","cancel-title":"Não","size":"sm","title":"Excluir Observação","centered":""},on:{"ok":function($event){return _vm.removerObs(_vm.excluirObs)}},model:{value:(_vm.modalExclusaoObs),callback:function ($$v) {_vm.modalExclusaoObs=$$v},expression:"modalExclusaoObs"}},[_vm._v("\n      Você tem certeza que deseja excluir esta observação do pedido?\n      ")]),_vm._v(" "),_c('modal-add-itens-vue',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalItensVisible),expression:"isModalItensVisible"}],attrs:{"pedidoSelecionado":_vm.pedido},on:{"close":_vm.closeModal}}),_vm._v(" "),_c('b-modal',{attrs:{"title":"Pesquise um cliente","header-text-variant":_vm.headerTextVariant,"header-bg-variant":_vm.headerBgVariant,"size":"lg","hide-footer":""},model:{value:(_vm.modalClienteInd),callback:function ($$v) {_vm.modalClienteInd=$$v},expression:"modalClienteInd"}},[_c('div',[_c('b-input-group',[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Cód. Cliente, Fantasia, Razão, CNPJ e Endereço","autocomplete":"no"},model:{value:(_vm.pesquisaClienteInd.termo),callback:function ($$v) {_vm.$set(_vm.pesquisaClienteInd, "termo", $$v)},expression:"pesquisaClienteInd.termo"}}),_vm._v(" "),_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text",on:{"click":function($event){return _vm.pesquisarClienteInd()}}},[_c('i',{staticClass:"fa fa-search"})])])],1)],1),_vm._v(" "),(_vm.clientesPesquisados.length > 0)?_c('div',{staticClass:"mt-3 table"},[_c('b-table',{staticClass:"mt-0",attrs:{"bordered":"","striped":"","small":"","fields":_vm.fieldsClientesInd,"items":_vm.clientesPesquisados},scopedSlots:_vm._u([{key:"actions",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.selecionarClienteInd(row.item)}}},[_vm._v("\n              Selecionar\n            ")])]}}],null,false,2749510465)})],1):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Sim","ok-variant":"primary","cancel-title":"Não","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.pageLista},model:{value:(_vm.modalVoltarConfirma),callback:function ($$v) {_vm.modalVoltarConfirma=$$v},expression:"modalVoltarConfirma"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Sair sem Salvar")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza que deseja sair sem salvar as alterações deste pedido?")])],2),_vm._v(" "),(_vm.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.msgBlockUi}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e(),_vm._v(" "),_c('toast-vue',{attrs:{"idToast":_vm.idToast,"variant":_vm.variant,"titleMsg":_vm.titleMsg,"message":_vm.message}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R/zC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RDVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"card shadow"},[_c('b-card',{staticClass:"promocoes"},[_c('p',[_vm._v("teste")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RQUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_relatorios__ = __webpack_require__("OLWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_google_charts__ = __webpack_require__("kXf/");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import { broadcastServer } from '@/main'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ToastVue: __WEBPACK_IMPORTED_MODULE_2__layouts_toastVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__["a" /* default */],
    GChart: __WEBPACK_IMPORTED_MODULE_4_vue_google_charts__["GChart"]
  },
  props: {
    pResumoComissoes: {
      valorMes: {
        mes: '',
        valor: 0
      },
      extrato: [],
      porCategoria: [],
      aceite: {},
      mes: 0,
      ano: 0
    },
    pObjClientes: {},
    pObjPaginacao: {}
  },
  data: function data() {
    return {
      cor: '',
      // resumoComissoes: [],
      // resumoComissoesCategorias: [],
      totalResumo: 0,
      totalResumoCategoria: 0,
      periodoSelecionado: '',
      resumoComissoes: '',
      totalCategoria: '',
      totalExtrato: '',
      valorMes: '',
      chartData: [['Year', 'Sales'], ['Março', 1000], ['Abril', 1170]],
      chartOptions: {
        chart: {
          title: 'Company Performance',
          subtitle: 'Sales, Expenses, and Profit: 2014-2017'
        }
      },
      modalMotivoRecusa: false,
      blockUI: {
        message: '',
        visibility: false
      },
      noticeAssina: false,
      noticeInfo: false,
      noticeBackoffice: false,
      tipoPedido: [],
      statusSelecionado: {},
      clientes: [],
      modes: ['single'],
      selectMode: 'single',
      selected: [],
      motivo: '',
      assinaComissao: false,
      parametros: {
        mes: 0,
        ano: 0,
        aceita: 0,
        motivo: ''
      },
      fieldsPeriodo: [{
        key: 'periodo',
        label: 'Periodo',
        sortable: false,
        class: 'txtCenter',
        isActive: true
      }, {
        key: 'valor',
        label: 'Valor',
        class: 'txtRight',
        isActive: true,
        formatter: this.formatPrice
      }],
      fieldsCategoria: [{
        key: 'categoria',
        label: 'Categoria',
        sortable: false,
        class: 'txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'valor',
        label: 'Valor',
        sortable: false,
        class: 'txtRight',
        formatter: this.formatPrice
      }],
      fieldsExtrato: [{
        key: 'fantasia',
        label: 'Cliente',
        sortable: true,
        class: 'relComFant txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'dataEmissao',
        label: 'Data Emissão',
        sortable: false,
        class: 'relComEmi txtCenter'
      }, {
        key: 'notaFiscal',
        label: 'NF',
        sortable: false,
        class: 'relComNF txtCenter'
      }, {
        key: 'valorBase',
        label: 'Base',
        sortable: false,
        class: 'relComBase txtCenter',
        formatter: this.formatPrice
      }, {
        key: 'percentual',
        label: '%',
        sortable: false,
        class: 'relComPerc txtCenter'
      }, {
        key: 'categoria',
        label: 'Categoria',
        sortable: false,
        class: 'relComCateg txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'valorComissao',
        label: 'Valor Comissão',
        sortable: false,
        class: 'relComVCom txtRight',
        formatter: this.formatPrice
      }, {
        label: '',
        key: 'mobile',
        class: 'relComMobile txtLeft'
      }]
    };
  },

  watch: {
    pResumoComissoes: function pResumoComissoes(newVal, oldVal) {
      // watch it
      if (newVal.aceite.aceita === 1) {
        this.noticeAssina = false;
        this.noticeInfo = true;
        this.noticeBackoffice = false;
      } else if (newVal.aceite.aceita === 0 && newVal.aceite.mensagemRejeicao !== '') {
        this.noticeAssina = true;
        this.noticeInfo = false;
        this.noticeBackoffice = true;
      } else if (newVal.aceite.aceita === 0 && newVal.aceite.mensagemRejeicao === '') {
        this.noticeAssina = true;
        this.noticeInfo = false;
        this.noticeBackoffice = false;
      }
      this.mostraAceiteComissao();
      var extrato = newVal.extrato.sort(function (a, b) {
        return a.dataEmissaoOrdem - b.dataEmissaoOrdem;
      });
      this.parametros.mes = this.pResumoComissoes.mes;
      this.parametros.ano = this.pResumoComissoes.ano;
      this.pResumoComissoes.extrato = extrato;
      this.totalCategoria = newVal.porCategoria.reduce(function (r, a) {
        return r + a.valor;
      }, 0);
      this.totalExtrato = newVal.extrato.reduce(function (r, a) {
        return r + a.valorComissao;
      }, 0);
    }
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    setTimeout(this.mostraAceiteComissao, 100);
  },

  methods: {
    mostraAceiteComissao: function mostraAceiteComissao() {
      var dataCorrente = new Date().getMonth() + 1;
      var anoCorrente = new Date().getFullYear();
      var mesAnterior = dataCorrente - 1;
      var dataSelecionada = this.pResumoComissoes.mes;
      var anoSelecionado = JSON.parse(this.pResumoComissoes.ano);
      if (dataCorrente === dataSelecionada && anoCorrente === anoSelecionado) {
        this.noticeAssina = false;
      } else if (dataSelecionada === mesAnterior && anoCorrente === anoSelecionado) {
        this.noticeAssina = true;
      } else {
        this.noticeAssina = false;
      }
      // } else this.noticeAssina = !((dataCorrente < dataSelecionada) && (anoCorrente === anoSelecionado))
    },
    enviar: function enviar(aceita, motivo) {
      var _this = this;

      this.blockUI.message = 'Enviando dados, aguarde...';
      this.blockUI.visibility = true;
      this.parametros.mes = this.pResumoComissoes.mes;
      this.parametros.ano = this.pResumoComissoes.ano;
      this.parametros.aceita = aceita;
      this.parametros.motivo = motivo;
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.parametros));
      __WEBPACK_IMPORTED_MODULE_1__services_relatorios__["a" /* default */].enviar(this.parametros).then(function (response) {
        console.log(response.data);
        _this.pResumoComissoes = response.data;
        _this.pResumoComissoes.mes = _this.parametros.mes;
        _this.pResumoComissoes.ano = _this.parametros.ano;
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this.blockUI.visibility = false;
        _this.modalMotivoRecusa = false;
      });
    },
    naoAceita: function naoAceita() {
      this.modalMotivoRecusa = true;
    },
    enviarMotivoRecusa: function enviarMotivoRecusa() {
      // let objectPost = {mes: '', ano: '', aceita: 0, motivo: ''}
    },
    assinatura: function assinatura() {
      this.noticeAssina = false;
      this.noticeInfo = false;
      this.noticeBackoffice = false;
      var semMotivo = this.aceitaComissao.mensagemRejeicao = '';
      if (this.aceitaComissao.aceita === 0) {
        this.noticeAssina = true;
      } else if (this.aceitaComissao.aceita === 0 && semMotivo) {
        this.noticeAssina = true;
        this.noticeBackoffice = true;
      } else {
        this.noticeBackoffice = true;
      }
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }
});

/***/ }),

/***/ "RZCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewItemsClientesVue_vue__ = __webpack_require__("jtrm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b7e4a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewItemsClientesVue_vue__ = __webpack_require__("iYuE");
function injectStyle (ssrContext) {
  __webpack_require__("Wh2W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48b7e4a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewItemsClientesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b7e4a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewItemsClientesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RfKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CardVue',
  props: ['title', 'header', 'comunicado']
});

/***/ }),

/***/ "RjI3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RuvD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SSQZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerVue_vue__ = __webpack_require__("lrkH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cec575e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerVue_vue__ = __webpack_require__("EfIp");
function injectStyle (ssrContext) {
  __webpack_require__("sErP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cec575e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cec575e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ScOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovoPedidoVue_vue__ = __webpack_require__("bGgs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_980b647c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovoPedidoVue_vue__ = __webpack_require__("Q9Zx");
function injectStyle (ssrContext) {
  __webpack_require__("T84B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-980b647c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovoPedidoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_980b647c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovoPedidoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T84B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TwnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-toast',{attrs:{"id":_vm.idToast,"variant":_vm.variant,"solid":""}},[_c('div',{staticClass:"d-flex flex-grow-1 align-items-baseline",attrs:{"slot":"toast-title"},slot:"toast-title"},[_c('strong',{staticClass:"mr-auto"},[_vm._v(_vm._s(_vm.titleMsg))])]),_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UHsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {}
});

/***/ }),

/***/ "UiTa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"impressaoPedido"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h3',{staticClass:"txtLeft mt-3"},[_vm._v("Detalhes do Cliente")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"txtLeft"},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b',[_vm._v("Cliente: ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b',[_vm._v("Contato: ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b',[_vm._v("Fantasia: ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b',[_vm._v("CNPJ: ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b',[_vm._v("Endereço: ")])])],1),_vm._v(" "),_c('h3',{staticClass:"txtLeft mt-3"},[_vm._v("Detalhes do Pedido")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b',[_vm._v("Representante: ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b',[_vm._v("Pedido: ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b',[_vm._v("Tipo Frete: ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b',[_vm._v(" Transp.: ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b',[_vm._v("Condição de Pagamento: ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b',[_vm._v("Forma de Pagamento: ")])])],1),_vm._v(" "),_c('h3',{staticClass:"txtLeft mt-3"},[_vm._v("Totais")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('span',[_vm._v("categoria")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('span',[_vm._v("R$")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b',[_vm._v("R$")])])],1),_vm._v(" "),_c('h3',{staticClass:"txtLeft mt-3"},[_vm._v("Observações")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('span',[_vm._v("Tipo obs")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('span',[_vm._v("obs")])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"border-top col-5 mt-5"},[_c('p',[_vm._v("Representante")])]),_vm._v(" "),_c('b-col',{staticClass:"border-top offset-2 col-5 mt-5"},[_c('p',[_vm._v("Cliente")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"container p-5",attrs:{"id":"impressaoListaPedidos"}},[_c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.items}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txtRight"},[_c('p',[_c('b',[_vm._v("Grupo|GC")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contanto: ")])]),_vm._v(" "),_c('p',[_vm._v("site")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txtLeft"},[_c('b',[_vm._v("Endereço: ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VDoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pProgressMetasValues: {}
  },
  data: function data() {
    return {
      variant: '',
      metaAtingida: 0,
      restante: 0,
      max: 100
    };
  },

  watch: {
    pProgressMetasValues: function pProgressMetasValues(newVal, oldVal) {
      // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      var atingido = newVal.valorAtingido;
      var meta = newVal.valorMeta;

      if (meta > 0) {
        var metaAtingida = parseFloat(atingido * 100 / meta); // valor atingido em porcentagem do valor da meta
        var restante = 100 - metaAtingida; // 100 - porc de valor da meta
        this.restante = restante;
        this.metaAtingida = metaAtingida;
        if (metaAtingida < 32) {
          this.variant = 'danger';
        } else if (metaAtingida > 33 && metaAtingida < 66) {
          this.variant = 'warning';
        } else {
          this.variant = 'success';
        }
      } else {
        this.restante = 0.00;
        this.metaAtingida = 0.00;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "VaBq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vh38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_relatorios__ = __webpack_require__("OLWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_items_ProgressMetasVue__ = __webpack_require__("flXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_search_select__ = __webpack_require__("ZAW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import relatoriosService from '@/services/relatorios'








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ToastVue: __WEBPACK_IMPORTED_MODULE_1__layouts_toastVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__["swiperSlide"],
    ProgressMetasVue: __WEBPACK_IMPORTED_MODULE_6__components_items_ProgressMetasVue__["a" /* default */],
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_7_vue_search_select__["ModelListSelect"]
  },
  props: {
    pObjClientes: {},
    pObjPaginacao: {},
    pMetasDados: {
      porCategoria: [],
      mesAtual: {}
    }
  },
  data: function data() {
    return {
      variant: '',
      fieldsMensal: [{
        key: 'desempenho',
        label: ' ',
        sortable: false,
        class: 'relMetDesemp td-pg txtLeft white'
      }, {
        key: 'valorMeta',
        label: 'Meta',
        sortable: false,
        class: 'relMetMeta txtRight',
        formatter: this.formatterValue
      }, {
        key: 'valorAtingido',
        label: 'Atingido',
        sortable: false,
        class: 'relMetAting txtRight',
        formatter: this.formatterValue
      }, {
        key: 'valorMedio',
        label: 'Média',
        sortable: false,
        class: 'relMetMedio txtRight',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobileGeral',
        class: 'relMetGeralMobile txtLeft'
      }],
      fieldsCategoria: [{
        key: 'categorias',
        label: 'Categorias',
        sortable: false,
        class: 'relMetDesemp td-pg txtLeft td-pg-title'
      }, {
        key: 'valorMeta',
        label: 'Meta',
        sortable: false,
        class: 'relMetMeta txtRight',
        formatter: this.formatterValue
      }, {
        key: 'valorAtingido',
        label: 'Atingido',
        sortable: false,
        class: 'relMetAting txtRight',
        formatter: this.formatterValue
      }, {
        key: 'valorMedio',
        label: 'Média',
        sortable: false,
        class: 'relMetMedio txtRight',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobileCategorias',
        class: 'relMetCategMobile txtLeft'
      }],
      cor: '',
      slotFirstcategoria: null,
      restante: 0,
      metaAtingida: 0,
      max: 100,
      animate: true,
      blockUI: {
        message: '',
        visibility: false
      },
      categoriaTodos: {
        codigo: '',
        descricao: '',
        ordem: -100
      },
      categoriaSelecionada: {},
      options: [],
      tipoPedido: [],
      statusSelecionado: {},
      clientes: [],
      anos: [],
      anoCorrente: 0,
      anoSelecionado: 0,
      MetasAtingido: [],
      categoriasRepresentante: [],
      representanteSelecionado: {},
      representantes: [],
      categoriasTodas: {
        codigo: '',
        descricao: 'Todas as Categorias',
        ordem: -100
      },
      tableMes: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp')
      // this.representantes = JSON.parse(localStorage.getItem('representantesLogin'))
    };var date = new Date();
    this.anoCorrente = date.getFullYear();
    this.anoSelecionado = this.anoCorrente;
    // this.anosMetas()
    // this.categoriaRepresentante()
  },

  watch: {
    pMetasDados: function pMetasDados(newVal, oldVal) {
      // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.tableMes = [];
      this.tableMes.push(newVal.mesAtual);
    }
  },
  methods: {
    onChartReady: function onChartReady(chart, google) {
      this.chartsLib = google;
    },

    buscar: function buscar() {
      this.metaXAtingido();
    },
    onChangeCategoria: function onChangeCategoria(index) {
      var categoria = this.categoriasRepresentante[index];
      this.categoriaSelecionada = categoria;
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(categoria));
      this.MetasAtingido = [];
    },
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    anosMetas: function anosMetas() {
      var _this = this;

      this.blockUI.visibility = true;
      this.blockUI.message = 'Listando anos, aguarde...';
      __WEBPACK_IMPORTED_MODULE_3__services_relatorios__["a" /* default */].listarAnosMetas().then(function (response) {
        var anos = [];
        for (var i = 0; i < response.data.anos.length; i++) {
          anos.push({ ano: response.data.anos[i] });
        }
        var anosAux = anos;
        anos = anosAux.sort(function (a, b) {
          return a.ano - b.ano;
        });
        _this.anos = anos;
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this.blockUI.visibility = false;
      });
    },
    resumoMetas: function resumoMetas() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_relatorios__["a" /* default */].listarMetas().then(function (response) {
        _this2.atingimentoMeta = response.data;
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this2.blockUI.visibility = false;
      });
    },
    categoriaRepresentante: function categoriaRepresentante() {
      var _this3 = this;

      this.blockUI.visibility = true;
      this.blockUI.message = 'Listando categorias, aguarde...';
      __WEBPACK_IMPORTED_MODULE_3__services_relatorios__["a" /* default */].listarCatRepresentante().then(function (response) {
        var categs = response.data.categorias.sort(function (a, b) {
          return a.ordem - b.ordem;
        });
        categs.unshift({
          codigo: '',
          descricao: 'Todas as Categorias',
          ordem: -100
        });
        _this3.categoriaSelecionada = {
          codigo: '',
          descricao: 'Todas as Categorias',
          ordem: -100
        };
        _this3.categoriasRepresentante = categs;
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this3.blockUI.visibility = false;
      });
    },
    selecionarAno: function selecionarAno(ano) {
      this.anoSelecionado = ano;
      this.MetasAtingido = [];
    },
    metaXAtingido: function metaXAtingido() {
      var _this4 = this;

      var ano = this.anoSelecionado;
      this.blockUI.visibility = true;
      this.blockUI.message = 'Listando metas, aguarde...';
      var codigoCategoria = '';
      if (this.categoriaSelecionada !== null) {
        if (typeof this.categoriaSelecionada.codigo !== 'undefined' && this.categoriaSelecionada.codigo !== '') {
          codigoCategoria = this.categoriaSelecionada.codigo;
        }
      }
      var parametros = { ano: ano, codCategoria: codigoCategoria };
      __WEBPACK_IMPORTED_MODULE_3__services_relatorios__["a" /* default */].MetasVsAtingido(parametros).then(function (response) {
        _this4.MetasAtingido = response.data.metas.sort(function (a, b) {
          return a.periodo - b.periodo;
        });
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this4.blockUI.visibility = false;
      });
    }
  }
});

/***/ }),

/***/ "WXZH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    header: '',
    pCardNovidadesValues: { destaques: [] }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var cor = state.cor.cor;

      return {
        'background-color': cor
      };
    }
  })),
  watch: {
    pCardNovidadesValues: function pCardNovidadesValues(newVal, oldVal) {
      // watch it
      this.destaques = newVal;
    }
  },
  data: function data() {
    return {
      destaques: [],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 5,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          // 1024: {
          //   slidesPerView: 4,
          //   spaceBetween: 40
          // },
          768: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 20
            // ,
            // 320: {
            //   slidesPerView: 2,
            //   spaceBetween: 20
            // }
          } }
      }
    };
  },
  mounted: function mounted() {
    this.destaques = this.pCardNovidadesValues;
  }
});

/***/ }),

/***/ "Wh2W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XSrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeVue_vue__ = __webpack_require__("rPU6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ddee81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeVue_vue__ = __webpack_require__("AX/c");
function injectStyle (ssrContext) {
  __webpack_require__("JqBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ddee81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XdU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YETF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tableClientes__ = __webpack_require__("FZRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import { mapState } from 'vuex'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableClientesVue',
  props: ['title'],
  components: {
    spinnerVue: __WEBPACK_IMPORTED_MODULE_2__components_items_SpinnerVue__["a" /* default */]
  },
  data: function data() {
    return {
      components: {
        TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["TheMask"]
      },
      blockUiVisibility: false,
      msgBlockUi: '',
      clientes: [],
      uf: '',
      cor: '',
      termo: '',
      cidade: '',
      // Note 'isActive' is left out and will not appear in the rendered table
      fields: [{
        key: 'codCliente',
        label: 'Cód. Cli.',
        sortable: true,
        class: 'cliListCod txtLeft'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'cliListFant txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true,
        class: 'cliListRaz txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'cnpjCpf',
        label: 'CNPJ/CPF',
        sortable: true,
        class: 'cliListCnpj txtLeft',
        formatter: this.formatterCnpjCpf
      }, {
        key: 'endereco',
        label: 'Endereço',
        sortable: true,
        class: 'cliListEnd txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'uf',
        label: 'UF',
        sortable: true,
        class: 'cliListUf txtLeft'
      }, {
        key: 'cidade',
        label: 'Cidade',
        sortable: true,
        class: 'cliListCid txtLeft',
        formatter: this.toCapitalize
      }, {
        label: '',
        key: 'mobile',
        class: 'cliListMobile txtLeft'
      }, {
        label: 'Ação',
        key: 'actions',
        class: 'cliListAcoes'
      }]
    };
  },
  created: function created() {
    var _this = this;

    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    this.corComp = { 'style: background-color': '#' + localStorage.getItem('corApp') };
    __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$on('parametrosSelecionadosCliente', function (parametros) {
      // console.log('filtros: ' + JSON.stringify(parametros))
      _this.msgBlockUi = 'Listando clientes, aguarde...';
      _this.blockUiVisibility = true;
      _this.listar(parametros);
    });
  },
  mounted: function mounted() {
    var parametros = { termo: this.termo, uf: this.uf, cidade: this.cidade };
    this.msgBlockUi = 'Listando clientes, aguarde...';
    this.blockUiVisibility = true;
    this.listar(parametros);
  },

  methods: {
    listar: function listar(parametros) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_tableClientes__["a" /* default */].listarSelect(parametros).then(function (response) {
        _this2.clientes = response.data.clientes;
        // this.clientes = response.data.clientes.replace(
        //   /\w\S*/g,
        //   function (txt) {
        //     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        //   }
        // )
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this2.blockUiVisibility = false;
      });
    },
    pageEdit: function pageEdit(item, index) {
      var _this3 = this;

      this.blockUiVisibility = true;
      var parametrosEdit = { id: item.id, codCliente: item.codCliente, clienteNovo: item.clienteNovo };
      __WEBPACK_IMPORTED_MODULE_0__services_tableClientes__["a" /* default */].editCliente(parametrosEdit).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('pageEditClienteResponse', response.data);
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this3.blockUiVisibility = false;
        var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_1__main__["operacao"].ALTERAR, modo: __WEBPACK_IMPORTED_MODULE_1__main__["modo"].EDICAO };
        __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('pageEditClientes', parametro);
      });
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterCnpjCpf: function formatterCnpjCpf(value) {
      if (value.length === 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
      }
      if (value.length === 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
      }
    }
  }
});

/***/ }),

/***/ "YG69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",attrs:{"role":"tablist","id":"listPedido"}},[_c('div',{},[_c('div',{},[(this.statusX.length)?_c('h5',{staticClass:"txtLeft",staticStyle:{"border-bottom":"1px solid #cecece"}},[_vm._v("Go Sales")]):_vm._e(),_vm._v(" "),_vm._l((this.statusX),function(statusX){return _c('b-card',{key:statusX.codigo+'X',staticClass:"mb-1 shadow b-radius-0",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapseX' + statusX.codigo),expression:"'collapseX' + statusX.codigo"}],attrs:{"block":"","variant":"secondary"}},[_vm._v(_vm._s(statusX.descricao))])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":'collapseX' + statusX.codigo,"accordion":"my-accordion","role":"tabpanel"}},[_c('b-card',[_c('b-card-text',{staticClass:"table"},[(!_vm.empresaKatec)?_c('b-table',{attrs:{"bordered":"","striped":"","items":statusX.pedidos,"fields":_vm.fieldsPedidos},scopedSlots:_vm._u([{key:"statusPedido",fn:function(row){return [_vm._v("\n                  "+_vm._s(row.item.status.descricao)+"\n                ")]}},{key:"urlImagemCanal",fn:function(row){return [_c('img',{staticClass:"m-1",attrs:{"src":row.item.canal.url}})]}},{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v(_vm._s(row.item.fantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 txtRight"},[_c('strong',[_vm._v("CÓD.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("ID Gosales:")]),_vm._v(" "+_vm._s(row.item.id))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.emissao !== '')?_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: "+_vm._s(row.item.emissao))]):_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: -")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 txtRight"},[_vm._v("Status: ")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-4 pedListImgMob"},[_c('img',{attrs:{"src":row.item.canal.url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8 mt-2 txtRight"},[_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.totalPedido)))])])])]}},{key:"acao",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.pageEdit(row.item, row.index)}}},[_vm._v("\n                    "+_vm._s(row.item.isEditavel ? 'Editar' : 'Visualizar')+"\n                  ")])]}}],null,true)}):_c('b-table',{attrs:{"bordered":"","striped":"","items":statusX.pedidos,"fields":_vm.fieldsPedidosKatec},scopedSlots:_vm._u([{key:"statusPedido",fn:function(row){return [_vm._v("\n                  "+_vm._s(row.item.status.descricao)+"\n                ")]}},{key:"urlImagemCanal",fn:function(row){return [_c('img',{staticClass:"m-1",attrs:{"src":row.item.canal.url}})]}},{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v(_vm._s(row.item.fantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 txtRight"},[_c('strong',[_vm._v("CÓD.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("ID Gosales:")]),_vm._v(" "+_vm._s(row.item.id))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.emissao !== '')?_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: "+_vm._s(row.item.emissao))]):_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: -")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 txtRight"},[_vm._v("Status: ")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-4 pedListImgMob"},[_c('img',{attrs:{"src":row.item.canal.url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8 mt-2 txtRight"},[_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.totalPedido)))])])])]}},{key:"acao",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.pageEdit(row.item, row.index)}}},[_vm._v("\n                    "+_vm._s(row.item.isEditavel ? 'Editar' : 'Visualizar')+"\n                  ")])]}}],null,true)})],1)],1)],1)],1)})],2),_vm._v(" "),_c('br'),_vm._v(" "),(this.status.length)?_c('h5',{staticClass:"txtLeft",staticStyle:{"border-bottom":"1px solid #cecece"}},[_vm._v("ERP")]):_vm._e(),_vm._v(" "),_vm._l((this.status),function(status){return _c('b-card',{key:status.codigo,staticClass:"mb-1 shadow b-radius-0",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse' + status.codigo),expression:"'collapse' + status.codigo"}],attrs:{"block":"","variant":"secondary"}},[_vm._v(_vm._s(status.descricao))])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":'collapse' + status.codigo,"accordion":"my-accordion","role":"tabpanel"}},[_c('b-card',[_c('b-card-text',{staticClass:"table"},[(!_vm.empresaKatec)?_c('b-table',{attrs:{"bordered":"","striped":"","items":status.pedidos,"fields":_vm.fieldsPedidos},scopedSlots:_vm._u([{key:"statusPedido",fn:function(row){return [_vm._v("\n                "+_vm._s(row.item.status.descricao)+"\n              ")]}},{key:"urlImagemCanal",fn:function(row){return [_c('img',{staticClass:"m-1",attrs:{"src":row.item.canal.url}})]}},{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 txtRight"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1 w-100 pl-1 pr-1"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1 w-100 pl-1 pr-1"},[_vm._v(_vm._s(row.item.cnpjCpf))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.numeroOrcamento !== '')?_c('div',{staticClass:"col-md-8"},[_vm._v("N. Orc: "+_vm._s(row.item.numeroOrcamento))]):_c('div',{staticClass:"col-md-8"},[_vm._v("N. Orc: -")]),_vm._v(" "),(row.item.numeroPedido)?_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("N. Ped: "+_vm._s(row.item.numeroPedido))]):_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("N. Ped: -")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.emissao !== '')?_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: "+_vm._s(row.item.emissao))]):_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: -")]),_vm._v(" "),(row.item.numeroPedidoCompra !== '')?_c('div',{staticClass:"col-md-6 txtRight"},[_vm._v("Ped. Compra: "+_vm._s(row.item.numeroPedidoCompra))]):_c('div',{staticClass:"col-md-6 txtRight"},[_vm._v("Ped. Compra: -")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-4 pedListImgMob"},[_c('img',{attrs:{"src":row.item.canal.url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8 txtRight"},[_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.totalPedido)))])])])]}},{key:"acao",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.pageEdit(row.item, row.index)}}},[_vm._v("\n                  "+_vm._s(row.item.isEditavel ? 'Editar' : 'Visualizar')+"\n                ")])]}}],null,true)}):_c('b-table',{attrs:{"bordered":"","striped":"","items":status.pedidos,"fields":_vm.fieldsPedidosKatec},scopedSlots:_vm._u([{key:"statusPedido",fn:function(row){return [_vm._v("\n                "+_vm._s(row.item.status.descricao)+"\n              ")]}},{key:"urlImagemCanal",fn:function(row){return [_c('img',{staticClass:"m-1",attrs:{"src":row.item.canal.url}})]}},{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 txtRight"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1 w-100 pl-1 pr-1"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1 w-100 pl-1 pr-1"},[_vm._v(_vm._s(row.item.cnpjCpf))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.numeroOrcamento !== '')?_c('div',{staticClass:"col-md-8"},[_vm._v("N. Orc: "+_vm._s(row.item.numeroOrcamento))]):_c('div',{staticClass:"col-md-8"},[_vm._v("N. Orc: -")]),_vm._v(" "),(row.item.numeroPedido)?_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("N. Ped: "+_vm._s(row.item.numeroPedido))]):_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("N. Ped: -")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.emissao !== '')?_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: "+_vm._s(row.item.emissao))]):_c('div',{staticClass:"col-md-6"},[_vm._v("Emissão: -")]),_vm._v(" "),(row.item.numeroPedidoCompra !== '')?_c('div',{staticClass:"col-md-6 txtRight"},[_vm._v("Ped. Compra: "+_vm._s(row.item.numeroPedidoCompra))]):_c('div',{staticClass:"col-md-6 txtRight"},[_vm._v("Ped. Compra: -")])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-4 pedListImgMob"},[_c('img',{attrs:{"src":row.item.canal.url,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8 txtRight"},[_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.totalPedido)))])])])]}},{key:"acao",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.pageEdit(row.item, row.index)}}},[_vm._v("\n                  "+_vm._s(row.item.isEditavel ? 'Editar' : 'Visualizar')+"\n                ")])]}}],null,true)})],1)],1)],1)],1)})],2),_vm._v(" "),(_vm.buscaVazia)?_c('span',{staticClass:"card mb-5 shadow p-3"},[_vm._v("\n    Não foram encontrados pedidos com os parâmetros pesquisados, por favor, tente novamente\n  ")]):_vm._e(),_vm._v(" "),(_vm.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.msgBlockUi}},[_c('spinner-vue')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YW99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://use.fontawesome.com/releases/v5.2.0/css/all.css","integrity":"sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ","crossorigin":"anonymous"}}),_vm._v(" "),_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Didact+Gothic|Roboto","rel":"stylesheet"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_Login_vue__ = __webpack_require__("300Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_PedidosVue__ = __webpack_require__("kkWH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ClientesVue__ = __webpack_require__("uwvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_HomeVue__ = __webpack_require__("XSrm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_CatalogoVue__ = __webpack_require__("828A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_RelatoriosVue__ = __webpack_require__("5fI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_StaticLayout__ = __webpack_require__("C0PT");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__templates_Login_vue__["a" /* default */]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_8__templates_StaticLayout__["a" /* default */],
    children: [{
      path: '/home',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_HomeVue__["a" /* default */]
    }, {
      path: '/pedidos',
      name: 'pedidos',
      component: __WEBPACK_IMPORTED_MODULE_3__pages_PedidosVue__["a" /* default */]
    }, {
      path: '/clientes',
      name: 'clientes',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_ClientesVue__["a" /* default */]
    }, {
      path: '/relatorios',
      name: 'relatorios',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_RelatoriosVue__["a" /* default */]
    }, {
      path: '/catalogo',
      name: 'catalogo',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_CatalogoVue__["a" /* default */]
    }]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ "ZEuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromocoesVue_vue__ = __webpack_require__("UHsC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273adf19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromocoesVue_vue__ = __webpack_require__("RDVf");
function injectStyle (ssrContext) {
  __webpack_require__("aWtn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273adf19"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromocoesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273adf19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromocoesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zm2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relListCli"}},[_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Clientes com pendência financeira","header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),_c('b-card',{staticClass:"cardBody"},[_c('div',[_c('b-pagination-nav',{attrs:{"size":"sm","number-of-pages":_vm.pObjPaginacao.length,"pages":_vm.pObjPaginacao,"align":"right","use-router":""},on:{"input":_vm.buscarClientesPorPagina},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}})],1),_vm._v(" "),_c('b-card-text',{staticClass:"table"},[_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.clientes,"fields":_vm.fieldsClientes},scopedSlots:_vm._u([{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v(_vm._s(row.item.telefone))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.cnpjCpf.length === 14)?_c('div',{staticClass:"col-md-8"},[_vm._v("CNPJ: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]):_c('div',{staticClass:"col-md-8"},[_vm._v("CPF: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v(_vm._s(row.item.email))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8 text-danger"},[_vm._v("Vencimento: "+_vm._s(row.item.vencimento))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight text-danger"},[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.valor)))])])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-pagination-nav',{attrs:{"size":"sm","number-of-pages":_vm.pObjPaginacao.length,"pages":_vm.pObjPaginacao,"align":"right","use-router":""},on:{"input":_vm.buscarClientesPorPagina},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}})],1)],1)],1),_vm._v(" "),(_vm.blockUI.visibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a+92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",attrs:{"id":"cardObservacoes"}},[_c('b-card-header',{staticStyle:{"background-color":"rgb(55, 71, 79)"},attrs:{"header":_vm.header,"header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),(this.clientesObs.duplicatas)?_c('b-card',{staticClass:"table-responsive-sm"},[(this.clientesObs.duplicatas.length > 0)?_c('b-card-text',{staticClass:"table",attrs:{"id":"tableCliObs"}},[_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.clientesObs.duplicatas,"fields":_vm.fields,"fixed":""}})],1):_c('span',[_vm._v("Não há itens para exibir nesta sessão")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a9Ub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_tableCatalogo__ = __webpack_require__("MW12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import { mapState } from 'vuex'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_4__components_items_SpinnerVue__["a" /* default */]
  },
  props: ['header'],
  data: function data() {
    return {
      blockUiVisibility: false,
      msgBlockUi: 'Listando itens, aguarde...',
      tabelaSelecionada: '',
      termo: '',
      novidades: [],
      categorias: [],
      gradesCategoria: [],
      swiperOptionNov: {
        slidesPerView: 5,
        spaceBetween: 15,
        freeMode: true,
        navigation: {
          nextEl: '.swiperButtonNovNext',
          prevEl: '.swiperButtonNovPrev'
        },
        breakpoints: {
          1000: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 10
          }
        }
        // ,
        // swiperOption: {
        //   slidesPerView: 5,
        //   spaceBetween: 15,
        //   freeMode: true,
        //   navigation: {
        //     nextEl: `.swiperButtonCategNext${index}`,
        //     prevEl: `.swiperButtonCategPrev${index}`
        //   },
        //   breakpoints: {
        //     1000: {
        //       slidesPerView: 4,
        //       spaceBetween: 10
        //     },
        //     700: {
        //       slidesPerView: 3,
        //       spaceBetween: 10
        //     },
        //     500: {
        //       slidesPerView: 2,
        //       spaceBetween: 10
        //     }
        //   }
        // }
      } };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__services_tableCatalogo__["a" /* default */].listarNovidades().then(function (response) {
      var empresa = localStorage.getItem('empresaLogada');
      if (JSON.parse(empresa).identificador === 2355480534) {
        _this.novidades = response.data.destaques.sort(function (a, b) {
          return a.codigo - b.codigo;
        });
      } else {
        _this.novidades = response.data.destaques;
      }
      _this.listarCategorias(_this.termo);
    });
  },

  created: function created() {
    var _this2 = this;

    window.addEventListener('beforeunload', this.toTopOnRefresh);
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    __WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$on('tabelaSelecionada', function (param) {
      _this2.tabelaSelecionada = param;
    });
    __WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$on('filtroCatalogo', function (param) {
      _this2.termo = param;
      _this2.listarCategorias(_this2.termo);
    });
  },
  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    },
    swiperOptionFormat: function swiperOptionFormat(index) {
      return {
        slidesPerView: 5,
        spaceBetween: 15,
        freeMode: true,
        navigation: {
          nextEl: '.swiperButtonCategNext' + index,
          prevEl: '.swiperButtonCategPrev' + index
        },
        breakpoints: {
          1000: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 10
          }
        }
      };
    },
    listarCategorias: function listarCategorias(param) {
      var _this3 = this;

      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_2__services_tableCatalogo__["a" /* default */].listarCategorias(this.termo).then(function (response) {
        var categorias = response.data.catalogos;
        _this3.categorias = categorias.sort(function (a, b) {
          return a.ordem - b.ordem;
        });
        var empresa = localStorage.getItem('empresaLogada');
        if (JSON.parse(empresa).identificador !== 2355480534) {
          var gradesCategoria = _this3.categorias.map(function (g) {
            return g.grades;
          });
          _this3.gradesCategoria = gradesCategoria.sort(function (a, b) {
            return a.ordemGrade - b.ordemGrade;
          });
        } else {
          var _gradesCategoria = _this3.categorias.map(function (g) {
            return g.grades;
          });
          _this3.gradesCategoria = _gradesCategoria.sort(function (a, b) {
            console.log(a, b);
            return a.codigoGrade - b.codigoGrade;
          });
        }
        // this.tabelaSelecionada = response.data
        // broadcastServer.$emit('tabelaSelecionada', this.tabelaSelecionada)
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this3.blockUiVisibility = false;
      });
    },
    selecionarCategoria: function selecionarCategoria(categ) {
      console.log(categ);
    },
    selecionarNovidade: function selecionarNovidade(codigo) {
      var _this4 = this;

      if (this.tabelaSelecionada === '') {
        alert('Por favor, selecione uma tabela de preço');
        return;
      } else {
        this.blockUiVisibility = true;
        var param = { codigoProduto: codigo, codigoTabelaPreco: this.tabelaSelecionada.codigo };
        __WEBPACK_IMPORTED_MODULE_2__services_tableCatalogo__["a" /* default */].detalhesItemNovidade(param).then(function (response) {
          var param = { gradeProdutos: response.data, tabela: _this4.tabelaSelecionada };
          __WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$emit('responseGrade', param);
        }).catch(function (error) {
          console.log(error);
          alert('Aconteceu alguma coisa!' + error);
        }).finally(function () {
          _this4.blockUiVisibility = false;
          var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_3__main__["operacao"].ALTERAR, modo: __WEBPACK_IMPORTED_MODULE_3__main__["modo"].EDICAO };
          __WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$emit('pageViewGrade', parametro);
        });
      }
    },
    selecionarGrade: function selecionarGrade(grade) {
      var _this5 = this;

      if (this.tabelaSelecionada === '') {
        alert('Por favor, selecione uma tabela de preço');
        return;
      } else {
        this.blockUiVisibility = true;
        var param = { codigoGrade: grade.codigoGrade, codigoTabelaPreco: this.tabelaSelecionada.codigo };
        __WEBPACK_IMPORTED_MODULE_2__services_tableCatalogo__["a" /* default */].detalhesItemCategoria(param).then(function (response) {
          var param = { gradeProdutos: response.data, tabela: _this5.tabelaSelecionada };
          __WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$emit('responseGrade', param);
        }).catch(function (error) {
          console.log(error);
          alert('Aconteceu alguma coisa!' + error);
        }).finally(function () {
          _this5.blockUiVisibility = false;
          var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_3__main__["operacao"].ALTERAR, modo: __WEBPACK_IMPORTED_MODULE_3__main__["modo"].EDICAO };
          __WEBPACK_IMPORTED_MODULE_3__main__["broadcastServer"].$emit('pageViewGrade', parametro);
        });
      }
    }
  }
});

/***/ }),

/***/ "aCXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"header-bg-variant":"dark","header-text-variant":"white","ok-title":"Concluir","ok-only":"","ok-variant":"secondary","id":"modalAddItens","size":"xl","title":"Inserir itens no pedido","hideHeaderClose":true,"no-close-on-backdrop":true,"no-close-on-esc":true,"scrollable":""},on:{"ok":_vm.salvarItemFechar},model:{value:(_vm.exibeModal),callback:function ($$v) {_vm.exibeModal=$$v},expression:"exibeModal"}},[_c('div',{staticClass:"m-5"},[(_vm.produtoSelecionado.url)?_c('img',{attrs:{"src":_vm.produtoSelecionado.url,"alt":"","id":"imgGrade"}}):_c('img',{staticClass:"semImagem",attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('b-card',{staticClass:"shadow2 col-md-11 m-z-auto mb-3",attrs:{"border-variant":"light"}},[_c('b-card-text',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Nome: ")]),_vm._v(" "+_vm._s(_vm.gradeProdutos.descricaoGrade))]),_vm._v(" "),(!_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Item: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.codigo))]):_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Código: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.codigo))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[(_vm.mostraCodBarras)?_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Cód. Barras: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.ean))]):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Estoque: ")]),_vm._v(_vm._s(_vm.formatQtde(_vm.produtoSelecionado.estoque)))]),_vm._v(" "),_c('b-col',{staticClass:"txtLeft",attrs:{"cols":"4"}},[_c('b',[_vm._v("Unid.Med: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.unidMed))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Estoque atualizado:")]),_vm._v(" "+_vm._s(_vm.dateTime))])],1),_vm._v(" "),(!_vm.empresaKatec)?_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"txtLeft"},[_c('b',[_vm._v("Descrição: ")]),_vm._v(_vm._s(_vm.produtoSelecionado.descricao))])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[(!_vm.empresaKatec)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Previsão: ")]),_vm._v(_vm._s(_vm.previsao.data))]):_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Próx. Chegada: ")]),_vm._v(_vm._s(_vm.previsao.data))]),_vm._v(" "),(_vm.produtoSelecionado.foraDeLinha === 1)?_c('b-col',{staticClass:"txtLeft col-4"},[_c('b',[_vm._v("Qtd. prevista: "+_vm._s(_vm.formatQtde(_vm.previsao.quantidade)))])]):_vm._e(),_vm._v(" "),(_vm.produtoSelecionado.foraDeLinha === 1)?_c('b-col',{staticClass:"txtLeft text-danger",attrs:{"cols":"col-4"}},[_c('b',[_vm._v("Sem Reposição")])]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2",staticStyle:{"background":"#eee"}},[_c('b-col',{staticClass:"txtCenter"},[_c('b',[_vm._v(_vm._s(this.tabela.descricao))])])],1)],1)],1),_vm._v(" "),(_vm.tamanhos.length > 0)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"12"}},[_c('p',[_vm._v("MODELO")])])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"m-z-auto col-md-11 p-0 mb-3"},[_c('b-form-input',{staticClass:"col-md-11",attrs:{"size":"sm","placeholder":"Pesquisar por descrição ou código do modelo","autocomplete":"off"},model:{value:(_vm.pesqTamanho),callback:function ($$v) {_vm.pesqTamanho=$$v},expression:"pesqTamanho"}}),_vm._v(" "),_c('b-button',{staticClass:"btnLimpaFiltroRep col-md-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltroMod()}}},[_c('i',{staticClass:"fas fa-eraser mr-2"})])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow2 col-md-11 m-z-auto mb-3",attrs:{"border-variant":"light"}},[_c('b-card-text',[(_vm.tamanhos.length > 0)?_c('swiper',{attrs:{"options":_vm.swiperOptionTamanhos,"id":"sliderTamanhos"}},_vm._l((_vm.tamanhosFiltrados),function(tamanho){return _c('swiper-slide',{key:tamanho.codigoTamanho,staticClass:"swiperSlide",nativeOn:{"click":function($event){return _vm.selecionarCores(tamanho.indexOrig, 0, '')}}},[_c('b-button',{class:tamanho.active,attrs:{"variant":"secondary","disabled":_vm.disabled}},[_vm._v(_vm._s(tamanho.descricaoTamanho))]),_vm._v(" "),(tamanho.count > 0)?_c('span',{staticClass:"countTam",style:(_vm.corEmpresa)},[_vm._v(_vm._s(tamanho.count))]):_vm._e()],1)}),1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev swprBtnTamPrev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next swprBtnTamNext",attrs:{"slot":"button-next"},slot:"button-next"})],1)],1),_vm._v(" "),(_vm.cores.length > 0)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"12"}},[_c('p',[_vm._v("VARIANTE")])])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"m-z-auto col-md-11 p-0 mb-3"},[_c('b-form-input',{staticClass:"col-md-11",attrs:{"size":"sm","placeholder":"Pesquisar por descrição, variante, código do produto ou código da variante","autocomplete":"off"},model:{value:(_vm.pesqVariante),callback:function ($$v) {_vm.pesqVariante=$$v},expression:"pesqVariante"}}),_vm._v(" "),_c('b-button',{staticClass:"btnLimpaFiltroRep col-md-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltroVar()}}},[_c('i',{staticClass:"fas fa-eraser mr-2"})])],1),_vm._v(" "),_c('b-card',{staticClass:"shadow2 col-md-11 m-z-auto mb-3",attrs:{"border-variant":"light"}},[_c('b-card-text',[(_vm.cores.length > 0)?_c('swiper',{attrs:{"options":_vm.swiperOptionVariantes}},[_vm._l((_vm.variantesFiltradas),function(cor){return _c('swiper-slide',{key:cor.cor.codigo,staticClass:"selecionar-variante",nativeOn:{"click":function($event){_vm.disabled === false ? _vm.selecionarProduto(cor.cor, cor.indexVarOrig, 0) : ''}}},[(cor.cor.url)?_c('div',{staticClass:"img"},[_c('img',{class:cor.classe,attrs:{"src":cor.cor.url,"alt":""}})]):_c('div',{staticClass:"img semImgItem"},[_c('img',{class:cor.classe,attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('label',{staticClass:"mt-4"},[_vm._v(_vm._s(cor.cor.descricaoCor))]),_vm._v(" "),(cor.count > 0)?_c('span',{staticClass:"countTam",style:(_vm.corEmpresa)},[_vm._v(_vm._s(cor.count))]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev swprBtnVarPrev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next swprBtnVarNext",attrs:{"slot":"button-next"},slot:"button-next"})],1)],1),_vm._v(" "),_c('b-card',{staticClass:"shadow2 col-md-11 m-z-auto mb-3",attrs:{"border-variant":"light"}},[_c('b-card-text',[(_vm.tabelaLote)?_c('div',{staticClass:"table"},[_c('b-table',{attrs:{"selectable":"","select-mode":_vm.selectMode,"selectedVariant":"secondary","fields":_vm.fields,"items":_vm.produtoSelecionado.lotes},on:{"row-selected":_vm.selecionaLote}})],1):_vm._e(),_vm._v(" "),(_vm.opcoesSobMedida)?_c('div',{staticClass:"row"},[_c('label',[_c('b',[_vm._v("Variante Sob Medida")])]),_vm._v(" "),_c('b-form-select',{staticClass:"col-md-4 ml-2 mb-3",attrs:{"options":_vm.options,"disabled":_vm.desabilitaVariante,"size":"sm"},model:{value:(_vm.itemPedido.tipoVarianteSobreMedida),callback:function ($$v) {_vm.$set(_vm.itemPedido, "tipoVarianteSobreMedida", $$v)},expression:"itemPedido.tipoVarianteSobreMedida"}})],1):_vm._e(),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"row"},[(_vm.opcoesSobMedida)?_c('div',{staticStyle:{"margin-right":"17px"}},[_c('label',[_c('b',[_vm._v("Redondo / Oval")])]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button","switch":""},on:{"change":_vm.redondoMudaVariante},model:{value:(_vm.itemPedido.corteRedondo),callback:function ($$v) {_vm.$set(_vm.itemPedido, "corteRedondo", $$v)},expression:"itemPedido.corteRedondo"}})],1):_vm._e(),_vm._v(" "),(_vm.opcoesSobMedida)?_c('div',{staticClass:"mr-4 ml-1"},[_c('label',[_c('b',[_vm._v("Largura:")])]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"type":"text","size":"sm","v-on:change":_vm.calculaDimensao()},model:{value:(_vm.itemPedido.largura),callback:function ($$v) {_vm.$set(_vm.itemPedido, "largura", $$v)},expression:"itemPedido.largura"}}),_vm._v(" "),_c('p',{staticClass:"exTamSobMed text-danger"},[_vm._v("Ex.: 1 metro = 1 | 50 cm = 0.5")])],1):_vm._e(),_vm._v(" "),(_vm.opcoesSobMedida)?_c('div',{staticClass:"mr-5",staticStyle:{"margin-left":"7px"}},[_c('label',[_c('b',[_vm._v("Comprimento:")])]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"type":"text","size":"sm","v-on:change":_vm.calculaDimensao()},model:{value:(_vm.itemPedido.comprimento),callback:function ($$v) {_vm.$set(_vm.itemPedido, "comprimento", $$v)},expression:"itemPedido.comprimento"}}),_vm._v(" "),_c('p',{staticClass:"exTamSobMed text-danger"},[_vm._v("Ex.: 1 metro = 1 | 50 cm = 0.5")])],1):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"txtRight",attrs:{"cols":"4"}},[_c('b',[_vm._v("Preço Tabela:")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","disabled":""},model:{value:(_vm.itemPedido.valorTabela),callback:function ($$v) {_vm.$set(_vm.itemPedido, "valorTabela", $$v)},expression:"itemPedido.valorTabela"}})],1),_vm._v(" "),_c('b-col',{staticClass:"txtRight",attrs:{"cols":"4"}},[_c('b',[_vm._v("Desc.: %")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"type":"text","size":"sm"},on:{"blur":function($event){return _vm.calcularTributos(1)},"focus":function($event){return _vm.desabilitaBotao()}},model:{value:(_vm.itemPedido.percDesconto),callback:function ($$v) {_vm.$set(_vm.itemPedido, "percDesconto", _vm._n($$v))},expression:"itemPedido.percDesconto"}})],1),_vm._v(" "),_c('b-col',{staticClass:"txtRight"},[_c('b',[_vm._v("Quantidade:")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","disabled":this.produtoSelecionado.vendaSobMedidaM2 === 1 || this.produtoSelecionado.lotes.length > 0},on:{"blur":function($event){return _vm.calcularTributos(3)},"focus":function($event){return _vm.desabilitaBotao()}},model:{value:(_vm.itemPedido.qtdVenda),callback:function ($$v) {_vm.$set(_vm.itemPedido, "qtdVenda", $$v)},expression:"itemPedido.qtdVenda"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"txtRight",attrs:{"cols":"4"}},[_c('b',[_vm._v("Valor Unitário:")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm"},on:{"blur":function($event){return _vm.calcularTributos(2)},"focus":function($event){return _vm.desabilitaBotao()}},model:{value:(_vm.itemPedido.valorUnitario),callback:function ($$v) {_vm.$set(_vm.itemPedido, "valorUnitario", $$v)},expression:"itemPedido.valorUnitario"}})],1),_vm._v(" "),_c('b-col',{staticClass:"txtRight",attrs:{"cols":"4"}},[_c('b',[_vm._v("IPI:")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","disabled":""},model:{value:(_vm.itemPedido.valorIPI),callback:function ($$v) {_vm.$set(_vm.itemPedido, "valorIPI", $$v)},expression:"itemPedido.valorIPI"}})],1),_vm._v(" "),_c('b-col',{staticClass:"txtRight",attrs:{"cols":"4"}},[_c('b',[_vm._v("ICMS ST:")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","disabled":""},model:{value:(_vm.itemPedido.valorICMSST),callback:function ($$v) {_vm.$set(_vm.itemPedido, "valorICMSST", $$v)},expression:"itemPedido.valorICMSST"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-4 txtRight"},[_c('b',[_vm._v("Valor Total:")]),_vm._v(" "),_c('b-form-input',{staticClass:"txtRight",attrs:{"size":"sm","disabled":""},model:{value:(_vm.itemPedido.totalItem),callback:function ($$v) {_vm.$set(_vm.itemPedido, "totalItem", $$v)},expression:"itemPedido.totalItem"}})],1),_vm._v(" "),_c('b-col',[(_vm.itemExistPed === 0)?_c('b-button',{staticClass:"offset-9 col-3 mt-3",attrs:{"variant":"primary","disabled":_vm.disableButton},on:{"click":function($event){return _vm.addQtde(0)}}},[_vm._v("Adicionar Item")]):_c('b-button',{staticClass:"offset-9 col-3 mt-3",attrs:{"variant":"primary","disabled":_vm.disableButton},on:{"click":function($event){return _vm.addQtde(1)}}},[_vm._v("Editar Item")])],1)],1)],1)],1)],1),_vm._v(" "),_c('toast-vue',{attrs:{"idToast":_vm.idToastItem,"variant":_vm.variant,"titleMsg":_vm.titleMsg,"message":_vm.message}}),_vm._v(" "),(_vm.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.msgBlockUi}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aVrV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['variant', 'message', 'titleMsg', 'idToast']
});

/***/ }),

/***/ "aWtn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_dashboard__ = __webpack_require__("39Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select__ = __webpack_require__("ZAW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__ = __webpack_require__("05AP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_produto__ = __webpack_require__("MGry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_tableClientes__ = __webpack_require__("FZRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_items_modalAddItensVue__ = __webpack_require__("MfZd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_items_impressaoPedidoVue__ = __webpack_require__("jLdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_money__ = __webpack_require__("9VIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_v_money__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  // props: ['title', 'header', 'clienteSelecionado'],
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_14_vue_the_mask__["mask"],
    money: __WEBPACK_IMPORTED_MODULE_15_v_money__["VMoney"]
  },
  data: function data() {
    return {
      tipoClienteJuridico: false,
      dadosPedidoOriginal: {},
      modalVoltarConfirma: false,
      clienteIndustrializadorNome: '',
      cor: '',
      corSelec: '',
      idToast: 'my-toast-novoPedido',
      titleMsg: '',
      message: '',
      variant: '',
      htmlImpressao: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: false
      },
      desabilitaSelectRepresentante: true,
      inserirItemPedido: {},
      isModalItensVisible: false,
      blockUiVisibility: false,
      visibility: {
        desconto: false
      },
      msgBlockUi: '',
      key: '',
      cidade: '',
      text: '',
      tiposObservacoes: null,
      options: [],
      textoMotivoCancelamento: '',
      headerTextVariant: 'light',
      headerBgVariant: 'dark',
      modalObs: false,
      modalConfirmaCancelamento: false,
      modalItens: false,
      modalImpressao: false,
      modalConfirmaRepLog: false,
      modalExclusao: false,
      modalExclusaoObs: false,
      modalClienteInd: false,
      dashboard: [],
      grades: [],
      clientes: [],
      btnSalvar: true,
      pesquisaClienteInd: {
        termo: '',
        uf: '',
        cidade: ''
      },
      pesquisa: {},
      desconto: {
        percentual: 0.00,
        valor: 0.00
      },
      excluirItem: '',
      excluirObs: '',
      status: [{
        idStatus: 1,
        codigo: '001',
        ordem: 1,
        chaveErp: '001',
        descricao: 'Orçamento',
        classe: 'col-md-4'
      }],
      fieldsGrades: [{
        key: 'urlImagemGrade',
        label: 'Imagem',
        sortable: false,
        tdClass: 'imgTable'
      }, {
        key: 'codigoGrade',
        label: 'Item',
        sortable: true,
        class: 'txtLeft vertical'
      }, {
        key: 'descricaoGrade',
        label: 'Descrição',
        sortable: true,
        class: 'txtLeft vertical'
      }, {
        key: 'actions',
        label: '',
        class: 'txtCenter vertical'
      }],
      fieldsClientesInd: [{
        key: 'cnpjCpf',
        label: 'CNPJ/CPF',
        sortable: true,
        formatter: this.formatterCnpjCpf
      }, {
        key: 'fantasia',
        label: 'Nome Fantasia',
        sortable: true
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true
      }, {
        key: 'actions',
        label: ''
      }],
      hover: true,
      novaObservacao: false,
      indiceObservacaoSelecionada: -1,
      observacao: {
        tipoObservacao: {
          codigo: '',
          exibeImpressao: 0,
          descricao: ''
        },
        observacao: '',
        chaveErp: '',
        numeroPedido: ''
      },
      dadosTabela: {
        condPagtos: [],
        tabelasPreco: [],
        representante: [],
        fretes: [],
        transportadoras: [],
        formaPagtos: [],
        tiposObservacoes: []
      },
      itemCondPagto: {
        codigo: '',
        faixaFinal: 0.00,
        faixaInicial: 0.00,
        descricao: ''
      },
      itemTabelaPreco: {
        codigo: '',
        tipoFrete: '',
        calculaImpostos: 0,
        descricao: ''
      },
      itemRepresentante: {
        codigo: '',
        apelido: ''
      },
      itemFretes: {
        codigo: '',
        descricao: ''
      },
      itemTransportadoras: {
        codigo: '',
        descricao: ''
      },
      itemFormaPagtos: {
        codigo: '',
        descricao: ''
      },
      clientesPesquisados: [],
      pedido: {
        chavePedido: 0,
        numeroPedido: '',
        numeroOrcamento: '',
        id: 0,
        statusGoSales: 2,
        isErp: false,
        isEditavel: true,
        chaveErp: '',
        motivoCancelamento: '',
        cliente: {},
        tabelaPreco: {},
        formaPagto: {},
        condPagto: {},
        tipoFrete: {},
        transportadora: {},
        representante: {},
        observacoes: [],
        itens: [],
        // totais: {}
        totais: {
          valorDesconto: 0.00,
          valorIPI: 0.00,
          valorICMSST: 0.00,
          valorTotal: 0.00
        }
      },
      counter: 0,
      empresaKatec: false,
      empresaAsiatex: false,
      empresaMaioricasa: false,
      percLimiteDescontoRepresentante: 0.00,
      dadosAcesso: '',
      descontoValor: 0,
      habilitaDescGeral: false
    };
  },

  props: {
    header: '',
    title: '',
    clienteSelecionado: {}
  },
  watch: {
    clienteSelecionado: function clienteSelecionado(newVal, oldVal) {
      // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.pedido.cliente = newVal; // this.clienteSelecionado
      this.dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'));
      // let repLogado = JSON.parse(localStorage.getItem('representantesLogin'))
      if (this.dadosAcesso.perfil.id === 3) {
        this.pedido.representante = { codigo: this.dadosAcesso.representante.codigo, apelido: this.dadosAcesso.representante.apelido };
      }
      // let repSelecionado = localStorage.getItem('representanteSelecionado')
    }
  },
  components: {
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_6_vue_search_select__["ModelListSelect"],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_10__components_items_SpinnerVue__["a" /* default */],
    modalAddItensVue: __WEBPACK_IMPORTED_MODULE_11__components_items_modalAddItensVue__["a" /* default */],
    ToastVue: __WEBPACK_IMPORTED_MODULE_13__layouts_toastVue__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_14_vue_the_mask__["TheMask"],
    impressaoPedidoVue: __WEBPACK_IMPORTED_MODULE_12__components_items_impressaoPedidoVue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    cor2: function cor2(state) {
      var cor2 = state.cor.cor2;

      return {
        'background-color': cor2
      };
    },
    corSelecionado2: function corSelecionado2(state) {
      var corSelecionado2 = state.cor.corSelecionado2;

      return {
        'background-color': corSelecionado2
      };
    }
  })),
  created: function created() {
    var _this = this;

    this.dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'));
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    this.corSelec = { 'background-color': '#' + localStorage.getItem('corSelecionado') };
    var empresa = localStorage.getItem('empresaLogada');
    if (JSON.parse(empresa).identificador === 2355480534) {
      this.empresaKatec = true;
    }
    if (JSON.parse(empresa).identificador === 224262964110) {
      this.empresaAsiatex = true;
    }
    if (JSON.parse(empresa).identificador === 67365910546) {
      this.empresaMaioricasa = true;
    }
    this.novoPedido();
    __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$on('pedidoSelecionado', function (objPedido) {
      window.scrollTo(0, 0);
      _this.refreshPedido(objPedido.pedido, objPedido.condPagtos);
      if (_this.pedido.cliente.cnpjCpf.length >= 14) {
        _this.tipoClienteJuridico = true;
      } else {
        _this.tipoClienteJuridico = false;
      }
      _this.pedido.cliente.cnpjCpf = _this.formataCNPJCPF(_this.pedido.cliente.cnpjCpf);
      _this.dadosPedidoOriginal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.pedido);
      if (_this.pedido.isErp) {
        _this.status = [{
          idStatus: 0,
          codigo: _this.pedido.status.codigo,
          ordem: _this.pedido.status.ordem,
          chaveErp: _this.pedido.status.chaveErp,
          descricao: _this.pedido.status.descricao,
          classe: 'col-md-12'
        }];
      } else {
        if (_this.pedido.isEditavel) {
          _this.novoStatus();
        } else {
          _this.status = [{
            idStatus: _this.pedido.status.idStatus,
            codigo: _this.pedido.status.codigo,
            ordem: _this.pedido.status.ordem,
            chaveErp: _this.pedido.status.chaveErp,
            descricao: _this.pedido.status.descricao,
            classe: 'col-md-12'
          }];
        }
      }
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].selecionar().then(function (response) {
        _this.dadosTabela = response.data;
        if (_this.empresaAsiatex) {
          if (_this.pedido.totais.valorTotal <= 1500) {
            _this.pedido.tipoFrete = {
              'codigo': '002',
              'descricao': 'FOB'
            };
            _this.dadosTabela.fretes = [{
              'codigo': '002',
              'descricao': 'FOB'
            }];
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'pedidoSelecionado selecionar erro');
      }).finally(function () {
        _this.blockUiVisibility = false;
      });
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$on('clienteSelecionado', function (objPedido) {
      window.scrollTo(0, 0);
      // this.refreshPedido(objPedido.pedido, objPedido.condPagtos)
      _this.novoPedido();
      _this.pedido.cliente = objPedido;
      if (_this.pedido.cliente.cnpjCpf.length >= 14) {
        _this.tipoClienteJuridico = true;
      } else {
        _this.tipoClienteJuridico = false;
      }
      _this.pedido.cliente.cnpjCpf = _this.formataCNPJCPF(_this.pedido.cliente.cnpjCpf);
      if (_this.dadosAcesso.perfil.id === 3) {
        _this.pedido.representante = { codigo: _this.dadosAcesso.representante.codigo, apelido: _this.dadosAcesso.representante.apelido };
      }
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].selecionar().then(function (response) {
        _this.dadosTabela = response.data;
        if (_this.empresaAsiatex) {
          if (_this.pedido.totais.valorTotal <= 1500) {
            _this.pedido.tipoFrete = {
              'codigo': '002',
              'descricao': 'FOB'
            };
            _this.dadosTabela.fretes = [{
              'codigo': '002',
              'descricao': 'FOB'
            }];
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'clienteSelecionado selecionar erro');
      }).finally(function () {
        _this.blockUiVisibility = false;
      });
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$on('refreshPedido', function (objPedido) {
      _this.refreshPedido(objPedido.pedido, objPedido.condPagtos);
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].selecionar().then(function (response) {
        _this.dadosTabela = response.data;
        if (_this.empresaAsiatex) {
          if (_this.pedido.totais.valorTotal <= 1500) {
            _this.pedido.tipoFrete = {
              'codigo': '002',
              'descricao': 'FOB'
            };
            _this.dadosTabela.fretes = [{
              'codigo': '002',
              'descricao': 'FOB'
            }];
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'refreshPedido selecionar erro');
      }).finally(function () {
        _this.blockUiVisibility = false;
      });
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$on('adicionarPedido', function (pedido) {
      window.scrollTo(0, 0);
      _this.novoPedido();
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].selecionar().then(function (response) {
        _this.dadosTabela = response.data;
        if (_this.empresaAsiatex) {
          if (_this.pedido.totais.valorTotal <= 1500) {
            _this.pedido.tipoFrete = {
              'codigo': '002',
              'descricao': 'FOB'
            };
            _this.dadosTabela.fretes = [{
              'codigo': '002',
              'descricao': 'FOB'
            }];
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'adicionarPedido selecionar erro');
      }).finally(function () {
        _this.blockUiVisibility = false;
      });
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$on('fechaModalItens', function (param) {
      _this.modalItens = false;
    });
    this.msgBlockUi = 'Listando itens, aguarde...';
    this.blockUiVisibility = true;
    __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].selecionar().then(function (response) {
      _this.dadosTabela = response.data;
      if (_this.empresaAsiatex) {
        if (_this.pedido.totais.valorTotal <= 1500) {
          _this.pedido.tipoFrete = {
            'codigo': '002',
            'descricao': 'FOB'
          };
          _this.dadosTabela.fretes = [{
            'codigo': '002',
            'descricao': 'FOB'
          }];
        }
      }
    }).catch(function (error) {
      console.log(error);
      _this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'created selecionar erro');
    }).finally(function () {
      _this.blockUiVisibility = false;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.novoPedido();
    __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].listarDashboard().then(function (response) {
      _this2.dashboard = response.data.duplicatas;
    });
    this.dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'));
    this.percLimiteDescontoRepresentante = this.dadosAcesso.representante.percLimiteDesconto;
  },

  methods: {
    descTabela: function descTabela(item) {
      return item.codigo + ' - ' + item.descricao;
    },
    descRepresentante: function descRepresentante(item) {
      return item.codigo + ' - ' + item.apelido;
    },
    mostraRepNatIvo: function mostraRepNatIvo() {
      console.log(this.pedido);
    },

    imprimirPedido: function imprimirPedido(telaImpressao) {
      telaImpressao = window.open('about:blank');
      var html = '';
      html += '<html>';
      html += '<head>';
      html += '<style>';
      html += '.txtRight {text-align: right}';
      html += '.md {margin-left: 15%}';
      html += '.md1 {margin-left: 25%}';
      html += '.md2 {margin-left: 35%}';
      html += '.md3 {margin-left: 45%}';
      html += '.md4 {margin-left: 50%}';
      html += '.md5 {margin-left: 65%}';
      html += '.line {margin-top: 1px solid black}';
      html += '.mt {margin-top: 30%}';
      html += '</style>';
      html += '</head>';
      html += '<body>';
      // inicio body
      html += '<h1>testando</h1>';
      html += '<div id="impressaoPedido">';
      html += '<div class="txtRight">';
      html += '<p><b>Grupo|GC</b></p>';
      html += '<p><b>Contanto: </b></p>';
      html += '<p>site</p>';
      html += '</div>';
      html += '<div class="txtLeft">';
      html += '<b>Endereço: </b>';
      html += '</div>';
      html += '<h3 class="txtLeft mt-3">Detalhes do Cliente</h3>';
      html += '<hr>';
      html += '<div class="txtLeft">';
      html += '<span><b>Cliente: </b></span><span class="md4"><b>Contato: </b></span><br>';
      html += '<span><b>Fantasia: </b></span><span class="md4"><b>CNPJ: </b></span><br>';
      html += '<hr>';
      html += '<h3 class="txtLeft mt-3">Detalhes do Pedido</h3>';
      html += '<hr>';
      html += '<span><b>Representante: </b></span><span class="md2"><b>Pedido: </b></span><span class="md"><b>Data Emissão: </b></span><br>';
      html += '<span><b>Tipo Frete: </b></span><span class="md"><b> Transp.: </b></span><br>';
      html += '<span><b>Condição de Pagamento: </b></span><span class="md1"><b>Forma de Pagamento: </b></span><br>';
      html += '<h3 class="txtLeft mt-3">Totais</h3>';
      html += '<hr>';
      html += '<span>categoria</span><span class="md3">R$ </span><br>';
      html += '<span><b>Total</b></span><span style="margin-left: 48.5%"><b>R$</b></span>';
      html += '<h3 class="txtLeft mt-3">Observações</h3>';
      html += '<hr>';
      html += '<span>Tipo obs</span><span class="md">obs</span>';
      html += '<span class="mt line"><p>Representante</p></span><span class="mt line"><p>Cliente</p></span>';
      // fim body
      html += '</body>';
      html += '</html>';
      telaImpressao.document.write(html);
      telaImpressao.document.close(); // FECHA A JANELA
      telaImpressao.print();
    },
    formataTelefone: function formataTelefone(telefone) {
      telefone.replace('-', '').replace('-', '');
      if (telefone.length === 8) {
        return telefone.substring(0, 4) + '-' + telefone.substring(4, 8);
      } else if (telefone.length === 9) {
        return telefone.substring(0, 5) + '-' + telefone.substring(5, 9);
      } else {
        return telefone;
      }
    },
    retornaEnderecoEmpresa: function retornaEnderecoEmpresa(empresa) {
      var cep = empresa.cep.substring(0, 5) + '-' + empresa.cep.substring(5, 8);
      return empresa.endereco + ', ' + empresa.numero + ' - CEP: ' + cep + ' - ' + empresa.bairro + ' - ' + empresa.cidade + ' - ' + empresa.uf;
    },
    retornaContatoEmpresa: function retornaContatoEmpresa(empresaLogada) {
      if (typeof empresaLogada.telefone !== 'undefined') {
        var telFormatado = this.formataTelefone(empresaLogada.telefone);
        return '(' + empresaLogada.ddd + ') ' + telFormatado;
      } else {
        return 'Não Cadastrado';
      }
    },
    retornaContatoCliente: function retornaContatoCliente(cliente) {
      if (typeof cliente.telefone !== 'undefined') {
        return cliente.ddd + ' ' + cliente.telefone;
      } else {
        return 'Não Cadastrado';
      }
    },
    retornaEnderecoCliente: function retornaEnderecoCliente(enderecoCliente) {
      if (typeof enderecoCliente !== 'undefined') {
        if (enderecoCliente.codTipo) {
          var cep = enderecoCliente.cep.substring(0, 5) + '-' + enderecoCliente.cep.substring(5, 8);
          return enderecoCliente.endereco + ', ' + enderecoCliente.numero + ' - CEP: ' + cep + ' - ' + enderecoCliente.bairro + ' - ' + enderecoCliente.cidade + ' - ' + enderecoCliente.uf;
        } else {
          return 'Não Cadastrado';
        }
      } else {
        return 'Não Cadastrado';
      }
    },
    formataCNPJCPF: function formataCNPJCPF(cnpjCpf) {
      cnpjCpf = cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '');
      if (cnpjCpf.length === 11) {
        return cnpjCpf.substring(0, 3) + '.' + cnpjCpf.substring(3, 6) + '.' + cnpjCpf.substring(6, 9) + '-' + cnpjCpf.substring(9, 11);
      } else if (cnpjCpf.length === 14) {
        return cnpjCpf.substring(0, 2) + '.' + cnpjCpf.substring(2, 5) + '.' + cnpjCpf.substring(5, 8) + '/' + cnpjCpf.substring(8, 12) + '-' + cnpjCpf.substring(12, 14);
      } else {
        return cnpjCpf;
      }
    },
    limpaFormataCNPJCPF: function limpaFormataCNPJCPF(cnpjCpf) {
      cnpjCpf = cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '');
      if (cnpjCpf.length === 11) {
        return cnpjCpf.substring(0, 3) + '.' + cnpjCpf.substring(3, 6) + '.' + cnpjCpf.substring(6, 9) + '-' + cnpjCpf.substring(9, 11);
      } else if (cnpjCpf.length === 14) {
        return cnpjCpf.substring(0, 2) + '.' + cnpjCpf.substring(2, 5) + '.' + cnpjCpf.substring(5, 8) + '/' + cnpjCpf.substring(8, 12) + '-' + cnpjCpf.substring(12, 14);
      } else {
        return cnpjCpf;
      }
    },
    retornaHtmlCabecalhoItem: function retornaHtmlCabecalhoItem(temDesconto) {
      var cabecalhoItem = '';
      if (temDesconto) {
        cabecalhoItem += '<div class="divTableRow">';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Produto</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Imagem</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:22%;height:10px;vertical-align: middle;text-align: center;">Descrição</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Preço Tab.</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Desconto</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Prc.Unit</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Qtde.</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Vlr.IPI</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">ICMS-ST</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Tot.Item</div>';
        cabecalhoItem += '</div>';
      } else {
        cabecalhoItem += '<div class="divTableRow">';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Produto</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Imagem</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:38%;height:10px;vertical-align: middle;text-align: center;">Descrição</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Prc.Unit</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Qtde.</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Vlr.IPI</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">ICMS-ST</div>';
        cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Tot.Item</div>';
        cabecalhoItem += '</div>';
      }
      return cabecalhoItem;
    },
    retornaHtmlItem: function retornaHtmlItem(item, temDesconto) {
      var htmlItem = '';
      var imgContent = '';
      if (item.url === '' || item.url === null) {
        imgContent = '<img style="max-width: 100%; max-height: 100%; vertical-align: middle; text-align: center;" src="/static/img/sem-imagem.44e3842.png"/>';
      } else {
        imgContent = '<img style="max-width: 100%; max-height: 100%; vertical-align: middle; text-align: center;" src="' + item.url + '"/>';
      }
      var descProduto = item.descricao;
      if (item.vendaSobMedidaM2 === 1) {
        descProduto += 'Larg.: ' + this.formatterValue(item.largura) + ' - Comp.: ' + this.formatterValue(item.comprimento);
      }
      if (temDesconto) {
        htmlItem += '<div class="divTableRow">';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle;text-align: center;font-family: Source Sans Pro-Regular; font-size: small; padding: 4px; width: 10%;height:40px;">' + item.codProduto + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align:center; width:15%; height:80px;">' + imgContent + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; font-family: Source Sans Pro Regular;font-size: small; width: 38%; padding-left:5px;height:80px;height:40px;">' + descProduto + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorTabela) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.percDesconto) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorUnitario) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.qtdVenda) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorIPI) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorICMSST) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 10%;height:40px;padding-right:2px">' + this.formatterValue(item.totalItem) + '</div>';
        htmlItem += '</div>';
      } else {
        htmlItem += '<div class="divTableRow">';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: center;font-family: Source Sans Pro-Regular; font-size: small; padding: 4px; width: 10%;height:40px;">' + item.codProduto + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align:center; width:15%; height:80px;">' + imgContent + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; font-family: Source Sans Pro Regular;font-size: small;width: 38%; padding-left:5px;height:80px;height:40px;">' + descProduto + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorUnitario) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.qtdVenda) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorIPI) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorICMSST) + '</div>';
        htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 10%;height:40px;padding-right:2px">' + this.formatterValue(item.totalItem) + '</div>';
        htmlItem += '</div>';
      }
      return htmlItem;
    },
    retornaHtmlItemPedidoTotal: function retornaHtmlItemPedidoTotal(temDesconto, somaQtdePedido, somaTotalPedido) {
      var totalItem = '';
      if (temDesconto) {
        totalItem += '<div class="divTableRow">';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px; width:10%;height:10px;vertical-align: middle;text-align: center;">Total</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:10%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:22%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">' + this.formatterValue(somaQtdePedido) + '</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000;width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px">' + this.formatterValue(somaTotalPedido) + '</div>';
        totalItem += '</div>';
      } else {
        totalItem += '<div class="divTableRow">';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px; width:10%;height:10px;vertical-align: middle;text-align: center;">Total</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:10%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:38%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">' + this.formatterValue(somaQtdePedido) + '</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>';
        totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000;width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px">' + this.formatterValue(somaTotalPedido) + '</div>';
        totalItem += '</div>';
      }
      return totalItem;
    },
    retornaTotaisPorCategoria: function retornaTotaisPorCategoria() {
      var categorias = [];
      var itens = this.pedido.itens.sort(function (a, b) {
        return a.ordemCategoria - b.ordemCategoria || a.descricao - b.descricao;
      });

      var _loop = function _loop() {
        var item = itens[i];
        if (categorias.length === 0) {
          categorias.push({ codigo: item.codigoCategoria, descricao: item.descricaoCategoria, ordem: item.ordemCategoria, valor: 0.00 });
        } else {
          var categoriaNoArray = categorias.filter(function (cat) {
            return cat.codigo === item.codigoCategoria;
          });
          if (categoriaNoArray.length === 0) {
            categorias.push({ codigo: item.codigoCategoria, descricao: item.descricaoCategoria, ordem: item.ordemCategoria, valor: 0.00 });
          }
        }
      };

      for (var i = 0; i < itens.length; i++) {
        _loop();
      }
      var somaTotaisCategorias = 0;

      var _loop2 = function _loop2() {
        var categoria = categorias[ii];
        var itensPedidosDaCategoria = itens.filter(function (item) {
          return item.codigoCategoria === categoria.codigo;
        });
        var totalCategoria = itensPedidosDaCategoria.reduce(function (r, a) {
          return r + (a.qtdVenda * a.valorTabela + a.valorIPI + a.valorICMSST);
        }, 0);
        categorias[ii].valor = totalCategoria;
        somaTotaisCategorias += totalCategoria;
      };

      for (var ii = 0; ii < categorias.length; ii++) {
        _loop2();
      }
      categorias = categorias.sort(function (a, b) {
        return a.ordem - b.ordem;
      });
      var htmlCategorias = '';
      for (var iii = 0; iii < categorias.length; iii++) {
        var _categoria = categorias[iii];
        htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">';
        htmlCategorias += '<td style="width: 80%;padding: 2px;width: 50%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>' + _categoria.descricao + '</b></td><td style="width: 20%;padding: 2px; width: 50%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>' + this.formatterValue(_categoria.valor) + '</b></td></tr>';
      }
      var totalDesconto = itens.reduce(function (r, a) {
        return r + a.valorDesconto;
      }, 0);
      if (totalDesconto > 0) {
        // SUBTOTAL
        htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">';
        htmlCategorias += '<td style="width: 80%;padding: 2px;width: 50%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>SubTotal</b></td><td style="width: 20%;padding: 2px; width: 50%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>' + this.formatterValue(somaTotaisCategorias) + '</b></td></tr>';
        // DESCONTO
        htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">';
        htmlCategorias += '<td style="width: 80%;padding: 2px;width: 50%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>Desconto</b></td><td style="width: 20%;padding: 2px; width: 50%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>' + this.formatterValue(totalDesconto) + '</b></td></tr>';
      }
      if (htmlCategorias !== '') {
        var total = somaTotaisCategorias - totalDesconto; // categorias.reduce(function (r, a) { return r + a.valor }, 0)
        htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">';
        htmlCategorias += '<td style="width: 80%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">';
        htmlCategorias += '<b>Total</b></td><td style="width: 20%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;"><b>' + this.formatterValue(total) + '</b></td></tr>';
      }
      return htmlCategorias;
    },
    retornaHtmlItensPedido: function retornaHtmlItensPedido() {
      var temDesconto = false;
      var arrayPaginas = [];
      var itens = this.pedido.itens.sort(function (a, b) {
        return a.ordemCategoria - b.ordemCategoria || a.descricao - b.descricao;
      });
      for (var i = 0; i < itens.length; i++) {
        var _item = this.pedido.itens[i];
        if (_item.percDesconto > 0) {
          temDesconto = true;
          break;
        }
      }
      for (var ii = 0; ii < this.pedido.itens.length; ii++) {
        var _item2 = this.pedido.itens[ii];
        var htmlItem = this.retornaHtmlItem(_item2, temDesconto);
        arrayPaginas.push(htmlItem);
      }
      var somaQtdePedido = this.pedido.itens.reduce(function (r, a) {
        return r + a.qtdVenda;
      }, 0);
      var somaTotalPedido = this.pedido.itens.reduce(function (r, a) {
        return r + a.totalItem;
      }, 0);
      var htmlTotaisItensPedido = this.retornaHtmlItemPedidoTotal(temDesconto, somaQtdePedido, somaTotalPedido);
      arrayPaginas.push(htmlTotaisItensPedido);
      // inicia o processo de paginar os itens
      var agrupaPagina = '';
      var acumulaAgrupador = '';
      var entrou = false;
      acumulaAgrupador += '<div style="page-break-inside: avoid;"></div><div style="page-break-inside: avoid; clear: both" />';
      for (var indiceArray = 0; indiceArray < arrayPaginas.length; indiceArray++) {
        var posicao = indiceArray + 1;
        entrou = false;
        agrupaPagina += arrayPaginas[indiceArray];
        if (posicao % 18 === 0) {
          var cabecalhoItem = this.retornaHtmlCabecalhoItem(temDesconto);
          // acumulaAgrupador += '<div style="page-break-before: always; clear: both"><div style="page-break-before: always">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-before: always; clear: both" />'
          acumulaAgrupador += '<div style="page-break-inside: avoid;">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-inside: avoid; clear: both" />';
          agrupaPagina = '';
          entrou = true;
        }
      }
      if (!entrou) {
        var _cabecalhoItem = this.retornaHtmlCabecalhoItem(temDesconto);
        // acumulaAgrupador += '<div style="page-break-before: always; clear: both"><div style="page-break-before: always">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-before: always; clear: both" />'
        acumulaAgrupador += '<div style="page-break-inside: avoid;">' + _cabecalhoItem + agrupaPagina + '</div><div style="page-break-inside: avoid; clear: both;" />';
        agrupaPagina = '';
      }
      var tamAcumulaAgrupador = acumulaAgrupador.length;
      // let tamCorta = '<div style="page-break-before: always; clear: both" />'.length
      var tamCorta = '<div style="page-break-inside: avoid; clear: both;" />'.length;
      var corta = tamAcumulaAgrupador - tamCorta;
      acumulaAgrupador = acumulaAgrupador.substring(0, corta);
      return acumulaAgrupador;
    },
    imprimePedido2: function imprimePedido2() {
      // telaImpressao
      if (this.pedido.itens.length === 0) {
        this.showMessage('Insira algum item no pedido antes de visualizar a impressão!', 'Alerta', 'danger', 'imprimePedido2');
      } else {
        var empresaLogada = JSON.parse(localStorage.getItem('empresaLogada'));
        console.log('empresa: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(empresaLogada));
        console.log('pedido: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pedido));
        // telaImpressao = window.open('about:blank')
        var html = '';
        var LS_IDGOSALES = 'ID GoSales: #';
        var LS_IDPEDIDO = 'ID Pedido: #';
        var LS_IDORCAMENTO = 'ID Orçamento: #';
        var LS_STATUSPEDIDO = 'Status Pedido: ';
        var IDGOSALES = this.pedido.id;
        var IDPEDIDO = this.pedido.numeroPedido;
        var IDORCAMENTO = this.pedido.numeroOrcamento;
        var STATUSPEDIDO = this.pedido.status.descricao;
        var LS_DATA_EMISSAO = 'Data Emissão: ';
        var EMISSAO = this.pedido.emissao;
        var NOME_EMPRESA = empresaLogada.nome;
        var URL_LOGO_MARCA = empresaLogada.urlLogoNegativo;
        var urlLogoEvento = '';
        var LOGO_EVENTO = '';
        var LS_CONTATO = 'Contato: ';
        var CONTATO_EMPRESA = this.retornaContatoEmpresa(empresaLogada);
        var URL_SITE_MARCA = empresaLogada.site;
        var LS_ENDERECO = 'Endereço: ';
        var ENDERECOCLIENTE = this.retornaEnderecoCliente(this.pedido.cliente.endereco);
        var ENDERECO_EMPRESA = this.retornaEnderecoEmpresa(empresaLogada);
        var LS_DETALHE_CLIENTE = 'Detalhes do Cliente';
        var LS_CLIENTE = 'Cliente: ';
        var RAZAOCLIENTE = this.pedido.cliente.razaoSocial;
        var LS_FANTASIA = 'Fantasia: ';
        var LS_CNPJ = '';
        var CNPJCLIENTE = this.limpaFormataCNPJCPF(this.pedido.cliente.cnpjCpf);
        var FANTASIACLIENTE = this.pedido.cliente.fantasia;
        var CONTATOCOMERCIAL = this.retornaContatoCliente(this.pedido.cliente);
        var LS_REPRESENTANTE = 'Representante: ';
        var VENDEDOR = this.pedido.representante.apelido;
        var LS_DETALHE_PEDIDO = 'Detalhes do Pedido';
        var LS_TIPO_FRETE = 'Tipo De Frete: ';
        var TIPOFRETE = typeof this.pedido.tipoFrete.descricao === 'undefined' ? ' Não Selecionado' : this.pedido.tipoFrete.descricao;
        var LS_TRANSP = 'Transp.:';
        var TRANSPORTADORA = typeof this.pedido.transportadora.nome === 'undefined' ? ' Não Informada' : this.pedido.transportadora.nome;
        var LS_CONDICAO_PAGTO = 'Condição de Pagamento: ';
        var CONDICAO = typeof this.pedido.condPagto.descricao === 'undefined' ? ' Não Informada' : this.pedido.condPagto.descricao;
        var LS_FORMA_PAGTO = 'Forma de Pagamento: ';
        var FORMA = typeof this.pedido.formaPagto.descricao === 'undefined' ? ' Não Informada' : this.pedido.formaPagto.descricao;
        var LS_TOTAIS = 'Totais';
        var TOTALIZADORES = this.retornaTotaisPorCategoria();
        var LS_NOTES = '';
        var OBSERVACOES = '';
        var LS_MOTIVO_CANCELAMENTO = '';
        var MOTIVO_CANCELAMENTO = '';
        var LS_REPRESENTANTE_ASSINATURA = 'Representante';
        var LS_CLIENTE_ASSINATURA = 'Cliente';
        var ITEMS_PEDIDO = this.retornaHtmlItensPedido();
        var URL_LOGO_GOSALESPRO = 'https://s3-sa-east-1.amazonaws.com/mustti-manager/go-sales-pro/logos/icon-gosalespro.png';
        if (urlLogoEvento !== '') {
          LOGO_EVENTO = '<img src="' + urlLogoEvento + '" style="width: 248px; height: 93px;" align="left">';
        }
        // observacoes
        if (this.pedido.observacoes.length > 0) {
          LS_NOTES = 'Observações';
          OBSERVACOES += '<tr>';
          OBSERVACOES += '<td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"></td>';
          OBSERVACOES += ' </tr>';
          for (var iObs = 0; iObs < this.pedido.observacoes.length; iObs++) {
            var observacao = this.pedido.observacoes[iObs];
            if (observacao.tipoObservacao.exibeImpressao === 1) {
              OBSERVACOES += '<tr style="border-bottom: 2px solid white; background-color: #D8D8D8;">';
              OBSERVACOES += '<td style="width: 20%;text-align: left; background-color: #D8D8D8; padding: 2px;">';
              OBSERVACOES += '<div style="padding: 2px;font-family: Source Sans Pro 10 ;font-size: small;"><b>' + observacao.tipoObservacao.descricao + '</b></div>';
              OBSERVACOES += '</td>';
              OBSERVACOES += '<td style="width: 80%;text-align: left; background-color: #ECECEC; padding: 2px;">';
              OBSERVACOES += '<div style="padding: 2px;font-family: Source Sans Pro 10 ;font-size: small;">' + observacao.observacao + '</div>';
              OBSERVACOES += '</td>';
              OBSERVACOES += '</tr>';
            }
          }
        }
        if (this.pedido.motivoCancelamento !== '') {
          LS_MOTIVO_CANCELAMENTO = 'Motivo do Cancelamento';
          MOTIVO_CANCELAMENTO += '<tr>';
          MOTIVO_CANCELAMENTO += '    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"><p>' + this.pedido.motivoCancelamento + '</p></td>';
          MOTIVO_CANCELAMENTO += '</tr>';
        }
        if (this.tipoClienteJuridico) {
          LS_CNPJ = 'CNPJ: ';
        } else {
          LS_CNPJ = 'CPF: ';
        }
        if (this.empresaKatec === true) {
          LS_FANTASIA = 'Cliente Reduzido: ';
        }
        html += '<!DOCTYPE html>';
        html += '<html>';
        html += '    <head>';
        html += '        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">';
        html += '        <meta name="format-detection" content="telephone=no">';
        html += '        <style type="text/css" media="print,screen">';
        html += '            .divTable{';
        html += '                display: table;';
        html += '                width: 100%;';
        html += '            }';
        html += '            .divTableRow {';
        html += '                display: table-row;';
        html += '            }';
        html += '            .divTableHeading {';
        html += '                background-color: #EEE;';
        html += '                display: table-header-group;';
        html += '            }';
        html += '            .divTableCell, .divTableHead {';
        html += '                border: 0.5px solid #999999;';
        html += '                display: table-cell;';
        html += '            }';
        html += '            .divTableCellTotal  {';
        html += '                display: table-cell;';
        html += '                padding: 3px 10px;';
        html += '                background-color:#000000;';
        html += '                color: #FFFFFF;';
        html += '                font-weight: bold;';
        html += '                height:10px;';
        html += '            }';
        html += '            .divTableHeading {';
        html += '                background-color: #EEE;';
        html += '                display: table-header-group;';
        html += '                font-weight: bold;';
        html += '            }';
        html += '            .divTableFoot {';
        html += '                background-color: #EEE;';
        html += '                display: table-footer-group;';
        html += '                font-weight: bold;';
        html += '            }';
        html += '            .divTableBody {';
        html += '                display: table-row-group;';
        html += '            }';
        html += '            section {';
        html += '                padding: 0px 0px 50px;';
        html += '            }';
        html += '            footer {';
        html += '                position: relative;';
        html += '                bottom: 0;';
        html += '                width: 100%;';
        html += '                background: #ECECEC;';
        html += '                padding: 10px;';
        html += '            }';
        html += '            footer p {';
        html += '                margin: 0;';
        html += '                display: inline-block;';
        html += '                font-size: 15px;';
        html += '                text-align: center;';
        html += '                width: 100%;';
        html += '            }';
        html += '            footer img {';
        html += '                width: 32px;';
        html += '                position: absolute;';
        html += '                top: 7px;';
        html += '                right: 20px;';
        html += '            }';
        html += '            body {';
        html += '                overflow-y: scroll;';
        html += '                height: 600px;';
        html += '                position: relative;';
        html += '            }';
        html += '        </style>';
        html += '    </head>';
        // CABEÇALHO
        html += '    <body>';
        html += '        <table width="90%" align="center" border="0">';
        html += '            <tbody>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="text-align:center ; padding-bottom: 3px;">';
        html += '                        <br>';
        html += '                        <img  src=' + URL_LOGO_MARCA + ' style="max-width: 30%; max-height:60px;" align="center">';
        html += '                      </td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:right; font-family: Source Sans Pro 8 Bold;font-size: medium; background-color: #FFFFFF; padding: 15px">' + LOGO_EVENTO + '<b>' + NOME_EMPRESA + '</b><br><b>' + LS_CONTATO + '</b> ' + CONTATO_EMPRESA + '<br>' + URL_SITE_MARCA + '<br><b>' + LS_ENDERECO + '</b>' + ENDERECO_EMPRESA;
        html += '                    </td>';
        html += '                </tr>';
        // DETALHES DO CLIENTE
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_DETALHE_CLIENTE + '</b></td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; padding: 0px;"><hr style="width: 100%;"></td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="5" style="width: 10%;text-align:left; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_CLIENTE + '</b>' + RAZAOCLIENTE + '</td>';
        html += '                    <td colspan="4" style="width: 33%;text-align:right; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_CONTATO + '</b>' + CONTATOCOMERCIAL + '</td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="5" style="width: 33%;text-align:left; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_FANTASIA + '</b>' + FANTASIACLIENTE + '</td>';
        html += '                    <td colspan="4" style="width: 10%;text-align:right; font-family: Source Sans Pro 6 ;font-size: small;"><b>' + LS_CNPJ + '</b>' + CNPJCLIENTE + '</td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 10%;text-align:left; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_ENDERECO + '</b>' + ENDERECOCLIENTE + '</td>';
        html += '                </tr>';
        html += '                <tr style="width:100%;height: 1px;">';
        html += '                    <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="width:10%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>';
        html += '                </tr>';
        // DETALHES DO PEDIDO
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_DETALHE_PEDIDO + '</b></td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"></td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="3" style="width: 30%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_STATUSPEDIDO + '</b>' + STATUSPEDIDO + '</td>';
        html += '                    <td colspan="2" style="width: 30%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_IDPEDIDO + '</b>' + IDPEDIDO + '</td>';
        html += '                    <td colspan="2" style="width: 30%;text-align:center; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_IDORCAMENTO + '</b>' + IDORCAMENTO + '</td>';
        html += '                    <td colspan="2" style="width: 30%;text-align:right; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_IDGOSALES + '</b>' + IDGOSALES + '</td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="6" style="width: 20%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_REPRESENTANTE + '</b> ' + VENDEDOR + '</td>';
        html += '                    <td colspan="3" style="width: 30%;text-align:right; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_DATA_EMISSAO + '</b>' + EMISSAO + '</td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="2" style="width: 10%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_TIPO_FRETE + '</b> ' + TIPOFRETE + '</td>';
        html += '                    <td colspan="7" style="width: 30%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_TRANSP + '</b>' + TRANSPORTADORA + '</td>';
        html += '                </tr>';
        html += '                <tr></tr>';
        html += '                <tr>';
        html += '                    <td colspan="4" style="width: 10%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_CONDICAO_PAGTO + '</b> ' + CONDICAO + '</td>';
        html += '                    <td colspan="5" style="width: 30%;text-align:right; font-family: Source Sans Pro 16 ;font-size: small;"><b>' + LS_FORMA_PAGTO + '</b> ' + FORMA + '</td>';
        html += '                </tr>';
        html += '                <tr style="width:100%;height: 1px;">';
        html += '                    <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="width:10%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>';
        html += '                </tr>';
        html += '            </tbody>';
        html += '        </table>';
        // TOTALIZADORES
        html += '        <table width="90%" align="center" style="border: 0.7px; solid white">';
        html += '            <tbody>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_TOTAIS + '</b></td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"></td>';
        html += '                </tr>';
        html += '                ' + TOTALIZADORES + '';
        html += '            </tbody>';
        html += '        </table>';
        html += '        <tr style="width:100%;height: 1px;">';
        html += '            <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>';
        html += '            <td style="width:10%;height: 1px;">&nbsp;</td>';
        html += '            <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>';
        html += '        </tr>';
        // OBSERVACOES
        html += '        <table width="90%" align="center" style="border: 0.7px; solid white">';
        html += '            <tbody>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_NOTES + '</b></td>';
        html += '                </tr>';
        html += '                ' + OBSERVACOES + '';
        html += '            </tbody>';
        html += '        </table>';
        html += '        <tr style="width:100%;height: 1px;">';
        html += '            <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>';
        html += '            <td style="width:10%;height: 1px;">&nbsp;</td>';
        html += '            <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>';
        html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>';
        html += '        </tr>';
        // MOTIVO CANCELAMENTO
        html += '        <table width="90%" align="center" style="border: 0.7px; solid white">';
        html += '            <tbody>';
        html += '                <tr>';
        html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_MOTIVO_CANCELAMENTO + '</b></td>';
        html += '                </tr>';
        html += '                ' + MOTIVO_CANCELAMENTO + '';
        html += '            </tbody>';
        html += '        </table>';
        // LINHAS EM BRANCO
        html += '        <br><br><br><br>';
        // ASSINATURA
        html += '        <table width="90%" align="center">';
        html += '            <tbody>';
        html += '                <tr>';
        html += '                    <td style="width:20%; border-top:1px solid black;text-align:left;"></td>';
        html += '                    <td style="width:20%; border-top:1px solid black;text-align:right;"></td>';
        html += '                </tr>';
        html += '                <tr>';
        html += '                    <td style="width:50%;text-align:center;font-family: Source Sans Pro 16 ;font-size: small;">' + LS_REPRESENTANTE_ASSINATURA + '</td>';
        html += '                    <td style="width:50%;text-align:center;font-family: Source Sans Pro 16 ;font-size: small;">' + LS_CLIENTE_ASSINATURA + '</td>';
        html += '                </tr>';
        html += '            </tbody>';
        html += '        </table>';
        html += '        <br>';
        // LOGO GOSALES
        html += '        <div class="divTable" style="width:90%; margin-left:auto; margin-right:auto;">';
        html += '            <div class="divTableBody">';
        html += '                ' + ITEMS_PEDIDO + '';
        html += '            </div>';
        html += '        </div>';
        html += '        <section>';
        html += '            <br>';
        html += '            <footer>';
        html += '                <p>Desenvolvido por Mustti - GoSales Pro</p>';
        html += '                <img src="' + URL_LOGO_GOSALESPRO + '" />';
        html += '            </footer>';
        html += '        </section>';
        html += '    </body>';
        html += '</html>';
        this.htmlImpressao = html;
        this.modalImpressao = true;
      }
    },
    imprimirPDF: function imprimirPDF() {
      // let sourceHtml = document.getElementById('impressaoPedido') // document.getElementsByTagName('body')[0]
      // var opt = {
      //   margin: 0,
      //   filename: 'myfile.pdf',
      //   image: {type: 'jpeg', quality: 0.98},
      //   html2canvas: {scale: 2, useCORS: true},
      //   jsPDF: {
      //     unit: 'mm',
      //     format: 'a4', // [280, 350],
      //     orientation: 'portrait'
      //   }
      // }
      // html2pdf().set(opt).from(this.htmlImpressao).save()
      // var printDoc = new JsPDF()
      // printDoc.fromHTML(sourceHtml, 10, 10, {'width': 180})
      // var specialElementHandlers = {}
      // var margins = {
      //   top: 10,
      //   bottom: 60,
      //   left: 10
      // }
      // printDoc.fromHTML(sourceHtml, margins.left, margins.top, {'width': 100, 'elementHandlers': specialElementHandlers}, function (dispose) {
      //   printDoc.save('test.pdf')
      // }, margins)
      // printDoc.fromHTML(sourceHtml.html())
      // *printDoc.autoPrint()
      // *printDoc.output('dataurlnewwindow')
      // let div = document.body.getElementById('impressaoPedido')
      var telaImpressao = window.open('about:blank');
      telaImpressao.document.write(this.htmlImpressao);
      telaImpressao.document.close(); // FECHA A JANELA
      telaImpressao.print();
    },
    limparDesconto: function limparDesconto() {
      this.desconto = { percentual: 0, valor: '0,00' };
      this.aplicarDesconto();
    },
    calculaValorDesconto: function calculaValorDesconto(from) {
      this.descontoValor = parseFloat(this.desconto.valor.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
      if (this.desconto.percentual === 0 && this.descontoValor === 0 || this.desconto.percentual === '' && this.descontoValor === 0) {
        this.habilitaDescGeral = false;
      } else {
        this.habilitaDescGeral = true;
      }
      if (from === 1) {
        if (this.desconto.percentual > 100) {
          this.showMessage('Percentual não pode ser maior que 100%', 'Atenção', 'warning', 'calculaValorDesconto percentual > 100');
          return;
        }
        if (this.percLimiteDescontoRepresentante === '' || typeof this.percLimiteDescontoRepresentante === 'undefined') {
          this.percLimiteDescontoRepresentante = 0;
        }
        if (this.desconto.percentual > this.percLimiteDescontoRepresentante) {
          this.showMessage('Percentual de desconto não permitido acima de: ' + this.percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'calculaValorDesconto percentual > percLimiteDescontoRepresentante');
          return;
        }
      }
      if (from === 2) {
        var itemValUnitFormat = this.pedido.itens.map(function (item) {
          if (typeof item.valorUnitario === 'string') {
            return parseFloat(item.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
          } else {
            return item.valorUnitario;
          }
        });
        var totalSomaItens = itemValUnitFormat.reduce(function (acc, item) {
          return acc + item;
        }, 0);
        var calcValorPerc = this.descontoValor * 100 / totalSomaItens;
        if (calcValorPerc > this.percLimiteDescontoRepresentante) {
          this.showMessage('Percentual de desconto não permitido acima de: ' + this.percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'calculaValorDesconto calcValorPerc > percLimiteDescontoRepresentante');
          return;
        }
        if (this.descontoValor >= this.pedido.totais.valorTotal) {
          this.showMessage('Desconto não pode ser maior ou igual ao valor total do pedido', 'Atenção', 'warning', 'calculaValorDesconto descontoValor > pedido.totais.valorTotal');
          return;
        }
      }
    },
    aplicarDesconto: function aplicarDesconto() {
      var _this3 = this;

      var fromInput = 1;
      if (this.desconto.valor === 0 && this.desconto.percentual === 0) {
        fromInput = 1;
      } else if (this.desconto.percentual > 0) {
        fromInput = 1;
      } else {
        fromInput = 2;
      }
      var param = { idPedido: this.pedido.id, fromInput: fromInput, percDesconto: this.desconto.percentual, valorDesconto: this.descontoValor };
      this.msgBlockUi = 'Calculando desconto, aguarde...';
      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].aplicarDesconto(param).then(function (response) {
        _this3.refreshPedido(response.data.pedido, response.data.condPagtos);
        console.log(response);
      }).catch(function (error) {
        console.log(error);
        _this3.percLimiteDescontoRepresentante = _this3.dadosAcesso.representante.percLimiteDesconto;
        // this.showMessage(error.response.data.mensagem, 'Atenção', 'warning')
        if (_this3.itemPedido.percDesconto > _this3.percLimiteDescontoRepresentante) {
          _this3.showMessage('Percentual de desconto não permitido acima de: ' + _this3.percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'aplicarDesconto erro');
        }
      }).finally(function () {
        _this3.blockUiVisibility = false;
      });
    },
    changeDesconto: function changeDesconto(fromInput) {
      if (fromInput === 1) {
        this.desconto.valor = 0.00;
      } else {
        this.desconto.percentual = 0.00;
      }
    },
    adicionarClienteInd: function adicionarClienteInd() {
      this.limparDadosModalPesquisaClienteInd();
      this.modalClienteInd = true;
    },
    limparClientInd: function limparClientInd() {
      this.clienteIndustrializadorNome = '';
      this.pedido.codClienteIndustrializador = '';
    },
    limparDadosModalPesquisaClienteInd: function limparDadosModalPesquisaClienteInd() {
      this.pesquisaClienteInd = {
        termo: '',
        uf: '',
        cidade: ''
      };
      this.clientesPesquisados = [];
    },
    selecionarClienteInd: function selecionarClienteInd(clienteIndustrializador) {
      this.pedido.codClienteIndustrializador = clienteIndustrializador.codCliente;
      this.clienteIndustrializadorNome = clienteIndustrializador.fantasia;
      this.limparDadosModalPesquisaClienteInd();
      this.modalClienteInd = false;
    },
    confirmaExclusao: function confirmaExclusao(id) {
      this.modalExclusao = true;
      this.excluirItem = id;
    },
    removerItem: function removerItem(idItem) {
      var _this4 = this;

      var param = { idPedido: this.pedido.id, idPedidoItem: idItem };
      this.msgBlockUi = 'Removendo item, aguarde...';
      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].removerItem(param).then(function (response) {
        _this4.showMessage('Item removido do pedido com sucesso!', 'Sucesso', 'success', 'removerItem ok');
        _this4.refreshPedido(response.data.pedido, response.data.condPagtos);
        if (_this4.empresaAsiatex) {
          if (_this4.pedido.totais.valorTotal <= 1500) {
            _this4.pedido.tipoFrete = {
              'codigo': '002',
              'descricao': 'FOB'
            };
            _this4.dadosTabela.fretes = [{
              'codigo': '002',
              'descricao': 'FOB'
            }];
            console.log('menor');
          } else {
            console.log('maior');
          }
        }
        console.log(response);
      }).catch(function (error) {
        console.log(error);
        _this4.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'removerItem erro');
      }).finally(function () {
        _this4.blockUiVisibility = false;
        _this4.modalExclusao = false;
      });
    },
    refreshPedido: function refreshPedido(pedido, condPagtos) {
      this.pedido = pedido;
      if (this.pedido.itens.length > 0) {
        if (condPagtos.constructor === Array) {
          this.dadosTabela.condPagtos = condPagtos;
        } else {
          this.dadosTabela.condPagtos = [condPagtos];
        }
      } else {
        this.dadosTabela.condPagtos = [];
      }
      this.clienteIndustrializadorNome = '';
      if (pedido.clienteIndustrializador.fantasia !== undefined) {
        this.clienteIndustrializadorNome = pedido.clienteIndustrializador.fantasia;
      }
      if (this.pedido.observacoes.length > 0) {
        for (var indiceObs = 0; indiceObs < this.pedido.observacoes.length; indiceObs++) {
          var observacao = this.pedido.observacoes[indiceObs];
          if (observacao.tipoObservacao === null) {
            observacao.tipoObservacao = {
              codigo: '',
              exibeImpressao: 0,
              descricao: ''
            };
            this.showMessage('Uma ou mais observações foram cadastradas sem o Tipo de Observação, favor corrigir!', 'Atenção', 'danger', 'refreshPedido sem o Tipo de Observação');
          }
        }
      }
    },
    // representante: function () {
    //   let dadosAcesso = localStorage.getItem('dadosAcesso')
    //   if (dadosAcesso.representante.apelido !== 1) {
    //     this.dadosTabela.representante = dadosAcesso.representante.apelido
    //     console.log('s')
    //   //   // dd
    //   }
    // },
    novoPedido: function novoPedido() {
      this.pedido = {
        id: 0,
        numeroPedido: 0,
        numeroOrcamento: 0,
        statusGoSales: 2,
        isErp: false,
        isEditavel: true,
        chaveErp: '',
        cliente: {},
        clienteIndustrializador: {},
        tabelaPreco: {},
        formaPagto: {},
        condPagto: {},
        tipoFrete: {},
        transportadora: {},
        representante: {},
        observacoes: [],
        itens: [],
        // totais: {}
        totais: {
          valorDesconto: 0,
          valorIPI: 0,
          valorICMSST: 0,
          valorTotal: 0
        }
      };
      this.status = [{
        idStatus: 2,
        codigo: '002',
        ordem: 1,
        chaveErp: '002',
        descricao: 'Orçamento',
        classe: 'col-md-12'
      }];
    },
    novoStatus: function novoStatus() {
      this.status = [{
        idStatus: 1,
        codigo: '001',
        ordem: 1,
        chaveErp: '001',
        descricao: 'Orçamento',
        classe: 'col-md-4'
      }, {
        idStatus: 2,
        codigo: '002',
        ordem: 2,
        chaveErp: '002',
        descricao: 'Finalizado',
        classe: 'col-md-4'
      }, {
        idStatus: 3,
        codigo: '003',
        ordem: 3,
        chaveErp: '003',
        descricao: 'Cancelado',
        classe: 'col-md-4'
      }];
    },
    desabilitaCondicaoPagto: function desabilitaCondicaoPagto() {
      if (this.desabilitaEdicao()) {
        return true;
      } else if (this.pedido.itens.length === 0) {
        return true;
      }
      return false;
    },
    desabilitaRepresentante: function desabilitaRepresentante() {
      if (this.desabilitaEdicao() === true) {
        return true;
      } else {
        return this.dadosAcesso.perfil.id === 3;
        // this.codigoRepresentante = dadosAcesso.representante.codigo
        // return this.codigoRepresentante === this.pedido.representante.codigo
      }
    },
    desabilitaEdicao: function desabilitaEdicao() {
      if (this.pedido.isErp) {
        return true;
      } else {
        return !this.pedido.isEditavel;
      }
    },
    selecionarStatus: function selecionarStatus(idStatus) {
      if (this.pedido.isErp) {
        return;
      } else {
        this.pedido.statusGoSales = idStatus;
      }
    },
    editarItemPedido: function editarItemPedido(itemPedido) {
      var _this5 = this;

      var param = { codigoGrade: '', codProduto: itemPedido.codProduto, codigoTabelaPreco: this.pedido.tabelaPreco.codigo };
      this.blockUiVisibility = true;
      itemPedido.idPedido = this.pedido.id;
      var itemPedidoObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, itemPedido);
      __WEBPACK_IMPORTED_MODULE_8__services_produto__["a" /* default */].detalheGrade(param).then(function (response) {
        var param = { gradeProdutos: response.data, tabela: _this5.pedido.tabelaPreco, itemPedido: itemPedidoObj
          // console.log(this.pedido)
        };__WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$emit('editarItemPedido', param);
        _this5.isModalItensVisible = true;
      }).catch(function (error) {
        console.log(error);
        _this5.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'editarItemPedido erro');
      }).finally(function () {
        _this5.blockUiVisibility = false;
      });
    },
    buscarProdutosGrade: function buscarProdutosGrade(grade) {
      var _this6 = this;

      var param = { codigoGrade: grade.codigoGrade, codProduto: '', codigoTabelaPreco: this.pedido.tabelaPreco.codigo };
      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_8__services_produto__["a" /* default */].detalheGrade(param).then(function (response) {
        var param = { gradeProdutos: response.data, tabela: _this6.pedido.tabelaPreco };
        __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$emit('abreModaltens', param);
        _this6.isModalItensVisible = true;
      }).catch(function (error) {
        console.log(error);
        _this6.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'buscarProdutosGrade erro');
      }).finally(function () {
        _this6.blockUiVisibility = false;
      });
    },
    closeModal: function closeModal() {
      this.isModalItensVisible = false;
    },

    showMessage: function showMessage(message, title, variantColor, from) {
      // console.log('from: ' + from + ' / message: ' + message)
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast-novoPedido');
    },
    addItem: function addItem() {
      var _this7 = this;

      if (this.pedido.tabelaPreco.codigo === '' || typeof this.pedido.tabelaPreco.codigo === 'undefined') {
        this.modalItens = false;
        this.showMessage('Por favor, selecione uma tabela de preço', 'Atenção', 'danger', 'addItem tabelaPreco.codigo === ""');
        return;
      }
      this.pesquisa.termo = '';
      this.grades = [];
      this.msgBlockUi = 'Listando itens, aguarde...';
      this.blockUiVisibility = true;
      // let pedidoToSend = {
      //   observacoes: []
      // }
      // pedidoToSend.codRpresentante = this.pedido.representante.codigo
      // for (var iObs = 0; iObs < this.pedido.observacoes.length; iObs++) {
      //   let obs = this.pedido.observacoes[iObs]
      //   let newObs = {chaveErp: obs.chaveErp, observacao: obs.observacao, codTipoObs: obs.tipoObservacao.codigo, numPedido: obs.numeroPedido}
      //   pedidoToSend.observacoes.push(newObs)
      // }
      // this.pedido.observacoes = pedidoToSend.observacoes
      var addItem = {
        id: this.pedido.id,
        numeroPedido: this.pedido.numeroPedido,
        numeroOrcamento: this.pedido.numeroOrcamento,
        statusGoSales: this.pedido.statusGoSales,
        isErp: this.pedido.isErp,
        isEditavel: this.pedido.isEditavel,
        chaveErp: this.pedido.chaveErp,
        cliente: {
          cidade: this.pedido.cliente.cidade,
          telefone: this.pedido.cliente.telefone,
          numero: this.pedido.cliente.numero,
          endereco: this.pedido.cliente.endereco,
          ddd: this.pedido.cliente.ddd,
          cnpjCpf: this.pedido.cliente.cnpjCpf,
          codCliente: this.pedido.cliente.codCliente,
          uf: this.pedido.cliente.uf,
          fantasia: this.pedido.cliente.fantasia,
          id: this.pedido.cliente.id,
          idClienteGoSales: this.pedido.cliente.idClienteGoSales,
          clienteNovo: this.pedido.cliente.clienteNovo,
          razaoSocial: this.pedido.cliente.razaoSocial
        },
        clienteIndustrializador: this.pedido.clienteIndustrializador,
        tabelaPreco: {
          codigo: this.pedido.tabelaPreco.codigo,
          tipoFrete: this.pedido.tabelaPreco.tipoFrete,
          calculaImpostos: this.pedido.tabelaPreco.calculaImpostos,
          descricao: this.pedido.tabelaPreco.descricao
        },
        formaPagto: {
          codigo: this.pedido.formaPagto.codigo,
          descricao: this.pedido.formaPagto.descricao
        },
        condPagto: this.pedido.condPagto,
        tipoFrete: {
          codigo: this.pedido.tipoFrete.codigo,
          descricao: this.pedido.tipoFrete.descricao
        },
        transportadora: this.pedido.transportadora,
        representante: this.pedido.representante,
        observacoes: this.pedido.observacoes,
        itens: this.pedido.itens,
        totais: {
          valorDesconto: this.pedido.totais.valorDesconto,
          valorIPI: this.pedido.totais.valorIPI,
          valorICMSST: this.pedido.totais.valorICMSST,
          valorTotal: this.pedido.totais.valorTotal
        }
      };
      if (typeof addItem.cliente.cnpjCpf !== 'undefined') {
        addItem.cliente.telefone = addItem.cliente.telefone.replace('-', '');
        addItem.cliente.ddd = addItem.cliente.ddd.replace('(', '').replace(')', '');
        addItem.cliente.cnpjCpf = addItem.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '');
      } else {
        addItem.cliente = {};
      }
      if (typeof addItem.totais.valorDesconto === 'string') {
        addItem.totais.valorDesconto = parseFloat(addItem.totais.valorDesconto.replace(',', '.'));
      }
      if (typeof addItem.totais.valorIPI === 'string') {
        addItem.totais.valorIPI = parseFloat(addItem.totais.valorIPI.replace(',', '.'));
      }
      if (typeof addItem.totais.valorICMSST === 'string') {
        addItem.totais.valorICMSST = parseFloat(addItem.totais.valorICMSST.replace(',', '.'));
      }
      if (typeof addItem.totais.valorTotal === 'string') {
        addItem.totais.valorTotal = parseFloat(addItem.totais.valorTotal.replace(',', '.'));
      }
      // console.log(JSON.stringify(addItem))
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].inserirPedido(addItem).then(function (response) {
        // console.log(JSON.stringify(response))
        _this7.refreshPedido(response.data.pedido, response.data.condPagtos);
        _this7.novoStatus();
        _this7.modalItens = true;
        _this7.pesquisa = {};
      }).catch(function (error) {
        console.log(error);
        _this7.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'addItem inserirPedido erro');
      }).finally(function () {
        _this7.blockUiVisibility = false;
      });
    },
    pageLista: function pageLista() {
      this.modalVoltarConfirma = false;
      __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$emit('exibirLista');
      this.clearForm();
    },
    confSairSemSalvar: function confSairSemSalvar() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.dadosPedidoOriginal) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pedido)) {
        this.modalVoltarConfirma = true;
      } else {
        this.pageLista();
      }
    },
    valida: function valida() {
      if (this.pedido.statusGoSales !== 3) {
        if (this.pedido.tabelaPreco.codigo === '' || typeof this.pedido.tabelaPreco.codigo === 'undefined') {
          return 'Por favor, selecione uma tabela de preço';
        }
        if (this.pedido.representante.codigo === '' || typeof this.pedido.representante.codigo === 'undefined') {
          return 'Por favor, selecione o representante';
        }
        // if (this.pedido.condPagto.codigo === '' || typeof this.pedido.condPagto.codigo === 'undefined') {
        //   return 'Por favor, selecione a condição de pagamento'
        // }
        if (this.pedido.itens.length === 0) {
          return 'É necessário que você adicione pelo menos um item antes de salvar';
        }
        if (this.empresaKatec) {
          if (this.pedido.transportadora.codigo === '' || typeof this.pedido.transportadora.codigo === 'undefined') {
            return 'Por favor, selecione a transportadora';
          }
        }
        if (this.empresaMaioricasa || this.empresaAsiatex) {
          if (this.pedido.tipoFrete.codigo === '002') {
            if (this.pedido.transportadora.codigo === '' || typeof this.pedido.transportadora.codigo === 'undefined') {
              return 'Por favor, selecione a transportadora';
            }
          }
        }
        if (this.pedido.statusGoSales === 2) {
          if (this.pedido.condPagto.codigo === '' || typeof this.pedido.condPagto.codigo === 'undefined') {
            return 'Por favor, selecione a condição de pagamento';
          }
        }
        this.pedido.motivoCancelamento = '';
      }
      if (this.pedido.statusGoSales === 3 && this.textoMotivoCancelamento === '') {
        this.modalConfirmaCancelamento = true;
        return 'Por favor, preencha o motivo para o cancelamento do pedido';
      } else {
        this.pedido.motivoCancelamento = this.textoMotivoCancelamento;
      }
      return '';
    },
    tentaSalvar: function tentaSalvar() {
      if (this.pedido.statusGoSales !== 3) {
        if (this.pedido.tipoFrete.codigo === '' || typeof this.pedido.tipoFrete.codigo === 'undefined') {
          this.modalItens = false;
          this.showMessage('Por favor, selecione o tipo de frete', 'Atenção', 'danger', 'tentaSalvar tipoFrete.codigo');
          return;
        }
        if (this.pedido.formaPagto.codigo === '' || typeof this.pedido.formaPagto.codigo === 'undefined') {
          this.modalItens = false;
          this.showMessage('Por favor, selecione a forma de pagamento', 'Atenção', 'danger', 'tentaSalvar formaPagto.codigo');
          return;
        }
      }
      var repLogado = localStorage.getItem('representantesLogin');
      var repSelecionado = localStorage.getItem('representanteSelecionado');
      repLogado = JSON.parse(repLogado);
      repSelecionado = JSON.parse(repSelecionado);
      if (repLogado[0].codigo !== repSelecionado.codigo) {
        this.modalConfirmaRepLog = true;
      } else {
        this.salvarPedido();
      }
    },
    salvarPedido: function salvarPedido() {
      var _this8 = this;

      var retValida = this.valida();
      if (retValida !== '') {
        console.log(retValida);
        this.showMessage(retValida, 'Atenção', 'warning', 'salvarPedido retValida !== ""');
        return;
      }
      // let pedidoToSend = {
      //   observacoes: []
      // }
      // pedidoToSend.codRpresentante = this.pedido.representante.codigo
      //
      // for (var iObs = 0; iObs < this.pedido.observacoes.length; iObs++) {
      //   let obs = this.pedido.observacoes[iObs]
      //   let newObs = {chaveErp: obs.chaveErp, observacao: obs.observacao, codTipoObs: obs.tipoObservacao.codigo, numPedido: obs.numeroPedido}
      //   pedidoToSend.observacoes.push(newObs)
      // }
      // this.pedido.observacoes = pedidoToSend.observacoes
      // console.log(JSON.stringify('este é o this.pedido -> ' + this.pedido))
      this.msgBlockUi = 'Salvando pedido, aguarde...';
      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_7__services_tablePedidos__["a" /* default */].inserirPedido(this.pedido).then(function (response) {
        // console.log(JSON.stringify('response do inserir pedido' + response))
        _this8.refreshPedido(response.data.pedido, response.data.condPagtos);
        _this8.modalItens = false;
        _this8.modalConfirmaCancelamento = false;
        _this8.pesquisa = {};
        var objectPost = { termo: '', codStatus: 0, emissaoDe: '', emissaoAte: '' };
        __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$emit('filtrosSelecionados', objectPost);
        __WEBPACK_IMPORTED_MODULE_5__main__["broadcastServer"].$emit('exibirLista');
      }).catch(function (error) {
        console.log(error);
        _this8.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'salvarPedido inserirPedido erro');
      }).finally(function () {
        _this8.blockUiVisibility = false;
        _this8.clearForm();
      });
    },

    confirmaExclusaoObs: function confirmaExclusaoObs(id) {
      this.modalExclusaoObs = true;
      this.excluirObs = id;
    },
    removerObs: function removerObs(indice) {
      var obs = this.pedido.observacoes[indice];
      this.pedido.observacoes.splice(indice, 1);
      // alert(obs.observacao)
      console.log(obs.observacao);
      this.showMessage('Observação removida do pedido com sucesso!', 'Sucesso', 'success', 'removerObs ok');
    },
    alterarObs: function alterarObs(obs, indice) {
      this.observacao = obs;
      this.modalObs = true;
      if (this.observacao.tipoObservacao.codigo === '') {
        this.novaObservacao = true;
      } else {
        this.novaObservacao = false;
      }
      this.indiceObservacaoSelecionada = indice;
    },
    clearForm: function clearForm() {
      this.dadosTabela = {
        condPagtos: [],
        tabelasPreco: [],
        representante: [],
        fretes: [],
        transportadoras: [],
        formaPagtos: [],
        tiposObservacoes: []
      };
      this.itemCondPagto = {
        codigo: '',
        faixaFinal: 0.00,
        faixaInicial: 0.00,
        descricao: ''
      };
      this.itemTabelaPreco = {
        codigo: '',
        tipoFrete: '',
        calculaImpostos: 0,
        descricao: ''
      };
      this.itemRepresentante = {
        codigo: '',
        apelido: ''
      };
      this.itemFretes = {
        codigo: '',
        descricao: ''
      };
      this.itemTransportadoras = {
        codigo: '',
        descricao: ''
      };
      this.itemFormaPagtos = {
        codigo: '',
        descricao: ''
      };
      this.pedido = {
        chavePedido: 0,
        numeroPedido: '',
        numeroOrcamento: '',
        id: 0,
        statusGoSales: 0,
        isErp: false,
        isEditavel: true,
        chaveErp: '',
        cliente: {},
        clienteIndustrializador: {},
        tabelaPreco: {},
        formaPagto: {},
        condPagto: {},
        tipoFrete: {},
        transportadora: {},
        representante: {},
        observacoes: [],
        itens: [],
        totais: {
          valorDesconto: 0.00,
          valorIPI: 0.00,
          valorICMSST: 0.00,
          valorTotal: 0.00
        }
      };
    },
    clearObs: function clearObs() {
      this.observacao = {
        tipoObservacao: {
          codigo: '',
          exibeImpressao: 0,
          descricao: ''
        },
        observacao: '',
        chaveErp: '',
        numeroPedido: ''
      };
    },
    newObs: function newObs() {
      this.clearObs();
      this.modalObs = true;
      this.novaObservacao = true;
    },
    addObs: function addObs(event) {
      var _this9 = this;

      if (this.novaObservacao) {
        var observacoes = this.pedido.observacoes.filter(function (obs) {
          return obs.tipoObservacao.codigo === _this9.observacao.tipoObservacao.codigo;
        });
        if (observacoes.length > 0) {
          event.preventDefault();
          this.showMessage('Tipo de observação já adicionada, selecione outro tipo para continuar ou edite a observação já disponível.', 'Atenção', 'warning', 'addObs observação já adicionada');
        } else {
          this.pedido.observacoes.push(this.observacao);
          this.modalObs = false;
          this.clearObs();
        }
      } else {
        if (this.indiceObservacaoSelecionada !== -1) {
          this.pedido.observacoes[this.indiceObservacaoSelecionada].observacao = this.observacao.observacao;
          this.newObs();
          this.indiceObservacaoSelecionada = -1;
        } else {
          this.showMessage('Problemas ao obter observação selecionada', 'Atenção', 'warning', 'addObs Problemas ao obter observação selecionada');
        }
      }
    },
    disableSalvarObs: function disableSalvarObs() {
      return this.observacao.observacao === '' || this.observacao.tipoObservacao.codigo === '';
    },
    disableEnviarCancelamento: function disableEnviarCancelamento() {
      return this.textoMotivoCancelamento === '';
    },
    fechaModalCancelamento: function fechaModalCancelamento() {
      this.modalConfirmaCancelamento = false;
      this.tentaSalvar();
    },
    formatterValue: function formatterValue(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    formatQtde: function formatQtde(qtde) {
      if (typeof qtde !== 'undefined') {
        return qtde.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },
    limpaPesq: function limpaPesq() {
      this.grades = [];
    },
    pesquisarGrades: function pesquisarGrades() {
      var _this10 = this;

      if (this.pesquisa.termo.length <= 2) {
        this.showMessage('Digite ao menos três caracteres.', 'Atenção', 'warning', 'pesquisarGrades pesquisa.termo.length <= 2');
        return;
      }
      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_8__services_produto__["a" /* default */].pesquisarGrades(this.pesquisa.termo).then(function (response) {
        _this10.grades = response.data.grades;
        if (_this10.grades.length === 0) {
          _this10.showMessage('Não existe produto com nome semelhante ao pesquisado, tente novamente', 'Atenção', 'warning', 'pesquisarGrades grades.length === 0');
        }
      }).catch(function (error) {
        console.log(error);
        _this10.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'pesquisarGrades erro');
      }).finally(function () {
        _this10.blockUiVisibility = false;
      });
    },
    pesquisarClienteInd: function pesquisarClienteInd() {
      var _this11 = this;

      if (this.pesquisaClienteInd.termo.length <= 2) {
        this.showMessage('Digite ao menos três caracteres.', 'Atenção', 'warning', 'pesquisarClienteInd .termo.length <= 2');
        return;
      }
      this.blockUiVisibility = true;
      this.pesquisaClienteInd.uf = '';
      this.pesquisaClienteInd.cidade = '';
      __WEBPACK_IMPORTED_MODULE_9__services_tableClientes__["a" /* default */].listarSelect(this.pesquisaClienteInd).then(function (response) {
        _this11.clientesPesquisados = response.data.clientes;
        if (_this11.clientesPesquisados.length === 0) {
          _this11.showMessage('Não existe cliente com nome semelhante ao pesquisado, tente novamente', 'Atenção', 'warning', 'pesquisarClienteInd listarSelect clientesPesquisados.length === 0');
        }
      }).catch(function (error) {
        console.log(error);
        _this11.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'pesquisarClienteInd erro');
      }).finally(function () {
        _this11.blockUiVisibility = false;
      });
    },
    reset: function reset() {
      /** TRECHO RESPONSÁVEL PELA FILTRAGEM DO SELECT **/
      this.itemCondPagto = {};
    },
    selectFromParentComponent1: function selectFromParentComponent1() {
      // select option from parent component
      this.itemCondPagto = this.dadosTabela.condPagtos[0];
      /** FIM COD DE FILTRO DO SELECT **/
    },

    formatterCnpjCpf: function formatterCnpjCpf(value) {
      if (value.length === 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
      }
      if (value.length === 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
      }
    }
  }
});

/***/ }),

/***/ "cmLO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cmjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",attrs:{"id":"cardOrcamento"}},[_c('b-card-header',{style:(_vm.style1),attrs:{"header":_vm.header,"header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),(this.pedidosOrcamento.pedidos)?_c('b-card',{staticClass:"cardBody"},[(this.pedidosOrcamento.pedidos.length > 0)?_c('b-card-text',{staticClass:"table"},[_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.pedidosOrcamento.pedidos,"fields":_vm.fields}})],1):_c('span',[_vm._v("Não há itens para exibir nesta sessão")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dSqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relListCli"}},[_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Ranking de clientes dos ultimos 6 meses","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"cardBody"},[_c('div',[(_vm.pObjPaginacao.length > 0)?_c('b-pagination-nav',{attrs:{"size":"sm","number-of-pages":_vm.pObjPaginacao.length,"pages":_vm.pObjPaginacao,"align":"right","use-router":""},on:{"input":_vm.buscarClientesPorPagina},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}}):_vm._e()],1),_vm._v(" "),_c('b-card-text',{staticClass:"table"},[(_vm.clientes && _vm.clientes.length > 0)?_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.clientes,"fields":_vm.fieldsClientes},scopedSlots:_vm._u([{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[(row.item.cnpjCpf.length === 14)?_c('div',{staticClass:"col-md-8"},[_vm._v("CNPJ: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]):_c('div',{staticClass:"col-md-8"},[_vm._v("CPF: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v(_vm._s(row.item.telefone))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_vm._v("Ranking: "+_vm._s(row.item.ranking))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 txtRight"},[_vm._v("R$ "+_vm._s(_vm.formatterValue(row.item.valorPedido)))])])]}}],null,false,4118614560)}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1),_vm._v(" "),_c('div',[(_vm.pObjPaginacao.length > 0)?_c('b-pagination-nav',{attrs:{"size":"sm","number-of-pages":_vm.pObjPaginacao.length,"pages":_vm.pObjPaginacao,"align":"right","use-router":""},on:{"input":_vm.buscarClientesPorPagina},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}}):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.blockUI.visibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eAmv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sem-banner.304184a.jpg";

/***/ }),

/***/ "enmS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "etK7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fiCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "flXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressMetasVue_vue__ = __webpack_require__("VDoM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6571ab92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressMetasVue_vue__ = __webpack_require__("2eij");
function injectStyle (ssrContext) {
  __webpack_require__("PVzy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6571ab92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressMetasVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6571ab92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressMetasVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "flaK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h3jR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableClientesVue',
  props: ['title'],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__["a" /* default */]
  },
  data: function data() {
    return {
      empresaKatec: false,
      dateTime: '',
      grade: {},
      tabela: {},
      blockUiVisibility: false,
      gradeProdutos: {},
      exibeModal: false,
      tamanhos: [],
      tamanhoSelecionado: {},
      coresTamanhos: [],
      cores: [],
      corSelecionada: {},
      indiceCorSelecionada: 0,
      produtoSelecionado: {},
      previsao: {
        data: '',
        quantidade: ''
      },
      swiperOptionModelos: {
        slidesPerView: 3,
        spaceBetween: 3,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionVariantes: {
        slidesPerView: 4,
        spaceBetween: 6,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1000: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          400: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      }
    };
  },

  created: function created() {
    var _this = this;

    var empresa = localStorage.getItem('empresaLogada');
    if (JSON.parse(empresa).identificador === 2355480534) {
      this.empresaKatec = true;
    }
    __WEBPACK_IMPORTED_MODULE_0__main__["broadcastServer"].$on('pageViewGrade', function (parametro) {
      window.scrollTo(0, 0);
      // console.log(parametro)
    });
    __WEBPACK_IMPORTED_MODULE_0__main__["broadcastServer"].$on('responseGrade', function (param) {
      window.scrollTo(0, 0);
      // console.log(param.gradeProdutos)
      _this.dataHoraEstoque();
      _this.tabela = param.tabela;
      _this.gradeProdutos = param.gradeProdutos;
      var tamanhos = [];
      var tamanhosGrade = param.gradeProdutos.tamanhos.sort(function (a, b) {
        return a.descricaoTamanho > b.descricaoTamanho ? 1 : b.descricaoTamanho > a.descricaoTamanho ? -1 : 0;
      });
      for (var iTam = 0; iTam < tamanhosGrade.length; iTam++) {
        var tamanho = tamanhosGrade[iTam];
        if (iTam === 0) {
          tamanhos.push({ codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active' });
          _this.tamanhoSelecionado = { codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active' };
        } else {
          tamanhos.push({ codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: '' });
        }
      }
      _this.tamanhos = tamanhos;
      if (_this.tamanhos.length > 0) {
        _this.selecionarCores(0);
      }
      // this.grade = parametro
    });
  },
  methods: {
    dataHoraEstoque: function dataHoraEstoque() {
      var today = new Date();
      var date = ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear().toString().substr(-2);
      var hour = ('0' + today.getHours()).slice(-2);
      var minute = ('0' + today.getMinutes()).slice(-2);
      var time = hour + ':' + minute;
      this.dateTime = date + ' - ' + time;
    },
    pageLista: function pageLista() {
      __WEBPACK_IMPORTED_MODULE_0__main__["broadcastServer"].$emit('filtroCatalogo', '');
      var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_0__main__["operacao"].ADICIONAR, modo: __WEBPACK_IMPORTED_MODULE_0__main__["modo"].LISTA };
      __WEBPACK_IMPORTED_MODULE_0__main__["broadcastServer"].$emit('pageViewGrade', parametro);
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    formatQtde: function formatQtde(qtde) {
      if (typeof qtde !== 'undefined') {
        return qtde.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },
    selecionarCores: function selecionarCores(indiceTamanhoSelecionado) {
      this.produtoSelecionado = { lotes: [] };
      for (var iTam = 0; iTam < this.tamanhos.length; iTam++) {
        this.tamanhos[iTam].active = '';
        if (indiceTamanhoSelecionado === iTam) {
          this.tamanhos[iTam].active = 'active';
        }
      }
      var tamanho = this.gradeProdutos.tamanhos[indiceTamanhoSelecionado];
      this.tamanhoSelecionado = tamanho;
      var cores = this.gradeProdutos.produtos.filter(function (prod) {
        return prod.codigoTamanho === tamanho.codigoTamanho;
      });
      this.cores = [];
      for (var iCor = 0; iCor < cores.length; iCor++) {
        var cor = cores[iCor];
        if (iCor === 0) {
          this.cores.push({ cor: cor, classe: 'imgSelecionada' });
          this.corSelecionada = { cor: cor, classe: 'imgSelecionada' };
        } else {
          this.cores.push({ cor: cor, classe: 'imgNaoSelecionada' });
        }
      }
      this.coresTamanhos = cores;
      if (this.cores.length > 0) {
        this.selecionarProduto(this.cores[0].cor, 0);
      }
      // console.log('cores: ' + JSON.stringify(cores))
    },
    selecionarProduto: function selecionarProduto(corSelecionada, indiceCorSelecionada) {
      var _this2 = this;

      this.produtoSelecionado = { lotes: [] };

      this.corSelecionada = corSelecionada;
      this.indiceCorSelecionada = indiceCorSelecionada;
      for (var iCor = 0; iCor < this.cores.length; iCor++) {
        this.cores[iCor].classe = 'imgNaoSelecionada';
        if (indiceCorSelecionada === iCor) {
          this.cores[iCor].classe = 'imgSelecionada';
        }
      }
      var produtos = this.gradeProdutos.produtos.filter(function (prod) {
        return prod.codigoTamanho === _this2.tamanhoSelecionado.codigoTamanho && prod.codigoCor === corSelecionada.codigoCor;
      });
      if (produtos.length > 0) {
        this.produtoSelecionado = produtos[0];
        this.previsao.data = this.produtoSelecionado.previsao.length === 0 ? 'Sem Previsão' : this.produtoSelecionado.previsao[0].dataPrevisao;
        this.previsao.quantidade = this.produtoSelecionado.previsao.length === 0 ? '' : this.produtoSelecionado.previsao[0].quantidade;
      }
      // console.log('produto selecionado: ' + JSON.stringify(this.produtoSelecionado))
    },
    onSlideStart: function onSlideStart(index) {
      var descricao = this.destaques[index].descricao;
      this.descricao = descricao;
    },
    onSlideEnd: function onSlideEnd(index) {
      var descricao = this.destaques[index].descricao;
      this.descricao = descricao;
    }
  }
});

/***/ }),

/***/ "hERF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewItemsCatalogoVue_vue__ = __webpack_require__("lQbo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afded4d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewItemsCatalogoVue_vue__ = __webpack_require__("hqVR");
function injectStyle (ssrContext) {
  __webpack_require__("FaGc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afded4d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewItemsCatalogoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afded4d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewItemsCatalogoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hmr2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hqVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"pt-3 pb-2"},[_c('b-col',{attrs:{"sm":"2 title"}},[_vm._v(_vm._s(_vm.title || "Título não informado"))]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10","id":"tabPrecoDesk"}},[(_vm.btnTabela)?_c('b-button',{staticClass:"btn-plus btnAdicionar right",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return _vm.trocaTabela()}}},[_vm._v("Tabela de Preço: "+_vm._s(_vm.tabelaSelecionada.descricao || "Selecionar"))]):_c('b-col',{staticClass:"right p-0",attrs:{"sm":"3"}},[_c('b-button',{staticClass:"btn-plus btnAdicionar right",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return _vm.voltar()}}},[_vm._v("Voltar")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro shadow"},[_c('b-col',{attrs:{"cols":"10","id":"inputFiltroCatalog"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","autocomplete":"no","placeholder":_vm.placeholderNm},model:{value:(_vm.termo),callback:function ($$v) {_vm.termo=$$v},expression:"termo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"btnLimpaFiltroCatalog",attrs:{"cols":"1"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltro()}}},[_c('i',{staticClass:"fas fa-eraser"})])],1),_vm._v(" "),_c('b-col',{staticClass:"btnBuscaFiltroCatalog",attrs:{"cols":"1"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.filtrar()}}},[_c('i',{staticClass:"fas fa-search"})])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2",attrs:{"id":"tabPrecoMob"}},[(_vm.btnTabela)?_c('b-button',{staticClass:"btn-plus btnAdicionar right",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return _vm.trocaTabela()}}},[_vm._v("Tabela de Preço: "+_vm._s(_vm.tabelaSelecionada.descricao || "Selecionar"))]):_vm._e()],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","cancel-title":"Fechar","cancel-variant":"secondary","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.selecTabPreco},model:{value:(_vm.modalTabPreco),callback:function ($$v) {_vm.modalTabPreco=$$v},expression:"modalTabPreco"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Selecione uma Tabela de Preço")])]),_vm._v(" "),_c('b-form-group',{staticClass:"m-0"},[_c('b-form-select',{attrs:{"size":"sm"},model:{value:(_vm.tabelaSelecModal),callback:function ($$v) {_vm.tabelaSelecModal=$$v},expression:"tabelaSelecModal"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("-- Tabelas --")])]),_vm._v(" "),_vm._l((this.dadosTabela.tabelasPreco),function(tabela){return _c('option',{key:tabela.codigo,domProps:{"value":tabela}},[_vm._v(_vm._s(tabela.descricao))])})],2)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i5vT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    style1: '',
    title: '',
    header: '',
    pCardPedidosEmOrcamentoValues: { pedidos: [] }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var cor = state.cor.cor;

      return {
        'background-color': cor
      };
    }
  })),
  watch: {
    pCardPedidosEmOrcamentoValues: function pCardPedidosEmOrcamentoValues(newVal, oldVal) {
      // watch it
      this.pedidosOrcamento = newVal;
    }
  },
  data: function data() {
    return {
      pedidosOrcamento: [],
      fields: [{
        key: 'id',
        label: 'Pedido',
        sortable: true
      }, {
        key: 'fantasia',
        label: 'Cliente',
        sortable: true,
        formatter: this.toCapitalize
      }, {
        key: 'emissao',
        label: 'Emissão',
        sortable: true
      }, {
        key: 'totalPedido',
        label: 'Valor',
        sortable: true,
        class: 'txtRight',
        formatter: this.formatterValue
      }]
    };
  },
  created: function created() {
    // console.log('card pedidos em orcamento criado')
  },
  mounted: function mounted() {
    // console.log('card pedidos em orcamento mount')
    this.pedidosOrcamento = this.pCardPedidosEmOrcamentoValues;
  },

  methods: {
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
});

/***/ }),

/***/ "iYuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"filtroClientes"}},[_c('b-row',{staticClass:"pt-3 pb-2",attrs:{"id":"headerPageCli"}},[_c('b-col',{staticClass:"pl-0",attrs:{"sm":"10 title"}},[_vm._v(_vm._s(_vm.title || "Título não informado"))]),_vm._v(" "),(_vm.pageCliente)?_c('b-col',{staticClass:"pr-0",attrs:{"sm":"2"}},[_c('b-button',{staticClass:"btn-plus btnAdicionar left",style:(_vm.cor),attrs:{"size":"sm"},on:{"click":function($event){return _vm.adicionar()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Adicionar")])],1):_vm._e(),_vm._v(" "),(_vm.pagePedido)?_c('b-col',{staticClass:"pr-0",attrs:{"sm":"2"}},[_c('b-button',{staticClass:"btn-plus btnVoltar left",style:(_vm.cor),attrs:{"size":"sm"},on:{"click":function($event){return _vm.voltar()}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Voltar")])],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro shadow p-2",attrs:{"id":"filtroWeb"}},[_c('b-col',{attrs:{"cols":"5"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","placeholder":_vm.placeholderNm,"autocomplete":"no"},model:{value:(_vm.termo),callback:function ($$v) {_vm.termo=$$v},expression:"termo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"p-0",attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("-- UF --")])]),_vm._v(" "),_vm._l((_vm.options),function(uf){return _c('option',{key:uf,domProps:{"value":uf}},[_vm._v(_vm._s(uf))])})],2)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","placeholder":_vm.placeholderCid,"autocomplete":"no"},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"2"}},[_c('b-button',{staticClass:"btnLimpaFiltro defaultColor",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltro()}}},[_c('i',{staticClass:"fas fa-eraser"})]),_vm._v(" "),_c('b-button',{staticClass:"btnBuscaFiltro defaultColor",attrs:{"size":"sm"},on:{"click":function($event){return _vm.filtrar()}}},[_c('i',{staticClass:"fas fa-search"})])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro shadow",attrs:{"id":"filtroMob"}},[_c('b-button',{attrs:{"id":"abreModalFiltro","size":"sm"},on:{"click":function($event){return _vm.abreModalFiltro()}}},[_c('i',{staticClass:"fas fa-search mr-2"}),_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"ml-3 btnLimpaFiltro",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltro()}}},[_c('i',{staticClass:"fas fa-eraser mr-2"}),_vm._v("Limpar Filtro")])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Filtrar","ok-variant":"primary","cancel-title":"Cancelar","cancel-variant":"secondary","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.filtrar},model:{value:(_vm.modalFiltro),callback:function ($$v) {_vm.modalFiltro=$$v},expression:"modalFiltro"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Filtrar Clientes")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row m-0"},[_c('div',{staticClass:"w-100"},[_c('b-input-group',[_c('b-input-group-prepend',{staticClass:"mt-0"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","placeholder":_vm.placeholderNm,"autocomplete":"no"},model:{value:(_vm.termo),callback:function ($$v) {_vm.termo=$$v},expression:"termo"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row w-100 mt-3 ml-0 mr-0"},[_c('div',{staticClass:"col-3 pl-0"},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("-- UF --")])]),_vm._v(" "),_vm._l((_vm.options),function(uf){return _c('option',{key:uf,domProps:{"value":uf}},[_vm._v(_vm._s(uf))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-9 pr-0"},[_c('b-input-group',[_c('b-input-group-prepend',{staticClass:"mt-0"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","placeholder":_vm.placeholderCid,"autocomplete":"no"},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}})],1)],1)])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j9Lh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jBOa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jLdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_impressaoPedidoVue_vue__ = __webpack_require__("6D4D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255b40c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impressaoPedidoVue_vue__ = __webpack_require__("UiTa");
function injectStyle (ssrContext) {
  __webpack_require__("RuvD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-255b40c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_impressaoPedidoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255b40c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impressaoPedidoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jdFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.novidades.length > 0)?_c('div',{staticClass:"card mb-5 shadow"},[_c('b-card-header',{staticClass:"txtLeft",style:(_vm.cor),attrs:{"header-text-variant":"white","header-tag":"header"},on:{"click":function($event){return _vm.selecionarCategoria(0)}}},[_vm._v("DESTAQUES")]),_vm._v(" "),_c('b-card',{staticClass:"cardNovidades",attrs:{"border-variant":"light"}},[_c('b-card-text',[_c('swiper',{attrs:{"options":_vm.swiperOptionNov}},_vm._l((_vm.novidades),function(item){return _c('swiper-slide',{key:item.codigo,nativeOn:{"click":function($event){return _vm.selecionarNovidade(item.codigo)}}},[[(item.url)?_c('span',{staticClass:"imgItem"},[_c('img',{attrs:{"src":item.url,"alt":""}})]):_c('span',{staticClass:"semImagem"},[_c('img',{attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"itemGrade"},[_c('strong',[_vm._v("Item:")]),_vm._v(" "+_vm._s(item.codigoGrade))]),_vm._v(" "),_c('span',{staticClass:"descGrade"},[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(item.descricaoGrade))])]],2)}),1),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev swiperButtonNovPrev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next swiperButtonNovNext",attrs:{"slot":"button-next"},slot:"button-next"})],1)],1)],1):_vm._e(),_vm._v(" "),(this.categorias.length > 0)?_c('div',_vm._l((this.categorias),function(categoria,index){return _c('div',{key:categoria.codigo,staticClass:"card mb-5 shadow"},[_c('b-card-header',{staticClass:"txtLeft",style:(_vm.cor),attrs:{"header":categoria.descricaoGrade,"header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),_c('b-card',{staticClass:"cardCategorias",attrs:{"border-variant":"light"}},[_c('b-card-text',[(categoria.grades.length > 0)?_c('div',[(categoria.grades.length > 0)?_c('swiper',{attrs:{"options":_vm.swiperOptionFormat(index)}},_vm._l((categoria.grades),function(grade){return _c('swiper-slide',{key:grade.codigoGrade,nativeOn:{"click":function($event){return _vm.selecionarGrade(grade)}}},[[(grade.urlImagemGrade)?_c('span',{staticClass:"imgItem"},[_c('img',{attrs:{"src":grade.urlImagemGrade,"alt":""}})]):_c('span',{staticClass:"semImagem"},[_c('img',{attrs:{"src":__webpack_require__("7sUr"),"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"itemGrade"},[_c('strong',[_vm._v("Item:")]),_vm._v(" "+_vm._s(grade.codigoGrade))]),_vm._v(" "),_c('span',{staticClass:"descGrade"},[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(grade.descricaoGrade))])]],2)}),1):_vm._e()],1):_c('span',[_vm._v("\n            Não há produtos nesta categoria\n          ")]),_vm._v(" "),(categoria.grades.length > 0)?_c('div',{staticClass:"swiper-button-prev",class:("swiperButtonCategPrev" + index),attrs:{"slot":"button-prev"},slot:"button-prev"}):_vm._e(),_vm._v(" "),(categoria.grades.length > 0)?_c('div',{staticClass:"swiper-button-next",class:("swiperButtonCategNext" + index),attrs:{"slot":"button-next"},slot:"button-next"}):_vm._e()])],1)],1)}),0):_c('span',{staticClass:"card mb-5 shadow p-3"},[_vm._v("\n    Não foram encontrados produtos com os parâmetros pesquisados, por favor, tente novamente\n  ")]),_vm._v(" "),(_vm.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.msgBlockUi}},[_c('spinner-vue')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jtrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tableClientes__ = __webpack_require__("FZRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewItemsClientesVue',
  props: ['title', 'placeholderNm', 'placeholderCid', 'escondeBtn'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var cor = state.cor.cor;

      return {
        'background-color': cor
      };
    },
    corSelecionado: function corSelecionado(state) {
      var corSelecionado = state.cor.corSelecionado;

      console.log(corSelecionado);
      return {
        'background-color': corSelecionado
      };
    }
  })),
  data: function data() {
    return {
      pageCliente: true,
      pagePedido: false,
      clientes: __WEBPACK_IMPORTED_MODULE_1__services_tableClientes__["a" /* default */],
      uf: '',
      termo: '',
      cidade: '',
      options: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
      modalFiltro: false,
      headerTextVariant: 'light',
      headerBgVariant: 'dark'
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$on('parametrosSelecionadosCliente', function (parametros) {
      _this.uf = parametros.uf;
      _this.termo = parametros.termo;
      _this.cidade = parametros.cidade;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$on('esconderBotaoAdicionarCliente', function (param) {
      _this2.pageCliente = false;
      _this2.pagePedido = true;
    });
  },

  methods: {
    adicionar: function adicionar() {
      var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_2__main__["operacao"].ADICIONAR, modo: __WEBPACK_IMPORTED_MODULE_2__main__["modo"].EDICAO };
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('pageEditClientes', parametro, '');
    },
    voltar: function voltar() {
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('exibirLista');
    },
    filtrar: function filtrar() {
      this.modalFiltro = false;
      var termoSemMascara = this.termo.replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '');
      var parametros = { termo: termoSemMascara, uf: this.uf, cidade: this.cidade
        // console.log(JSON.stringify(parametros))
      };__WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('parametrosSelecionadosCliente', parametros);
    },
    limparFiltro: function limparFiltro() {
      this.termo = '';
      this.uf = '';
      this.cidade = '';
      var parametros = { termo: this.termo, uf: this.uf, cidade: this.cidade
        // console.log(JSON.stringify(parametros))
      };__WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('parametrosSelecionadosCliente', parametros);
    },
    onChange: function onChange(index) {
      this.statusSelecionado = this.options[index];
      this.codStatus = this.statusSelecionado;
    },

    abreModalFiltro: function abreModalFiltro() {
      this.modalFiltro = true;
    }
  }
});

/***/ }),

/***/ "kDM7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kkWH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PedidosVue_vue__ = __webpack_require__("xdU/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe2b0bb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PedidosVue_vue__ = __webpack_require__("4Ts9");
function injectStyle (ssrContext) {
  __webpack_require__("rmCP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe2b0bb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PedidosVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe2b0bb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PedidosVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lGdt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lPSB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tableClientes__ = __webpack_require__("FZRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import NewItemsClientesVue from '@/components/items/NewItemsClientesVue'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  data: function data() {
    return {
      cor: '',
      clientes: [],
      uf: '',
      termo: '',
      cidade: '',
      // Note 'isActive' is left out and will not appear in the rendered table
      fields: [{
        key: 'codCliente',
        label: 'Cód. Cli.',
        sortable: true,
        class: 'cliListCod txtLeft'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'cliListCod txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true,
        class: 'cliListRaz txtLeft',
        formatter: this.toCapitalize
      },
      // {
      //   key: 'cnpjCpf',
      //   label: 'CNPJ/CPF',
      //   sortable: true,
      //   class: 'cliListCnpj txtLeft'
      // },
      {
        key: 'endereco',
        label: 'Endereço',
        sortable: true,
        class: 'cliListEnd txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'uf',
        label: 'UF',
        sortable: true,
        class: 'cliListUf txtLeft'
      }, {
        key: 'cidade',
        label: 'Cidade',
        sortable: true,
        class: 'cliListCid txtLeft',
        formatter: this.toCapitalize
      }, {
        label: '',
        key: 'mobile',
        class: 'cliListMobile txtLeft'
      }, {
        label: 'Ação',
        key: 'actions',
        class: 'cliListAcoes'
      }]
    };
  },
  created: function created() {
    var _this = this;

    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    this.corComp = { 'style: background-color': '#' + localStorage.getItem('corApp') };
    __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$on('parametrosSelecionadosCliente', function (parametros) {
      // console.log('filtros: ' + JSON.stringify(parametros))
      _this.listar(parametros);
    });
  },
  mounted: function mounted() {
    // NewItemsClientesVue.$refs.btnAdicionar.innerText = 'leticia'
    var parametros = { termo: this.termo, uf: this.uf, cidade: this.cidade };
    this.listar(parametros);
  },

  methods: {
    selecionar: function selecionar(cliente) {
      cliente.cnpjCpf = cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '').replace('-', '');
      // console.log(JSON.stringify(cliente))
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('clienteSelecionado', cliente);
      // broadcastServer.$emit('clienteSelecionado', cliente)
    },
    listar: function listar(parametros) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_tableClientes__["a" /* default */].listarSelect(parametros).then(function (response) {
        _this2.clientes = response.data.clientes;
      });
    },
    info: function info(item, index) {
      // console.log(`item: ${item.codCliente}`)
      var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_1__main__["operacao"].ALTERAR, modo: __WEBPACK_IMPORTED_MODULE_1__main__["modo"].EDICAO };
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('pageEditClientes', parametro);
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatterCnpjCpf: function formatterCnpjCpf(value) {
      if (value.length === 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
      }
      if (value.length === 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
      }
    }
  }
});

/***/ }),

/***/ "lQbo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tableCatalogo__ = __webpack_require__("MW12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // , operacao, modo
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewItemsCatalogoVue',
  props: ['title', 'placeholderNm', 'escondeBtn'],
  components: {},
  data: function data() {
    return {
      termo: '',
      btnTabela: true,
      headerTextVariant: 'light',
      headerBgVariant: 'dark',
      modalTabPreco: false,
      // catalogos: catalogos,
      dadosTabela: [],
      tabelaSelecionada: '',
      tabelaSelecModal: ''
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_tableCatalogo__["a" /* default */].listarTabelaDefault().then(function (response) {
      _this.tabelaSelecionada = response.data;
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('tabelaSelecionada', _this.tabelaSelecionada);
    }).catch(function (error) {
      console.log(error);
      alert('Aconteceu alguma coisa!' + error);
    }).finally(function () {
      _this.blockUiVisibility = false;
    });
    __WEBPACK_IMPORTED_MODULE_0__services_tableCatalogo__["a" /* default */].selecionar().then(function (response) {
      _this.blockUiVisibility = true;
      _this.dadosTabela = response.data;
    }).catch(function (error) {
      console.log(error);
      alert('Aconteceu alguma coisa!' + error);
    }).finally(function () {
      _this.blockUiVisibility = false;
    });
    __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$on('pageViewGrade', function (parametro) {
      _this.termo = '';
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$on('esconderBotaoAdicionarCliente', function (param) {
      _this2.hideBtn = false;
    });
  },

  methods: {
    trocaTabela: function trocaTabela() {
      this.modalTabPreco = true;
    },
    selecTabPreco: function selecTabPreco() {
      this.tabelaSelecionada = this.tabelaSelecModal;
      this.modalTabPreco = false;
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('tabelaSelecionada', this.tabelaSelecionada);
    },
    voltar: function voltar() {},
    filtrar: function filtrar() {
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('filtroCatalogo', this.termo);
    },
    limparFiltro: function limparFiltro() {
      this.termo = '';
      __WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$emit('filtroCatalogo', '');
    }
  }
});

/***/ }),

/***/ "lRLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModoLista),expression:"isModoLista"}]},[_c('new-items-clientes-vue',{attrs:{"title":"CLIENTES","placeholderNm":"Cód. Cliente, Fantasia, Razão, CNPJ e Endereço","placeholderCid":"Cidade"}}),_vm._v(" "),_c('table-clientes-vue',{attrs:{"title":"Clientes"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isModoLista),expression:"!isModoLista"}]},[_c('table-edit-clientes-vue',{attrs:{"title":"EDITAR CLIENTE"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "llmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPedidosOrcamentoVue_vue__ = __webpack_require__("i5vT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f822b36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPedidosOrcamentoVue_vue__ = __webpack_require__("cmjM");
function injectStyle (ssrContext) {
  __webpack_require__("2ihc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f822b36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPedidosOrcamentoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f822b36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPedidosOrcamentoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lrkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinner',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var corSelecionado = state.cor.corSelecionado;

      return {
        'background-color': corSelecionado
      };
    }
  }))
});

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isLog: {
    empresa: localStorage.getItem('urlLogoPositivo'),
    token: localStorage.getItem('token')
  },
  cor: {
    cor2: '#' + localStorage.getItem('corApp'),
    corSelecionado2: '#' + localStorage.getItem('corSelecionado'),
    cor: '#' + localStorage.getItem('corApp'),
    corSelecionado: { 'background-color': '#' + localStorage.getItem('corSelecionado') }
  },
  appData: {
    empresa: localStorage.getItem('empresaLogada'),
    dadosAcesso: localStorage.getItem('dadosAcesso')
  }
});

/***/ }),

/***/ "mN5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterVue_vue__ = __webpack_require__("s+R/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1d6d9fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterVue_vue__ = __webpack_require__("OckI");
function injectStyle (ssrContext) {
  __webpack_require__("9ERK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1d6d9fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1d6d9fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  changeUser: function changeUser(context, payload) {
    context.commit('CHANGE_', payload);
  },
  changeColor: function changeColor(context, payload) {
    context.commit('CHANGE_', payload);
  },
  changeColorSelecionado: function changeColorSelecionado(context, payload) {
    context.commit('CHANGE_', payload);
  },
  changeLogo: function changeLogo(context, payload) {
    context.commit('CHANGE_', payload);
  }
});

/***/ }),

/***/ "mia8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mvb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_login__ = __webpack_require__("xQLQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_toastVue__ = __webpack_require__("7luQ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      idToastItem: 'my-toast-item',
      titleMsg: '',
      message: '',
      variant: '',
      escolhaEmpresas: false,
      esqueciASenha: true,
      isLoading: false,
      disabled: false,
      authUser: {
        usuario: '',
        senha: '',
        identificador: ''
      },
      empresas: [],
      dadosLogin: {
        identificador: '',
        usuario: '',
        senha: ''
      },
      browser: false,
      details: '',
      result: '',
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 3,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // message: {
        //   idToast: 'my-toast',
        //   titleMsg: '',
        //   message: '',
        //   variant: ''
        // }
      } };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"],
    ToastVue: __WEBPACK_IMPORTED_MODULE_3__components_layouts_toastVue__["a" /* default */]
  },
  props: ['status', 'cor', 'logo', 'corSelecionado'],
  created: function created() {
    this.verificaBrowser();
  },

  methods: {
    // showMessage: function (message, title, variantColor) {
    //   this.message = message
    //   this.titleMsg = title
    //   this.variant = variantColor
    //   this.$bvToast.show(this.message.idToast)
    // },
    showMessage: function showMessage(message, title, variantColor) {
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast-item');
    },
    mudarCorPSelecionada: function mudarCorPSelecionada() {
      var payload = {
        corSelecionado: { 'background-color': '#' + localStorage.getItem('corSelecionado') }
      };
      this.$store.commit('CHANGE_COLOR_SELECIONADO', payload);
    },
    mudarCor: function mudarCor() {
      var payload = {
        cor: { 'background-color': '#' + localStorage.getItem('corApp') }
      };
      this.$store.commit('CHANGE_COLOR', payload);
    },
    mudarLogo: function mudarLogo() {
      var payload = {
        empresa: localStorage.getItem('urlLogoPositivo')
      };
      this.$store.commit('CHANGE_LOGO', payload);
    },

    listarEmpresas: function listarEmpresas() {
      var _this = this;

      this.isLoading = true;
      this.disabled = true;
      __WEBPACK_IMPORTED_MODULE_1__services_login__["a" /* default */].listarEmpresas(this.authUser).then(function (response) {
        _this.isLoading = false;
        _this.empresas = response.data.empresas;
        if (_this.empresas.length === 0) {
          alert(response.data.acesso.mensagem);
        } else if (_this.empresas.length === 1) {
          _this.logar(_this.empresas[0]);
        }
        _this.escolhaEmpresas = true;
      }).catch(function (e) {
        _this.disabled = false;
        _this.isLoading = false;
        _this.showMessage(e.response.data.acesso.mensagem, 'Atenção', 'danger');
      });
    },
    logar: function logar(empresa) {
      var _this2 = this;

      // console.log('chamou logar ' + new Date())
      this.authUser.identificador = empresa.identificador;
      __WEBPACK_IMPORTED_MODULE_1__services_login__["a" /* default */].logar(this.authUser).then(function (response) {
        // console.log(JSON.stringify(response))
        if (response.data.acesso.autenticado) {
          localStorage.setItem('dadosAcesso', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.dadosAcesso));
          localStorage.setItem('representanteSelecionado', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.dadosAcesso.representante));
          localStorage.setItem('representantesLogin', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.dadosAcesso.representante.representantes));
          localStorage.setItem('empresaLogada', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.empresa));
          var cor = response.data.empresa.appConfig.cores.corApp;
          localStorage.setItem('corApp', cor);
          var corSelecionado = response.data.empresa.appConfig.cores.corMenuPrincipalSelecionado;
          localStorage.setItem('corSelecionado', corSelecionado);
          var logo = response.data.empresa.urlLogoPositivo;
          localStorage.setItem('urlLogoPositivo', logo);
          var accessToken = response.data.acesso.token;
          localStorage.setItem('token', accessToken);
          _this2.mudarCor();
          _this2.mudarLogo();
          _this2.mudarCorPSelecionada();
          _this2.$router.push('/Home');
          _this2.$forceUpdate();
        }
      }).catch(function (error) {
        // this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        if (typeof error.response.data.mensagem === 'string') {
          var message = JSON.parse(error.response.data.mensagem);
          _this2.showMessage(message.acesso.mensagem + ' - Por favor, entre em contato com o suporte', 'Atenção', 'danger');
        } else {
          _this2.showMessage(error.response.data.mensagem, 'Atenção', 'danger');
        }

        // alert('erro login ' + error.response.data)

        _this2.errors = error.response.data.acesso.mensagem;
      });
    },
    recuperaSenha: function recuperaSenha() {
      this.esqueciASenha = false;
    },
    cancelar: function cancelar() {
      this.esqueciASenha = true;
    },
    verificaBrowser: function verificaBrowser() {
      // Get IE or Edge browser version
      var version = detectEdge();

      if (version <= 17) {
        this.browser = true;
        this.result = 'Edge na versão ' + version;
      }

      // add details to debug result
      this.details = window.navigator.userAgent;

      function detectEdge() {
        var ua = window.navigator.userAgent;

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
          // Edge (IE 12+) => return version number
          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        // other browser
        this.browser = false;
        return false;
      }
    }
  }
});

/***/ }),

/***/ "n651":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselVue_vue__ = __webpack_require__("LPat");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137d5f2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselVue_vue__ = __webpack_require__("KHI7");
function injectStyle (ssrContext) {
  __webpack_require__("5JdH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-137d5f2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137d5f2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nM7b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o55V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oic8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"relListCom"}},[(_vm.pResumoComissoes.porCategoria && _vm.pResumoComissoes.porCategoria.length > 0)?_c('div',[_c('b-row',{staticClass:"pt-2 topRelCom"},[(_vm.pResumoComissoes.valorMes)?_c('b-col',{staticClass:"col-md-4 title pl-3 relComMes"},[_vm._v(_vm._s(_vm.pResumoComissoes.valorMes.mes))]):_c('b-col',{staticClass:"col-md-4 title pl-3 relComMes"},[_vm._v("-")]),_vm._v(" "),(_vm.pResumoComissoes.valorMes)?_c('b-col',{staticClass:"col-md-8 title text-right relComVal"},[_vm._v("Valor total: "+_vm._s(this.formatPrice(_vm.pResumoComissoes.valorMes.valor))+" ")]):_c('b-col',{staticClass:"col-md-8 title text-right relComVal"},[_vm._v("-")])],1),_vm._v(" "),_c('b-col',{staticClass:"topRelCom p-0"},[(_vm.noticeAssina)?_c('b-alert',{staticClass:"mt-3",attrs:{"show":"","variant":"warning"}},[_c('b-row',[_c('b-col',{staticClass:"col-md-8 txtLeft p-0",attrs:{"id":"pergAceite"}},[_vm._v("\n              Aceitar comissão?\n          ")]),_vm._v(" "),_c('b-col',{staticClass:"col-md-2 pr-0 txtRight btnsAceite"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.naoAceita()}}},[_vm._v("Não")])],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-2 pr-0 txtRight btnsAceite"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.enviar(1, '')}}},[_vm._v("Sim")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.noticeInfo)?_c('b-alert',{staticClass:"txtLeft mt-3",attrs:{"show":"","variant":"info"}},[_vm._v("Comissão aceita em "+_vm._s(_vm.pResumoComissoes.aceite.dataAceite))]):_vm._e(),_vm._v(" "),(_vm.noticeBackoffice)?_c('b-alert',{staticClass:"txtLeft mt-3",attrs:{"show":"","variant":"light"}},[_vm._v(_vm._s(_vm.pResumoComissoes.aceite.mensagemRejeicao))]):_vm._e()],1),_vm._v(" "),_c('b-modal',{attrs:{"header-bg-variant":"headerBgVariant","header-text-variant":"headerTextVariant","id":"modal-center","centered":"","title":"Motivo"},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return cancel()}}},[_vm._v("\n          Cancelar\n        ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"secondary","disabled":_vm.motivo.length <= 10},on:{"click":function($event){return _vm.enviar(0, _vm.motivo)}}},[_vm._v("\n          Enviar\n        ")])]}}],null,false,1035566903),model:{value:(_vm.modalMotivoRecusa),callback:function ($$v) {_vm.modalMotivoRecusa=$$v},expression:"modalMotivoRecusa"}},[_c('p',{staticClass:"my-4"},[_c('b-form-textarea',{directives:[{name:"validate",rawName:"v-validate",value:('min:10'),expression:"'min:10'"}],staticClass:"mb-3",attrs:{"required":"","minlength":"10","data-vv-as":"field","id":"textarea-small","name":"motivo_recusa","size":"sm","placeholder":"Insira o por quê de estar em desacordo com o valor."},model:{value:(_vm.motivo),callback:function ($$v) {_vm.motivo=$$v},expression:"motivo"}}),_vm._v(" "),(_vm.errors.has('motivo_recusa'))?_c('span',{staticClass:"mt-2",staticStyle:{"color":"#7c000a"}},[_c('b',[_vm._v("Escreva pelo menos 10 caracteres para avaliação do backoffice.")])]):_vm._e()],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"card mt-3"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":'Resumo',"header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-body',{staticClass:"p-0"},[(_vm.pResumoComissoes.porCategoria && _vm.pResumoComissoes.porCategoria.length > 0)?_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.pResumoComissoes.porCategoria,"fields":_vm.fieldsCategoria}}):_c('span',[_vm._v("\n            Não há itens para este filtro\n          ")])],1),_vm._v(" "),(_vm.pResumoComissoes.porCategoria && _vm.pResumoComissoes.porCategoria.length > 0)?_c('div',{staticClass:"footer txtRight mr-4",attrs:{"slot":"footer"},slot:"footer"},[_c('b',[_vm._v("Total: "+_vm._s(this.formatPrice(_vm.totalCategoria)))])]):_vm._e()],1)],1),_vm._v(" "),_c('section',{staticClass:"card mt-3"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":'Extrato',"header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-text',{staticClass:"table pt-0 pb-0"},[(_vm.pResumoComissoes.extrato && _vm.pResumoComissoes.extrato.length > 0)?_c('b-table',{attrs:{"bordered":"","striped":"","items":_vm.pResumoComissoes.extrato,"fields":_vm.fieldsExtrato},scopedSlots:_vm._u([{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('strong',[_vm._v("Cliente:")]),_vm._v(" "+_vm._s(_vm.toCapitalize(row.item.fantasia))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("NF:")]),_vm._v(" "+_vm._s(row.item.notaFiscal))]),_vm._v(" "),_c('div',{staticClass:"col-md-6 txtRight"},[_c('strong',[_vm._v("Emissão:")]),_vm._v(" "+_vm._s(row.item.dataEmissao))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Base:")]),_vm._v(" "+_vm._s(_vm.formatPrice(row.item.valorBase)))]),_vm._v(" "),_c('div',{staticClass:"col-md-6 txtRight"},[_c('strong',[_vm._v("Valor Comissão:")]),_vm._v(" "+_vm._s(_vm.formatPrice(row.item.valorComissao)))])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Percentual:")]),_vm._v(" "+_vm._s(row.item.percentual))]),_vm._v(" "),_c('div',{staticClass:"col-md-6 txtRight"},[_c('strong',[_vm._v("Categoria:")]),_vm._v(" "+_vm._s(_vm.toCapitalize(row.item.categoria)))])])]}}],null,false,4151761498)}):_c('span',[_vm._v("\n            Não há itens para este filtro\n          ")])],1),_vm._v(" "),(_vm.pResumoComissoes.extrato && _vm.pResumoComissoes.extrato.length > 0)?_c('div',{staticClass:"footer txtRight mr-4",attrs:{"slot":"footer"},slot:"footer"},[_c('b',[_vm._v("Total: "+_vm._s(this.formatPrice(_vm.totalExtrato)))])]):_vm._e()],1)],1),_vm._v(" "),(false)?_c('section',{staticClass:"card mt-3"},[_c('b-card',{staticClass:"shadow"},[_c('b-card-body',[_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.blockUI.visibility)?_c('BlockUI',{attrs:{"message":_vm.blockUI.message}},[_c('spinner-vue',{attrs:{"id":"modal-xl"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pKu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tablePedidos__ = __webpack_require__("05AP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pObjPedido: {},
    pObjStatus: {}
  },
  data: function data() {
    return {
      cor: '',
      blockUI: {
        message: '',
        blockUiVisibility: false
      },
      tipoPedido: [],
      statusSelecionado: {},
      pedidos: [],
      fieldsPedidos: [{
        key: 'urlImagemCanal',
        label: 'Origem',
        sortable: false,
        class: 'relPedImg'
      }, {
        key: 'fantasia',
        label: 'Fantasia',
        sortable: true,
        class: 'relPedFant txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'razaoSocial',
        label: 'Razão Social',
        sortable: true,
        class: 'relPedRaz txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'numeroOrcamento',
        label: 'Nº Orç',
        sortable: true,
        class: 'relPedNOrc'
      }, {
        key: 'numeroPedido',
        label: 'Nº Pedido',
        sortable: true,
        class: 'relPedNPed'
      }, {
        key: 'emissao',
        label: 'Emissão',
        sortable: true,
        class: 'relPedEmi'
      }, {
        key: 'numeroPedidoCompra',
        label: 'Pedido Compra',
        sortable: true,
        class: 'relPedPCom'
      }, {
        key: 'totalPedido',
        label: 'Total R$',
        sortable: true,
        class: 'relPedTot txtRight',
        formatter: this.formatterValue
      }, {
        label: '',
        key: 'mobile',
        class: 'relPedMobile txtLeft'
      }]
    };
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
  },

  watch: {
    pObjPedido: function pObjPedido(newVal, oldVal) {
      // watch it
      // console.log(JSON.stringify(newVal))
      this.statusSelecionado = this.pObjStatus;
      this.pedidos = newVal;
    }
  },
  methods: {
    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    showMessage: function showMessage(message, title, variantColor) {
      this.message = message;
      this.titleMsg = title;
      this.variant = variantColor;
      this.$bvToast.show('my-toast');
    },
    listandoPedidos: function listandoPedidos(objectPost) {
      var _this = this;

      this.msgBlockUi = 'Listando pedidos favor aguarde...';
      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_0__services_tablePedidos__["a" /* default */].listarPedidos(objectPost).then(function (response) {
        _this.status = _this.montaPedidos(response.data.pedidos);
      }).catch(function (error) {
        console.log(error);
        alert('Aconteceu alguma coisa!' + error);
      }).finally(function () {
        _this.blockUiVisibility = false;
      });
    },
    montaPedidos: function montaPedidos(pedidos) {
      var statusPedidos = [];
      var pedidosSemStatus = [];

      var _loop = function _loop() {
        var pedido = pedidos[i];
        if (i === 0) {
          statusPedidos.push(pedido.status);
        } else {
          var statusExistentes = statusPedidos.filter(function (status) {
            return status.codigo === pedido.status.codigo;
          });
          if (statusExistentes.length <= 0) {
            statusPedidos.push(pedido.status);
          }
        }
        delete pedido.status;
        pedidosSemStatus.push(pedido);
      };

      for (var i = 0; i < pedidos.length; i++) {
        _loop();
      }
      statusPedidos = statusPedidos.sort(function (a, b) {
        return a.ordem - b.ordem;
      });

      var _loop2 = function _loop2() {
        var status = statusPedidos[indice];
        var pedidosDoStatus = pedidosSemStatus.filter(function (pedido) {
          return pedido.codStatus === status.codigo;
        });
        statusPedidos[indice].pedidos = pedidosDoStatus;
      };

      for (var indice = 0; indice < statusPedidos.length; indice++) {
        _loop2();
      }
      return statusPedidos;
    },
    listarPedidos: function listarPedidos(objectPost) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_tablePedidos__["a" /* default */].listarPedidos(objectPost).then(function (response) {
        _this2.status = response.data.pedidos;
      });
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }
});

/***/ }),

/***/ "povw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewItemsVue_vue__ = __webpack_require__("yUj9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42dddbc3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewItemsVue_vue__ = __webpack_require__("wduK");
function injectStyle (ssrContext) {
  __webpack_require__("2BcH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42dddbc3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewItemsVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42dddbc3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewItemsVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pxRZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qaQL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select__ = __webpack_require__("ZAW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_tableClientes__ = __webpack_require__("FZRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableClientesVue',
  props: ['title'],
  components: {
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_3_vue_search_select__["ModelListSelect"],
    TheMask: __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__["TheMask"]
  },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__["mask"] },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    cor: function cor(state) {
      var cor = state.cor.cor;
      // console.log(cor)

      return {
        'background-color': cor
      };
    },
    corSelecionado: function corSelecionado(state) {
      var corSelecionado = state.cor.corSelecionado;
      // console.log(corSelecionado)

      return {
        'background-color': corSelecionado
      };
    }
  })),
  data: function data() {
    var _this = this;

    return {
      dataAtual: '',
      filterTipoEnd: [],
      filterTipoEmail: [],
      showDismissibleAlert: false,
      errosLabels: [],
      dateFormat: 'D MMM',
      inputDateOne: '',
      inputDateTwo: '',
      buttonDateOne: '',
      buttonDateTwo: '',
      inlineDateOne: '',
      sundayDateOne: '',
      sundayFirst: false,
      alignRight: false,
      trigger: false,
      termo: '',
      dataDe: '',
      dataAte: '',
      uf: null,
      options: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
      cliente: {
        tipo: 'J',
        contatos: [],
        enderecos: [],
        emails: [],
        referenciasComerciais: [],
        duplicatasEmAberto: [],
        ultimosPedidos: [],
        tabelaPreco: {},
        condPagto: '',
        limiteCredito: '',
        valorUtilizado: ''
      },
      dadosTabela: {
        tabelasPreco: [],
        condPagtos: [],
        tipoContatos: [],
        tipoEnderecos: [],
        tipoEmails: []
      },
      checked: 'Jurídica',
      clienteIeIsento: false,
      selected: null,
      isJuridico: true,
      isFisica: false,
      headerTextVariant: 'light',
      headerBgVariant: 'dark',
      btnSalvar: true,
      modalCont: false,
      text: '',
      desabilitado: false,
      desabilitadoIsento: false,
      tipoPessoaJ: 'Pessoa Juridica',
      tipoPessoaF: 'Pessoa Física',
      tipoPessoaJMobile: 'PJ',
      tipoPessoaFMobile: 'PF',
      clienteExistente: {},
      indiceArrayContato: '',
      indiceArrayEndereco: '',
      indiceArrayEmail: '',
      indiceArrayReferencia: '',
      modalConfSairSemSalvar: false,
      modalConfSalvarCliente: false,
      modalClienteSalvo: false,
      modalClienteExist: false,
      modalExcluirContato: false,
      modalExcluirEndereco: false,
      modalExcluirEmail: false,
      modalExcluirReferencia: false,
      modalItemExcluido: false,
      modalContato: false,
      modalEndereco: false,
      modalEmail: false,
      modalReferencia: false,
      novoContato: false,
      novoEndereco: false,
      novoEmail: false,
      novaReferencia: false,
      indiceContatoSelecionado: -1,
      indiceEnderecoSelecionado: -1,
      emailTemErros: true,
      incluirContato: false,
      contato: {
        dataNasc: '',
        telefone: '',
        ddd: '',
        tipoContato: {
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        dataNascFormat: '',
        chaveErp: '',
        nome: '',
        email: '',
        codCliente: ''
      },
      endereco: {
        uf: '',
        cidade: '',
        complemento: '',
        numero: '',
        bairro: '',
        logradouro: '',
        latitude: 0,
        chaveErp: '',
        tipoEndereco: {
          principal: 0,
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        enderecoCompleto: '',
        cep: '',
        longitude: 0
      },
      email: {
        tipoEmail: {
          principal: 0,
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        chaveErp: '',
        email: ''
      },
      referencia: {
        telefone: '',
        ddd: '',
        chaveErp: '',
        nome: '',
        email: ''
      },
      fieldsContatos: [{
        key: 'nome',
        label: 'Nome',
        class: 'cliContNome',
        formatter: this.toCapitalize
      }, {
        key: 'email',
        label: 'Email',
        class: 'cliContEmail',
        formatter: this.toLowerCase
      }, {
        key: 'ddd',
        label: 'DDD',
        class: 'cliContDDD'
      }, {
        key: 'telefone',
        label: 'Telefone',
        class: 'cliContTel'
      }, {
        key: 'tipoContato.descricao',
        label: 'Tipo',
        class: 'cliContTipo'
      }, {
        label: 'Ações',
        key: 'actionAcoes',
        class: 'columnActions'
      }],
      fieldsEnderecos: [{
        key: 'enderecoCompleto',
        label: 'Endereço',
        class: 'cliEnd',
        formatter: this.toCapitalize
      }, {
        key: 'tipoEndereco.descricao',
        label: 'Tipo',
        class: 'cliEndTipo'
      }, {
        key: 'tipoEndereco.principal',
        label: 'Principal',
        formatter: function formatter(value) {
          return value === 1 ? 'Sim' : 'Não';
        },
        class: 'cliEndPrinc txtCenter'
      }, {
        label: 'Ações',
        key: 'actionAcoes',
        class: 'columnActions'
      }],
      fieldsEmails: [{
        key: 'email',
        label: 'Email',
        class: 'cliEmail',
        formatter: this.toLowerCase
      }, {
        key: 'tipoEmail.descricao',
        label: 'Tipo',
        class: 'cliEmailTipo'
      }, {
        key: 'tipoEmail.principal',
        label: 'Principal',
        formatter: function formatter(value) {
          return value === 1 ? 'Sim' : 'Não';
        },
        class: 'txtCenter cliEmailPrinc'
      }, {
        label: 'Ações',
        key: 'actionAcoes',
        class: 'columnActions'
      }],
      fieldsReferencias: [{
        key: 'nome',
        label: 'Nome',
        class: 'cliRefNome',
        formatter: this.toCapitalize
      }, {
        key: 'email',
        label: 'Email',
        class: 'cliRefEmail',
        formatter: this.toLowerCase
      }, {
        key: 'ddd',
        label: 'DDD',
        class: 'cliRefDDD txtCenter'
      }, {
        key: 'telefone',
        label: 'Telefone',
        class: 'cliRefTel txtCenter'
      }, {
        label: 'Ações',
        key: 'actionAcoes',
        class: 'columnActions'
      }],
      fieldsDuplicatas: [{
        key: 'numeroPedido',
        label: 'Pedido',
        class: 'cliNumPed'
      }, {
        key: 'duplicata',
        label: 'Duplicata',
        class: 'txtCenter cliDuplicata'
      }, {
        key: 'vencimento',
        label: 'Vencimento',
        class: 'txtCenter'
      }, {
        key: 'valor',
        label: 'Valor R$',
        formatter: function formatter(valor) {
          return _this.formatterValue(valor);
        },
        class: 'txtRight'
      }],
      fieldsUltPed: [{
        key: 'numeroPedido',
        label: 'Pedido'
      }, {
        key: 'emissao',
        label: 'Emissão',
        class: 'txtCenter'
      }, {
        key: 'status.descricao',
        label: 'Status'
      }],
      operacaoAtual: 0,
      desabilitaIE: false
    };
  },

  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    },
    lengthCnpj: function lengthCnpj() {
      if (this.cliente.cnpjCpf.length === 18) {
        var param = this.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '');
        this.verifCNPJ(param);
      }
    },
    verifCNPJ: function verifCNPJ(param) {
      var _this2 = this;

      this.blockUiVisibility = true;
      __WEBPACK_IMPORTED_MODULE_4__services_tableClientes__["a" /* default */].verificaCNPJ(param).then(function (response) {
        _this2.modalClienteExist = true;
        _this2.clienteExistente = response.data;
        var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_2__main__["operacao"].ALTERAR, modo: __WEBPACK_IMPORTED_MODULE_2__main__["modo"].EDICAO };
        __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('pageEditClientes', parametro);
      }).catch(function (error) {
        console.log(error);
        _this2.desabilitado = false;
        _this2.operacaoAtual = 0;
        // alert('Aconteceu alguma coisa!' + error)
      }).finally(function () {
        _this2.blockUiVisibility = false;
      });
    },
    dadosCliExist: function dadosCliExist() {
      this.cliente = this.clienteExistente;
    },
    verifClienteIsento: function verifClienteIsento(event) {
      if (event === 'isento') {
        this.cliente.ieRg = 'ISENTO';
        this.desabilitadoIsento = true;
      } else {
        this.cliente.ieRg = '';
        this.desabilitadoIsento = false;
      }
    },
    changeEmail: function changeEmail(emailTemErros) {
      this.emailTemErros = emailTemErros;
      // console.log('email tem erros: ' + emailTemErros)
    },
    formatterValue: function formatterValue(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    toLowerCase: function toLowerCase(value) {
      return value.toLowerCase();
    },
    verifLenghtArray: function verifLenghtArray(array) {
      return !(array.length === 0);
    },
    changePJ: function changePJ(event) {
      this.isJuridico = event;
      this.isFisica = !event;
      this.cliente.tipo = event === true ? 'J' : 'F';
    },
    changePF: function changePF(event) {
      this.isFisica = event;
      this.isJuridico = !event;
      this.cliente.tipo = event === true ? 'F' : 'J';
    },
    pageLista: function pageLista() {
      this.modalConfSairSemSalvar = false;
      this.isJuridico = true;
      this.isFisica = false;
      this.cliente = {
        tipo: 'J',
        contatos: [],
        enderecos: [],
        emails: [],
        referenciasComerciais: [],
        duplicatasEmAberto: [],
        ultimosPedidos: [],
        tabelaPreco: {},
        condPagto: '',
        limiteCredito: '',
        valorUtilizado: ''
      };
      this.contato = {
        dataNasc: '',
        telefone: '',
        ddd: '',
        tipoContato: {
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        dataNascFormat: '',
        chaveErp: '',
        nome: '',
        email: '',
        codCliente: ''
      };
      this.endereco = {
        uf: '',
        cidade: '',
        complemento: '',
        numero: '',
        bairro: '',
        logradouro: '',
        latitude: 0,
        chaveErp: '',
        tipoEndereco: {
          principal: 0,
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        enderecoCompleto: '',
        cep: '',
        longitude: 0
      };
      this.email = {
        tipoEmail: {
          principal: 0,
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        chaveErp: '',
        email: ''
      };
      this.referencia = {
        telefone: '',
        ddd: '',
        chaveErp: '',
        nome: '',
        email: ''
      };
      this.showDismissibleAlert = false;
      this.errosLabels = [];
      this.errors.clear();
      this.$validator.reset();
      var parametro = { operacao: __WEBPACK_IMPORTED_MODULE_2__main__["operacao"].ALTERAR, modo: __WEBPACK_IMPORTED_MODULE_2__main__["modo"].LISTA };
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('pageEditClientes', parametro);
      // let parametros = {termo: '', uf: '', cidade: ''}
      // console.log(JSON.stringify(parametros))
      // broadcastServer.$emit('parametrosSelecionadosCliente', parametros)
    },
    clearContato: function clearContato() {
      this.contato = {
        dataNasc: '',
        telefone: '',
        ddd: '',
        tipoContato: {
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        dataNascFormat: '',
        chaveErp: '',
        nome: '',
        email: '',
        codCliente: ''
      };
    },
    clearEndereco: function clearEndereco() {
      this.endereco = {
        uf: '',
        cidade: '',
        complemento: '',
        numero: '',
        bairro: '',
        logradouro: '',
        latitude: 0,
        chaveErp: '',
        tipoEndereco: {
          principal: 0,
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        enderecoCompleto: '',
        cep: '',
        longitude: 0
      };
    },
    clearEmail: function clearEmail() {
      this.email = {
        tipoEmail: {
          principal: 0,
          codigo: '',
          chaveErp: '',
          deletado: 0,
          descricao: ''
        },
        chaveErp: '',
        email: ''
      };
    },
    clearReferencia: function clearReferencia() {
      this.referencia = {
        telefone: '',
        ddd: '',
        chaveErp: '',
        nome: '',
        email: ''
      };
    },
    newContato: function newContato() {
      this.incluirContato = true;
      this.clearContato();
      this.novoContato = true;
      this.modalContato = true;
    },
    newEndereco: function newEndereco() {
      this.clearEndereco();
      this.novoEndereco = true;
      this.modalEndereco = true;
    },
    newEmail: function newEmail() {
      this.clearEmail();
      this.novoEmail = true;
      this.modalEmail = true;
    },
    newReferencia: function newReferencia() {
      this.clearReferencia();
      this.novaReferencia = true;
      this.modalReferencia = true;
    },
    addCont: function addCont() {
      if (this.novoContato) {
        this.cliente.contatos.push(this.contato);
        this.modalContato = false;
        this.clearContato();
      } else {
        this.cliente.contatos[this.indiceContatoSelecionado].nome = this.contato.nome;
        this.cliente.contatos[this.indiceContatoSelecionado].email = this.contato.email;
        this.cliente.contatos[this.indiceContatoSelecionado].dataNascFormat = this.contato.dataNascFormat;
        this.cliente.contatos[this.indiceContatoSelecionado].ddd = this.contato.ddd;
        this.cliente.contatos[this.indiceContatoSelecionado].telefone = this.contato.telefone;
        this.cliente.contatos[this.indiceContatoSelecionado].tipoContato = this.contato.tipoContato;
        this.clearContato();
      }
    },
    addEnd: function addEnd(event) {
      var _this3 = this;

      this.endereco.enderecoCompleto = this.endereco.logradouro + ', ' + this.endereco.numero + ', ' + this.endereco.bairro + ' - ' + this.endereco.cidade + ' - ' + this.endereco.uf;
      if (this.novoEndereco) {
        var enderecos = this.cliente.enderecos.filter(function (end) {
          return end.tipoEndereco.codigo === _this3.endereco.tipoEndereco.codigo;
        });
        if (enderecos.length > 0) {
          event.preventDefault();
          alert('Este tipo de endereço já foi adicionado, por favor, selecione outro tipo');
        } else {
          this.cliente.enderecos.push(this.endereco);
          this.modalEndereco = false;
          this.clearEndereco();
        }
      } else {
        this.cliente.enderecos[this.indiceEnderecoSelecionado].uf = this.endereco.uf;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].cidade = this.endereco.cidade;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].complemento = this.endereco.complemento;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].numero = this.endereco.numero;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].bairro = this.endereco.bairro;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].logradouro = this.endereco.logradouro;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].latitude = this.endereco.latitude;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].chaveErp = this.endereco.chaveErp;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].tipoEndereco = this.endereco.tipoEndereco;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].enderecoCompleto = this.endereco.enderecoCompleto;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].cep = this.endereco.cep;
        this.cliente.enderecos[this.indiceEnderecoSelecionado].longitude = this.endereco.longitude;
        this.clearEndereco();
      }
    },
    addEmail: function addEmail() {
      if (this.novoEmail) {
        this.cliente.emails.push(this.email);
        this.modalEmail = false;
        this.clearEmail();
      } else {
        this.cliente.emails[this.indiceEmailSelecionado].chaveErp = this.email.chaveErp;
        this.cliente.emails[this.indiceEmailSelecionado].tipoEmail = this.email.tipoEmail;
        this.cliente.emails[this.indiceEmailSelecionado].email = this.email.email;
        this.clearEmail();
      }
    },
    addRef: function addRef() {
      if (this.novaReferencia) {
        this.cliente.referenciasComerciais.push(this.referencia);
        this.modalReferencia = false;
        this.clearReferencia();
      } else {
        this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].telefone = this.referencia.telefone;
        this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].ddd = this.referencia.ddd;
        this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].chaveErp = this.referencia.chaveErp;
        this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].nome = this.referencia.nome;
        this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].email = this.referencia.email;
        this.clearReferencia();
      }
    },
    alterContato: function alterContato(indiceArrayContato) {
      this.incluirContato = false;
      this.novoContato = false;
      var contato = this.cliente.contatos[indiceArrayContato];
      this.indiceContatoSelecionado = indiceArrayContato;
      this.clearContato();
      this.modalContato = true;
      var editContato = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, contato);
      this.contato = editContato;
    },
    alterEndereco: function alterEndereco(indiceArrayEndereco) {
      this.novoEndereco = false;
      var endereco = this.cliente.enderecos[indiceArrayEndereco];
      this.indiceEnderecoSelecionado = indiceArrayEndereco;
      this.clearEndereco();
      this.modalEndereco = true;
      var editEndereco = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, endereco);
      this.endereco = editEndereco;
    },
    alterEmail: function alterEmail(indiceArrayEmail) {
      this.novoEmail = false;
      var email = this.cliente.emails[indiceArrayEmail];
      this.indiceEmailSelecionado = indiceArrayEmail;
      this.clearEmail();
      this.modalEmail = true;
      var editEmail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, email);
      this.email = editEmail;
    },
    alterReferencia: function alterReferencia(indiceArrayReferencia) {
      this.novaReferencia = false;
      var referencia = this.cliente.referenciasComerciais[indiceArrayReferencia];
      this.indiceReferenciaSelecionado = indiceArrayReferencia;
      this.clearReferencia();
      this.modalReferencia = true;
      var editReferencia = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, referencia);
      this.referencia = editReferencia;
    },
    askExcluirContato: function askExcluirContato(indiceArrayContato) {
      this.modalExcluirContato = true;
      this.indiceArrayContato = indiceArrayContato;
    },
    askExcluirEndereco: function askExcluirEndereco(indiceArrayEndereco) {
      this.modalExcluirEndereco = true;
      this.indiceArrayEndereco = indiceArrayEndereco;
    },
    askExcluirEmail: function askExcluirEmail(indiceArrayEmail) {
      this.modalExcluirEmail = true;
      this.indiceArrayEmail = indiceArrayEmail;
    },
    askExcluirReferencia: function askExcluirReferencia(indiceArrayReferencia) {
      this.modalExcluirReferencia = true;
      this.indiceArrayReferencia = indiceArrayReferencia;
    },
    excluirContato: function excluirContato() {
      this.modalExcluirContato = false;
      this.novoContato = false;
      this.cliente.contatos.splice(this.indiceArrayContato, 1);
      this.indiceContatoSelecionado = -1;
      this.modalContato = false;
      this.indiceArrayContato = '';
      this.modalItemExcluido = true;
    },
    excluirEndereco: function excluirEndereco() {
      this.modalExcluirEndereco = false;
      this.novoEndereco = false;
      this.cliente.enderecos.splice(this.indiceArrayEndereco, 1);
      this.indiceEnderecoSelecionado = -1;
      this.modalEndereco = false;
      this.indiceArrayEndereco = '';
      this.modalItemExcluido = true;
    },
    excluirEmail: function excluirEmail() {
      this.modalExcluirEmail = false;
      this.novoEmail = false;
      this.cliente.emails.splice(this.indiceArrayEmail, 1);
      this.indiceEmailSelecionado = -1;
      this.modalEmail = false;
      this.indiceArrayEmail = '';
      this.modalItemExcluido = true;
    },
    excluirReferencia: function excluirReferencia() {
      this.modalExcluirReferencia = false;
      this.novaReferencia = false;
      this.cliente.referenciasComerciais.splice(this.indiceArrayReferencia, 1);
      this.indiceReferenciaSelecionado = -1;
      this.modalReferencia = false;
      this.indiceArrayReferencia = '';
      this.modalItemExcluido = true;
    },
    disableSalvarContato: function disableSalvarContato() {
      if (this.incluirContato === true) {
        if (this.contato.nome === '' || this.contato.tipoContato.codigo === '' || this.contato.ddd.length < 4 || this.contato.telefone.length < 9 || this.emailTemErros === true) {
          return true;
        }
        return false;
      } else {
        if (this.contato.nome === '' || this.contato.tipoContato.codigo === '' || this.contato.ddd.length < 2 || this.contato.telefone.length < 9) {
          return true;
        }
        return false;
      }
    },
    disableSalvarEndereco: function disableSalvarEndereco() {
      if (this.endereco.uf === '' || this.endereco.cidade === '' || this.endereco.numero === '' || this.endereco.logradouro === '' || this.endereco.tipoEndereco.codigo === '' || this.endereco.cep === '' || this.endereco.cep.length < 9) {
        return true;
      }
      return false;
    },
    disableSalvarEmail: function disableSalvarEmail() {
      if (this.email.email === '' || this.email.tipoEmail.codigo === '' || this.emailTemErros === true) {
        return true;
      }
      return false;
    },
    disableSalvarReferencia: function disableSalvarReferencia() {
      if (this.referencia.nome === '' || this.referencia.ddd === '' || this.referencia.telefone === '' || this.referencia.ddd.length < 4 || this.referencia.telefone.length < 9 || this.emailTemErros === true) {
        return true;
      }
      return false;
    },
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        this.dataDe = dateOne;
        var dataFormatada = dateOne.substring(8, 10) + '/' + dateOne.substring(5, 7) + '/' + dateOne.substring(0, 4);
        formattedDates = dataFormatada; // dateFns.format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        this.dataAte = dateTwo;
        var _dataFormatada = dateTwo.substring(8, 10) + '/' + dateTwo.substring(5, 7) + '/' + dateTwo.substring(0, 4);
        formattedDates += ' - ' + _dataFormatada; // dateFns.format(dateTwo, this.dateFormat)
      }
      return formattedDates;
    },
    onClosed: function onClosed() {
      // let datesStr = this.formatDates(this.inputDateOne, this.inputDateTwo)
      // console.log('Dates Selected: ' + datesStr)
      this.trigger = false;
    },
    onMonthChange: function onMonthChange(dates) {
      // console.log('months changed', dates)
    },
    validaDados: function validaDados() {
      this.errosLabels = [];
      if (this.cliente.enderecos.length > 0) {
        var filterTipoEnd = this.cliente.enderecos.map(function (item) {
          return item;
        });
        this.filterTipoEnd = filterTipoEnd.filter(function (tipo) {
          return tipo.tipoEndereco.principal === 1;
        });
      }
      if (this.cliente.emails.length > 0) {
        var filterTipoEmail = this.cliente.emails.map(function (item) {
          return item;
        });
        this.filterTipoEmail = filterTipoEmail.filter(function (tipo) {
          return tipo.tipoEmail.principal === 1;
        });
      }
      var retorno = true;
      if (typeof this.cliente.fantasia === 'undefined' || this.cliente.fantasia === '') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo Fantasia é obrigatório, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      }
      if (typeof this.cliente.razaoSocial === 'undefined' || this.cliente.razaoSocial === '') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo Razão Social é obrigatório, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      }
      if (this.cliente.tipo === 'J' && typeof this.cliente.cnpjCpf === 'undefined') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo CNPJ é obrigatório, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      } else if (this.cliente.tipo === 'J' && this.cliente.cnpjCpf.length < 18) {
        retorno = false;
        this.errosLabels.push({ message: 'O campo CNPJ é obrigatório e deve conter 18 caracteres, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      }
      // if (typeof this.cliente.ieRg !== 'undefined') {
      //   if (this.cliente.ieRg.length > 0 && this.cliente.ieRg.length < 15) {
      //     retorno = false
      //     this.errosLabels.push({message: 'O campo Inscrição Estadual deve conter 12 caracteres, favor preencher corretamente'})
      //     this.showDismissibleAlert = true
      //   }
      // }
      if (this.cliente.tipo === 'F' && typeof this.cliente.cnpjCpf === 'undefined') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo CPF é obrigatório, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      } else if (this.cliente.tipo === 'F' && this.cliente.cnpjCpf.length < 14) {
        retorno = false;
        this.errosLabels.push({ message: 'O campo CPF é obrigatório e deve conter 14 caracteres, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      }
      if (typeof this.cliente.ddd === 'undefined') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo DDD é obrigatório, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      } else if (this.cliente.ddd.length < 4) {
        retorno = false;
        this.errosLabels.push({ message: 'O campo DDD é obrigatório e deve conter 4 caracteres, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      }
      if (typeof this.cliente.telefone === 'undefined') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo Telefone é obrigatório, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      } else if (this.cliente.telefone.length < 9) {
        retorno = false;
        this.errosLabels.push({ message: 'O campo Telefone é obrigatório e deve conter ao menos 8 caracteres, favor preencher corretamente' });
        this.showDismissibleAlert = true;
      }
      if (typeof this.cliente.tabelaPreco.codigo === 'undefined') {
        retorno = false;
        this.errosLabels.push({ message: 'O campo Tabela Preço é obrigatório, favor selecionar uma opção válida' });
        this.showDismissibleAlert = true;
      }
      // if (this.emailTemErros === true) {
      //   retorno = false
      //   this.errosLabels.push({message: 'O campo Email contém erros, favor preencher corretamente'})
      //   this.showDismissibleAlert = true
      // }
      if (this.filterTipoEnd.length === 0) {
        retorno = false;
        this.errosLabels.push({ message: 'Ao menos um Endereço tipo Fiscal deve ser cadastrado' });
        this.showDismissibleAlert = true;
      }
      if (this.filterTipoEmail.length === 0) {
        retorno = false;
        this.errosLabels.push({ message: 'Ao menos um Email tipo NFE deve ser cadastrado' });
        this.showDismissibleAlert = true;
      }
      // if (this.filterTipoEnd.length === 0) {
      //   retorno = false
      //   // sinaliza input filterTipoEnd
      // }
      // if (this.filterTipoEmail.length === 0) {
      //   retorno = false
      //   // sinaliza input filterTipoEmail
      // }
      return retorno;
    },
    confSairSemSalvar: function confSairSemSalvar() {
      this.modalConfSairSemSalvar = true;
    },
    confirmaSalvar: function confirmaSalvar() {
      this.modalConfSalvarCliente = true;
    },
    salvarCliente: function salvarCliente() {
      var _this4 = this;

      this.modalConfSalvarCliente = false;
      // console.log(this.cliente)
      if (this.validaDados()) {
        if (this.errosLabels.length === 0) {
          this.showDismissibleAlert = false;
        }
        var novosContatos = [];
        for (var iContato = 0; iContato < this.cliente.contatos.length; iContato++) {
          var contato = this.cliente.contatos[iContato];
          novosContatos.push({
            dataNasc: contato.dataNasc,
            telefone: contato.telefone.replace('-', ''),
            tipoContato: contato.tipoContato.codigo,
            chaveErp: contato.chaveErp,
            email: contato.email,
            ddd: contato.ddd.replace('(', '').replace(')', ''),
            nome: contato.nome
          });
        }
        var novosEnderecos = [];
        for (var iEndereco = 0; iEndereco < this.cliente.enderecos.length; iEndereco++) {
          var endereco = this.cliente.enderecos[iEndereco];
          novosEnderecos.push({
            bairro: endereco.bairro,
            chaveErp: endereco.chaveErp,
            cidade: endereco.cidade,
            uf: endereco.uf,
            complemento: endereco.complemento,
            principal: 0,
            tipoEndereco: endereco.tipoEndereco.codigo,
            numero: endereco.numero,
            latitude: 0,
            logradouro: endereco.logradouro,
            longitude: 0,
            cep: endereco.cep.replace('-', '')
          });
        }
        var novosEmails = [];
        for (var iEmail = 0; iEmail < this.cliente.emails.length; iEmail++) {
          var email = this.cliente.emails[iEmail];
          novosEmails.push({
            principal: 0,
            tipoEmail: email.tipoEmail.codigo,
            chaveErp: email.chaveErp,
            email: email.email
          });
        }
        var novasReferencias = [];
        for (var iReferencia = 0; iReferencia < this.cliente.referenciasComerciais.length; iReferencia++) {
          var referencia = this.cliente.referenciasComerciais[iReferencia];
          novasReferencias.push({
            chaveErp: referencia.chaveErp,
            telefone: referencia.telefone.replace('-', ''),
            ddd: referencia.ddd.replace('(', '').replace(')', ''),
            nome: referencia.nome,
            email: referencia.email
          });
        }
        if (this.operacaoAtual === 0) {
          var clienteSalvar = {
            razaoSocial: this.cliente.razaoSocial,
            tipo: this.cliente.tipo,
            fantasia: this.cliente.fantasia,
            grupoTributario: '',
            telefone: this.cliente.telefone.replace('-', ''),
            tabelaPreco: this.cliente.tabelaPreco.codigo,
            idClienteGoSales: 0,
            ieRg: this.cliente.ieRg.replace('.', '').replace('.', '').replace('.', ''),
            condPagto: this.cliente.condPagto,
            chaveErp: '',
            suframa: '',
            cnpjCpf: this.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''),
            codCliente: '',
            valorUtilizado: 0,
            ddd: this.cliente.ddd.replace('(', '').replace(')', ''),
            limiteCredito: 0,
            enderecos: novosEnderecos,
            emails: novosEmails,
            referenciasComerciais: novasReferencias,
            contatos: novosContatos
            // console.log(JSON.stringify(clienteSalvar))
          };this.blockUiVisibility = true;
          __WEBPACK_IMPORTED_MODULE_4__services_tableClientes__["a" /* default */].salvar(clienteSalvar).then(function (response) {
            // console.log(response)
          }).catch(function (error) {
            console.log(error);
            alert('Aconteceu alguma coisa!' + error);
          }).finally(function () {
            _this4.blockUiVisibility = false;
            _this4.modalClienteSalvo = true;
          });
          // console.log(this.cliente)
        } else {
          var _clienteSalvar = {
            razaoSocial: this.cliente.razaoSocial,
            tipo: this.cliente.tipo,
            fantasia: this.cliente.fantasia,
            grupoTributario: '',
            telefone: this.cliente.telefone.replace('-', ''),
            tabelaPreco: this.cliente.tabelaPreco.codigo,
            idClienteGoSales: this.cliente.idClienteGoSales,
            ieRg: this.cliente.ieRg.replace('.', '').replace('.', '').replace('.', ''),
            condPagto: this.cliente.condPagto,
            chaveErp: this.cliente.chaveErp,
            suframa: this.cliente.suframa,
            cnpjCpf: this.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''),
            codCliente: this.cliente.codCliente,
            valorUtilizado: this.cliente.valorUtilizado,
            ddd: this.cliente.ddd.replace('(', '').replace(')', ''),
            limiteCredito: this.cliente.limiteCredito,
            enderecos: novosEnderecos,
            emails: novosEmails,
            referenciasComerciais: novasReferencias,
            contatos: novosContatos
            // console.log(JSON.stringify(clienteSalvar))
          };this.blockUiVisibility = true;
          __WEBPACK_IMPORTED_MODULE_4__services_tableClientes__["a" /* default */].salvar(_clienteSalvar).then(function (response) {
            // console.log(response)
          }).catch(function (error) {
            console.log(error);
            alert('Aconteceu alguma coisa!' + error);
          }).finally(function () {
            _this4.blockUiVisibility = false;
            _this4.modalClienteSalvo = true;
          });
        }
        // console.log('true')
      } else {
          // console.log('false')
        }
    }
  },
  created: function created() {
    var _this5 = this;

    window.addEventListener('beforeunload', this.toTopOnRefresh);
    __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$on('pageEditClientes', function (parametro) {
      window.scrollTo(0, 0);
      // console.log(parametro)
      if (parametro.operacao === 'adicionar') {
        _this5.operacaoAtual = 0; // 0 NOVO CLIENTE
        _this5.desabilitado = false;
        _this5.desabilitaIE = false;
        _this5.clienteIeIsento = false;
        _this5.desabilitadoIsento = false;
        _this5.limiteCredito = '0,00';
        _this5.valorUtilizado = '0,00';
        _this5.cliente = {
          tipo: 'J',
          contatos: [],
          enderecos: [],
          emails: [],
          referenciasComerciais: [],
          duplicatasEmAberto: [],
          ultimosPedidos: [],
          tabelaPreco: {},
          limiteCredito: '',
          valorUtilizado: ''
          // console.log(this.desabilitaIE)
        };
      } else {
        _this5.desabilitado = true;
        _this5.operacaoAtual = 1; // 0 ALTERA CLIENTE
        if (_this5.cliente.ieRg !== '') {
          _this5.desabilitaIE = true;
        } else {
          _this5.desabilitaIE = false;
          _this5.clienteIeIsento = false;
          _this5.desabilitadoIsento = false;
        }
        // console.log(this.desabilitaIE)
      }
    });
    __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$on('pageEditClienteResponse', function (parametro) {
      window.scrollTo(0, 0);
      // console.log(parametro)
      _this5.cliente = parametro;
      if (parametro.tipo === 'J') {
        _this5.isJuridico = true;
        _this5.isFisica = false;
      } else {
        _this5.isJuridico = false;
        _this5.isFisica = true;
      }
      _this5.cliente.duplicatasEmAberto = parametro.duplicatasEmAberto.sort(function (a, b) {
        return a.vencimentoOrdem > b.vencimentoOrdem ? 1 : b.vencimentoOrdem > a.vencimentoOrdem ? -1 : 0;
      });
      _this5.cliente.ultimosPedidos = parametro.ultimosPedidos.sort(function (a, b) {
        return b.emissaoOrdem > a.emissaoOrdem ? 1 : a.emissaoOrdem > b.emissaoOrdem ? -1 : 0;
      });
    });
    __WEBPACK_IMPORTED_MODULE_4__services_tableClientes__["a" /* default */].selecionar().then(function (response) {
      _this5.blockUiVisibility = true;
      _this5.dadosTabela = response.data;
      // console.log(response)
    }).catch(function (error) {
      console.log(error);
      alert('Aconteceu alguma coisa!' + error);
    }).finally(function () {
      _this5.blockUiVisibility = false;
    });
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    this.dataAtual = mm + '/' + dd + '/' + yyyy;
  }
});

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qctk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Categorias","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-text',{staticClass:"pt-0 table"},[(_vm.pRelatorioGerencialDados.porCategoria && _vm.pRelatorioGerencialDados.porCategoria.length > 0)?_c('b-table',{attrs:{"items":_vm.pRelatorioGerencialDados.porCategoria,"fields":_vm.fieldsCategoria}}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1),_vm._v(" "),(_vm.pRelatorioGerencialDados.porCategoria && _vm.pRelatorioGerencialDados.porCategoria.length > 0)?_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("Total: R$ "+_vm._s(this.formatterValue(_vm.totalCategoria)))]):_vm._e()],1)],1),_vm._v(" "),(_vm.representantes.length > 1)?_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Representante","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-text',{staticClass:"pt-0 table"},[(_vm.pRelatorioGerencialDados.porRepresentate && _vm.pRelatorioGerencialDados.porRepresentate.length > 0)?_c('b-table',{attrs:{"items":_vm.pRelatorioGerencialDados.porRepresentate,"fields":_vm.fieldsRepresentante}}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1),_vm._v(" "),(_vm.pRelatorioGerencialDados.porRepresentate && _vm.pRelatorioGerencialDados.porRepresentate.length > 0)?_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("Total: R$ "+_vm._s(this.formatterValue(_vm.totalRepresentante)))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Clientes","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-text',{staticClass:"pt-0 table"},[(_vm.pRelatorioGerencialDados.porCliente && _vm.pRelatorioGerencialDados.porCliente.length > 0)?_c('b-table',{attrs:{"items":_vm.pRelatorioGerencialDados.porCliente,"fields":_vm.fieldsCliente}}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1),_vm._v(" "),(_vm.pRelatorioGerencialDados.porCliente && _vm.pRelatorioGerencialDados.porCliente.length > 0)?_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("Total: R$ "+_vm._s(this.formatterValue(_vm.totalCliente)))]):_vm._e()],1)],1),_vm._v(" "),_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"UF","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-text',{staticClass:"pt-0 table"},[(_vm.pRelatorioGerencialDados.porUFCliente && _vm.pRelatorioGerencialDados.porUFCliente.length > 0)?_c('b-table',{attrs:{"items":_vm.pRelatorioGerencialDados.porUFCliente,"fields":_vm.fieldsUF}}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1),_vm._v(" "),(_vm.pRelatorioGerencialDados.porUFCliente && _vm.pRelatorioGerencialDados.porUFCliente.length > 0)?_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("Total: R$ "+_vm._s(this.formatterValue(_vm.totalUF)))]):_vm._e()],1)],1),_vm._v(" "),_c('section',{staticClass:"card mt-4"},[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Diário","header-text-variant":"white"}}),_vm._v(" "),_c('b-card',{staticClass:"shadow"},[_c('b-card-text',{staticClass:"pt-0 table"},[(_vm.pRelatorioGerencialDados.porDia && _vm.pRelatorioGerencialDados.porDia.length > 0)?_c('b-table',{attrs:{"items":_vm.pRelatorioGerencialDados.porDia,"fields":_vm.fieldsDiario}}):_c('span',[_vm._v("\n          Não há itens para este filtro\n        ")])],1),_vm._v(" "),(_vm.pRelatorioGerencialDados.porDia && _vm.pRelatorioGerencialDados.porDia.length > 0)?_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("Total: R$ "+_vm._s(this.formatterValue(_vm.totaDia)))]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qknN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r/qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"tablist","id":"formCliente"}},[_c('b-row',{staticClass:"pt-3"},[_c('b-col',{attrs:{"sm":"9 title pl-0","id":"titlePage"}},[_vm._v(_vm._s(_vm.title || "Título não informado"))]),_vm._v(" "),_c('b-col',{staticClass:"right pr-0 btnAcoesPag"},[_c('b-button',{staticClass:"defaultColor",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.confSairSemSalvar()}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Voltar")])],1),_vm._v(" "),(_vm.btnSalvar)?_c('b-col',{staticClass:"right btnAcoesPag pr-0"},[_c('b-button',{staticClass:"btnSalvar",style:(_vm.cor),attrs:{"type":"submit","value":"Submit"},on:{"click":function($event){return _vm.confirmaSalvar()}}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Salvar")])],1):_vm._e()],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1 shadow mt-2",attrs:{"no-body":""}},[_c('b-card-body',[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"p-0 w-100"},[_c('b-alert',{staticClass:"w-100",attrs:{"variant":"danger","dismissible":""},model:{value:(_vm.showDismissibleAlert),callback:function ($$v) {_vm.showDismissibleAlert=$$v},expression:"showDismissibleAlert"}},[_vm._v("\n              Existem erros nos seguintes campos: "),_c('br'),_vm._v(" "),_vm._l((this.errosLabels),function(erro){return _c('div',{key:erro.message},[_vm._v(_vm._s(erro.message))])})],2),_vm._v(" "),_c('b-row',{staticClass:"pt-3",attrs:{"id":"headerCliente"}},[_c('b-col',{staticClass:"pl-0",attrs:{"md":"7"}},[_c('span',[_c('strong',[_vm._v("Código:")]),_vm._v(" "+_vm._s(_vm.cliente.codCliente))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-row',[_c('b-col',{staticClass:"p-0"},[_c('b-form-checkbox',{attrs:{"name":"check-button","switch":"","disabled":_vm.desabilitado},on:{"change":_vm.changePJ},model:{value:(_vm.isJuridico),callback:function ($$v) {_vm.isJuridico=$$v},expression:"isJuridico"}},[_c('b',{staticClass:"tipoPessoaWeb"},[_vm._v(_vm._s(_vm.tipoPessoaJ))]),_vm._v(" "),_c('b',{staticClass:"tipoPessoaMob"},[_vm._v(_vm._s(_vm.tipoPessoaJMobile))])])],1),_vm._v(" "),_c('b-col',{staticClass:"p-0"},[_c('b-form-checkbox',{attrs:{"name":"check-button","switch":"","disabled":_vm.desabilitado},on:{"change":_vm.changePF},model:{value:(_vm.isFisica),callback:function ($$v) {_vm.isFisica=$$v},expression:"isFisica"}},[_c('b',{staticClass:"tipoPessoaWeb"},[_vm._v(_vm._s(_vm.tipoPessoaF))]),_vm._v(" "),_c('b',{staticClass:"tipoPessoaMob"},[_vm._v(_vm._s(_vm.tipoPessoaFMobile))])])],1)],1)],1)],1),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row mt-4"},[_c('div',{staticClass:"col-md-6 mb-3"},[_c('b-form-group',{attrs:{"label":"* Fantasia","label-for":"cliFantasia"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('fantasia')},attrs:{"autocomplete":"no","id":"cliFantasia","size":"sm","placeholder":"Nome Fantasia","disabled":_vm.desabilitado,"name":"fantasia"},model:{value:(_vm.cliente.fantasia),callback:function ($$v) {_vm.$set(_vm.cliente, "fantasia", $$v)},expression:"cliente.fantasia"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('fantasia')),expression:"errors.has('fantasia')"}],staticClass:"invalid"},[_vm._v(_vm._s(_vm.errors.first('fantasia')))])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('b-form-group',{attrs:{"label":"* Razão Social","label-for":"cliRazao"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('razao')},attrs:{"autocomplete":"no","id":"cliRazao","size":"sm","placeholder":"Razão Social","disabled":_vm.desabilitado,"name":"razao"},model:{value:(_vm.cliente.razaoSocial),callback:function ($$v) {_vm.$set(_vm.cliente, "razaoSocial", $$v)},expression:"cliente.razaoSocial"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('razao')),expression:"errors.has('razao')"}],staticClass:"invalid"},[_vm._v("O campo Razão Social é obrigatório")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-6 mb-3"},[(this.cliente.tipo === 'J')?_c('b-form-group',{attrs:{"label":"* CNPJ","label-for":"cliCNPJ"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##.###.###/####-##'),expression:"'##.###.###/####-##'"},{name:"validate",rawName:"v-validate",value:('required|min:18'),expression:"'required|min:18'"}],class:{'input': true, 'invalid': _vm.errors.has('cnpj')},attrs:{"autocomplete":"no","id":"cliCNPJ","size":"sm","placeholder":"CNPJ","disabled":_vm.desabilitado,"name":"cnpj"},on:{"keyup":function($event){return _vm.lengthCnpj()}},model:{value:(_vm.cliente.cnpjCpf),callback:function ($$v) {_vm.$set(_vm.cliente, "cnpjCpf", $$v)},expression:"cliente.cnpjCpf"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cnpj')),expression:"errors.has('cnpj')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Mínimo 14 caracteres")])],1):_c('b-form-group',{attrs:{"label":"* CPF","label-for":"cliCPF"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('###.###.###-##'),expression:"'###.###.###-##'"},{name:"validate",rawName:"v-validate",value:('required|min:14'),expression:"'required|min:14'"}],class:{'input': true, 'invalid': _vm.errors.has('cpf')},attrs:{"autocomplete":"no","id":"cliCPF","size":"sm","placeholder":"CPF","disabled":_vm.desabilitado,"name":"cpf"},model:{value:(_vm.cliente.cnpjCpf),callback:function ($$v) {_vm.$set(_vm.cliente, "cnpjCpf", $$v)},expression:"cliente.cnpjCpf"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cpf')),expression:"errors.has('cpf')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Mínimo 11 caracteres")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-4",attrs:{"id":"inputIe"}},[_c('b-form-group',{attrs:{"label":"Insc. Est.","label-for":"cliIE"}},[(this.cliente.tipo === 'J')?_c('b-form-input',{attrs:{"autocomplete":"no","id":"cliIE","size":"sm","placeholder":"Inscrição Estadual","disabled":_vm.desabilitado || _vm.desabilitadoIsento,"type":"number"},model:{value:(_vm.cliente.ieRg),callback:function ($$v) {_vm.$set(_vm.cliente, "ieRg", $$v)},expression:"cliente.ieRg"}}):_c('b-form-input',{attrs:{"autocomplete":"no","id":"cliIE","v-model":_vm.cliente.ieRg='ISENTO',"value":"ISENTO","size":"sm","disabled":""}})],1)],1),_vm._v(" "),(this.cliente.tipo === 'J')?_c('div',{staticClass:"col-2",attrs:{"id":"checkIsento"}},[_c('b-form-group',{attrs:{"label":"Isento"}},[_c('b-form-checkbox',{attrs:{"id":"clienteIeIsento","name":"clienteIeIsento","value":"isento","unchecked-value":"nao","disabled":_vm.desabilitaIE},on:{"change":this.verifClienteIsento},model:{value:(_vm.clienteIeIsento),callback:function ($$v) {_vm.clienteIeIsento=$$v},expression:"clienteIeIsento"}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('b-form-group',{attrs:{"label":"* DDD","label-for":"cliDDD"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:4'),expression:"'required|min:4'"},{name:"mask",rawName:"v-mask",value:('(##)'),expression:"'(##)'"}],class:{'input': true, 'invalid': _vm.errors.has('ddd')},attrs:{"autocomplete":"no","id":"cliDDD","size":"sm","placeholder":"DDD","name":"ddd"},model:{value:(_vm.cliente.ddd),callback:function ($$v) {_vm.$set(_vm.cliente, "ddd", $$v)},expression:"cliente.ddd"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('ddd')),expression:"errors.has('ddd')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Deve conter 2 digitos")])],1)],1),_vm._v(" "),(this.cliente.tipo === 'J')?_c('div',{staticClass:"col-4"},[_c('b-form-group',{attrs:{"label":"* Telefone","label-for":"cliTelefone"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"},{name:"mask",rawName:"v-mask",value:(['####-####', '#####-####']),expression:"['####-####', '#####-####']"}],class:{'input': true, 'invalid': _vm.errors.has('telefone')},attrs:{"autocomplete":"no","id":"cliTelefone","size":"sm","placeholder":"Telefone","name":"telefone"},model:{value:(_vm.cliente.telefone),callback:function ($$v) {_vm.$set(_vm.cliente, "telefone", $$v)},expression:"cliente.telefone"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telefone')),expression:"errors.has('telefone')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Mínimo 8 digitos")])],1)],1):_c('div',{staticClass:"col-6"},[_c('b-form-group',{attrs:{"label":"* Telefone","label-for":"cliTelefone"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"},{name:"mask",rawName:"v-mask",value:(['####-####', '#####-####']),expression:"['####-####', '#####-####']"}],class:{'input': true, 'invalid': _vm.errors.has('telefone')},attrs:{"autocomplete":"no","id":"cliTelefone","size":"sm","placeholder":"Telefone","name":"telefone"},model:{value:(_vm.cliente.telefone),callback:function ($$v) {_vm.$set(_vm.cliente, "telefone", $$v)},expression:"cliente.telefone"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telefone')),expression:"errors.has('telefone')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Mínimo 8 digitos")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-5"},[_c('div',{staticClass:"col-md-6 mb-3"},[_c('label',{attrs:{"for":"input-tabelaPreco"}},[_vm._v("* Tabela de Preço")]),_vm._v(" "),_c('model-list-select',{staticClass:"selectStyle",attrs:{"id":"input-tabelaPreco","list":_vm.dadosTabela.tabelasPreco,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar"},model:{value:(_vm.cliente.tabelaPreco),callback:function ($$v) {_vm.$set(_vm.cliente, "tabelaPreco", $$v)},expression:"cliente.tabelaPreco"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('label',{attrs:{"for":"input-tabelaPreco"}},[_vm._v("Condição de Pagamento")]),_vm._v(" "),_c('model-list-select',{staticClass:"selectStyle",attrs:{"id":"input-tabelaPreco","list":_vm.dadosTabela.condPagtos,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar"},model:{value:(_vm.cliente.condPagto),callback:function ($$v) {_vm.$set(_vm.cliente, "condPagto", $$v)},expression:"cliente.condPagto"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mb-5"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"10"}},[_c('p',[_vm._v("CONTATOS")])]),_vm._v(" "),_c('b-col',{staticClass:"p-0 txtRight",attrs:{"md":"2"}},[_c('b-button',{staticClass:"col-md-8 defaultColor",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.newContato()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Novo")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.verifLenghtArray(_vm.cliente.contatos)),expression:"verifLenghtArray(cliente.contatos)"}],attrs:{"bordered":"","hover":"","items":_vm.cliente.contatos,"fields":_vm.fieldsContatos},scopedSlots:_vm._u([{key:"actionAcoes",fn:function(row){return [_c('b-navbar-nav',[_c('b-nav-item-dropdown',[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.alterContato(row.index)}}},[_vm._v("Editar / Ver Detalhes")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.askExcluirContato(row.index)}}},[_vm._v("Excluir")])],2)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row mb-5"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"10"}},[_c('p',[_vm._v("ENDEREÇOS")])]),_vm._v(" "),_c('b-col',{staticClass:"p-0 txtRight",attrs:{"md":"2"}},[_c('b-button',{staticClass:"col-md-8 defaultColor",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.newEndereco()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Novo")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.verifLenghtArray(_vm.cliente.enderecos)),expression:"verifLenghtArray(cliente.enderecos)"}],attrs:{"bordered":"","hover":"","items":_vm.cliente.enderecos,"fields":_vm.fieldsEnderecos},scopedSlots:_vm._u([{key:"actionAcoes",fn:function(row){return [_c('b-navbar-nav',[_c('b-nav-item-dropdown',[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.alterEndereco(row.index)}}},[_vm._v("Editar / Ver Detalhes")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.askExcluirEndereco(row.index)}}},[_vm._v("Excluir")])],2)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row mb-5"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"10"}},[_c('p',[_vm._v("E-MAILS")])]),_vm._v(" "),_c('b-col',{staticClass:"p-0 txtRight",attrs:{"md":"2"}},[_c('b-button',{staticClass:"col-md-8 defaultColor",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.newEmail()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Novo")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.verifLenghtArray(_vm.cliente.emails)),expression:"verifLenghtArray(cliente.emails)"}],attrs:{"bordered":"","hover":"","items":_vm.cliente.emails,"fields":_vm.fieldsEmails},scopedSlots:_vm._u([{key:"actionAcoes",fn:function(row){return [_c('b-navbar-nav',[_c('b-nav-item-dropdown',[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.alterEmail(row.index)}}},[_vm._v("Editar / Ver Detalhes")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.askExcluirEmail(row.index)}}},[_vm._v("Excluir")])],2)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row mb-5"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"10"}},[_c('p',[_vm._v("REFERÊNCIAS COMERCIAIS")])]),_vm._v(" "),_c('b-col',{staticClass:"p-0 txtRight",attrs:{"md":"2"}},[_c('b-button',{staticClass:"col-md-8 defaultColor",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.newReferencia()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Novo")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.verifLenghtArray(_vm.cliente.referenciasComerciais)),expression:"verifLenghtArray(cliente.referenciasComerciais)"}],attrs:{"bordered":"","hover":"","items":_vm.cliente.referenciasComerciais,"fields":_vm.fieldsReferencias},scopedSlots:_vm._u([{key:"actionAcoes",fn:function(row){return [_c('b-navbar-nav',[_c('b-nav-item-dropdown',[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.alterReferencia(row.index)}}},[_vm._v("Editar / Ver Detalhes")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.askExcluirReferencia(row.index)}}},[_vm._v("Excluir")])],2)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row mb-5"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"12"}},[_c('p',[_vm._v("LIMITE DE CRÉDITO")])])],1),_vm._v(" "),_c('div',{staticClass:"form-row",attrs:{"id":"boxLimite"}},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Valor Total")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"m-0"},[_vm._v("R$ "+_vm._s(_vm.formatterValue(_vm.cliente.limiteCredito)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Valor Usado")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"m-0"},[_vm._v("R$ "+_vm._s(_vm.formatterValue(_vm.cliente.valorUtilizado)))])])]),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.verifLenghtArray(_vm.cliente.duplicatasEmAberto)),expression:"verifLenghtArray(cliente.duplicatasEmAberto)"}]},[_c('span',[_c('strong',[_vm._v("Duplicatas em Aberto")])]),_vm._v(" "),_c('b-table',{attrs:{"bordered":"","hover":"","items":_vm.cliente.duplicatasEmAberto,"fields":_vm.fieldsDuplicatas}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-row mb-3"},[_c('b-col',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"titleFluid",attrs:{"md":"12"}},[_c('p',[_vm._v("ÚLTIMOS PEDIDOS")])])],1),_vm._v(" "),_c('b-row',[(_vm.verifLenghtArray(_vm.cliente.ultimosPedidos))?_c('b-table',{attrs:{"bordered":"","hover":"","items":_vm.cliente.ultimosPedidos,"fields":_vm.fieldsUltPed}}):_c('span',{staticClass:"w-100",attrs:{"id":"semPedidos"}},[_vm._v("Este cliente ainda não realizou pedidos")])],1)],1)],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Salvar","ok-variant":"primary","ok-disabled":_vm.disableSalvarContato(),"cancel-title":"Fechar","cancel-variant":"secondary","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.addCont},model:{value:(_vm.modalContato),callback:function ($$v) {_vm.modalContato=$$v},expression:"modalContato"}},[_c('template',{style:(_vm.cor),slot:"modal-header"},[(this.novoContato)?_c('h5',[_vm._v("Novo Contato")]):_c('h5',[_vm._v("Editar Contato")])]),_vm._v(" "),_c('form',{attrs:{"autocomplete":"false"}},[_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"* Nome","label-for":"cliNomeContato"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('nmCnt')},attrs:{"autocomplete":"false","id":"cliNomeContato","size":"sm","placeholder":"Nome do Contato","name":"nmCnt"},model:{value:(_vm.contato.nome),callback:function ($$v) {_vm.$set(_vm.contato, "nome", $$v)},expression:"contato.nome"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('nmCnt')),expression:"errors.has('nmCnt')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"* Email","label-for":"cliEmailContato"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'input': true, 'invalid': _vm.errors.has('emlCnt')},attrs:{"autocomplete":"nope","id":"cliEmailContato","type":"text","size":"sm","placeholder":"exemplo@contato.com.br","name":"emlCnt"},on:{"keyup":function($event){_vm.changeEmail(_vm.errors.has('emlCnt'))}},model:{value:(_vm.contato.email),callback:function ($$v) {_vm.$set(_vm.contato, "email", $$v)},expression:"contato.email"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('emlCnt')),expression:"errors.has('emlCnt')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Digite um email válido")])],1),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('b-form-group',{attrs:{"label":"Data Nasc.:","label-for":"cliNascContato"}},[_c('div',{staticClass:"datepicker-container with-button"},[_c('div',{staticClass:"datepicker-trigger"},[_c('input',{attrs:{"name":"date_limit","type":"hidden"},domProps:{"value":this.dataAtual}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"validate",rawName:"v-validate",value:('after:01/01/1900|before:02/05/2019|date_format:dd/MM/yyyy'),expression:"'after:01/01/1900|before:02/05/2019|date_format:dd/MM/yyyy'"}],class:{'input': true, 'invalid': _vm.errors.has('brth_dt')},attrs:{"autocomplete":"false","name":"brth_dt","data-vv-as":"Birth day","type":"text","size":"sm","placeholder":"Data de Nascimento"},model:{value:(_vm.contato.dataNascFormat),callback:function ($$v) {_vm.$set(_vm.contato, "dataNascFormat", $$v)},expression:"contato.dataNascFormat"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('brth_dt')),expression:"errors.has('brth_dt')"}],staticClass:"invalid"},[_vm._v("Digite uma data válida")])],1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-4"},[_c('b-form-group',{attrs:{"label":"* DDD","label-for":"cliDDDContato"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:4'),expression:"'required|min:4'"},{name:"mask",rawName:"v-mask",value:('(##)'),expression:"'(##)'"}],class:{'input': true, 'invalid': _vm.errors.has('dddCnt')},attrs:{"autocomplete":"no","id":"cliDDDContato","size":"sm","placeholder":"(00)","name":"dddCnt"},model:{value:(_vm.contato.ddd),callback:function ($$v) {_vm.$set(_vm.contato, "ddd", $$v)},expression:"contato.ddd"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('dddCnt')),expression:"errors.has('dddCnt')"}],staticClass:"invalid mt-2"},[_vm._v("Preenchimento obrigatório | Deve conter 2 digitos")])],1),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('b-form-group',{attrs:{"label":"* Telefone","label-for":"cliTelefoneContato"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"},{name:"mask",rawName:"v-mask",value:(['####-####', '#####-####']),expression:"['####-####', '#####-####']"}],class:{'input': true, 'invalid': _vm.errors.has('telCnt')},attrs:{"autocomplete":"no","id":"cliTelefoneContato","size":"sm","placeholder":"0000-0000 ou 00000-0000","name":"telCnt"},model:{value:(_vm.contato.telefone),callback:function ($$v) {_vm.$set(_vm.contato, "telefone", $$v)},expression:"contato.telefone"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telCnt')),expression:"errors.has('telCnt')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Mínimo 8 digitos")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('label',[_vm._v("* Tipo de Contato")]),_vm._v(" "),_c('model-list-select',{staticClass:"selectStyle",attrs:{"list":_vm.dadosTabela.tipoContatos,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar"},model:{value:(_vm.contato.tipoContato),callback:function ($$v) {_vm.$set(_vm.contato, "tipoContato", $$v)},expression:"contato.tipoContato"}})],1)],1)],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Salvar","ok-variant":"primary","ok-disabled":_vm.disableSalvarEndereco(),"cancel-title":"Fechar","cancel-variant":"secondary","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.addEnd},model:{value:(_vm.modalEndereco),callback:function ($$v) {_vm.modalEndereco=$$v},expression:"modalEndereco"}},[_c('template',{slot:"modal-header"},[(this.novoEndereco)?_c('h5',[_vm._v("Novo Endereço")]):_c('h5',[_vm._v("Editar Endereço")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('b-form-group',{attrs:{"label":"* Cep","label-for":"cliEndCep"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"},{name:"mask",rawName:"v-mask",value:('#####-###'),expression:"'#####-###'"}],class:{'input': true, 'invalid': _vm.errors.has('cepEndereco')},attrs:{"autocomplete":"no","id":"cliEndCep","size":"sm","placeholder":"00000-000","name":"cepEndereco"},model:{value:(_vm.endereco.cep),callback:function ($$v) {_vm.$set(_vm.endereco, "cep", $$v)},expression:"endereco.cep"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cepEndereco')),expression:"errors.has('cepEndereco')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Deve conter 8 digitos")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-12"},[_c('b-form-group',{attrs:{"label":"* Logradouro","label-for":"cliEndLog"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('logradouroEndereco')},attrs:{"autocomplete":"no","id":"cliEndLog","size":"sm","placeholder":"Rua, Avenida, etc...","name":"logradouroEndereco"},model:{value:(_vm.endereco.logradouro),callback:function ($$v) {_vm.$set(_vm.endereco, "logradouro", $$v)},expression:"endereco.logradouro"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('logradouroEndereco')),expression:"errors.has('logradouroEndereco')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-4"},[_c('b-form-group',{attrs:{"label":"* Número","label-for":"cliEndNum"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('numeroEndereco')},attrs:{"autocomplete":"no","id":"cliEndNum","size":"sm","placeholder":"000","type":"number","name":"numeroEndereco"},model:{value:(_vm.endereco.numero),callback:function ($$v) {_vm.$set(_vm.endereco, "numero", $$v)},expression:"endereco.numero"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('numeroEndereco')),expression:"errors.has('numeroEndereco')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('b-form-group',{attrs:{"label":"Complemento","label-for":"cliEndComp"}},[_c('b-form-input',{attrs:{"autocomplete":"no","id":"cliEndComp","size":"sm","placeholder":"Ex.: Casa 1 / Apartamento 1"},model:{value:(_vm.endereco.complemento),callback:function ($$v) {_vm.$set(_vm.endereco, "complemento", $$v)},expression:"endereco.complemento"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-3"},[_c('b-form-group',{attrs:{"label":"* Estado","label-for":"cliEndEst"}},[_c('b-form-select',{attrs:{"size":"sm"},model:{value:(_vm.endereco.uf),callback:function ($$v) {_vm.$set(_vm.endereco, "uf", $$v)},expression:"endereco.uf"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Estado --")])]),_vm._v(" "),_vm._l((_vm.options),function(uf,key){return _c('option',{key:key,domProps:{"value":uf}},[_vm._v("\n                      "+_vm._s(uf)+"\n                  ")])})],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('b-form-group',{attrs:{"label":"Bairro","label-for":"cliEndBairro"}},[_c('b-form-input',{attrs:{"autocomplete":"no","id":"cliEndBairro","size":"sm","placeholder":"Bairro"},model:{value:(_vm.endereco.bairro),callback:function ($$v) {_vm.$set(_vm.endereco, "bairro", $$v)},expression:"endereco.bairro"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('b-form-group',{attrs:{"label":"* Cidade","label-for":"cliEndCid"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('cidadeEndereco')},attrs:{"autocomplete":"no","id":"cliEndCid","size":"sm","placeholder":"Cidade","name":"cidadeEndereco"},model:{value:(_vm.endereco.cidade),callback:function ($$v) {_vm.$set(_vm.endereco, "cidade", $$v)},expression:"endereco.cidade"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cidadeEndereco')),expression:"errors.has('cidadeEndereco')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('label',[_vm._v("* Tipo End.")]),_vm._v(" "),_c('model-list-select',{staticClass:"selectStyle",attrs:{"list":_vm.dadosTabela.tipoEnderecos,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar"},model:{value:(_vm.endereco.tipoEndereco),callback:function ($$v) {_vm.$set(_vm.endereco, "tipoEndereco", $$v)},expression:"endereco.tipoEndereco"}})],1)])])])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Salvar","ok-variant":"primary","ok-disabled":_vm.disableSalvarEmail(),"cancel-title":"Fechar","cancel-variant":"secondary","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.addEmail},model:{value:(_vm.modalEmail),callback:function ($$v) {_vm.modalEmail=$$v},expression:"modalEmail"}},[_c('template',{slot:"modal-header"},[(this.novoEmail)?_c('h5',[_vm._v("Novo E-mail")]):_c('h5',[_vm._v("Editar E-mail")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row"},[_c('label',[_vm._v("* Tipo E-mail")]),_vm._v(" "),_c('model-list-select',{staticClass:"selectStyle",attrs:{"list":_vm.dadosTabela.tipoEmails,"option-value":"codigo","option-text":"descricao","placeholder":"Selecione ou digite para pesquisar"},model:{value:(_vm.email.tipoEmail),callback:function ($$v) {_vm.$set(_vm.email, "tipoEmail", $$v)},expression:"email.tipoEmail"}})],1),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('b-form-group',{staticClass:"w-100",attrs:{"label":"* Email","label-for":"cliEmail"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'input': true, 'invalid': _vm.errors.has('inputEmail')},attrs:{"type":"text","id":"cliEmail","size":"sm","placeholder":"exemplo@email.com.br","name":"inputEmail"},on:{"keyup":function($event){_vm.changeEmail(_vm.errors.has('inputEmail'))}},model:{value:(_vm.email.email),callback:function ($$v) {_vm.$set(_vm.email, "email", $$v)},expression:"email.email"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('inputEmail')),expression:"errors.has('inputEmail')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Digite um email válido")])],1)],1)])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Salvar","ok-variant":"primary","ok-disabled":_vm.disableSalvarReferencia(),"cancel-title":"Fechar","cancel-variant":"secondary","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.addRef},model:{value:(_vm.modalReferencia),callback:function ($$v) {_vm.modalReferencia=$$v},expression:"modalReferencia"}},[_c('template',{slot:"modal-header"},[(this.novaReferencia)?_c('h5',[_vm._v("Nova Referência Comercial")]):_c('h5',[_vm._v("Editar Referência Comercial")])]),_vm._v(" "),_c('form',{attrs:{"autocomplete":"false"}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-12"},[_c('b-form-group',{staticClass:"w-100",attrs:{"label":"* Nome","label-for":"cliNomeRef"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input': true, 'invalid': _vm.errors.has('nmRf')},attrs:{"autocomplete":"false","id":"cliNomeRef","size":"sm","placeholder":"Nome","name":"nmRf"},model:{value:(_vm.referencia.nome),callback:function ($$v) {_vm.$set(_vm.referencia, "nome", $$v)},expression:"referencia.nome"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('nmRf')),expression:"errors.has('nmRf')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('b-form-group',{staticClass:"w-100",attrs:{"label":"* Email","label-for":"cliEmailRef"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'input': true, 'invalid': _vm.errors.has('emlRef')},attrs:{"autocomplete":"nope","type":"text","id":"cliEmailRef","size":"sm","placeholder":"exemplo@referencia.com.br","name":"emlRef"},on:{"keyup":function($event){_vm.changeEmail(_vm.errors.has('emlRef'))}},model:{value:(_vm.referencia.email),callback:function ($$v) {_vm.$set(_vm.referencia, "email", $$v)},expression:"referencia.email"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('emlRef')),expression:"errors.has('emlRef')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Digite um email válido")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row mt-2"},[_c('div',{staticClass:"col-3"},[_c('b-form-group',{attrs:{"label":"* DDD","label-for":"cliDDDRef"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:4'),expression:"'required|min:4'"},{name:"mask",rawName:"v-mask",value:('(##)'),expression:"'(##)'"}],class:{'input': true, 'invalid': _vm.errors.has('dddReferencia')},attrs:{"autocomplete":"no","id":"cliDDDRef","size":"sm","placeholder":"(00)","name":"dddReferencia"},model:{value:(_vm.referencia.ddd),callback:function ($$v) {_vm.$set(_vm.referencia, "ddd", $$v)},expression:"referencia.ddd"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('dddReferencia')),expression:"errors.has('dddReferencia')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Deve conter 2 digitos")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-form-group',{attrs:{"label":"* Telefone","label-for":"cliTelefoneRef"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"},{name:"mask",rawName:"v-mask",value:(['####-####', '#####-####']),expression:"['####-####', '#####-####']"}],class:{'input': true, 'invalid': _vm.errors.has('telefoneReferencia')},attrs:{"autocomplete":"no","id":"cliTelefoneRef","size":"sm","placeholder":"0000-0000 ou 00000-0000","name":"telefoneReferencia"},model:{value:(_vm.referencia.telefone),callback:function ($$v) {_vm.$set(_vm.referencia, "telefone", $$v)},expression:"referencia.telefone"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telefoneReferencia')),expression:"errors.has('telefoneReferencia')"}],staticClass:"invalid"},[_vm._v("Preenchimento obrigatório | Mínimo 8 digitos")])],1)],1)])])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","ok-only":"","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.dadosCliExist},model:{value:(_vm.modalClienteExist),callback:function ($$v) {_vm.modalClienteExist=$$v},expression:"modalClienteExist"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Cliente Existente")])]),_vm._v(" "),_c('span',[_vm._v("Já existe um cliente com este CNPJ cadastrado no sistema!! "),_c('br'),_vm._v(" Os dados serão exibidos a seguir")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Sim","ok-variant":"primary","cancel-title":"Não","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.pageLista},model:{value:(_vm.modalConfSairSemSalvar),callback:function ($$v) {_vm.modalConfSairSemSalvar=$$v},expression:"modalConfSairSemSalvar"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Sair sem Salvar")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza que deseja sair sem salvar as alterações neste cliente?")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Salvar","ok-variant":"primary","cancel-title":"Não","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.salvarCliente},model:{value:(_vm.modalConfSalvarCliente),callback:function ($$v) {_vm.modalConfSalvarCliente=$$v},expression:"modalConfSalvarCliente"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Salvar")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza de que deseja salvar este cliente?")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","ok-only":"","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.pageLista},model:{value:(_vm.modalClienteSalvo),callback:function ($$v) {_vm.modalClienteSalvo=$$v},expression:"modalClienteSalvo"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Salvo")])]),_vm._v(" "),_c('span',[_vm._v("Cliente Salvo com sucesso!")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","cancel-title":"Cancelar","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.excluirContato},model:{value:(_vm.modalExcluirContato),callback:function ($$v) {_vm.modalExcluirContato=$$v},expression:"modalExcluirContato"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Excluir")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza de que deseja exluir este Contato? Esta ação não poderá ser desfeita!")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","cancel-title":"Cancelar","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.excluirEndereco},model:{value:(_vm.modalExcluirEndereco),callback:function ($$v) {_vm.modalExcluirEndereco=$$v},expression:"modalExcluirEndereco"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Excluir")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza de que deseja exluir este Endereço? Esta ação não poderá ser desfeita!")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","cancel-title":"Cancelar","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.excluirEmail},model:{value:(_vm.modalExcluirEmail),callback:function ($$v) {_vm.modalExcluirEmail=$$v},expression:"modalExcluirEmail"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Excluir")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza de que deseja exluir este Email? Esta ação não poderá ser desfeita!")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","cancel-title":"Cancelar","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.excluirReferencia},model:{value:(_vm.modalExcluirReferencia),callback:function ($$v) {_vm.modalExcluirReferencia=$$v},expression:"modalExcluirReferencia"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Excluir")])]),_vm._v(" "),_c('span',[_vm._v("Tem certeza de que deseja exluir esta Referência? Esta ação não poderá ser desfeita!")])],2),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"primary","ok-only":"","no-close-on-esc":true,"no-close-on-backdrop":true,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},model:{value:(_vm.modalItemExcluido),callback:function ($$v) {_vm.modalItemExcluido=$$v},expression:"modalItemExcluido"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Excluído")])]),_vm._v(" "),_c('span',[_vm._v("Registro excluído com sucesso!")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rLMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardMetasVue_vue__ = __webpack_require__("N1v1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a552a92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardMetasVue_vue__ = __webpack_require__("Gn9B");
function injectStyle (ssrContext) {
  __webpack_require__("2mXq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a552a92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardMetasVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a552a92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardMetasVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rPU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_CardMetasVue__ = __webpack_require__("rLMP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_CardPedidosOrcamentoVue__ = __webpack_require__("llmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_items_ComunicadoVue__ = __webpack_require__("6/OE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_items_CarouselVue__ = __webpack_require__("n651");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_items_CardPedidosObservacaoVue__ = __webpack_require__("sNsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_items_PromocoesVue__ = __webpack_require__("ZEuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_items_cardNovidadesVue__ = __webpack_require__("NiA1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_dashboard__ = __webpack_require__("39Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_items_SpinnerVue__ = __webpack_require__("SSQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_items_cardBannersVue__ = __webpack_require__("7Ov1");
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    CardNovidadesVue: __WEBPACK_IMPORTED_MODULE_8__components_items_cardNovidadesVue__["a" /* default */],
    CardPedidosObservacaoVue: __WEBPACK_IMPORTED_MODULE_6__components_items_CardPedidosObservacaoVue__["a" /* default */],
    App: __WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */],
    CardMetasVue: __WEBPACK_IMPORTED_MODULE_2__components_items_CardMetasVue__["a" /* default */],
    ComunicadoVue: __WEBPACK_IMPORTED_MODULE_4__components_items_ComunicadoVue__["a" /* default */],
    CarouselVue: __WEBPACK_IMPORTED_MODULE_5__components_items_CarouselVue__["a" /* default */],
    CardPedidosOrcamentoVue: __WEBPACK_IMPORTED_MODULE_3__components_items_CardPedidosOrcamentoVue__["a" /* default */],
    spinnerVue: __WEBPACK_IMPORTED_MODULE_10__components_items_SpinnerVue__["a" /* default */],
    PromocoesVue: __WEBPACK_IMPORTED_MODULE_7__components_items_PromocoesVue__["a" /* default */],
    CardBannersVue: __WEBPACK_IMPORTED_MODULE_11__components_items_cardBannersVue__["a" /* default */]
  },
  data: function data() {
    return {
      cor: '',
      blockUI: {
        message: '',
        blockUiVisibility: false
      },
      cardMetasValues: {
        valorMeta: 0.00,
        valorAtingido: 0.00,
        periodo: ''
      },
      cardPedidosEmOrcamentoValues: { pedidos: [] },
      cardNovidadesValues: { destaques: [] },
      cardPedidosEmObservacaoValues: { duplicatas: [] },
      cardBannersValues: { banners: [] }
    };
  },

  created: function created() {
    var _this = this;

    window.addEventListener('beforeunload', this.toTopOnRefresh);
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    this.corComp = { 'style: background-color': '#' + localStorage.getItem('corApp')
      // console.log('home criado')
    };__WEBPACK_IMPORTED_MODULE_1__main__["broadcastServer"].$on('emitBuscaDadosDashboard', function (parametro) {
      _this.buscaDadosDashboard();
    });
  },
  mounted: function mounted() {
    this.buscaDadosDashboard();
  },

  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    },
    buscaDadosDashboard: function buscaDadosDashboard() {
      var _this2 = this;

      this.blockUI.blockUiVisibility = true;
      this.blockUI.message = 'Atualizando Dashboard, aguarde...';
      __WEBPACK_IMPORTED_MODULE_9__services_dashboard__["a" /* default */].listarDashboard().then(function (response) {
        // card metas
        _this2.cardMetasValues = {
          valorMeta: response.data.meta.valorMeta,
          valorAtingido: response.data.atingido.valorAtingido,
          periodo: response.data.comissao.periodo
          // card pedidos em orcamento
        };_this2.cardPedidosEmOrcamentoValues.pedidos = response.data.pedidosEmOrcamento.sort(function (a, b) {
          return b.id - a.id;
        });
        // car novidades
        _this2.cardNovidadesValues.destaques = response.data.destaques;
        // card pedidos Observacao
        _this2.cardPedidosEmObservacaoValues.duplicatas = response.data.duplicatas.sort(function (a, b) {
          return b.diasAtraso - a.diasAtraso;
        });
        _this2.cardBannersValues.banners = response.data.banners.sort(function (a, b) {
          return a.ordem - b.ordem;
        });
      }).catch(function (error) {
        console.log(error);
        _this2.showMessage('Erro ao obter dados do dashboard!\n' + error, 'Atenção', 'danger');
      }).finally(function () {
        _this2.blockUI.blockUiVisibility = false;
      });
    }
  }
});

/***/ }),

/***/ "rUTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import catalogoService from '@/services/tableCatalogo'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pCardBannersValues: {
      banners: []
    }
  },
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      banners: [],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },

  watch: {
    pCardBannersValues: function pCardBannersValues(newVal, oldVal) {
      // watch it
      this.banners = newVal;
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "rcKX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rmCP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ruqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rwEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_items_NewItemsClientesVue__ = __webpack_require__("RZCr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_TableClientesVue__ = __webpack_require__("LHVF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_TableEditClientesVue__ = __webpack_require__("3vl3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientesVue',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */],
    NewItemsClientesVue: __WEBPACK_IMPORTED_MODULE_1__components_items_NewItemsClientesVue__["a" /* default */],
    TableClientesVue: __WEBPACK_IMPORTED_MODULE_2__components_items_TableClientesVue__["a" /* default */],
    TableEditClientesVue: __WEBPACK_IMPORTED_MODULE_3__components_items_TableEditClientesVue__["a" /* default */]
  },
  data: function data() {
    return {
      isModoLista: true
    };
  },
  created: function created() {
    var _this = this;

    window.addEventListener('beforeunload', this.toTopOnRefresh);
    // console.log('modo: ' + JSON.stringify(modo.LISTA))
    __WEBPACK_IMPORTED_MODULE_4__main__["broadcastServer"].$on('pageEditClientes', function (parametro) {
      window.scrollTo(0, 0);
      _this.isModoLista = parametro.modo === __WEBPACK_IMPORTED_MODULE_4__main__["modo"].LISTA;
    });
  },

  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "s+R/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterVue'
});

/***/ }),

/***/ "sErP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sF6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_toastVue__ = __webpack_require__("7luQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__ = __webpack_require__("SSQZ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var ROW_INDEX = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pRelatorioGerencialDados: {}
  },
  data: function data() {
    return {
      blockUI: {
        message: '',
        visibility: false
      },
      message: [{
        idToast: 'my-toast',
        titleMsg: '',
        message: '',
        variant: ''
      }],
      representantes: [],
      totalCategoria: 0.00,
      totalRepresentante: 0.00,
      totalCliente: 0.00,
      totalUF: 0.00,
      totaDia: 0.00,
      fieldsCategoria: [{
        key: 'categoria',
        label: 'Categoria',
        sortable: false,
        class: 'txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'valor',
        label: 'Valor',
        sortable: false,
        class: 'txtRight',
        formatter: this.formatterValue
      }],
      fieldsRepresentante: [{
        key: 'nome',
        label: 'Nome',
        sortable: false,
        class: 'txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'valor',
        label: 'Valor',
        sortable: false,
        class: 'txtRight',
        formatter: this.formatterValue
      }],
      fieldsCliente: [{
        key: 'nome',
        label: 'Fantasia',
        sortable: false,
        class: 'txtLeft',
        formatter: this.toCapitalize
      }, {
        key: 'valor',
        label: 'Valor',
        sortable: false,
        class: 'txtRight',
        formatter: this.formatterValue
      }],
      fieldsUF: [{
        key: 'uf',
        label: 'UF',
        sortable: false,
        class: 'txtLeft'
      }, {
        key: 'valor',
        label: 'Valor',
        sortable: false,
        class: 'txtRight',
        formatter: this.formatterValue
      }],
      fieldsDiario: [{
        key: 'emissao',
        label: 'Data',
        sortable: false,
        class: 'txtLeft'
      }, {
        key: 'valor',
        label: 'Valor',
        sortable: false,
        class: 'txtRight',
        formatter: this.formatterValue
      }],
      components: {
        spinnerVue: __WEBPACK_IMPORTED_MODULE_3__components_items_SpinnerVue__["a" /* default */],
        ToastVue: __WEBPACK_IMPORTED_MODULE_2__layouts_toastVue__["a" /* default */]
      }
    };
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
    this.representantes = JSON.parse(localStorage.getItem('representantesLogin'));
  },

  watch: {
    pRelatorioGerencialDados: function pRelatorioGerencialDados(newVal, oldVal) {
      // watch it
      this.totalCategoria = newVal.porCategoria.reduce(function (r, a) {
        return r + a.valor;
      }, 0);
      // REPRESENTANTE
      this.totalRepresentante = newVal.porRepresentate.reduce(function (r, a) {
        return r + a.valor;
      }, 0);
      // CLIENTE
      this.totalCliente = newVal.porCliente.reduce(function (r, a) {
        return r + a.valor;
      }, 0);
      // UF
      this.totalUF = newVal.porUFCliente.reduce(function (r, a) {
        return r + a.valor;
      }, 0);
      // DIA
      this.totaDia = newVal.porDia.reduce(function (r, a) {
        return r + a.valor;
      }, 0);
    }
  },
  computed: {
    flattenedTree: function flattenedTree() {
      return this._flattenTreeStructure(this.tree);
    }
  },
  methods: {
    teste: function teste() {
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.tree));
      this.tree[0].children = [{
        columnA: 'filho jhon',
        columnB: 'filho Smith',
        columnC: '150'
      }];
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.tree));
      this.flattenedTree();
    },
    _toggleRowExpansion: function _toggleRowExpansion(row) {
      if (row._hasChildren) {
        row._rowIsExpanded = !row._rowIsExpanded;
        this.$set(this.filterObj.expandedRowIndices, row._rowIndex, row._rowIsExpanded);
      }
    },
    _expandAll: function _expandAll() {
      this._collapseOrExpandAll(true);
    },
    _collapseAll: function _collapseAll() {
      this._collapseOrExpandAll(false);
    },
    _collapseOrExpandAll: function _collapseOrExpandAll(doExpand) {
      var vm = this;
      this.flattenedTree.filter(function (row) {
        return row._hasChildren;
      }).forEach(function (row) {
        row._rowIsExpanded = doExpand;
        vm.$set(vm.filterObj.expandedRowIndices, row._rowIndex, doExpand);
      });
    },
    _filterFunction: function _filterFunction(row, filter) {
      if (row._rowDepth === 0) {
        return true;
      }
      var shouldExpand = true;
      var currentRow = row;
      while (shouldExpand && currentRow._rowParent !== null) {
        shouldExpand = shouldExpand && filter.expandedRowIndices[currentRow._rowParent._rowIndex] === true;
        currentRow = currentRow._rowParent;
      }
      return shouldExpand;
    },
    _flattenTreeStructure: function _flattenTreeStructure(rows) {
      var parentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var result = [];
      for (var idx = 0; idx < rows.length; idx++) {
        var row = rows[idx];
        result.push(row);
        row._rowDepth = depth;
        row._rowIsExpanded = false;
        row._rowParent = parentRow;
        row._rowIndex = ROW_INDEX;
        ROW_INDEX++;
        if (row.children && row.children.length > 0) {
          row._hasChildren = true;
          var children = row.children;
          var flattenedChildren = this._flattenTreeStructure(children, row, depth + 1);
          result = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(flattenedChildren));
        }
      }
      return result;
    },

    formatterValue: function formatterValue(valor) {
      var val = (valor / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    toCapitalize: function toCapitalize(value) {
      return value.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }
});

/***/ }),

/***/ "sNsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPedidosObservacaoVue_vue__ = __webpack_require__("39eN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a381c52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPedidosObservacaoVue_vue__ = __webpack_require__("a+92");
function injectStyle (ssrContext) {
  __webpack_require__("nM7b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a381c52a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPedidosObservacaoVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a381c52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPedidosObservacaoVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tDQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_HeaderVue__ = __webpack_require__("vCYq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_FooterVue__ = __webpack_require__("mN5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_dashboard__ = __webpack_require__("39Xj");
//
//
//
//
//
//
//
//
//



// import { mapState } from 'vuex'

// import { cor } from '@/main'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StaticLayout',
  data: function data() {
    return {
      cor: ''
    };
  },

  computed: {
    // ...mapState({
    //   cor: state => {
    //     const { cor } = state.cor
    //     return {
    //       'background-color': cor
    //     }
    //   }
    // })
  },
  components: {
    HeaderVue: __WEBPACK_IMPORTED_MODULE_0__components_layouts_HeaderVue__["a" /* default */],
    FooterVue: __WEBPACK_IMPORTED_MODULE_1__components_layouts_FooterVue__["a" /* default */]
  },
  created: function created() {
    this.cor = { 'background-color': '#' + localStorage.getItem('corApp') };
  },

  methods: {
    sair: function sair() {
      localStorage.clear();
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__services_dashboard__["a" /* default */].listarDashboard().then(function (response) {
      // console.log(response)
    });
  }
});

/***/ }),

/***/ "tqkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioClientesRankingVue_vue__ = __webpack_require__("JA57");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31efc21a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioClientesRankingVue_vue__ = __webpack_require__("dSqS");
function injectStyle (ssrContext) {
  __webpack_require__("Ljhw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31efc21a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioClientesRankingVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31efc21a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioClientesRankingVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txSb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatoriosComissoesVue_vue__ = __webpack_require__("RQUi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ca27f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatoriosComissoesVue_vue__ = __webpack_require__("oic8");
function injectStyle (ssrContext) {
  __webpack_require__("fiCi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43ca27f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatoriosComissoesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ca27f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatoriosComissoesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uiNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uk2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioMetasVue_vue__ = __webpack_require__("Vh38");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5506208c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioMetasVue_vue__ = __webpack_require__("6AU5");
function injectStyle (ssrContext) {
  __webpack_require__("flaK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5506208c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatorioMetasVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5506208c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatorioMetasVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'CHANGE_COLOR': function CHANGE_COLOR(state, payload) {
    state.cor = payload;
  },
  'CHANGE_COLOR_SELECIONADO': function CHANGE_COLOR_SELECIONADO(state, payload) {
    state.cor = payload;
  },
  'CHANGE_LOGO': function CHANGE_LOGO(state, payload) {
    state.isLog = payload;
  }
});

/***/ }),

/***/ "uwvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesVue_vue__ = __webpack_require__("rwEV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f325f41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesVue_vue__ = __webpack_require__("lRLB");
function injectStyle (ssrContext) {
  __webpack_require__("znTo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f325f41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f325f41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vCYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderVue_vue__ = __webpack_require__("OfRQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122b4cb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderVue_vue__ = __webpack_require__("Ga2I");
function injectStyle (ssrContext) {
  __webpack_require__("mia8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-122b4cb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122b4cb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wduK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"filtroPedido"}},[_c('b-row',{staticClass:"pt-3 pb-2",attrs:{"id":"headerPagePed"}},[_c('b-col',{staticClass:"pl-0",attrs:{"sm":"10 title"}},[_vm._v(_vm._s(_vm.title || "Título não informado"))]),_vm._v(" "),_c('b-col',{staticClass:"pr-0",attrs:{"sm":"2"}},[_c('b-button',{staticClass:"btn-plus left",attrs:{"size":"sm","variant":"secondary","id":"btnTeste"},on:{"click":_vm.adicionar}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Adicionar")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro shadow p-2",attrs:{"id":"filtroWeb"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","placeholder":_vm.placeholderNm,"autocomplete":"off"},model:{value:(_vm.termo),callback:function ($$v) {_vm.termo=$$v},expression:"termo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"p-0",attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChangeSituacao($event)}},model:{value:(_vm.statusPedidoSelec),callback:function ($$v) {_vm.statusPedidoSelec=$$v},expression:"statusPedidoSelec"}},_vm._l((_vm.statusPedidos),function(item,key){return _c('option',{key:item.codigo,domProps:{"value":key}},[_vm._v("\n        "+_vm._s(item.descricao)+"\n      ")])}),0)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('div',{staticClass:"datepicker-container with-button"},[_c('div',{staticClass:"datepicker-trigger"},[_c('b-button',{attrs:{"id":"datepicker-button-trigger","size":"sm"}},[_vm._v("\n            "+_vm._s(_vm.formatDates(_vm.buttonDateOne, _vm.buttonDateTwo) || 'Período')+"\n          ")]),_vm._v(" "),_c('airbnb-style-datepicker',{attrs:{"trigger-element-id":'datepicker-button-trigger',"mode":'range',"date-one":_vm.buttonDateOne,"date-two":_vm.buttonDateTwo,"min-date":'2018-02-28',"fullscreen-mobile":true,"months-to-show":2,"offset-y":10,"trigger":_vm.trigger},on:{"date-one-selected":function(val) { _vm.buttonDateOne = val },"date-two-selected":function(val) { _vm.buttonDateTwo = val },"closed":_vm.onClosed,"previous-month":_vm.onMonthChange,"next-month":_vm.onMonthChange}})],1)])]),_vm._v(" "),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"2"}},[_c('b-button',{staticClass:"btnLimpaFiltro",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltro()}}},[_c('i',{staticClass:"fas fa-eraser"})]),_vm._v(" "),_c('b-button',{staticClass:"btnBuscaFiltro",attrs:{"size":"sm"},on:{"click":function($event){return _vm.filtrar()}}},[_c('i',{staticClass:"fas fa-search"})])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"input-search filtro shadow",attrs:{"id":"filtroMob"}},[_c('b-button',{attrs:{"id":"abreModalFiltro","size":"sm"},on:{"click":function($event){return _vm.abreModalFiltro()}}},[_c('i',{staticClass:"fas fa-search mr-2"}),_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"ml-3 btnLimpaFiltro",attrs:{"size":"sm"},on:{"click":function($event){return _vm.limparFiltro()}}},[_c('i',{staticClass:"fas fa-eraser mr-2"}),_vm._v("Limpar Filtro")])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-title":"Filtrar","ok-variant":"primary","cancel-title":"Cancelar","cancel-variant":"secondary","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"ok":_vm.filtrar},model:{value:(_vm.modalFiltro),callback:function ($$v) {_vm.modalFiltro=$$v},expression:"modalFiltro"}},[_c('template',{slot:"modal-header"},[_c('h5',[_vm._v("Filtrar Pedidos")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row m-0"},[_c('div',{staticClass:"w-100 mb-3"},[_c('b-input-group',[_c('b-input-group-prepend',{staticClass:"mt-0"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{attrs:{"size":"sm","placeholder":_vm.placeholderNm},model:{value:(_vm.termo),callback:function ($$v) {_vm.termo=$$v},expression:"termo"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100 mb-3"},[_c('b-form-select',{attrs:{"size":"sm"},on:{"change":function($event){return _vm.onChangeSituacao($event)}},model:{value:(_vm.statusPedidoSelec),callback:function ($$v) {_vm.statusPedidoSelec=$$v},expression:"statusPedidoSelec"}},_vm._l((_vm.statusPedidos),function(item,key){return _c('option',{key:item.codigo,domProps:{"value":key}},[_vm._v("\n              "+_vm._s(item.descricao)+"\n            ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"w-100 mb-3"},[_c('div',{staticClass:"datepicker-container with-button"},[_c('div',{staticClass:"datepicker-trigger"},[_c('b-button',{attrs:{"id":"datepicker-button-trigger-mobile","size":"sm"}},[_vm._v("\n                "+_vm._s(_vm.formatDates(_vm.buttonDateOne, _vm.buttonDateTwo) || 'Período')+"\n              ")]),_vm._v(" "),_c('airbnb-style-datepicker',{attrs:{"trigger-element-id":'datepicker-button-trigger-mobile',"mode":'range',"date-one":_vm.buttonDateOne,"date-two":_vm.buttonDateTwo,"min-date":'2018-02-28',"fullscreen-mobile":true,"months-to-show":2,"offset-y":10,"trigger":_vm.trigger},on:{"date-one-selected":function(val) { _vm.buttonDateOne = val },"date-two-selected":function(val) { _vm.buttonDateTwo = val },"closed":_vm.onClosed,"previous-month":_vm.onMonthChange,"next-month":_vm.onMonthChange}})],1)])])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */],
  modules: {}
}));

/***/ }),

/***/ "xCYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3",attrs:{"role":"tablist","id":"listCliente"}},[_c('div',[_c('b-card-header',{style:(_vm.cor),attrs:{"header":"Lista de Clientes","header-text-variant":"white","header-tag":"header"}}),_vm._v(" "),_c('b-card',{staticClass:"mb-1 shadow b-radius-0 p-3",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"table"},[(this.clientes.length > 0)?_c('b-table',{staticClass:"verticalAlign",attrs:{"bordered":"","striped":"","items":_vm.clientes,"fields":_vm.fields},scopedSlots:_vm._u([{key:"mobile",fn:function(row){return [_c('div',{staticClass:"form-row mb-1"},[_c('div',{staticClass:"col-md-8"},[_c('strong',[_vm._v(_vm._s(_vm.toCapitalize(row.item.fantasia)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Cód.: "+_vm._s(row.item.codCliente))])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_vm._v(_vm._s(_vm.toCapitalize(row.item.razaoSocial)))]),_vm._v(" "),(row.item.cnpjCpf.length === 14)?_c('div',{staticClass:"form-row mb-1"},[_vm._v("CNPJ: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]):_c('div',{staticClass:"form-row mb-1"},[_vm._v("CPF: "+_vm._s(_vm.formatterCnpjCpf(row.item.cnpjCpf)))]),_vm._v(" "),_c('div',{staticClass:"form-row mb-1"},[_vm._v("ENDEREÇO: "+_vm._s(_vm.toCapitalize(row.item.endereco))+" - "+_vm._s(_vm.toCapitalize(row.item.cidade))+" - "+_vm._s(row.item.uf))])]}},{key:"actions",fn:function(row){return [_c('b-button',{staticClass:"mr-1 defaultColor",attrs:{"size":"sm"},on:{"click":function($event){return _vm.pageEdit(row.item, row.index)}}},[_vm._v("\n              Editar\n            ")])]}}],null,false,727769437)}):_c('span',[_vm._v("\n          Não foram encontrados clientes com os termos pesquisados, tente novamente\n        ")])],1)],1)],1),_vm._v(" "),(_vm.blockUiVisibility)?_c('BlockUI',{attrs:{"message":_vm.msgBlockUi}},[_c('spinner-vue')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_style_css__ = __webpack_require__("VaBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_config__ = __webpack_require__("CyCq");

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
  var restRequest = -1;
  var token = '';
  console.log('interceptor');
  restRequest = config.url.indexOf(__WEBPACK_IMPORTED_MODULE_3__services_config__["a" /* endPointPrivate */]);
  if (restRequest !== -1) {
    token = localStorage.token;
    config.headers['Authorization'] = 'Token ' + token;
    config.headers['Content-Type'] = 'application/json';
    var representanteSelecionado = JSON.parse(localStorage.getItem('representanteSelecionado'));
    if (representanteSelecionado) {
      var codRepresentante = representanteSelecionado.codigo;
      if (typeof codRepresentante !== 'undefined' && codRepresentante !== '') {
        config.headers['codRepresentante'] = codRepresentante;
      }
    }
  }

  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  console.log('interceptor');
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),

/***/ "xQLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  listarEmpresas: function listarEmpresas(listar) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* endPointPublic */] + 'v1/listaEmpresasAcesso', listar);
  },
  logar: function logar(_logar) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* endPointPublic */] + 'v1/login', _logar);
  }
});

/***/ }),

/***/ "xdU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_items_NewItemsVue__ = __webpack_require__("povw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_items_TablePedidosVue__ = __webpack_require__("4OE9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_items_TableAcoesVue__ = __webpack_require__("5NKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_items_NewItemsClientesVue__ = __webpack_require__("RZCr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_items_NovoPedidoVue__ = __webpack_require__("ScOC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pedidos',
  components: {
    NewItemsClientesVue: __WEBPACK_IMPORTED_MODULE_5__components_items_NewItemsClientesVue__["a" /* default */],
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */],
    NewItemsVue: __WEBPACK_IMPORTED_MODULE_0__components_items_NewItemsVue__["a" /* default */],
    TablePedidosVue: __WEBPACK_IMPORTED_MODULE_2__components_items_TablePedidosVue__["a" /* default */],
    tableAcoesVue: __WEBPACK_IMPORTED_MODULE_3__components_items_TableAcoesVue__["a" /* default */],
    NovoPedidoVue: __WEBPACK_IMPORTED_MODULE_6__components_items_NovoPedidoVue__["a" /* default */]
  },
  data: function data() {
    return {
      exibirListaPedido: true,
      exibirSelecionarCliente: false,
      novoPedido: false,
      cliente: {},
      mostraPedidos: true
    };
  },
  created: function created() {
    var _this = this;

    window.addEventListener('beforeunload', this.toTopOnRefresh);
    var empresa = localStorage.getItem('empresaLogada');
    if (JSON.parse(empresa).identificador === 2355480534) {
      this.titlePageLista = 'ORÇAMENTOS';
      this.mostraPedidos = false;
    } else {
      this.titlePageLista = 'PEDIDOS';
    }
    __WEBPACK_IMPORTED_MODULE_4__main__["broadcastServer"].$on('adicionarPedido', function (param) {
      _this.exibirListaPedido = false;
      _this.exibirSelecionarCliente = true;
      _this.novoPedido = false;
    });
    __WEBPACK_IMPORTED_MODULE_4__main__["broadcastServer"].$on('exibirLista', function (param) {
      window.scrollTo(0, 0);
      _this.exibirListaPedido = true;
      _this.exibirSelecionarCliente = false;
      _this.novoPedido = false;
    });
    __WEBPACK_IMPORTED_MODULE_4__main__["broadcastServer"].$on('clienteSelecionado', function (cliente) {
      window.scrollTo(0, 0);
      _this.exibirListaPedido = false;
      _this.exibirSelecionarCliente = false;
      _this.novoPedido = true;
      _this.cliente = cliente;
    });
    __WEBPACK_IMPORTED_MODULE_4__main__["broadcastServer"].$on('vizualizarPedido', function (param) {
      window.scrollTo(0, 0);
      _this.exibirListaPedido = false;
      _this.exibirSelecionarCliente = false;
      _this.novoPedido = true;
    });
  },

  methods: {
    toTopOnRefresh: function toTopOnRefresh(event) {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "yUj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectVue__ = __webpack_require__("qknN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__ = __webpack_require__("05AP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import format from 'date-fns/format'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      firstDay: '',
      lastDay: '',
      dateFormat: 'D MMM',
      inputDateOne: '',
      inputDateTwo: '',
      buttonDateOne: '',
      buttonDateTwo: '',
      inlineDateOne: '',
      sundayDateOne: '',
      sundayFirst: false,
      alignRight: false,
      trigger: false,
      termo: '',
      pedidos: [],
      statusPedido: null,
      codigo: '',
      key: '',
      codStatus: '',
      options: [],
      statusPedidos: [],
      statusPedidoSelec: 0,
      statusPedidoFiltrar: null,
      situacaoSelecionada: {},
      dataDe: '',
      dataAte: '',
      modalFiltro: false,
      headerTextVariant: 'light',
      headerBgVariant: 'dark',
      selected: null
    };
  },

  name: 'NewItemsVue',
  props: ['title', 'placeholderNm'],
  components: {
    SelectVue: __WEBPACK_IMPORTED_MODULE_0__SelectVue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.buttonDateOne = firstDay.toJSON().slice(0, 10);
    this.buttonDateTwo = lastDay.toJSON().slice(0, 10);
    __WEBPACK_IMPORTED_MODULE_1__services_tablePedidos__["a" /* default */].listarSituacaoPedido().then(function (response) {
      _this.statusPedidos = response.data.dados.sort(function (a, b) {
        return a.codigo - b.codigo;
      });
    });
  },

  methods: {
    onChangeSituacao: function onChangeSituacao(index) {
      var statusSelec = index;
      // this.git  = statusSelec.codigo
      console.log('dssdf' + statusSelec);
    },

    adicionar: function adicionar() {
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('adicionarPedido', '');
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('esconderBotaoAdicionarCliente', '');
    },
    onChange: function onChange(index) {
      this.statusSelecionado = this.options[index];
      this.codStatus = this.statusSelecionado.codigo;
      // console.log(this.codStatus)
    },

    filtrar: function filtrar() {
      var objectPost = { termo: this.termo, codStatus: this.statusPedidoSelec, emissaoDe: this.dataDe, emissaoAte: this.dataAte };
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('filtrosSelecionados', objectPost, 0);
    },
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        this.dataDe = dateOne;
        var dataFormatada = dateOne.substring(8, 10) + '/' + dateOne.substring(5, 7) + '/' + dateOne.substring(0, 4);
        // console.log(dataFormatada)
        formattedDates = dataFormatada; // dateFns.format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        this.dataAte = dateTwo;
        var _dataFormatada = dateTwo.substring(8, 10) + '/' + dateTwo.substring(5, 7) + '/' + dateTwo.substring(0, 4);
        formattedDates += ' - ' + _dataFormatada; // dateFns.format(dateTwo, this.dateFormat)
      }
      return formattedDates;
    },
    onClosed: function onClosed() {
      var datesStr = this.formatDates(this.inputDateOne, this.inputDateTwo);
      console.log('Dates Selected: ' + datesStr);
      this.trigger = false;
    },
    onMonthChange: function onMonthChange(dates) {
      console.log('months changed', dates);
    },
    limparFiltro: function limparFiltro() {
      this.termo = '';
      this.statusPedido = null;
      this.dataDe = '';
      this.dataAte = '';
      this.inputDateOne = '';
      this.inputDateTwo = '';
      this.buttonDateOne = '';
      this.buttonDateTwo = '';
      var objectPost = { termo: '', codStatus: 0, emissaoDe: '', emissaoAte: '' };
      __WEBPACK_IMPORTED_MODULE_2__main__["broadcastServer"].$emit('filtrosSelecionados', objectPost, 1);
    },
    abreModalFiltro: function abreModalFiltro() {
      this.modalFiltro = true;
    }
  }
});

/***/ }),

/***/ "zeQ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "znTo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.765611680549235f34c1.js